import { DocumentNode } from 'graphql';
import gql from 'graphql-tag';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  AdditionalInfoValue: { input: any; output: any; }
  BigNumber: { input: any; output: any; }
  CardNumber: { input: any; output: any; }
  DateTime: { input: any; output: any; }
  IBAN: { input: any; output: any; }
  JSON: { input: any; output: any; }
  Long: { input: any; output: any; }
  PhoneNumber: { input: any; output: any; }
  SWIFT: { input: any; output: any; }
  Timestamp: { input: any; output: any; }
  VabsBigNumber: { input: any; output: any; }
  VabsDateTime: { input: any; output: any; }
  VabsJSON: { input: any; output: any; }
  VabsTimestamp: { input: any; output: any; }
};

export enum AbsPaymentStatus {
  Declined = 'DECLINED',
  Error = 'ERROR',
  Pending = 'PENDING',
  Processing = 'PROCESSING',
  Settled = 'SETTLED'
}

export type AccessTokenForApplicantType = {
  __typename?: 'AccessTokenForApplicantType';
  token: Scalars['String']['output'];
};

export type Account = {
  __typename?: 'Account';
  absAccountId?: Maybe<Scalars['String']['output']>;
  absAccountNickname?: Maybe<Scalars['String']['output']>;
  absAccountStatus?: Maybe<Scalars['String']['output']>;
  absAccountType?: Maybe<Scalars['String']['output']>;
  accountNumber: Scalars['String']['output'];
  balance: Balance;
  bankDetails: NewBankDetails;
  blockReasons?: Maybe<Array<Scalars['String']['output']>>;
  common: CommonItemInfo;
  /** @deprecated This field will be removed in a future. Please, use "virtualAccounts" field instead. */
  contomobileSubAccount?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  currency: Currency;
  holderType?: Maybe<AccountHolderType>;
  id: Scalars['ID']['output'];
  internalType: InternalAccountType;
  /** Indicates if the account has an open external account with the provider */
  isProviderAccountReady: Scalars['Boolean']['output'];
  isSystem: Scalars['Boolean']['output'];
  isSystemBlock?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  openingDate?: Maybe<Scalars['DateTime']['output']>;
  provider?: Maybe<AccountsProviderEnum>;
  providerTag?: Maybe<Scalars['String']['output']>;
  reasonForInactive?: Maybe<Scalars['String']['output']>;
  state: AccountState;
  tag: Scalars['String']['output'];
  trackerId: Scalars['ID']['output'];
  type: AccountType;
  userId: Scalars['String']['output'];
  virtualAccounts?: Maybe<Array<VAccount>>;
  walletId: Scalars['String']['output'];
};


export type AccountBankDetailsArgs = {
  input: FilterInput;
};

export enum AccountFiIntegration {
  ClearJunction = 'CLEAR_JUNCTION',
  Contomobile = 'CONTOMOBILE',
  Satchel = 'SATCHEL'
}

export enum AccountHolderType {
  Individual = 'INDIVIDUAL',
  Legal = 'LEGAL'
}

export enum AccountState {
  Active = 'ACTIVE',
  Closed = 'CLOSED',
  Error = 'ERROR',
  External = 'EXTERNAL',
  Inactive = 'INACTIVE',
  Pending = 'PENDING',
  Processing = 'PROCESSING'
}

export enum AccountType {
  Credit = 'CREDIT',
  Debit = 'DEBIT'
}

export type Accounts = {
  __typename?: 'Accounts';
  count: Scalars['Int']['output'];
  cursor: Scalars['Int']['output'];
  nodes: Array<Account>;
};

export type AccountsCreateMultipleCurrencyInput = {
  accountCurrencyIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  activeCurrencyIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  clientId: Scalars['ID']['input'];
  provider?: InputMaybe<AccountsProviderEnum>;
  tag: Scalars['String']['input'];
  trackerId?: InputMaybe<Scalars['ID']['input']>;
};

export type AccountsInput = {
  accountNumbers?: InputMaybe<Array<Scalars['String']['input']>>;
  companyId?: InputMaybe<Scalars['ID']['input']>;
  currencyId?: InputMaybe<Scalars['ID']['input']>;
  currencyIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  filter?: InputMaybe<Filter>;
  isSystems?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  likeConditions?: InputMaybe<Array<LikeConditionInput>>;
  provider?: InputMaybe<AccountsProviderEnum>;
  providerTag?: InputMaybe<Scalars['String']['input']>;
  requestGCP?: InputMaybe<Scalars['Boolean']['input']>;
  states?: InputMaybe<Array<AccountState>>;
  tag?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['ID']['input']>;
  walletIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export enum AccountsProviderEnum {
  BankOfChina = 'BANK_OF_CHINA',
  Cj = 'CJ',
  Satchel = 'SATCHEL'
}

export type AccountsRouteInput = {
  clientId: Scalars['ID']['input'];
  tag: Scalars['String']['input'];
};

export type AddApplicantDocumentDataInput = {
  country: Scalars['String']['input'];
  downloadFileUrl: Scalars['String']['input'];
  idDocSubType?: InputMaybe<ApplicantDocumentSubTypeEnum>;
  idDocType: ApplicantDocumentTypeEnum;
};

export type AddApplicantDocumentInput = {
  document: AddApplicantDocumentDataInput;
  externalUserId: Scalars['String']['input'];
};

export type AddTagByCodeInput = {
  codes: Array<Scalars['String']['input']>;
  rewrite?: InputMaybe<Array<Scalars['String']['input']>>;
  tags: Array<Scalars['String']['input']>;
  type: ItemType;
};

export type AddTagInput = {
  ids: Array<Scalars['ID']['input']>;
  rewrite?: InputMaybe<Array<Scalars['String']['input']>>;
  tags: Array<Scalars['String']['input']>;
  type: ItemType;
};

export type AdditionalInfo = {
  __typename?: 'AdditionalInfo';
  clientId: Scalars['ID']['output'];
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  key: Scalars['String']['output'];
  name: Scalars['String']['output'];
  type: AdditionalInfoTypeEnum;
  updatedAt: Scalars['DateTime']['output'];
  value: Scalars['AdditionalInfoValue']['output'];
};

/** Type of additional info value */
export enum AdditionalInfoTypeEnum {
  Boolean = 'BOOLEAN',
  Date = 'DATE',
  Number = 'NUMBER',
  String = 'STRING'
}

export type AdditionalInfos = {
  __typename?: 'AdditionalInfos';
  count: Scalars['Int']['output'];
  cursor: Scalars['Int']['output'];
  nodes: Array<AdditionalInfo>;
};

export type Address = {
  __typename?: 'Address';
  buildingName?: Maybe<Scalars['String']['output']>;
  buildingNumber?: Maybe<Scalars['String']['output']>;
  categories?: Maybe<AddressCategories>;
  city?: Maybe<City>;
  client?: Maybe<AddressClientUnion>;
  clientId: Scalars['ID']['output'];
  /** additional comment */
  comment?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Country>;
  createdAt: Scalars['DateTime']['output'];
  flatNumber?: Maybe<Scalars['String']['output']>;
  /** presentation of address as formatted string */
  formattedStringValue: Scalars['String']['output'];
  /** presentation of address as formatted string english */
  formattedStringValueEn: Scalars['String']['output'];
  geoLatitude?: Maybe<Scalars['String']['output']>;
  geoLongitude?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isActual?: Maybe<Scalars['Boolean']['output']>;
  isLegal?: Maybe<Scalars['Boolean']['output']>;
  isPrimary: Scalars['Boolean']['output'];
  postalCode?: Maybe<Scalars['String']['output']>;
  rawCityName?: Maybe<Scalars['String']['output']>;
  rawCityNameEn?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  stateEn?: Maybe<Scalars['String']['output']>;
  street?: Maybe<Scalars['String']['output']>;
  streetEn?: Maybe<Scalars['String']['output']>;
  subStreet?: Maybe<Scalars['String']['output']>;
  subStreetEn?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};


export type AddressCategoriesArgs = {
  input: FilterInput;
};

export type AddressByGeoInput = {
  /** [Dictionary] Latitude and longitude of supposed address */
  geo: GeoLocationInput;
};

export type AddressCategories = {
  __typename?: 'AddressCategories';
  count: Scalars['Int']['output'];
  cursor: Scalars['Int']['output'];
  nodes: Array<AddressCategory>;
};

export type AddressCategoriesInput = {
  addressIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  createdAt?: InputMaybe<AddressesDateRangeInput>;
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  pagination: PaginationInput;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<SortAddressCategoriesInput>;
  updatedAt?: InputMaybe<AddressesDateRangeInput>;
  withDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AddressCategory = {
  __typename?: 'AddressCategory';
  addresses: Addresses;
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};


export type AddressCategoryAddressesArgs = {
  input: FilterInput;
};

export type AddressCategoryInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type AddressClientUnion = Company | User;

export type AddressData = {
  __typename?: 'AddressData';
  /** [Dictionary] Represents name of building located at given address */
  buildingName?: Maybe<Scalars['String']['output']>;
  /** [Dictionary] Represents city at which address was located */
  city?: Maybe<City>;
  /** [Dictionary] Represents optional comment */
  comment?: Maybe<Scalars['String']['output']>;
  /** [Dictionary] Represents floor of building at given address */
  flatNumber?: Maybe<Scalars['String']['output']>;
  /** [Dictionary] Formatted value created from data of existing fields */
  formattedStringValue: Scalars['String']['output'];
  /** [Dictionary] Latitude and longitude of supposed address */
  geo: GeoLocation;
  /** [Dictionary] Represents whether this address is primary for user */
  isPrimary: Scalars['Boolean']['output'];
  /** [Dictionary] Represents address related postal code */
  postalCode?: Maybe<Scalars['String']['output']>;
  /** [Dictionary] Represents address' street */
  street?: Maybe<Scalars['String']['output']>;
  /** [Dictionary] Represents address' sub street */
  subStreet?: Maybe<Scalars['String']['output']>;
};

export enum AddressSortOrder {
  Asc = 'ASC',
  Desc = 'DESC'
}

export type Addresses = {
  __typename?: 'Addresses';
  count: Scalars['Int']['output'];
  cursor: Scalars['Int']['output'];
  nodes: Array<Address>;
};

export type AddressesDateRangeInput = {
  dateFrom?: InputMaybe<Scalars['String']['input']>;
  dateTo?: InputMaybe<Scalars['String']['input']>;
};

export enum AdminResponseKybType {
  Approved = 'APPROVED',
  Rejected = 'REJECTED',
  RejectedRetry = 'REJECTED_RETRY'
}

export enum AdminResponseType {
  Approved = 'APPROVED',
  Rejected = 'REJECTED'
}

export type AdminSignUpInput = {
  birthDate?: InputMaybe<Scalars['DateTime']['input']>;
  device: Device;
  firstName?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<GenderEnum>;
  identity: Scalars['String']['input'];
  lastName?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  region?: InputMaybe<Scalars['String']['input']>;
  service: Scalars['String']['input'];
  userId?: InputMaybe<Scalars['String']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
};

export type AgeRangeStatisticSetting = {
  __typename?: 'AgeRangeStatisticSetting';
  ageFrom: Scalars['Int']['output'];
  ageTo?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  rangeName: Scalars['String']['output'];
};

export type AgeRangeStatisticSettings = {
  __typename?: 'AgeRangeStatisticSettings';
  count: Scalars['Int']['output'];
  cursor: Scalars['Int']['output'];
  nodes: Array<AgeRangeStatisticSetting>;
};

export type AmountRangeInput = {
  max?: InputMaybe<Scalars['BigNumber']['input']>;
  min?: InputMaybe<Scalars['BigNumber']['input']>;
};

export type AppleSignInInput = {
  /** authorization code for auth user if no token provided */
  authorizationCode?: InputMaybe<Scalars['String']['input']>;
  /** first name given only at very first apple signin if present */
  firstName?: InputMaybe<Scalars['String']['input']>;
  /** identity token if present */
  identityToken?: InputMaybe<Scalars['String']['input']>;
  /** last name given only at very first apple signin if present */
  lastName?: InputMaybe<Scalars['String']['input']>;
  service: Scalars['String']['input'];
  /** token for PUSH notification */
  token?: InputMaybe<Scalars['String']['input']>;
};

export type ApplicantAddressType = {
  __typename?: 'ApplicantAddressType';
  country?: Maybe<Scalars['String']['output']>;
  formattedAddress?: Maybe<Scalars['String']['output']>;
  postCode?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  stateEn?: Maybe<Scalars['String']['output']>;
  street?: Maybe<Scalars['String']['output']>;
  streetEn?: Maybe<Scalars['String']['output']>;
  subStreet?: Maybe<Scalars['String']['output']>;
  subStreetEn?: Maybe<Scalars['String']['output']>;
  town?: Maybe<Scalars['String']['output']>;
  townEn?: Maybe<Scalars['String']['output']>;
};

export type ApplicantBeneficiaryType = {
  __typename?: 'ApplicantBeneficiaryType';
  applicantPlatform?: Maybe<Scalars['String']['output']>;
  applicantType?: Maybe<ApplicantBeneficiaryTypeEnum>;
  clientId: Scalars['String']['output'];
  createdAt: Scalars['String']['output'];
  email?: Maybe<Scalars['String']['output']>;
  externalUserId: Scalars['String']['output'];
  fixedInfo?: Maybe<ApplicantInfoType>;
  id: Scalars['String']['output'];
  info?: Maybe<ApplicantInfoType>;
  inspectionId: Scalars['String']['output'];
  lang?: Maybe<Scalars['String']['output']>;
  positions?: Maybe<Array<Scalars['String']['output']>>;
  questionnaires?: Maybe<Scalars['JSON']['output']>;
  requiredIdDocs?: Maybe<ApplicantRequiredIdDocsType>;
  review: ApplicantReviewInfoType;
  sourceKey?: Maybe<Scalars['String']['output']>;
  type: ApplicantTypeEnum;
};

export enum ApplicantBeneficiaryTypeEnum {
  Director = 'director',
  Representative = 'representative',
  Shareholder = 'shareholder',
  Ubo = 'ubo'
}

export type ApplicantDocSetType = {
  __typename?: 'ApplicantDocSetType';
  idDocSetType: ApplicantIdDocSetTypeEnum;
  types?: Maybe<Array<ApplicantDocumentTypeEnum>>;
};

export type ApplicantDocStatusType = {
  __typename?: 'ApplicantDocStatusType';
  status: ApplicantDocumentStatusType;
  type: ApplicantIdDocSetTypeEnum;
};

export enum ApplicantDocumentErrorTypeEnum {
  DataNotReadable = 'DATA_NOT_READABLE',
  DifferentDocTypeOrCountry = 'DIFFERENT_DOC_TYPE_OR_COUNTRY',
  DocumentWayTooMuchOutside = 'DOCUMENT_WAY_TOO_MUCH_OUTSIDE',
  ExpiredDoc = 'EXPIRED_DOC',
  ForbiddenDocument = 'FORBIDDEN_DOCUMENT',
  Grayscale = 'GRAYSCALE',
  MissingImportantInfo = 'MISSING_IMPORTANT_INFO',
  NoIdDocFacePhoto = 'NO_ID_DOC_FACE_PHOTO',
  SameSides = 'SAME_SIDES',
  Screenshot = 'SCREENSHOT',
  ScreenRecapture = 'SCREEN_RECAPTURE'
}

export type ApplicantDocumentImageReviewResultType = {
  __typename?: 'ApplicantDocumentImageReviewResultType';
  imageId: Scalars['String']['output'];
  /** A human-readable comment that can be shown to your end user */
  moderationComment?: Maybe<Scalars['String']['output']>;
  rejectLabels?: Maybe<Array<ApplicantDocumentRejectLabelEnum>>;
  reviewAnswer?: Maybe<ApplicantDocumentReviewAnswerEnum>;
  reviewRejectType?: Maybe<ApplicantDocumentReviewRejectTypeEnum>;
};

export enum ApplicantDocumentRejectLabelEnum {
  AdditionalDocumentRequired = 'ADDITIONAL_DOCUMENT_REQUIRED',
  AdverseMedia = 'ADVERSE_MEDIA',
  AgeRequirementMismatch = 'AGE_REQUIREMENT_MISMATCH',
  ApplicantInterruptedInterview = 'APPLICANT_INTERRUPTED_INTERVIEW',
  BackSideMissing = 'BACK_SIDE_MISSING',
  BadAvatar = 'BAD_AVATAR',
  BadFaceMatching = 'BAD_FACE_MATCHING',
  BadProofOfAddress = 'BAD_PROOF_OF_ADDRESS',
  BadProofOfIdentity = 'BAD_PROOF_OF_IDENTITY',
  BadProofOfPayment = 'BAD_PROOF_OF_PAYMENT',
  BadSelfie = 'BAD_SELFIE',
  BadVideoSelfie = 'BAD_VIDEO_SELFIE',
  Blacklist = 'BLACKLIST',
  BlackAndWhite = 'BLACK_AND_WHITE',
  Blocklist = 'BLOCKLIST',
  CheckUnavailable = 'CHECK_UNAVAILABLE',
  CompanyNotDefinedBeneficiaries = 'COMPANY_NOT_DEFINED_BENEFICIARIES',
  CompanyNotDefinedRepresentatives = 'COMPANY_NOT_DEFINED_REPRESENTATIVES',
  CompanyNotDefinedStructure = 'COMPANY_NOT_DEFINED_STRUCTURE',
  CompanyNotValidatedBeneficiaries = 'COMPANY_NOT_VALIDATED_BENEFICIARIES',
  CompanyNotValidatedRepresentatives = 'COMPANY_NOT_VALIDATED_REPRESENTATIVES',
  CompromisedPersons = 'COMPROMISED_PERSONS',
  ConnectionInterrupted = 'CONNECTION_INTERRUPTED',
  Criminal = 'CRIMINAL',
  DbDataMismatch = 'DB_DATA_MISMATCH',
  DbDataNotFound = 'DB_DATA_NOT_FOUND',
  DigitalDocument = 'DIGITAL_DOCUMENT',
  DocumentDamaged = 'DOCUMENT_DAMAGED',
  DocumentDeprived = 'DOCUMENT_DEPRIVED',
  DocumentMissing = 'DOCUMENT_MISSING',
  DocumentPageMissing = 'DOCUMENT_PAGE_MISSING',
  DocumentTemplate = 'DOCUMENT_TEMPLATE',
  Duplicate = 'DUPLICATE',
  ExperienceRequirementMismatch = 'EXPERIENCE_REQUIREMENT_MISMATCH',
  ExpirationDate = 'EXPIRATION_DATE',
  ExternalDecisionRejection = 'EXTERNAL_DECISION_REJECTION',
  Foreigner = 'FOREIGNER',
  Forgery = 'FORGERY',
  FraudulentLiveness = 'FRAUDULENT_LIVENESS',
  FraudulentPatterns = 'FRAUDULENT_PATTERNS',
  FrontSideMissing = 'FRONT_SIDE_MISSING',
  GraphicEditor = 'GRAPHIC_EDITOR',
  IdInvalid = 'ID_INVALID',
  IncompatibleLanguage = 'INCOMPATIBLE_LANGUAGE',
  IncompleteDocument = 'INCOMPLETE_DOCUMENT',
  InconsistentProfile = 'INCONSISTENT_PROFILE',
  IncorrectSocialNumber = 'INCORRECT_SOCIAL_NUMBER',
  LowQuality = 'LOW_QUALITY',
  NotAllChecksCompleted = 'NOT_ALL_CHECKS_COMPLETED',
  NotDocument = 'NOT_DOCUMENT',
  Ok = 'OK',
  Other = 'OTHER',
  Pep = 'PEP',
  ProblematicApplicantData = 'PROBLEMATIC_APPLICANT_DATA',
  RegulationsViolations = 'REGULATIONS_VIOLATIONS',
  RequestedDataMismatch = 'REQUESTED_DATA_MISMATCH',
  Sanctions = 'SANCTIONS',
  Screenshots = 'SCREENSHOTS',
  SelfieMismatch = 'SELFIE_MISMATCH',
  SelfieWithPaper = 'SELFIE_WITH_PAPER',
  Spam = 'SPAM',
  SuspiciousPatterns = 'SUSPICIOUS_PATTERNS',
  ThirdPartyInvolved = 'THIRD_PARTY_INVOLVED',
  UnfilledId = 'UNFILLED_ID',
  UnsatisfactoryPhotos = 'UNSATISFACTORY_PHOTOS',
  UnsuitableEnv = 'UNSUITABLE_ENV',
  UnsupportedLanguage = 'UNSUPPORTED_LANGUAGE',
  WrongAddress = 'WRONG_ADDRESS',
  WrongUserRegion = 'WRONG_USER_REGION'
}

export enum ApplicantDocumentReviewAnswerEnum {
  Green = 'GREEN',
  Red = 'RED'
}

export enum ApplicantDocumentReviewRejectTypeEnum {
  External = 'EXTERNAL',
  Final = 'FINAL',
  Retry = 'RETRY'
}

export type ApplicantDocumentStatusType = {
  __typename?: 'ApplicantDocumentStatusType';
  /** document country */
  country: Scalars['String']['output'];
  /** specific document type for the step */
  idDocType: ApplicantDocumentTypeEnum;
  /** image IDs that represent a document */
  imageIds: Array<Scalars['String']['output']>;
  imageReviewResults: Array<ApplicantDocumentImageReviewResultType>;
  stepStatuses?: Maybe<Array<ApplicantDocumentStepStatusType>>;
};

export type ApplicantDocumentStepStatusType = {
  __typename?: 'ApplicantDocumentStepStatusType';
  name: Scalars['String']['output'];
  reviewResult: ApplicantReviewResultType;
  reviewStatus: Scalars['String']['output'];
};

export enum ApplicantDocumentSubTypeEnum {
  BackSide = 'BACK_SIDE',
  FrontSide = 'FRONT_SIDE'
}

export type ApplicantDocumentType = {
  __typename?: 'ApplicantDocumentType';
  country: Scalars['String']['output'];
  errors?: Maybe<Array<ApplicantDocumentErrorTypeEnum>>;
  idDocType: Scalars['String']['output'];
  imageId: Scalars['String']['output'];
  warnings?: Maybe<Array<ApplicantDocumentWarningTypeEnum>>;
};

export enum ApplicantDocumentTypeEnum {
  Agreement = 'AGREEMENT',
  BankCard = 'BANK_CARD',
  BankStatement = 'BANK_STATEMENT',
  Contract = 'CONTRACT',
  Drivers = 'DRIVERS',
  DriversTranslation = 'DRIVERS_TRANSLATION',
  EmploymentCertificate = 'EMPLOYMENT_CERTIFICATE',
  IdCard = 'ID_CARD',
  IdDocPhoto = 'ID_DOC_PHOTO',
  IncomeSource = 'INCOME_SOURCE',
  InvestorDoc = 'INVESTOR_DOC',
  Other = 'OTHER',
  Passport = 'PASSPORT',
  PaymentMethod = 'PAYMENT_METHOD',
  ProfileImage = 'PROFILE_IMAGE',
  ResidencePermit = 'RESIDENCE_PERMIT',
  Selfie = 'SELFIE',
  UtilityBill = 'UTILITY_BILL',
  VehicleRegistrationCertificate = 'VEHICLE_REGISTRATION_CERTIFICATE',
  VideoSelfie = 'VIDEO_SELFIE'
}

export enum ApplicantDocumentWarningTypeEnum {
  BadSelfie = 'BAD_SELFIE',
  DataReadability = 'DATA_READABILITY',
  DocumentTooMuchOutside = 'DOCUMENT_TOO_MUCH_OUTSIDE',
  InconsistentDocument = 'INCONSISTENT_DOCUMENT',
  MaybeExpiredDoc = 'MAYBE_EXPIRED_DOC'
}

export type ApplicantDriversDocument = {
  __typename?: 'ApplicantDriversDocument';
  country?: Maybe<Scalars['String']['output']>;
  dob?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  firstNameEn?: Maybe<Scalars['String']['output']>;
  issueAuthority?: Maybe<Scalars['String']['output']>;
  issuedDate?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  lastNameEn?: Maybe<Scalars['String']['output']>;
  number?: Maybe<Scalars['String']['output']>;
  validUntil?: Maybe<Scalars['String']['output']>;
};

export enum ApplicantGenderEnum {
  F = 'F',
  M = 'M'
}

export type ApplicantGeneralReviewResultType = {
  __typename?: 'ApplicantGeneralReviewResultType';
  moderationComment?: Maybe<Scalars['String']['output']>;
  rejectLabels?: Maybe<Array<ApplicantDocumentRejectLabelEnum>>;
  reviewAnswer: ApplicantReviewAnswerEnum;
  reviewRejectType?: Maybe<ApplicantReviewRejectTypeEnum>;
};

export type ApplicantIdCardDocument = {
  __typename?: 'ApplicantIdCardDocument';
  country?: Maybe<Scalars['String']['output']>;
  dob?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  firstNameEn?: Maybe<Scalars['String']['output']>;
  issueAuthority?: Maybe<Scalars['String']['output']>;
  issuedDate?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  lastNameEn?: Maybe<Scalars['String']['output']>;
  number?: Maybe<Scalars['String']['output']>;
  validUntil?: Maybe<Scalars['String']['output']>;
};

export enum ApplicantIdDocSetTypeEnum {
  ApplicantData = 'APPLICANT_DATA',
  Company = 'COMPANY',
  Identity = 'IDENTITY',
  Identity2 = 'IDENTITY2',
  Investability = 'INVESTABILITY',
  PaymentMethods = 'PAYMENT_METHODS',
  ProofOfResidence = 'PROOF_OF_RESIDENCE',
  Questionnaire = 'QUESTIONNAIRE',
  Selfie = 'SELFIE',
  Selfie2 = 'SELFIE2'
}

export type ApplicantIdentityDocsType = {
  __typename?: 'ApplicantIdentityDocsType';
  drivers?: Maybe<ApplicantDriversDocument>;
  idCard?: Maybe<ApplicantIdCardDocument>;
  passport?: Maybe<ApplicantPassportDocument>;
  utilityBill?: Maybe<ApplicantUtilityBillDocument>;
};

export type ApplicantInfoType = {
  __typename?: 'ApplicantInfoType';
  addresses?: Maybe<Array<ApplicantAddressType>>;
  country?: Maybe<Scalars['String']['output']>;
  countryOfBirth?: Maybe<Scalars['String']['output']>;
  dob?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  firstNameEn?: Maybe<Scalars['String']['output']>;
  gender?: Maybe<ApplicantGenderEnum>;
  idDocs?: Maybe<ApplicantIdentityDocsType>;
  lastName?: Maybe<Scalars['String']['output']>;
  lastNameEn?: Maybe<Scalars['String']['output']>;
  legalName?: Maybe<Scalars['String']['output']>;
  middleName?: Maybe<Scalars['String']['output']>;
  middleNameEn?: Maybe<Scalars['String']['output']>;
  nationality?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  placeOfBirth?: Maybe<Scalars['String']['output']>;
};

export type ApplicantPassportDocument = {
  __typename?: 'ApplicantPassportDocument';
  country?: Maybe<Scalars['String']['output']>;
  dob?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  firstNameEn?: Maybe<Scalars['String']['output']>;
  issueAuthority?: Maybe<Scalars['String']['output']>;
  issuedDate?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  lastNameEn?: Maybe<Scalars['String']['output']>;
  mrzLine1?: Maybe<Scalars['String']['output']>;
  mrzLine2?: Maybe<Scalars['String']['output']>;
  mrzLine3?: Maybe<Scalars['String']['output']>;
  number?: Maybe<Scalars['String']['output']>;
  validUntil?: Maybe<Scalars['String']['output']>;
};

export type ApplicantRequiredIdDocsType = {
  __typename?: 'ApplicantRequiredIdDocsType';
  docSets: Array<ApplicantDocSetType>;
};

export enum ApplicantReviewAnswerEnum {
  Green = 'GREEN',
  Red = 'RED'
}

export type ApplicantReviewInfoType = {
  __typename?: 'ApplicantReviewInfoType';
  createDate: Scalars['String']['output'];
  elapsedSincePendingMs?: Maybe<Scalars['Float']['output']>;
  elapsedSinceQueuedMs?: Maybe<Scalars['Float']['output']>;
  levelName: Scalars['String']['output'];
  reprocessing?: Maybe<Scalars['Boolean']['output']>;
  reviewDate?: Maybe<Scalars['String']['output']>;
  reviewResult?: Maybe<ApplicantGeneralReviewResultType>;
  reviewStatus: ApplicantReviewStatusEnum;
  startDate?: Maybe<Scalars['String']['output']>;
};

export enum ApplicantReviewRejectTypeEnum {
  External = 'EXTERNAL',
  Final = 'FINAL',
  Retry = 'RETRY'
}

export type ApplicantReviewResultType = {
  __typename?: 'ApplicantReviewResultType';
  moderationComment?: Maybe<Scalars['String']['output']>;
  rejectLabels?: Maybe<Array<ApplicantDocumentRejectLabelEnum>>;
  reviewAnswer: ApplicantDocumentReviewAnswerEnum;
};

export enum ApplicantReviewStatusEnum {
  Completed = 'completed',
  Init = 'init',
  OnHold = 'onHold',
  Pending = 'pending',
  Queued = 'queued'
}

export type ApplicantType = {
  __typename?: 'ApplicantType';
  applicantPlatform?: Maybe<Scalars['String']['output']>;
  clientId: Scalars['String']['output'];
  createdAt: Scalars['String']['output'];
  email?: Maybe<Scalars['String']['output']>;
  externalUserId: Scalars['String']['output'];
  fixedInfo?: Maybe<ApplicantInfoType>;
  id: Scalars['String']['output'];
  info?: Maybe<ApplicantInfoType>;
  inspectionId: Scalars['String']['output'];
  lang?: Maybe<Scalars['String']['output']>;
  questionnaires?: Maybe<Scalars['JSON']['output']>;
  requiredIdDocs?: Maybe<ApplicantRequiredIdDocsType>;
  review: ApplicantReviewInfoType;
  sourceKey?: Maybe<Scalars['String']['output']>;
  type: ApplicantTypeEnum;
};

export enum ApplicantTypeEnum {
  Company = 'COMPANY',
  Individual = 'INDIVIDUAL'
}

export type ApplicantUtilityBillAddress = {
  __typename?: 'ApplicantUtilityBillAddress';
  country?: Maybe<Scalars['String']['output']>;
  postCode?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  stateEn?: Maybe<Scalars['String']['output']>;
  street?: Maybe<Scalars['String']['output']>;
  streetEn?: Maybe<Scalars['String']['output']>;
  subStreet?: Maybe<Scalars['String']['output']>;
  subStreetEn?: Maybe<Scalars['String']['output']>;
  town?: Maybe<Scalars['String']['output']>;
  townEn?: Maybe<Scalars['String']['output']>;
};

export type ApplicantUtilityBillDocument = {
  __typename?: 'ApplicantUtilityBillDocument';
  address?: Maybe<ApplicantUtilityBillAddress>;
  country?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  firstNameEn?: Maybe<Scalars['String']['output']>;
  issuedDate?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  lastNameEn?: Maybe<Scalars['String']['output']>;
  number?: Maybe<Scalars['String']['output']>;
  validUntil?: Maybe<Scalars['String']['output']>;
};

export type ApprovePaymentInput = {
  paymentId: Scalars['String']['input'];
  tokens: Array<VerifyTokenInput>;
};

export type ApproveUserPaymentInput = {
  paymentId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};

export type AttachDetachTagsInput = {
  attach?: InputMaybe<Array<Scalars['String']['input']>>;
  detach?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type Auth = {
  __typename?: 'Auth';
  accessToken: Scalars['String']['output'];
  expiresIn: Scalars['Float']['output'];
  idToken?: Maybe<Scalars['String']['output']>;
  refreshToken: Scalars['String']['output'];
  tokenType: Scalars['String']['output'];
};

export type AuthInput = {
  captcha: ReCaptchaInput;
  device: Device;
  identity: Scalars['String']['input'];
  messengerType?: InputMaybe<MessengerType>;
  password?: InputMaybe<Scalars['String']['input']>;
  service: Scalars['String']['input'];
  srp?: InputMaybe<SrpVerifyInput>;
};

export type AuthRegisterPhoneInput = {
  captcha: ReCaptchaInput;
  identity: Scalars['String']['input'];
};

export type AuthTfaSend = {
  operationId: Scalars['String']['input'];
  type: TfaType;
};

export enum AuthUserKybDocumentStatus {
  Pending = 'PENDING',
  WaitingForUploadDocument = 'WAITING_FOR_UPLOAD_DOCUMENT'
}

export type AuthVerify2FaInput = {
  /** token for PUSH notification */
  pushToken?: InputMaybe<Scalars['String']['input']>;
  tfaVerifyData: Verify2FaInput;
};

export type AuthorizedUser = {
  __typename?: 'AuthorizedUser';
  EOS?: Maybe<PublicKeyInfo>;
  appleUserId?: Maybe<Scalars['String']['output']>;
  avatar?: Maybe<File>;
  birthDate?: Maybe<Scalars['DateTime']['output']>;
  chatClientId?: Maybe<Scalars['String']['output']>;
  chatClientIdentity?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  email?: Maybe<EmailDeviceInfo>;
  /** User's extra data */
  extra?: Maybe<Scalars['JSON']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  gender?: Maybe<GenderEnum>;
  kybDocumentStatus: AuthUserKybDocumentStatus;
  language: Scalars['String']['output'];
  lastLoginDate?: Maybe<Scalars['DateTime']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  leadId?: Maybe<Scalars['String']['output']>;
  p256?: Maybe<PublicKeyInfo>;
  phone?: Maybe<PhoneDeviceInfo>;
  role: RoleEnum;
  service: Scalars['String']['output'];
  status: StatusEnum;
  sub?: Maybe<Scalars['String']['output']>;
  tariff: UserTariff;
  timezone: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  userId: Scalars['String']['output'];
  username?: Maybe<Scalars['String']['output']>;
};

export type Balance = {
  __typename?: 'Balance';
  available: Money;
  full: Money;
  held: Money;
};

export type BalanceCjIntegrations = {
  __typename?: 'BalanceCjIntegrations';
  crypto: Array<BalanceSystemAccount>;
  fiat: Array<BalanceSystemAccount>;
};

export type BalanceSystemAccount = {
  __typename?: 'BalanceSystemAccount';
  amount: Scalars['BigNumber']['output'];
  currencyTicker: Scalars['String']['output'];
};

export type BalanceSystemAccounts = {
  __typename?: 'BalanceSystemAccounts';
  cj: BalanceSystemCjAccounts;
};

export type BalanceSystemCjAccounts = {
  __typename?: 'BalanceSystemCjAccounts';
  cryptoExchange: BalanceCjIntegrations;
  nostroAbs: BalanceCjIntegrations;
  nostroCj: BalanceCjIntegrations;
};

export type Bank = {
  __typename?: 'Bank';
  address: Scalars['String']['output'];
  bicCode?: Maybe<Scalars['String']['output']>;
  bins: Bins;
  branches: Banks;
  city?: Maybe<City>;
  code: Scalars['String']['output'];
  country: Country;
  id: Scalars['ID']['output'];
  item: CommonDictItem;
  name: Scalars['String']['output'];
  parent?: Maybe<Bank>;
  sortCode?: Maybe<Scalars['String']['output']>;
};


export type BankBinsArgs = {
  input?: InputMaybe<DictionaryFilter>;
};


export type BankBranchesArgs = {
  input?: InputMaybe<DictionaryFilter>;
};

export type BankCreateDataInput = {
  address: Scalars['String']['input'];
  bicCode?: InputMaybe<Scalars['String']['input']>;
  cityId?: InputMaybe<Scalars['ID']['input']>;
  countryId: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  sortCode?: InputMaybe<Scalars['String']['input']>;
};

export type BankCreateInput = {
  bank: BankCreateDataInput;
  links?: InputMaybe<BankCreateLinksInput>;
};

export type BankCreateLinksInput = {
  attachBranchIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  attachParentId?: InputMaybe<Scalars['ID']['input']>;
};

export type BankDetail = {
  __typename?: 'BankDetail';
  accountHolder: Scalars['String']['output'];
  beneficiaryAccountNumber?: Maybe<Scalars['String']['output']>;
  beneficiaryAddress?: Maybe<Scalars['String']['output']>;
  beneficiaryBIC?: Maybe<Scalars['String']['output']>;
  beneficiaryBank: Scalars['String']['output'];
  beneficiaryIBAN?: Maybe<Scalars['String']['output']>;
  beneficiaryName: Scalars['String']['output'];
  beneficiarySortCode?: Maybe<Scalars['String']['output']>;
  clearJunctionIban?: Maybe<Scalars['String']['output']>;
  mandatoryReference: Scalars['String']['output'];
  userInternalIban: Scalars['String']['output'];
  walletId: Scalars['String']['output'];
};

export type BankDetails = {
  __typename?: 'BankDetails';
  count: Scalars['Int']['output'];
  cursor: Scalars['Int']['output'];
  nodes: Array<BankDetail>;
};

export type BankInfoInput = {
  bankAddress: Scalars['String']['input'];
  bankCityId: Scalars['ID']['input'];
  bankName: Scalars['String']['input'];
};

export type BankInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  bicCode?: InputMaybe<Scalars['String']['input']>;
  bin?: InputMaybe<Scalars['String']['input']>;
  cityId?: InputMaybe<Scalars['ID']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
  countryId?: InputMaybe<Scalars['ID']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  sortCode?: InputMaybe<Scalars['String']['input']>;
};

export type BankTransferFee = {
  __typename?: 'BankTransferFee';
  amountV2: PaymentsAmount;
  feeV2: PaymentsFee;
  totalAmountV2: PaymentsTotalAmount;
};

export type BankUpdateDataInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  bicCode?: InputMaybe<Scalars['String']['input']>;
  cityId?: InputMaybe<Scalars['ID']['input']>;
  countryId?: InputMaybe<Scalars['ID']['input']>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  sortCode?: InputMaybe<Scalars['String']['input']>;
};

export type BankUpdateInput = {
  bank: BankUpdateDataInput;
  links?: InputMaybe<BankUpdateLinksInput>;
};

export type BankUpdateLinksInput = {
  attachBranchIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  attachParentId?: InputMaybe<Scalars['ID']['input']>;
  detachBranchIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  detachParent?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Banks = {
  __typename?: 'Banks';
  count: Scalars['Int']['output'];
  cursor: Scalars['Int']['output'];
  nodes: Array<Bank>;
};

export type BanksInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  bicCode?: InputMaybe<Scalars['String']['input']>;
  cityId?: InputMaybe<Scalars['ID']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
  countryId?: InputMaybe<Scalars['ID']['input']>;
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  name?: InputMaybe<Scalars['String']['input']>;
  pagination?: InputMaybe<PaginationInput>;
  parentId?: InputMaybe<Scalars['ID']['input']>;
  sortCode?: InputMaybe<Scalars['String']['input']>;
};

export type BaseOrderFilter = {
  __typename?: 'BaseOrderFilter';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  owner: ExchangeService;
  /** JSON string with filter parameters. */
  parameters: BinanceFilterParameters;
  type: OrderFilterType;
};

export type Bin = {
  __typename?: 'Bin';
  bank?: Maybe<Bank>;
  bin: Scalars['String']['output'];
  /** The type of payment network. For example: VISA, MASTERCARD, AMERICAN EXPRESS, etc. */
  brand?: Maybe<Scalars['String']['output']>;
  country: Country;
  currency?: Maybe<Currency>;
  /** Untyped response from the provider */
  fullInfo?: Maybe<Scalars['JSON']['output']>;
  id: Scalars['ID']['output'];
  /** @deprecated The property will be removed, use 'issuerDetails.name' */
  issuer?: Maybe<Scalars['String']['output']>;
  issuerDetails: BinIssuerDetails;
  /** The level of the card. For example: CLASSIC, PREMIUM, WORLD, etc. */
  level?: Maybe<Scalars['String']['output']>;
  /** The type of the card. For example: CREDIT, DEBIT, PREPAID, etc. */
  type?: Maybe<Scalars['String']['output']>;
};

export type BinCreateInput = {
  bankId?: InputMaybe<Scalars['ID']['input']>;
  bin: Scalars['String']['input'];
  brand?: InputMaybe<Scalars['String']['input']>;
  countryId: Scalars['ID']['input'];
  currencyId?: InputMaybe<Scalars['ID']['input']>;
  fullInfo?: InputMaybe<Scalars['JSON']['input']>;
  issuer?: InputMaybe<Scalars['String']['input']>;
  issuerDetails: BinCreateIssuerDetailsInput;
  level?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type BinCreateIssuerDetailsInput = {
  name?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
};

export type BinIssuerDetails = {
  __typename?: 'BinIssuerDetails';
  name?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  website?: Maybe<Scalars['String']['output']>;
};

export type BinanceExchangeMaxNumAlgoOrdersParameters = {
  __typename?: 'BinanceExchangeMaxNumAlgoOrdersParameters';
  filterType: BinanceFilters;
  maxNumAlgoOrders: Scalars['BigNumber']['output'];
};

export type BinanceExchangeMaxNumOrdersFilterParameters = {
  __typename?: 'BinanceExchangeMaxNumOrdersFilterParameters';
  filterType: BinanceFilters;
  maxNumOrders: Scalars['BigNumber']['output'];
};

export type BinanceFilterParameters = BinanceExchangeMaxNumAlgoOrdersParameters | BinanceExchangeMaxNumOrdersFilterParameters | BinanceIcebergPartsFilterParameters | BinanceLotSizeFilterParameters | BinanceMarketLotSizeFilterParameters | BinanceMaxNumAlgoOrdersFilterParameters | BinanceMaxNumIcebergOrdersFilterParameters | BinanceMaxNumOrdersFilterParameters | BinanceMaxPositionFilterParameters | BinanceMinNotionalFilterParameters | BinancePercentPriceFilterParameters | BinancePriceFilterParameters | BinanceTrailingDeltaFilterParameters;

export enum BinanceFilters {
  ExchangeMaxNumAlgoOrders = 'EXCHANGE_MAX_NUM_ALGO_ORDERS',
  ExchangeMaxNumOrders = 'EXCHANGE_MAX_NUM_ORDERS',
  IcebergParts = 'ICEBERG_PARTS',
  LotSize = 'LOT_SIZE',
  MarketLotSize = 'MARKET_LOT_SIZE',
  MaxNumAlgoOrders = 'MAX_NUM_ALGO_ORDERS',
  MaxNumIcebergOrders = 'MAX_NUM_ICEBERG_ORDERS',
  MaxNumOrders = 'MAX_NUM_ORDERS',
  MaxPosition = 'MAX_POSITION',
  MinNotional = 'MIN_NOTIONAL',
  PercentPrice = 'PERCENT_PRICE',
  PercentPriceBySide = 'PERCENT_PRICE_BY_SIDE',
  PriceFilter = 'PRICE_FILTER',
  TrailingDelta = 'TRAILING_DELTA'
}

export type BinanceIcebergPartsFilterParameters = {
  __typename?: 'BinanceIcebergPartsFilterParameters';
  filterType: BinanceFilters;
  limit: Scalars['BigNumber']['output'];
};

export type BinanceLotSizeFilterParameters = {
  __typename?: 'BinanceLotSizeFilterParameters';
  filterType: BinanceFilters;
  maxQty: Scalars['BigNumber']['output'];
  minQty: Scalars['BigNumber']['output'];
  reverseStepSize: Scalars['BigNumber']['output'];
  stepSize: Scalars['BigNumber']['output'];
};

export type BinanceMarketLotSizeFilterParameters = {
  __typename?: 'BinanceMarketLotSizeFilterParameters';
  filterType: BinanceFilters;
  maxQty: Scalars['BigNumber']['output'];
  minQty: Scalars['BigNumber']['output'];
  stepSize: Scalars['BigNumber']['output'];
};

export type BinanceMaxNumAlgoOrdersFilterParameters = {
  __typename?: 'BinanceMaxNumAlgoOrdersFilterParameters';
  filterType: BinanceFilters;
  maxNumAlgoOrders: Scalars['BigNumber']['output'];
};

export type BinanceMaxNumIcebergOrdersFilterParameters = {
  __typename?: 'BinanceMaxNumIcebergOrdersFilterParameters';
  filterType: BinanceFilters;
  maxNumIcebergOrders: Scalars['BigNumber']['output'];
};

export type BinanceMaxNumOrdersFilterParameters = {
  __typename?: 'BinanceMaxNumOrdersFilterParameters';
  filterType: BinanceFilters;
  maxNumOrders: Scalars['BigNumber']['output'];
};

export type BinanceMaxPositionFilterParameters = {
  __typename?: 'BinanceMaxPositionFilterParameters';
  filterType: BinanceFilters;
  maxPosition: Scalars['BigNumber']['output'];
};

export type BinanceMinNotionalFilterParameters = {
  __typename?: 'BinanceMinNotionalFilterParameters';
  applyToMarket: Scalars['Boolean']['output'];
  avgPriceMins: Scalars['BigNumber']['output'];
  filterType: BinanceFilters;
  minNotional: Scalars['BigNumber']['output'];
};

export type BinancePercentPriceFilterParameters = {
  __typename?: 'BinancePercentPriceFilterParameters';
  avgPriceMins: Scalars['BigNumber']['output'];
  filterType: BinanceFilters;
  multiplierDown: Scalars['BigNumber']['output'];
  multiplierUp: Scalars['BigNumber']['output'];
};

export type BinancePriceFilterParameters = {
  __typename?: 'BinancePriceFilterParameters';
  filterType: BinanceFilters;
  maxPrice: Scalars['BigNumber']['output'];
  minPrice: Scalars['BigNumber']['output'];
  tickSize: Scalars['BigNumber']['output'];
};

export type BinanceTrailingDeltaFilterParameters = {
  __typename?: 'BinanceTrailingDeltaFilterParameters';
  filterType: BinanceFilters;
  maxTrailingAboveDelta: Scalars['BigNumber']['output'];
  maxTrailingBelowDelta: Scalars['BigNumber']['output'];
  minTrailingAboveDelta: Scalars['BigNumber']['output'];
  minTrailingBelowDelta: Scalars['BigNumber']['output'];
};

export type BindIndividualApplicantToCompanyInput = {
  externalCompanyId: Scalars['ID']['input'];
  externalUserId: Scalars['ID']['input'];
  positions?: InputMaybe<Array<Scalars['String']['input']>>;
  type: ApplicantBeneficiaryTypeEnum;
};

export type BindOperationToTariffInput = {
  operationId: Scalars['ID']['input'];
  tariffId: Scalars['ID']['input'];
};

export type BindUnbindLimitToTariffOperationInput = {
  limitId: Scalars['ID']['input'];
  operationId: Scalars['ID']['input'];
  tariffId: Scalars['ID']['input'];
};

export type Bins = {
  __typename?: 'Bins';
  count: Scalars['Int']['output'];
  cursor: Scalars['Int']['output'];
  nodes: Array<Bin>;
};

export type BlockAccountInput = {
  accountId: Scalars['ID']['input'];
  reasons: Array<Scalars['String']['input']>;
};

export type BlockCompanyInput = {
  id: Scalars['ID']['input'];
  reasons: Array<Scalars['String']['input']>;
};

export type BlockUserInput = {
  id: Scalars['ID']['input'];
  reasons: Array<Scalars['String']['input']>;
};

export type BoundIndividualCompanyApplicant = {
  __typename?: 'BoundIndividualCompanyApplicant';
  applicant: ApplicantType;
  applicantId: Scalars['String']['output'];
  positions: Array<Scalars['String']['output']>;
  type: ApplicantBeneficiaryTypeEnum;
};

export type BusinessActivities = {
  __typename?: 'BusinessActivities';
  count: Scalars['Int']['output'];
  cursor: Scalars['Int']['output'];
  nodes: Array<BusinessActivity>;
};

export type BusinessActivity = {
  __typename?: 'BusinessActivity';
  children: BusinessActivities;
  classificationSystem: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  item: CommonDictItem;
  level: Scalars['Int']['output'];
  parent?: Maybe<BusinessActivity>;
};


export type BusinessActivityChildrenArgs = {
  input?: InputMaybe<GetBusinessActivitiesInput>;
};

export type CaptchaInput = {
  /** An action that is protected by a reCAPTCHA, for example: SIGN_IN, SEND_SMS */
  captchaAction?: InputMaybe<Scalars['String']['input']>;
  /** reCAPTCHA token */
  captchaToken: Scalars['String']['input'];
};

export type CardData = {
  __typename?: 'CardData';
  bin: Scalars['String']['output'];
  cardCategory?: Maybe<Scalars['String']['output']>;
  cardType?: Maybe<Scalars['String']['output']>;
  expiryMonth: Scalars['Float']['output'];
  expiryYear: Scalars['Float']['output'];
  issuer?: Maybe<Scalars['String']['output']>;
  issuerCountry?: Maybe<Scalars['String']['output']>;
  last4: Scalars['String']['output'];
  productId?: Maybe<Scalars['String']['output']>;
  productType?: Maybe<Scalars['String']['output']>;
  scheme?: Maybe<Scalars['String']['output']>;
  token: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

/** This input represents card data received from checkout after requesting a token */
export type CardDataInput = {
  bin: Scalars['String']['input'];
  cardCategory: Scalars['String']['input'];
  cardType: Scalars['String']['input'];
  expiryMonth: Scalars['Float']['input'];
  expiryYear: Scalars['Float']['input'];
  issuer: Scalars['String']['input'];
  issuerCountry: Scalars['String']['input'];
  last4: Scalars['String']['input'];
  productId: Scalars['String']['input'];
  productType: Scalars['String']['input'];
  scheme: Scalars['String']['input'];
  type: Scalars['String']['input'];
};

export type CardTopUpConfig = {
  __typename?: 'CardTopUpConfig';
  clientEeaFinancialInstitutionsContractId: Scalars['String']['output'];
  clientNonEeaFinancialInstitutionsContractId: Scalars['String']['output'];
  clientUkFinancialInstitutionsContractId: Scalars['String']['output'];
  corporateClientTransitContractId: Scalars['String']['output'];
  corporateInwardPaymentsIncomeContractId: Scalars['String']['output'];
  dailyLimit: Scalars['Float']['output'];
  defaultFee: Scalars['BigNumber']['output'];
  defaultFeeMargin: Scalars['BigNumber']['output'];
  feePercentage: Scalars['BigNumber']['output'];
  minimalLimit: Scalars['Float']['output'];
  monthlyLimit: Scalars['Float']['output'];
  otherDirectCostsContractId: Scalars['String']['output'];
  otherReceivablesContractId: Scalars['String']['output'];
  ownEeaFinancialInstitutionsContractId: Scalars['String']['output'];
  ownNonEeaFinancialInstitutionsContractId: Scalars['String']['output'];
  ownUkFinancialInstitutionsContractId: Scalars['String']['output'];
  payablesSettlementContractId: Scalars['String']['output'];
  physicalClientTransitContractId: Scalars['String']['output'];
  physicalInwardPaymentsIncomeContractId: Scalars['String']['output'];
  provisionContractId: Scalars['String']['output'];
  receivablesFromCustomersContractId: Scalars['String']['output'];
  transactionLimit: Scalars['Float']['output'];
};

export type CardTopUpFee = {
  __typename?: 'CardTopUpFee';
  fee: Scalars['BigNumber']['output'];
};

export type ChangeApplicantLevelInput = {
  externalUserId: Scalars['String']['input'];
  levelName: Scalars['String']['input'];
};

export type ChangeBaseCurrencyLimitInput = {
  attachLimitId: Scalars['ID']['input'];
  operationId: Scalars['ID']['input'];
  tariffId: Scalars['ID']['input'];
};

export type ChangeIdentityInput = {
  messengerType?: InputMaybe<MessengerType>;
  /** New identity */
  newIdentity: Scalars['String']['input'];
  type: IdentityType;
};

export type ChangeIdentityResponseType = {
  __typename?: 'ChangeIdentityResponseType';
  newIdentity2fa: CheckResendOneTimeCodeType;
  oldIdentity2fa?: Maybe<Send2FaTokenResponse>;
};

export type ChangePasswordInput = {
  newPassword?: InputMaybe<Scalars['String']['input']>;
  /** Deprecated: this field is not longer used */
  oldPassword?: InputMaybe<Scalars['String']['input']>;
  srp?: InputMaybe<SrpInfo>;
};

export type ChangePasswordNew = {
  oldPassword?: InputMaybe<Scalars['String']['input']>;
  srp?: InputMaybe<SrpVerifyInput>;
};

export type ChangePasswordV2Input = {
  messengerType?: InputMaybe<MessengerType>;
  oldPassword?: InputMaybe<Scalars['String']['input']>;
  srp?: InputMaybe<SrpVerifyInput>;
};

export type ChangeUserStatusInput = {
  service: Scalars['String']['input'];
  status: StatusEnum;
  userId: Scalars['String']['input'];
};

export type CheckOutgoingPaymentInput = {
  options: CheckOutgoingPaymentOptionsInput;
  payment: SendSystemPaymentInput;
};

export type CheckOutgoingPaymentOptionsInput = {
  checkSenderBalance?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CheckOutgoingPaymentResult = {
  __typename?: 'CheckOutgoingPaymentResult';
  errors: Array<Scalars['String']['output']>;
  result: Scalars['Boolean']['output'];
};

/**
 * Description: input data for getting the remaining code lifetime
 *
 * Example:
 *
 *
 *
 * {
 *
 *
 * "deviceId": "64a5448c7e019dbee9006f62",
 *
 *
 * "device": "EMAIL",
 *
 *
 * "operationTitle": "REGISTRATION"
 *
 *
 * }
 */
export type CheckResendOneTimeCodeInput = {
  /**
   * Required: true
   *
   * Description: device type
   *
   * Format:
   *
   *         string parameter from custom enum
   *
   *
   * Example:
   *
   *         "EMAIL"
   */
  device: Device;
  /**
   * Required: true
   *
   * Description: device Id
   *
   * Additional info:
   *
   *         24 hex characters from a MongoDB ID
   *
   *
   * Format:
   *
   *         24 hexadecimal characters
   *
   *
   * Example:
   *
   *         64a5448c7e019dbee9006f62
   */
  deviceId: Scalars['String']['input'];
  /**
   * Required: true
   *
   * Description: operation title
   *
   * Example:
   *
   *         REGISTRATION
   */
  operationTitle: Scalars['String']['input'];
};

/** returns information by resend one time code */
export type CheckResendOneTimeCodeType = {
  __typename?: 'CheckResendOneTimeCodeType';
  /**
   * Required: true
   *
   * Description: device type
   *
   * Format:
   *
   *         string parameter from custom enum
   *
   *
   * Example:
   *
   *         "EMAIL"
   */
  device: Device;
  /**
   * Required: true
   *
   * Description: device Id
   *
   * Additional info:
   *
   *         24 hex characters from a MongoDB ID
   *
   *
   * Format:
   *
   *         24 hexadecimal characters
   *
   *
   * Example:
   *
   *         64a5448c7e019dbee9006f62
   */
  deviceId: Scalars['String']['output'];
  /**
   * Required: false
   *
   * Description: the time when you can resend the confirmation code
   *
   * Format:
   *
   *         Date
   *
   *
   * Example:
   *
   *         "2022-03-06T08:23:45.000Z"
   */
  emailRetryAfter?: Maybe<Scalars['DateTime']['output']>;
  /**
   * Required: false
   *
   * Description: timer that shows how long it takes to resend an EMAIL
   *
   * Format:
   *
   *         milliseconds
   *
   *
   * Example:
   *
   *         45000
   */
  emailTimeout?: Maybe<Scalars['Float']['output']>;
  /**
   * Required: false
   *
   * Description: the time when you can resend the confirmation code
   *
   * Format:
   *
   *         Date
   *
   *
   * Example:
   *
   *         "2022-03-06T08:23:45.000Z"
   */
  smsRetryAfter?: Maybe<Scalars['DateTime']['output']>;
  /**
   * Required: false
   *
   * Description: timer that shows how long it takes to resend an SMS
   *
   * Format:
   *
   *         milliseconds
   *
   *
   * Example:
   *
   *         45000
   */
  smsTimeout?: Maybe<Scalars['Float']['output']>;
};

export type CheckSrpInput = {
  device: Device;
  identity: Scalars['String']['input'];
  service: Scalars['String']['input'];
};

export type Checkout3ds = {
  __typename?: 'Checkout3ds';
  downgraded: Scalars['Boolean']['output'];
  enrolled: Scalars['String']['output'];
};

export type Checkout3dsInput = {
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CheckoutCustomerInput = {
  email: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type CheckoutHref = {
  __typename?: 'CheckoutHref';
  href: Scalars['String']['output'];
};

export type CheckoutLinks = {
  __typename?: 'CheckoutLinks';
  redirect?: Maybe<CheckoutHref>;
  self: CheckoutHref;
};

export type CheckoutPayment = {
  __typename?: 'CheckoutPayment';
  id: Scalars['String']['output'];
  links: CheckoutLinks;
  reference: Scalars['String']['output'];
  secure3d: Checkout3ds;
  status: CheckoutStatus;
};

export enum CheckoutPaymentType {
  Id = 'ID',
  Token = 'TOKEN'
}

export type CheckoutSourceInput = {
  id?: InputMaybe<Scalars['String']['input']>;
  token?: InputMaybe<Scalars['String']['input']>;
  type: CheckoutPaymentType;
};

export enum CheckoutStatus {
  Approved = 'APPROVED',
  Canceled = 'CANCELED',
  Captured = 'CAPTURED',
  CaptureDeclined = 'CAPTURE_DECLINED',
  CapturePending = 'CAPTURE_PENDING',
  Declined = 'DECLINED',
  Expired = 'EXPIRED',
  Pending = 'PENDING',
  Refunded = 'REFUNDED',
  RefundDeclined = 'REFUND_DECLINED',
  RefundPending = 'REFUND_PENDING',
  Voided = 'VOIDED',
  VoidDeclined = 'VOID_DECLINED'
}

export enum CheckoutTokenType {
  Applepay = 'APPLEPAY',
  Card = 'CARD',
  Googlepay = 'GOOGLEPAY'
}

export type Cities = {
  __typename?: 'Cities';
  count: Scalars['Int']['output'];
  nodes: Array<City>;
};

export type CitiesV2 = {
  __typename?: 'CitiesV2';
  count: Scalars['Int']['output'];
  cursor: Scalars['Int']['output'];
  nodes: Array<City>;
};

export type City = {
  __typename?: 'City';
  country?: Maybe<Country>;
  id: Scalars['ID']['output'];
  item: CommonDictItem;
  region?: Maybe<Region>;
};

export type CityByNameInput = {
  /** [Dictionary] Represents name by which search query will be executed */
  address: Scalars['String']['input'];
  /** [Dictionary] Represents country by which search query will be executed */
  countryId: Scalars['String']['input'];
};

export type CityInput = {
  /** [Dictionary] Unique identifier of country in which city is located */
  countryId: Scalars['ID']['input'];
  item: CommonDictItemInput;
  /** [Dictionary] Unique identifier of region in which city is located */
  regionId?: InputMaybe<Scalars['ID']['input']>;
};

export enum ClearJunctionWalletEnum {
  Crypto = 'CRYPTO',
  Fiat = 'FIAT'
}

export type CoinNetwork = {
  __typename?: 'CoinNetwork';
  addressRegex: Scalars['String']['output'];
  coin: Scalars['String']['output'];
  depositDesc: Scalars['String']['output'];
  depositEnable: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  isDefault: Scalars['Boolean']['output'];
  memoRegex: Scalars['String']['output'];
  name: Scalars['String']['output'];
  network: Scalars['String']['output'];
  resetAddressStatus: Scalars['Boolean']['output'];
  sameAddress: Scalars['Boolean']['output'];
  specialTips?: Maybe<Scalars['String']['output']>;
  withdrawDesc: Scalars['String']['output'];
  withdrawEnable: Scalars['Boolean']['output'];
  withdrawFee: Scalars['String']['output'];
  withdrawIntegerMultiple: Scalars['String']['output'];
  withdrawMax: Scalars['String']['output'];
  withdrawMin: Scalars['String']['output'];
};

/**
 * Description: input to get the verification types used by the user at the time the user performed the operation
 *
 * Example:
 *
 *
 *
 * {
 *
 *
 * "operationId": "08a16b83-9094-4e89-8c05-2ccadd5c1c7e",
 *
 *
 * "operationTitle": "BUYCRYPTO"
 *
 *
 * }
 */
export type Common2FaInput = {
  /**
   * Required: true
   *
   * Description: Operation identifier
   *
   * Format:
   *
   *         uuid v4
   */
  operationId?: InputMaybe<Scalars['String']['input']>;
  /**
   * Required: false
   *
   * Description: title type
   *
   * Format:
   *
   *         string parameters from custom enum
   *
   *
   * Example:
   *
   *         "BUYCRYPTO"
   */
  operationTitle?: InputMaybe<Scalars['String']['input']>;
};

export type CommonDictItem = {
  __typename?: 'CommonDictItem';
  /**
   * [Dictionary] Represents item code
   * Contains unique data for different parent types (city, country, measure unit, language, currency etc.)
   */
  code: Scalars['String']['output'];
  /** [Dictionary] Represents common item fields */
  common: CommonItemInfo;
  /** [Dictionary] Unique identified */
  id: Scalars['ID']['output'];
  /** [Dictionary] Representation of item name in chosen language */
  localizedNames?: Maybe<Array<Maybe<LocalizedName>>>;
  /** [Dictionary] Represents item name */
  name: Scalars['String']['output'];
  /** [Dictionary] Item custon tags */
  tags?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type CommonDictItemLocalizedNamesArgs = {
  langId?: InputMaybe<Scalars['ID']['input']>;
};

export type CommonDictItemInput = {
  code: Scalars['String']['input'];
  localizedNames: Array<InputMaybe<LocalizedNameInput>>;
  name: Scalars['String']['input'];
  tags?: InputMaybe<AttachDetachTagsInput>;
};

export type CommonItemInfo = {
  __typename?: 'CommonItemInfo';
  isDeleted: Scalars['Boolean']['output'];
  timestamps: Timestamps;
};

export type CommonSort = {
  createdAt?: InputMaybe<Scalars['Boolean']['input']>;
  updateAt?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Companies = {
  __typename?: 'Companies';
  count: Scalars['Int']['output'];
  cursor: Scalars['Int']['output'];
  nodes: Array<Company>;
};

export type CompaniesDateRangeInput = {
  dateFrom?: InputMaybe<Scalars['String']['input']>;
  dateTo?: InputMaybe<Scalars['String']['input']>;
};

export type Company = {
  __typename?: 'Company';
  absCustomer?: Maybe<Customer>;
  additionalInfos: AdditionalInfos;
  addresses: Addresses;
  annualTurnover?: Maybe<FinancialAmountType>;
  blockReasons?: Maybe<Array<Scalars['String']['output']>>;
  businessActivities?: Maybe<Array<BusinessActivity>>;
  businessEmail?: Maybe<Scalars['String']['output']>;
  businessPhone?: Maybe<Scalars['String']['output']>;
  businessProfit?: Maybe<FinancialAmountType>;
  childCompanies?: Maybe<Companies>;
  companyOwnershipStructure?: Maybe<CompanyOwnershipStructure>;
  companyType?: Maybe<CompanyType>;
  controlSchema?: Maybe<Scalars['String']['output']>;
  countryOfIncorporation?: Maybe<Country>;
  createdAt: Scalars['DateTime']['output'];
  currentKYBLevelStatus?: Maybe<KybLevelStatus>;
  currentKYBLevelStatusV2?: Maybe<KybLevelStatusV2>;
  dateOfIncorporation?: Maybe<Scalars['DateTime']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  detailsSourceOfWealth?: Maybe<Array<DetailSourceOfWealth>>;
  documents: Documents;
  employmentIncome?: Maybe<FinancialAmountType>;
  faxNumber?: Maybe<Scalars['String']['output']>;
  finalDecision?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  incomingPaymentsByCountries?: Maybe<Array<PaymentFlowByCountryType>>;
  incomingPaymentsByCurrencies?: Maybe<Array<PaymentFlowByCurrencyType>>;
  isInternalTransferAllowed: Scalars['Boolean']['output'];
  kybLevelStatuses: KybLevelStatuses;
  kybLevelStatusesV2: KybLevelStatusesV2;
  loan?: Maybe<FinancialAmountType>;
  members: CompanyMembers;
  metadata: Scalars['JSON']['output'];
  name?: Maybe<Scalars['String']['output']>;
  otherPlannedAccountUse?: Maybe<Scalars['String']['output']>;
  otherPurposeForAccountOpening?: Maybe<Scalars['String']['output']>;
  otherReasonsForAccountOpening?: Maybe<Scalars['String']['output']>;
  otherSourceOfFunds?: Maybe<Scalars['String']['output']>;
  otherSourceOfWealth?: Maybe<Scalars['String']['output']>;
  outgoingPaymentsByCountries?: Maybe<Array<PaymentFlowByCountryType>>;
  outgoingPaymentsByCurrencies?: Maybe<Array<PaymentFlowByCurrencyType>>;
  paidUpShareCapital?: Maybe<FinancialAmountType>;
  parentCompany?: Maybe<Company>;
  parentCompanyId?: Maybe<Scalars['String']['output']>;
  plannedAccountUse?: Maybe<Array<Scalars['String']['output']>>;
  potentialRisks: PotentialRisks;
  purposeForAccountOpening?: Maybe<Array<Scalars['String']['output']>>;
  reasonsForAccountOpening?: Maybe<Array<Scalars['String']['output']>>;
  registeredBusinessName?: Maybe<Scalars['String']['output']>;
  registrant: CompanyMember;
  registrationLocation?: Maybe<Scalars['String']['output']>;
  registrationNumber?: Maybe<Scalars['String']['output']>;
  savingsAndDeposit?: Maybe<FinancialAmountType>;
  scoringRiskLevel?: Maybe<Scalars['String']['output']>;
  service: Scalars['String']['output'];
  share?: Maybe<Scalars['Float']['output']>;
  sourceOfFunds?: Maybe<Array<Scalars['String']['output']>>;
  sourceOfFundsV2?: Maybe<Array<SourceOfFundsV2>>;
  sourceOfWealth?: Maybe<Array<Scalars['String']['output']>>;
  taxId?: Maybe<Scalars['String']['output']>;
  taxNumber?: Maybe<Scalars['String']['output']>;
  totalNumberOfEmployees?: Maybe<Scalars['String']['output']>;
  totalScore?: Maybe<Scalars['String']['output']>;
  totalShare: Scalars['Float']['output'];
  tradingName?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  website?: Maybe<Scalars['String']['output']>;
};


export type CompanyAdditionalInfosArgs = {
  input: FindAdditionalInfosInput;
};


export type CompanyAddressesArgs = {
  input: FilterInput;
};


export type CompanyChildCompaniesArgs = {
  input: FilterInput;
};


export type CompanyDocumentsArgs = {
  input: FilterInput;
};


export type CompanyKybLevelStatusesArgs = {
  input: FilterInput;
};


export type CompanyKybLevelStatusesV2Args = {
  input: FilterInput;
};


export type CompanyMembersArgs = {
  input: FindMembersInput;
};

export type CompanyApplicant = {
  __typename?: 'CompanyApplicant';
  clientId: Scalars['String']['output'];
  createdAt: Scalars['String']['output'];
  externalUserId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  info?: Maybe<CompanyApplicantInfoType>;
  inspectionId: Scalars['String']['output'];
  questionnaires?: Maybe<Scalars['JSON']['output']>;
  review: ApplicantReviewInfoType;
  sourceKey?: Maybe<Scalars['String']['output']>;
  type: ApplicantTypeEnum;
};

export type CompanyApplicantBeneficiariesType = {
  __typename?: 'CompanyApplicantBeneficiariesType';
  companies?: Maybe<Array<CompanyApplicantBeneficiaryType>>;
  individuals?: Maybe<Array<ApplicantBeneficiaryType>>;
};

export type CompanyApplicantBeneficiaryType = {
  __typename?: 'CompanyApplicantBeneficiaryType';
  applicantType?: Maybe<ApplicantBeneficiaryTypeEnum>;
  clientId: Scalars['String']['output'];
  createdAt: Scalars['String']['output'];
  externalUserId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  info?: Maybe<CompanyApplicantInfoType>;
  inspectionId: Scalars['String']['output'];
  positions?: Maybe<Array<Scalars['String']['output']>>;
  questionnaires?: Maybe<Scalars['JSON']['output']>;
  review: ApplicantReviewInfoType;
  sourceKey?: Maybe<Scalars['String']['output']>;
  type: ApplicantTypeEnum;
};

export type CompanyApplicantDocStatusType = {
  __typename?: 'CompanyApplicantDocStatusType';
  status: CompanyApplicantDocumentStatusType;
  type: CompanyApplicantIdDocSetType;
};

export type CompanyApplicantDocumentStatusType = {
  __typename?: 'CompanyApplicantDocumentStatusType';
  /** document country */
  country?: Maybe<Scalars['String']['output']>;
  /** specific document type for the step */
  idDocType?: Maybe<CompanyApplicantDocumentTypeEnum>;
  /** image IDs that represent a document */
  imageIds?: Maybe<Array<Scalars['String']['output']>>;
  imageReviewResults: Array<ApplicantDocumentImageReviewResultType>;
  stepStatuses?: Maybe<Array<CompanyApplicantDocumentStepStatusType>>;
};

export type CompanyApplicantDocumentStepImageDataType = {
  __typename?: 'CompanyApplicantDocumentStepImageDataType';
  idDocSetType?: Maybe<CompanyApplicantIdDocSetType>;
  idDocType?: Maybe<CompanyApplicantDocumentTypeEnum>;
  imageId?: Maybe<Scalars['ID']['output']>;
  reviewResult?: Maybe<ApplicantReviewResultType>;
};

export type CompanyApplicantDocumentStepStatusType = {
  __typename?: 'CompanyApplicantDocumentStepStatusType';
  images?: Maybe<Array<CompanyApplicantDocumentStepImageDataType>>;
  name: Scalars['String']['output'];
  reviewResult?: Maybe<ApplicantReviewResultType>;
  reviewStatus: Scalars['String']['output'];
};

export enum CompanyApplicantDocumentTypeEnum {
  CompanyDoc = 'COMPANY_DOC',
  PowerOfAttorney = 'POWER_OF_ATTORNEY'
}

export enum CompanyApplicantIdDocSetType {
  Company = 'COMPANY',
  EmailVerification = 'EMAIL_VERIFICATION',
  PhoneVerification = 'PHONE_VERIFICATION',
  Questionnaire = 'QUESTIONNAIRE'
}

export type CompanyApplicantInfoInput = {
  companyInfo: CreateCompanyApplicantInfoInput;
};

export type CompanyApplicantInfoType = {
  __typename?: 'CompanyApplicantInfoType';
  address?: Maybe<ApplicantAddressType>;
  beneficiaries?: Maybe<CompanyApplicantBeneficiariesType>;
  companyName?: Maybe<Scalars['String']['output']>;
  controlScheme?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  incorporatedOn?: Maybe<Scalars['String']['output']>;
  legalAddress?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  postalAddress?: Maybe<Scalars['String']['output']>;
  registrationLocation?: Maybe<Scalars['String']['output']>;
  registrationNumber?: Maybe<Scalars['String']['output']>;
  taxId?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  website?: Maybe<Scalars['String']['output']>;
};

export type CompanyBeneficiaries = {
  __typename?: 'CompanyBeneficiaries';
  count: Scalars['Int']['output'];
  cursor: Scalars['Int']['output'];
  nodes: Array<CompanyBeneficiary>;
};

export type CompanyBeneficiary = {
  __typename?: 'CompanyBeneficiary';
  annualTurnover?: Maybe<FinancialAmountType>;
  businessActivities?: Maybe<Array<BusinessActivity>>;
  businessEmail?: Maybe<Scalars['String']['output']>;
  businessPhone?: Maybe<Scalars['String']['output']>;
  businessProfit?: Maybe<FinancialAmountType>;
  companyBeneficiaries?: Maybe<CompanyBeneficiaries>;
  companyOwnershipStructure?: Maybe<CompanyOwnershipStructure>;
  companyType?: Maybe<CompanyType>;
  controlSchema?: Maybe<Scalars['String']['output']>;
  countryOfIncorporation?: Maybe<Country>;
  createdAt: Scalars['DateTime']['output'];
  dateOfIncorporation?: Maybe<Scalars['DateTime']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  detailsSourceOfWealth?: Maybe<Array<DetailSourceOfWealth>>;
  employmentIncome?: Maybe<FinancialAmountType>;
  faxNumber?: Maybe<Scalars['String']['output']>;
  finalDecision?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  incomingPaymentsByCountries?: Maybe<Array<PaymentFlowByCountryType>>;
  incomingPaymentsByCurrencies?: Maybe<Array<PaymentFlowByCurrencyType>>;
  individualBeneficiaries?: Maybe<IndividualBeneficiaries>;
  isInternalTransferAllowed: Scalars['Boolean']['output'];
  loan?: Maybe<FinancialAmountType>;
  metadata: Scalars['JSON']['output'];
  name?: Maybe<Scalars['String']['output']>;
  otherPlannedAccountUse?: Maybe<Scalars['String']['output']>;
  otherPurposeForAccountOpening?: Maybe<Scalars['String']['output']>;
  otherReasonsForAccountOpening?: Maybe<Scalars['String']['output']>;
  otherSourceOfFunds?: Maybe<Scalars['String']['output']>;
  otherSourceOfWealth?: Maybe<Scalars['String']['output']>;
  outgoingPaymentsByCountries?: Maybe<Array<PaymentFlowByCountryType>>;
  outgoingPaymentsByCurrencies?: Maybe<Array<PaymentFlowByCurrencyType>>;
  paidUpShareCapital?: Maybe<FinancialAmountType>;
  parent?: Maybe<CompanyUnion>;
  parentCompanyId?: Maybe<Scalars['String']['output']>;
  plannedAccountUse?: Maybe<Array<Scalars['String']['output']>>;
  purposeForAccountOpening?: Maybe<Array<Scalars['String']['output']>>;
  reasonsForAccountOpening?: Maybe<Array<Scalars['String']['output']>>;
  registeredBusinessName?: Maybe<Scalars['String']['output']>;
  registrationLocation?: Maybe<Scalars['String']['output']>;
  registrationNumber?: Maybe<Scalars['String']['output']>;
  savingsAndDeposit?: Maybe<FinancialAmountType>;
  scoringRiskLevel?: Maybe<Scalars['String']['output']>;
  share?: Maybe<Scalars['Float']['output']>;
  sourceOfFunds?: Maybe<Array<Scalars['String']['output']>>;
  sourceOfWealth?: Maybe<Array<Scalars['String']['output']>>;
  taxId?: Maybe<Scalars['String']['output']>;
  taxNumber?: Maybe<Scalars['String']['output']>;
  totalNumberOfEmployees?: Maybe<Scalars['String']['output']>;
  totalScore?: Maybe<Scalars['String']['output']>;
  trackerId: Scalars['String']['output'];
  tradingName?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  website?: Maybe<Scalars['String']['output']>;
};

export type CompanyMember = {
  __typename?: 'CompanyMember';
  companies?: Maybe<Companies>;
  id: Scalars['ID']['output'];
  pep?: Maybe<MemberPep>;
  positions?: Maybe<Array<Scalars['String']['output']>>;
  share?: Maybe<Scalars['Float']['output']>;
  type: CompanyMemberType;
  user: User;
};


export type CompanyMemberCompaniesArgs = {
  input: FilterInput;
};

export enum CompanyMemberType {
  Director = 'director',
  Representative = 'representative',
  Shareholder = 'shareholder',
  Ubo = 'ubo'
}

export type CompanyMembers = {
  __typename?: 'CompanyMembers';
  count: Scalars['Int']['output'];
  cursor: Scalars['Int']['output'];
  nodes: Array<CompanyMember>;
};

/** Ownership structure of the company */
export enum CompanyOwnershipStructure {
  Private = 'PRIVATE',
  Public = 'PUBLIC'
}

export enum CompanySortOrder {
  Asc = 'ASC',
  Desc = 'DESC'
}

export type CompanyStaticDataAdditionalInfo = {
  __typename?: 'CompanyStaticDataAdditionalInfo';
  isRequired: Scalars['Boolean']['output'];
  label: Scalars['String']['output'];
  name: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type CompanyStaticDataConfig = {
  __typename?: 'CompanyStaticDataConfig';
  additionalInfos: Array<CompanyStaticDataAdditionalInfo>;
  companyAddresses: Array<CompanyStaticDataFieldConfig>;
  companyAddressesRequiredCategories: Array<Scalars['String']['output']>;
  documents: Array<CompanyStaticDataFieldConfig>;
  documentsRequiredConfigs: Array<CompanyStaticDataDocumentConfig>;
  mainFields: Array<CompanyStaticDataFieldConfig>;
  peps: Array<CompanyStaticDataFieldConfig>;
  shareholders: Array<CompanyStaticDataFieldConfig>;
  shareholdersRequiredAddressCategories: Array<Scalars['String']['output']>;
};

export type CompanyStaticDataDocumentConfig = {
  __typename?: 'CompanyStaticDataDocumentConfig';
  description?: Maybe<Scalars['String']['output']>;
  docType: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type CompanyStaticDataFieldConfig = {
  __typename?: 'CompanyStaticDataFieldConfig';
  children?: Maybe<Array<CompanyStaticDataFieldConfig>>;
  defaultValue?: Maybe<Scalars['String']['output']>;
  filter?: Maybe<Scalars['JSON']['output']>;
  isAvailable: Scalars['Boolean']['output'];
  isRequired: Scalars['Boolean']['output'];
  label: Scalars['String']['output'];
  maxValue?: Maybe<Scalars['Float']['output']>;
  maximum?: Maybe<Scalars['Float']['output']>;
  minValue?: Maybe<Scalars['Float']['output']>;
  minimum?: Maybe<Scalars['Float']['output']>;
  name: Scalars['String']['output'];
  values?: Maybe<Array<CompanyStaticDataValue>>;
};

export type CompanyStaticDataValue = {
  __typename?: 'CompanyStaticDataValue';
  name: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type CompanyType = {
  __typename?: 'CompanyType';
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  item: CommonDictItem;
};

export type CompanyTypes = {
  __typename?: 'CompanyTypes';
  count: Scalars['Int']['output'];
  cursor: Scalars['Int']['output'];
  nodes: Array<CompanyType>;
};

export type CompanyUnion = Company | CompanyBeneficiary;

export type CompleteOrderFilter = {
  __typename?: 'CompleteOrderFilter';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  owner: ExchangeService;
  pair?: Maybe<OrderPair>;
  /** JSON string with filter parameters. */
  parameters: BinanceFilterParameters;
  type: OrderFilterType;
};

/**
 * Description: input to confirm enable or disable two-factor authentication
 *
 * Example:
 *
 *
 *
 * {
 *
 *
 * "operationId": "operationId",
 *
 *
 * "type": "SMS",
 *
 *
 * "token": "token"
 *
 *
 * }
 */
export type Confirm2FaInput = {
  /**
   * Required: true
   *
   * Description: Operation identifier
   *
   * Format:
   *
   *         uuid v4
   */
  operationId: Scalars['ID']['input'];
  /**
   * Required: true
   *
   * Description: SMS code
   *
   * Format:
   *
   *         string containing 6 digits
   *
   *
   * Example:
   *
   *         "123456"
   */
  token: Scalars['String']['input'];
  /**
   * Required: true
   *
   * Description: two-factor authentication type
   *
   * Format:
   *
   *         string parameter from custom enum
   *
   *
   * Example:
   *
   *         "SMS"
   */
  type: TfaType;
};

export type ConfirmChangeIdentityInput = {
  /** New identity */
  newIdentity: Scalars['String']['input'];
  /** New identity code */
  newIdentityCode: Scalars['String']['input'];
  tfaVerifyData?: InputMaybe<Verify2FaInput>;
  type: IdentityType;
};

export type ConfirmChangePasswordInput = {
  changePassword: ChangePasswordInput;
  verify2FAInput: Verify2FaInput;
};

export type ConfirmInput = {
  code: Scalars['String']['input'];
  device: Device;
  identity: Scalars['String']['input'];
  type: SendCode;
};

/**
 * Description: input data for checking the one-time timecode for relevance and correctness
 *
 * Example:
 *
 *
 *
 * {
 *
 *
 * "code": "123456",
 *
 *
 * "identity": "test-email@yourcompany. com",
 *
 *
 * "device": "EMAIL",
 *
 *
 * "type": "REGISTRATION",
 *
 *
 * "service": "BANXEID"
 *
 *
 * }
 */
export type ConfirmOneTimeCodeInput = {
  /**
   * Required: true
   *
   * Description: SMS code
   *
   * Format:
   *
   *         string containing 6 digits
   *
   *
   * Example:
   *
   *         "123456"
   */
  code: Scalars['String']['input'];
  /**
   * Required: true
   *
   * Description: device type
   *
   * Format:
   *
   *         string parameter from custom enum
   *
   *
   * Example:
   *
   *         "EMAIL"
   */
  device: Device;
  /**
   * Required: true
   *
   * Description: field containing the email address or phone number to which the OneTimeCode should be sent
   *
   * Format:
   *
   *         string containing a phone number or email address
   *
   *
   * Example:
   *
   *         "test-email@yourcompany.com"
   */
  identity: Scalars['String']['input'];
  /**
   * Required: true
   *
   * Description: service type
   *
   * Format:
   *
   *         string parameter from custom enum
   *
   *
   * Example:
   *
   *         "BANXEID"
   */
  service: Scalars['String']['input'];
  /**
   * Required: true
   *
   * Description: code type
   *
   * Format:
   *
   *         string parameter from custom enum
   *
   *
   * Example:
   *
   *         "REGISTRATION"
   */
  type: SendCode;
};

/** one time code check result */
export type ConfirmOneTimeCodeResponse = {
  __typename?: 'ConfirmOneTimeCodeResponse';
  /**
   * Required: true
   *
   * Description: device type
   *
   * Format:
   *
   *         string parameter from custom enum
   *
   *
   * Example:
   *
   *         "EMAIL"
   */
  device: Device;
  /**
   * Required: true
   *
   * Description: device Id
   *
   * Additional info:
   *
   *         24 hex characters from a MongoDB ID
   *
   *
   * Format:
   *
   *         24 hexadecimal characters
   *
   *
   * Example:
   *
   *         64a5448c7e019dbee9006f62
   */
  deviceId: Scalars['String']['output'];
  /**
   * Required: true
   *
   * Description: field containing the email address or phone number to which the OneTimeCode should be sent
   *
   * Format:
   *
   *         string containing a phone number or email address
   *
   *
   * Example:
   *
   *         "test-email@yourcompany.com"
   */
  identity: Scalars['String']['output'];
};

/** Input data of password recovery confirmation */
export type ConfirmPasswordRecoveryInput = {
  /** Password recovery data */
  passwordRecovery: PasswordRecoveryInput;
  /** 2FA data */
  verify2FAInput: Verify2FaInput;
};

export type Continent = {
  __typename?: 'Continent';
  item: CommonDictItem;
};

export type ContinentInput = {
  item: CommonDictItemInput;
};

export type Countries = {
  __typename?: 'Countries';
  count: Scalars['Int']['output'];
  nodes: Array<Country>;
};

export type CountriesV2 = {
  __typename?: 'CountriesV2';
  count: Scalars['Int']['output'];
  cursor: Scalars['Int']['output'];
  nodes: Array<Country>;
};

export type Country = {
  __typename?: 'Country';
  alpha3: Scalars['String']['output'];
  continent?: Maybe<Continent>;
  currencies?: Maybe<Array<Maybe<Currency>>>;
  icon?: Maybe<File>;
  id: Scalars['ID']['output'];
  item?: Maybe<CommonDictItem>;
  languages?: Maybe<Array<Maybe<Language>>>;
  phoneCode: Scalars['String']['output'];
  phoneTemplate: Scalars['String']['output'];
};

export type CountryInput = {
  alpha3?: InputMaybe<Scalars['String']['input']>;
  continentId: Scalars['ID']['input'];
  currencyIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  iconFileId?: InputMaybe<Scalars['ID']['input']>;
  item: CommonDictItemInput;
  languageIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  phoneCode: Scalars['String']['input'];
  phoneTemplate: Scalars['String']['input'];
};

export type CrateUserDocumentInput = {
  configId: Scalars['ID']['input'];
  countryId?: InputMaybe<Scalars['ID']['input']>;
  externalRejectReasons?: InputMaybe<Scalars['String']['input']>;
  fields?: InputMaybe<Array<CreateUserDocumentFieldInput>>;
  fileIds?: InputMaybe<Array<Scalars['String']['input']>>;
  fileUrls: Array<Scalars['String']['input']>;
  internalRejectReasons?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  rejectTags?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type CreateAccessTokenForApplicantInput = {
  externalUserId: Scalars['String']['input'];
  levelName: Scalars['String']['input'];
  ttlInSecs?: InputMaybe<Scalars['Int']['input']>;
};

export type CreateAccountsForExistingTagInput = {
  accountCurrencyIds: Array<Scalars['ID']['input']>;
  clientIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  tag: Scalars['String']['input'];
  trackerId?: InputMaybe<Scalars['ID']['input']>;
};

export type CreateAdditionalInfoInput = {
  clientId: Scalars['ID']['input'];
  key: Scalars['String']['input'];
  name: Scalars['String']['input'];
  type: AdditionalInfoTypeEnum;
  value: Scalars['AdditionalInfoValue']['input'];
};

export type CreateAddressCategoryInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};

export type CreateAddressInput = {
  buildingName?: InputMaybe<Scalars['String']['input']>;
  buildingNumber?: InputMaybe<Scalars['String']['input']>;
  categoryIds: Array<Scalars['ID']['input']>;
  /** id of city from dictionary-microservice */
  cityId?: InputMaybe<Scalars['ID']['input']>;
  clientId: Scalars['ID']['input'];
  /** additional comment */
  comment?: InputMaybe<Scalars['String']['input']>;
  /** id of country from dictionary-microservice */
  countryId?: InputMaybe<Scalars['ID']['input']>;
  flatNumber?: InputMaybe<Scalars['String']['input']>;
  geoLatitude?: InputMaybe<Scalars['String']['input']>;
  geoLongitude?: InputMaybe<Scalars['String']['input']>;
  isActual?: InputMaybe<Scalars['Boolean']['input']>;
  isLegal?: InputMaybe<Scalars['Boolean']['input']>;
  /** should be true if current address is primary for user */
  isPrimary: Scalars['Boolean']['input'];
  postalCode?: InputMaybe<Scalars['String']['input']>;
  rawCityName?: InputMaybe<Scalars['String']['input']>;
  rawCityNameEn?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  stateEn?: InputMaybe<Scalars['String']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
  streetEn?: InputMaybe<Scalars['String']['input']>;
  subStreet?: InputMaybe<Scalars['String']['input']>;
  subStreetEn?: InputMaybe<Scalars['String']['input']>;
};

export type CreateAgeRangeStatisticSettingInput = {
  ageFrom: Scalars['Int']['input'];
  ageTo?: InputMaybe<Scalars['Int']['input']>;
  rangeName: Scalars['String']['input'];
};

export type CreateApplicantAddressInput = {
  /** Building name if applicable */
  buildingName?: InputMaybe<Scalars['String']['input']>;
  buildingNumber?: InputMaybe<Scalars['String']['input']>;
  /** Alpha-3 country code */
  country?: InputMaybe<Scalars['String']['input']>;
  /** End date of stay in current building (format YYYY-mm-dd, e.g. 2002-10-26) */
  endDate?: InputMaybe<Scalars['String']['input']>;
  flatNumber?: InputMaybe<Scalars['String']['input']>;
  postCode?: InputMaybe<Scalars['String']['input']>;
  /** Start date of stay in current building (format YYYY-mm-dd, e.g. 2001-09-25) */
  startDate?: InputMaybe<Scalars['String']['input']>;
  /** State name if applicable */
  state?: InputMaybe<Scalars['String']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
  /** Additional street information */
  subStreet?: InputMaybe<Scalars['String']['input']>;
  town?: InputMaybe<Scalars['String']['input']>;
};

export type CreateApplicantInfoInput = {
  /** List of addresses */
  addresses?: InputMaybe<Array<CreateApplicantAddressInput>>;
  /** Alpha-3 country code (e.g. DEU or RUS) */
  country?: InputMaybe<Scalars['String']['input']>;
  /** Alpha-3 code (e.g. DEU or RUS) */
  countryOfBirth?: InputMaybe<Scalars['String']['input']>;
  /** Date of birth (format YYYY-mm-dd, e.g. 2001-09-25) */
  dob?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  /** Sex of a person (M or F) */
  gender?: InputMaybe<ApplicantGenderEnum>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  legalName?: InputMaybe<Scalars['String']['input']>;
  middleName?: InputMaybe<Scalars['String']['input']>;
  /** Alpha-3 country code */
  nationality?: InputMaybe<Scalars['String']['input']>;
  placeOfBirth?: InputMaybe<Scalars['String']['input']>;
  stateOfBirth?: InputMaybe<Scalars['String']['input']>;
};

export type CreateApplicantInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  externalUserId: Scalars['String']['input'];
  /** Basic information about the applicant that we shouldn't change from our side but cross-validate it with data recognized from documents. Has the same attributes as info */
  fixedInfo?: InputMaybe<CreateApplicantInfoInput>;
  /** Basic information about the applicant */
  info?: InputMaybe<CreateApplicantInfoInput>;
  /** The language in which the applicant should see the result of verification in ISO 639-1 format */
  lang?: InputMaybe<Scalars['String']['input']>;
  levelName: Scalars['String']['input'];
  /** Additional information that is not displayed to the end user ( Example: [{"key": "keyFromClient", "value": "valueFromClient"}] ) */
  metadata?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  /** If you want to separate your clients that send applicants, provide this field to distinguish between them. It also shows up at the webhook payloads */
  sourceKey?: InputMaybe<Scalars['String']['input']>;
};

export type CreateCheckoutPaymentInput = {
  amount: Scalars['BigNumber']['input'];
  currency: Scalars['String']['input'];
  customer: CheckoutCustomerInput;
  description: Scalars['String']['input'];
  failure_url?: InputMaybe<Scalars['String']['input']>;
  reference: Scalars['String']['input'];
  secure3d: Checkout3dsInput;
  source: CheckoutSourceInput;
  success_url?: InputMaybe<Scalars['String']['input']>;
};

export type CreateCityInput = {
  city: CityInput;
};

export type CreateCompanyApplicantBeneficiaryInput = {
  applicantId: Scalars['String']['input'];
  positions: Array<Scalars['String']['input']>;
  type: ApplicantBeneficiaryTypeEnum;
};

export type CreateCompanyApplicantInfoInput = {
  addresses?: InputMaybe<CreateApplicantAddressInput>;
  beneficiaries?: InputMaybe<Array<CreateCompanyApplicantBeneficiaryInput>>;
  companyName: Scalars['String']['input'];
  controlScheme?: InputMaybe<Scalars['String']['input']>;
  country: Scalars['String']['input'];
  email?: InputMaybe<Scalars['String']['input']>;
  incorporatedOn?: InputMaybe<Scalars['String']['input']>;
  legalAddress?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  postalAddress?: InputMaybe<Scalars['String']['input']>;
  registrationLocation?: InputMaybe<Scalars['String']['input']>;
  registrationNumber: Scalars['String']['input'];
  taxId?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
};

export type CreateCompanyApplicantInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  externalUserId: Scalars['String']['input'];
  /** Basic information about the applicant */
  info?: InputMaybe<CompanyApplicantInfoInput>;
  /** The language in which the applicant should see the result of verification in ISO 639-1 format */
  lang?: InputMaybe<Scalars['String']['input']>;
  levelName: Scalars['String']['input'];
  /** Additional information that is not displayed to the end user ( Example: [{"key": "keyFromClient", "value": "valueFromClient"}] ) */
  metadata?: InputMaybe<Scalars['String']['input']>;
  /** If you want to separate your clients that send applicants, provide this field to distinguish between them. It also shows up at the webhook payloads */
  sourceKey?: InputMaybe<Scalars['String']['input']>;
};

export type CreateCompanyDocumentFieldCascadeInput = {
  fieldConfigId: Scalars['ID']['input'];
  value: Scalars['String']['input'];
};

export type CreateCompanyDocumentInput = {
  configId: Scalars['ID']['input'];
  countryId?: InputMaybe<Scalars['ID']['input']>;
  externalRejectReasons?: InputMaybe<Scalars['String']['input']>;
  fields?: InputMaybe<Array<CreateCompanyDocumentFieldCascadeInput>>;
  fileIds?: InputMaybe<Array<Scalars['String']['input']>>;
  fileUrls: Array<Scalars['String']['input']>;
  internalRejectReasons?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  rejectTags?: InputMaybe<Array<Scalars['String']['input']>>;
  status?: InputMaybe<DocumentStatus>;
};

export type CreateCompanyInput = {
  additionalInfos?: InputMaybe<Array<CreateMyAdditionalInfoInput>>;
  addresses?: InputMaybe<Array<CreateMyAddressInput>>;
  annualTurnover?: InputMaybe<FinancialAmountInput>;
  businessActivityIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  businessEmail?: InputMaybe<Scalars['String']['input']>;
  businessPhone?: InputMaybe<Scalars['String']['input']>;
  businessProfit?: InputMaybe<FinancialAmountInput>;
  companyOwnershipStructure?: InputMaybe<CompanyOwnershipStructure>;
  companyTypeId?: InputMaybe<Scalars['ID']['input']>;
  controlSchema?: InputMaybe<Scalars['String']['input']>;
  countryOfIncorporationId?: InputMaybe<Scalars['ID']['input']>;
  dateOfIncorporation?: InputMaybe<Scalars['DateTime']['input']>;
  detailsSourceOfWealth?: InputMaybe<Array<DetailSourceOfWealthInput>>;
  documents?: InputMaybe<Array<CreateCompanyDocumentInput>>;
  employmentIncome?: InputMaybe<FinancialAmountInput>;
  faxNumber?: InputMaybe<Scalars['String']['input']>;
  finalDecision?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  incomingPaymentsByCountries?: InputMaybe<Array<PaymentFlowByCountryInput>>;
  incomingPaymentsByCurrencies?: InputMaybe<Array<PaymentFlowByCurrencyInput>>;
  isInternalTransferAllowed?: InputMaybe<Scalars['Boolean']['input']>;
  loan?: InputMaybe<FinancialAmountInput>;
  members: Array<CreateMyCompanyMemberInput>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  otherPlannedAccountUse?: InputMaybe<Scalars['String']['input']>;
  otherPurposeForAccountOpening?: InputMaybe<Scalars['String']['input']>;
  otherReasonsForAccountOpening?: InputMaybe<Scalars['String']['input']>;
  otherSourceOfFunds?: InputMaybe<Scalars['String']['input']>;
  otherSourceOfWealth?: InputMaybe<Scalars['String']['input']>;
  outgoingPaymentsByCountries?: InputMaybe<Array<PaymentFlowByCountryInput>>;
  outgoingPaymentsByCurrencies?: InputMaybe<Array<PaymentFlowByCurrencyInput>>;
  paidUpShareCapital?: InputMaybe<FinancialAmountInput>;
  parentCompanyId?: InputMaybe<Scalars['ID']['input']>;
  plannedAccountUse?: InputMaybe<Array<Scalars['String']['input']>>;
  purposeForAccountOpening?: InputMaybe<Array<Scalars['String']['input']>>;
  reasonsForAccountOpening?: InputMaybe<Array<Scalars['String']['input']>>;
  registeredBusinessName?: InputMaybe<Scalars['String']['input']>;
  registrant: CreateCompanyRegistrantInput;
  registrationLocation?: InputMaybe<Scalars['String']['input']>;
  registrationNumber?: InputMaybe<Scalars['String']['input']>;
  savingsAndDeposit?: InputMaybe<FinancialAmountInput>;
  scoringRiskLevel?: InputMaybe<ScoringRiskLevelEnum>;
  service: Scalars['String']['input'];
  share?: InputMaybe<Scalars['Float']['input']>;
  sourceOfFunds?: InputMaybe<Array<Scalars['String']['input']>>;
  sourceOfWealth?: InputMaybe<Array<Scalars['String']['input']>>;
  taxNumber?: InputMaybe<Scalars['String']['input']>;
  totalNumberOfEmployees?: InputMaybe<Scalars['String']['input']>;
  totalScore?: InputMaybe<Scalars['String']['input']>;
  tradingName?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
};

export type CreateCompanyRegistrantInput = {
  id: Scalars['ID']['input'];
  pep?: InputMaybe<MemberPepInput>;
  positions?: InputMaybe<Array<Scalars['String']['input']>>;
  share?: InputMaybe<Scalars['Float']['input']>;
  type: CompanyMemberType;
};

export type CreateCompanyTypeInput = {
  code: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};

export type CreateContinentInput = {
  continent: ContinentInput;
};

export type CreateCountryInput = {
  country: CountryInput;
};

export type CreateCurrenciesInput = {
  currencies: Array<CurrencyInput>;
};

export type CreateCurrencyInput = {
  currency: CurrencyInput;
};

export type CreateDocumentConfigInput = {
  availableCountryIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  description?: InputMaybe<Scalars['String']['input']>;
  docType: Scalars['String']['input'];
  fieldConfigs?: InputMaybe<Array<CreateDocumentFieldConfigCascadeInput>>;
  name: Scalars['String']['input'];
};

export type CreateDocumentFieldCascadeInput = {
  fieldConfigId: Scalars['ID']['input'];
  value: Scalars['String']['input'];
};

export type CreateDocumentFieldConfigCascadeInput = {
  description: Scalars['String']['input'];
  displayInTable: Scalars['Boolean']['input'];
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  key: Scalars['String']['input'];
  label: Scalars['String']['input'];
  order: Scalars['Int']['input'];
  type: DocumentFieldType;
};

export type CreateDocumentFieldConfigInput = {
  description: Scalars['String']['input'];
  displayInTable: Scalars['Boolean']['input'];
  documentConfigId: Scalars['ID']['input'];
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  key: Scalars['String']['input'];
  label: Scalars['String']['input'];
  order: Scalars['Int']['input'];
  type: DocumentFieldType;
};

export type CreateDocumentFieldInput = {
  documentId: Scalars['ID']['input'];
  fieldConfigId: Scalars['ID']['input'];
  value: Scalars['String']['input'];
};

export type CreateDocumentInput = {
  clientId: Scalars['ID']['input'];
  clientType: IdentityTypeEnum;
  configId: Scalars['ID']['input'];
  countryId?: InputMaybe<Scalars['ID']['input']>;
  externalRejectReasons?: InputMaybe<Scalars['String']['input']>;
  fields?: InputMaybe<Array<CreateDocumentFieldCascadeInput>>;
  fileIds?: InputMaybe<Array<Scalars['String']['input']>>;
  fileUrls: Array<Scalars['String']['input']>;
  internalRejectReasons?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  rejectTags?: InputMaybe<Array<Scalars['String']['input']>>;
  status?: InputMaybe<DocumentStatus>;
};

export type CreateDocumentRejectTagInput = {
  action: DocumentRejectTagAction;
  description: Scalars['String']['input'];
  documentConfigIds: Array<Scalars['ID']['input']>;
  name: Scalars['String']['input'];
  tags: Array<Scalars['String']['input']>;
};

export type CreateExchangeConfigInput = {
  currencyIds: Array<Scalars['ID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  exchange: ExchangeEnum;
  provider: PaymentProviderType;
  providerTag?: InputMaybe<ClearJunctionWalletEnum>;
};

export type CreateExchangeStepConfigInput = {
  cryptoOrderConfigId: Scalars['ID']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  order: Scalars['Int']['input'];
  providerTag?: InputMaybe<ClearJunctionWalletEnum>;
  step: ExchangeStepConfigTypeEnum;
};

export type CreateIncomingPaymentCreditorBankInput = {
  bankId: Scalars['ID']['input'];
};

export type CreateIncomingPaymentCreditorClientInput = {
  accountId: Scalars['ID']['input'];
  accountNumber?: InputMaybe<Scalars['String']['input']>;
  clientId: Scalars['ID']['input'];
  iban?: InputMaybe<Scalars['String']['input']>;
};

export type CreateIncomingPaymentCreditorInput = {
  bankRequisite: CreateIncomingPaymentCreditorBankInput;
  clientRequisite: CreateIncomingPaymentCreditorClientInput;
};

export type CreateIncomingPaymentDebitorBankInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  bankId?: InputMaybe<Scalars['ID']['input']>;
  bic?: InputMaybe<Scalars['String']['input']>;
  cityId?: InputMaybe<Scalars['ID']['input']>;
  countryId?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  sortCode?: InputMaybe<Scalars['String']['input']>;
};

export type CreateIncomingPaymentDebitorClientInput = {
  accountNumber?: InputMaybe<Scalars['String']['input']>;
  address?: InputMaybe<Scalars['String']['input']>;
  iban?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};

export type CreateIncomingPaymentDebitorInput = {
  bankRequisite: CreateIncomingPaymentDebitorBankInput;
  clientRequisite: CreateIncomingPaymentDebitorClientInput;
};

export type CreateIncomingPaymentInput = {
  amount: Scalars['BigNumber']['input'];
  attachmentId?: InputMaybe<Scalars['ID']['input']>;
  creditor: CreateIncomingPaymentCreditorInput;
  currencyId: Scalars['ID']['input'];
  debitor: CreateIncomingPaymentDebitorInput;
  description?: InputMaybe<Scalars['String']['input']>;
  isDeclined?: InputMaybe<Scalars['Boolean']['input']>;
  kyt?: InputMaybe<Scalars['JSON']['input']>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  paymentId?: InputMaybe<Scalars['ID']['input']>;
  providerFee: Scalars['BigNumber']['input'];
  tezroFee: Scalars['BigNumber']['input'];
};

export type CreateIntermediaryInput = {
  accountTypes?: InputMaybe<Array<InternalAccountType>>;
  beneficiaryAccountNumber?: InputMaybe<Scalars['String']['input']>;
  beneficiaryAddress?: InputMaybe<Scalars['String']['input']>;
  beneficiaryBIC?: InputMaybe<Scalars['String']['input']>;
  beneficiaryBank: Scalars['String']['input'];
  beneficiaryIBAN?: InputMaybe<Scalars['String']['input']>;
  beneficiaryName: Scalars['String']['input'];
  beneficiarySortCode?: InputMaybe<Scalars['String']['input']>;
  companyCountriesAlpha3?: InputMaybe<Array<Scalars['String']['input']>>;
  currenciesTickers?: InputMaybe<Array<Scalars['String']['input']>>;
  forbiddenNACECodes?: InputMaybe<Array<Scalars['String']['input']>>;
  name?: InputMaybe<Scalars['String']['input']>;
  userCountriesAlpha3?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type CreateKybConfigInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  level: Scalars['Int']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  service: Scalars['String']['input'];
  steps?: InputMaybe<Array<CreateKybStepCascadeInput>>;
};

export type CreateKybStepCascadeInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  order: Scalars['Int']['input'];
  step: KybStepEnum;
};

export type CreateKybStepInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  kybConfigId: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  order: Scalars['Int']['input'];
  providerConfig: Scalars['JSON']['input'];
  step: KybStepEnum;
};

export type CreateKycConfigInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  level: Scalars['Int']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  service: Scalars['String']['input'];
  steps?: InputMaybe<Array<CreateKycStepCascadeInput>>;
};

export type CreateKycStepCascadeInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  order: Scalars['Int']['input'];
  providerConfig: Scalars['JSON']['input'];
  step: KycStepEnum;
};

export type CreateKycStepInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  kycConfigId: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  order: Scalars['Int']['input'];
  providerConfig: Scalars['JSON']['input'];
  step: KycStepEnum;
};

export type CreateLanguageInput = {
  language: LanguageInput;
};

export type CreateMemberFromExistingUserInput = {
  companyIds: Array<Scalars['ID']['input']>;
  pep?: InputMaybe<MemberPepInput>;
  positions?: InputMaybe<Array<Scalars['String']['input']>>;
  share?: InputMaybe<Scalars['Float']['input']>;
  type: CompanyMemberType;
  userId: Scalars['ID']['input'];
};

export type CreateMyAdditionalInfoInput = {
  key: Scalars['String']['input'];
  name: Scalars['String']['input'];
  type: AdditionalInfoTypeEnum;
  value: Scalars['AdditionalInfoValue']['input'];
};

export type CreateMyAddressInput = {
  buildingName?: InputMaybe<Scalars['String']['input']>;
  buildingNumber?: InputMaybe<Scalars['String']['input']>;
  categoryIds: Array<Scalars['ID']['input']>;
  /** id of city from dictionary-microservice */
  cityId?: InputMaybe<Scalars['ID']['input']>;
  /** additional comment */
  comment?: InputMaybe<Scalars['String']['input']>;
  /** id of country from dictionary-microservice */
  countryId?: InputMaybe<Scalars['ID']['input']>;
  flatNumber?: InputMaybe<Scalars['String']['input']>;
  geoLatitude?: InputMaybe<Scalars['String']['input']>;
  geoLongitude?: InputMaybe<Scalars['String']['input']>;
  isActual?: InputMaybe<Scalars['Boolean']['input']>;
  isLegal?: InputMaybe<Scalars['Boolean']['input']>;
  /** should be true if current address is primary for user */
  isPrimary: Scalars['Boolean']['input'];
  postalCode?: InputMaybe<Scalars['String']['input']>;
  rawCityName?: InputMaybe<Scalars['String']['input']>;
  rawCityNameEn?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  stateEn?: InputMaybe<Scalars['String']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
  streetEn?: InputMaybe<Scalars['String']['input']>;
  subStreet?: InputMaybe<Scalars['String']['input']>;
  subStreetEn?: InputMaybe<Scalars['String']['input']>;
};

export type CreateMyCompanyInput = {
  additionalInfos?: InputMaybe<Array<CreateMyAdditionalInfoInput>>;
  addresses?: InputMaybe<Array<CreateMyAddressInput>>;
  annualTurnover?: InputMaybe<FinancialAmountInput>;
  businessActivityIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  businessEmail?: InputMaybe<Scalars['String']['input']>;
  businessPhone?: InputMaybe<Scalars['String']['input']>;
  businessProfit?: InputMaybe<FinancialAmountInput>;
  companyOwnershipStructure?: InputMaybe<CompanyOwnershipStructure>;
  companyTypeId?: InputMaybe<Scalars['ID']['input']>;
  controlSchema?: InputMaybe<Scalars['String']['input']>;
  countryOfIncorporationId?: InputMaybe<Scalars['ID']['input']>;
  dateOfIncorporation?: InputMaybe<Scalars['DateTime']['input']>;
  detailsSourceOfWealth?: InputMaybe<Array<DetailSourceOfWealthInput>>;
  documents?: InputMaybe<Array<CreateCompanyDocumentInput>>;
  employmentIncome?: InputMaybe<FinancialAmountInput>;
  faxNumber?: InputMaybe<Scalars['String']['input']>;
  finalDecision?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  incomingPaymentsByCountries?: InputMaybe<Array<PaymentFlowByCountryInput>>;
  incomingPaymentsByCurrencies?: InputMaybe<Array<PaymentFlowByCurrencyInput>>;
  isInternalTransferAllowed?: InputMaybe<Scalars['Boolean']['input']>;
  loan?: InputMaybe<FinancialAmountInput>;
  members: Array<CreateMyCompanyMemberInput>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  otherPlannedAccountUse?: InputMaybe<Scalars['String']['input']>;
  otherPurposeForAccountOpening?: InputMaybe<Scalars['String']['input']>;
  otherReasonsForAccountOpening?: InputMaybe<Scalars['String']['input']>;
  otherSourceOfFunds?: InputMaybe<Scalars['String']['input']>;
  otherSourceOfWealth?: InputMaybe<Scalars['String']['input']>;
  outgoingPaymentsByCountries?: InputMaybe<Array<PaymentFlowByCountryInput>>;
  outgoingPaymentsByCurrencies?: InputMaybe<Array<PaymentFlowByCurrencyInput>>;
  paidUpShareCapital?: InputMaybe<FinancialAmountInput>;
  parentCompanyId?: InputMaybe<Scalars['ID']['input']>;
  plannedAccountUse?: InputMaybe<Array<Scalars['String']['input']>>;
  purposeForAccountOpening?: InputMaybe<Array<Scalars['String']['input']>>;
  reasonsForAccountOpening?: InputMaybe<Array<Scalars['String']['input']>>;
  registeredBusinessName?: InputMaybe<Scalars['String']['input']>;
  registrant: CreateMyCompanyRegistrantInput;
  registrationLocation?: InputMaybe<Scalars['String']['input']>;
  registrationNumber?: InputMaybe<Scalars['String']['input']>;
  savingsAndDeposit?: InputMaybe<FinancialAmountInput>;
  scoringRiskLevel?: InputMaybe<ScoringRiskLevelEnum>;
  service: Scalars['String']['input'];
  share?: InputMaybe<Scalars['Float']['input']>;
  sourceOfFunds?: InputMaybe<Array<Scalars['String']['input']>>;
  sourceOfWealth?: InputMaybe<Array<Scalars['String']['input']>>;
  taxNumber?: InputMaybe<Scalars['String']['input']>;
  totalNumberOfEmployees?: InputMaybe<Scalars['String']['input']>;
  totalScore?: InputMaybe<Scalars['String']['input']>;
  tradingName?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
};

export type CreateMyCompanyMemberInput = {
  pep?: InputMaybe<MemberPepInput>;
  positions?: InputMaybe<Array<Scalars['String']['input']>>;
  share?: InputMaybe<Scalars['Float']['input']>;
  type?: InputMaybe<CompanyMemberType>;
  user: CreateUserInput;
};

export type CreateMyCompanyRegistrantInput = {
  pep?: InputMaybe<MemberPepInput>;
  positions?: InputMaybe<Array<Scalars['String']['input']>>;
  share?: InputMaybe<Scalars['Float']['input']>;
  type?: InputMaybe<CompanyMemberType>;
};

export type CreateMyDocumentInput = {
  configId: Scalars['ID']['input'];
  countryId?: InputMaybe<Scalars['ID']['input']>;
  externalRejectReasons?: InputMaybe<Scalars['String']['input']>;
  fields?: InputMaybe<Array<CreateDocumentFieldCascadeInput>>;
  fileIds?: InputMaybe<Array<Scalars['String']['input']>>;
  fileUrls: Array<Scalars['String']['input']>;
  internalRejectReasons?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  rejectTags?: InputMaybe<Array<Scalars['String']['input']>>;
  status?: InputMaybe<DocumentStatus>;
};

export type CreateMyPaymentTemplateInput = {
  amount: Scalars['BigNumber']['input'];
  approverId?: InputMaybe<Scalars['String']['input']>;
  attachmentId?: InputMaybe<Scalars['String']['input']>;
  category: PaymentCategory;
  creatorId?: InputMaybe<Scalars['String']['input']>;
  creditor: PaymentTemplatePartyInput;
  /** Creditor auth user id */
  creditorId?: InputMaybe<Scalars['String']['input']>;
  currencyTicker: Scalars['String']['input'];
  debtor: PaymentTemplatePartyInput;
  documentNo?: InputMaybe<Scalars['String']['input']>;
  documentNoOrDate?: InputMaybe<Scalars['String']['input']>;
  isChosen?: InputMaybe<Scalars['Boolean']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  reason?: InputMaybe<PaymentReason>;
  receipt?: InputMaybe<Scalars['String']['input']>;
  schedule?: InputMaybe<Scalars['DateTime']['input']>;
  type: PaymentType;
  vat?: InputMaybe<Scalars['BigNumber']['input']>;
};

export type CreateNumberRangeInput = {
  numberRange: NumberRangeInput;
};

/**
 * Description: input to create an operation and get the operation ID
 *
 * Example:
 *
 *
 *
 * {
 *
 *
 * "operationTitle": "BUYCRYPTO",
 *
 *
 * "templateDataJson": "templateDataJson"
 *
 *
 * "isTimeUp": false
 *
 *
 * }
 */
export type CreateOperationIdInput = {
  /**
   * Required: false
   *
   * Description: indicates that resending the 2fa code will increase the resend timer
   *
   * Format:
   *
   *         boolean
   *
   *
   * Example:
   *
   *         false
   */
  isTimeUp?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Required: true
   *
   * Description: title type
   *
   * Format:
   *
   *         string parameters from custom enum
   *
   *
   * Example:
   *
   *         "BUYCRYPTO"
   */
  operationTitle: Scalars['String']['input'];
  /**
   * Required: false
   *
   * Description: Serialized JSON containing variables to be inserted into an email template
   *
   * Format:
   *
   *         JSON
   */
  templateDataJson?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Description: input to create an operation
 *
 * Example:
 *
 *
 *
 * {
 *
 *
 * "title": "BUYCRYPTO",
 *
 *
 * "verificationTypes": ["SMS", "EMAIL"]
 *
 *
 * "isTimeUp": false
 *
 *
 * }
 */
export type CreateOperationInput = {
  /**
   * Required: false
   *
   * Description: indicates that resending the 2fa code will increase the resend timer
   *
   * Format:
   *
   *         boolean
   *
   *
   * Example:
   *
   *         false
   */
  isTimeUp?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Required: true
   *
   * Description: title type
   *
   * Format:
   *
   *         string parameters from custom enum
   *
   *
   * Example:
   *
   *         "BUYCRYPTO"
   */
  title: Scalars['String']['input'];
  /**
   * Required: true
   *
   * Description: two-factor authentication type
   *
   * Format:
   *
   *         array of string parameters from custom enum
   *
   *
   * Example:
   *
   *         ["SMS", "EMAIL"]
   */
  verificationTypes: Array<TfaType>;
};

export type CreateOrUpdateMyAdditionalInfoInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<AdditionalInfoTypeEnum>;
  value?: InputMaybe<Scalars['AdditionalInfoValue']['input']>;
};

export type CreatePositionInput = {
  position: PositionInput;
};

export type CreateRateCommissionInput = {
  baseAssetTicker: Scalars['String']['input'];
  percent: Scalars['Float']['input'];
  quoteAssetTicker: Scalars['String']['input'];
};

export type CreateRegionInput = {
  region: RegionInput;
};

export type CreateScoringRiskLevelInput = {
  max: Scalars['Int']['input'];
  min: Scalars['Int']['input'];
  /** LOW_RISK, MEDIUM_RISK, HIGH_RISK, VERY_HIGH_RISK, PROHIBITED_RISK */
  scoringRiskLevel: ScoringRiskLevelEnum;
};

export type CreateTariffClientInput = {
  billingPeriod?: InputMaybe<Scalars['String']['input']>;
  clientCategory: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  tariffId: Scalars['ID']['input'];
};

export type CreateTariffCommissionFactorCascadeInput = {
  amountFrom: Scalars['BigNumber']['input'];
  amountTo: Scalars['BigNumber']['input'];
  conditions?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  fixed?: InputMaybe<Scalars['BigNumber']['input']>;
  formula?: InputMaybe<Scalars['String']['input']>;
  max?: InputMaybe<Scalars['BigNumber']['input']>;
  min?: InputMaybe<Scalars['BigNumber']['input']>;
  name: Scalars['String']['input'];
  order: Scalars['Float']['input'];
  percent?: InputMaybe<Scalars['BigNumber']['input']>;
  type: Scalars['String']['input'];
};

export type CreateTariffCommissionFactorInput = {
  amountFrom: Scalars['BigNumber']['input'];
  amountTo: Scalars['BigNumber']['input'];
  commissionId: Scalars['ID']['input'];
  conditions?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  fixed?: InputMaybe<Scalars['BigNumber']['input']>;
  formula?: InputMaybe<Scalars['String']['input']>;
  max?: InputMaybe<Scalars['BigNumber']['input']>;
  min?: InputMaybe<Scalars['BigNumber']['input']>;
  name: Scalars['String']['input'];
  order: Scalars['Float']['input'];
  percent?: InputMaybe<Scalars['BigNumber']['input']>;
  type: Scalars['String']['input'];
};

export type CreateTariffCommissionInput = {
  clientId?: InputMaybe<Scalars['ID']['input']>;
  currencyTicker: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  factors?: InputMaybe<Array<CreateTariffCommissionFactorCascadeInput>>;
  isBaseCurrency: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  operationId: Scalars['ID']['input'];
  tariffIds: Array<Scalars['ID']['input']>;
};

export type CreateTariffInput = {
  clientCategory: Scalars['String']['input'];
  commissionIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  conditions: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  limitIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  name: Scalars['String']['input'];
  operationIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type CreateTariffLimitInput = {
  annual: Scalars['BigNumber']['input'];
  clientId?: InputMaybe<Scalars['ID']['input']>;
  currencyTicker: Scalars['String']['input'];
  daily: Scalars['BigNumber']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  isBaseCurrency: Scalars['Boolean']['input'];
  max?: InputMaybe<Scalars['BigNumber']['input']>;
  min?: InputMaybe<Scalars['BigNumber']['input']>;
  monthly: Scalars['BigNumber']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  operationId: Scalars['ID']['input'];
  restrictionId?: InputMaybe<Scalars['ID']['input']>;
  tariffIds: Array<Scalars['ID']['input']>;
  weekly: Scalars['BigNumber']['input'];
};

export type CreateTariffLimitRestrictionInput = {
  currencyTicker: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  limitIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  max?: InputMaybe<Scalars['BigNumber']['input']>;
  maxAnnual: Scalars['BigNumber']['input'];
  maxDaily: Scalars['BigNumber']['input'];
  maxMonthly: Scalars['BigNumber']['input'];
  maxWeekly: Scalars['BigNumber']['input'];
  min?: InputMaybe<Scalars['BigNumber']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type CreateTariffOperationHistoryInput = {
  amount: Scalars['BigNumber']['input'];
  clientId: Scalars['ID']['input'];
  currencyTicker: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  operationId: Scalars['ID']['input'];
  status: TariffOperationHistoryStatusEnum;
  trackerId: Scalars['String']['input'];
};

export type CreateTariffOperationInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  tariffIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type CreateUnitInput = {
  unit: UnitInput;
};

export type CreateUserCardInput = {
  token: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};

export type CreateUserCompanyMemberInput = {
  companyIds: Array<Scalars['ID']['input']>;
  pep?: InputMaybe<CreateUserCompanyMemberPepInput>;
  positions?: InputMaybe<Array<Scalars['String']['input']>>;
  share?: InputMaybe<Scalars['Float']['input']>;
  type: CompanyMemberType;
};

export type CreateUserCompanyMemberPepInput = {
  endWorkingDate?: InputMaybe<Scalars['DateTime']['input']>;
  position?: InputMaybe<Scalars['String']['input']>;
  startWorkingDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CreateUserDocumentFieldInput = {
  fieldConfigId: Scalars['ID']['input'];
  value: Scalars['String']['input'];
};

export type CreateUserInput = {
  addresses?: InputMaybe<Array<CreateMyAddressInput>>;
  companiesMember?: InputMaybe<Array<CreateUserCompanyMemberInput>>;
  documents?: InputMaybe<Array<CrateUserDocumentInput>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  personal?: InputMaybe<PersonalInput>;
  service: Scalars['String']['input'];
};

export type CreateVatInput = {
  /** [Dictionary] VAT is Value Added Tax number/code of company or person */
  vat: VatInput;
};

export type CreateVirtualAccountInput = {
  iban: Scalars['String']['input'];
  provider: AccountsProviderEnum;
  realAccountId: Scalars['ID']['input'];
};

export type CreateWebSdkLinkInput = {
  externalUserId: Scalars['String']['input'];
  levelName: Scalars['String']['input'];
  ttlInSecs?: InputMaybe<Scalars['Int']['input']>;
};

export type CreateWebSdkLinkType = {
  __typename?: 'CreateWebSDKLinkType';
  url: Scalars['String']['output'];
};

export type CreatedDocument = {
  __typename?: 'CreatedDocument';
  clientId: Scalars['ID']['output'];
  clientType: IdentityTypeEnum;
  config?: Maybe<DocumentConfig>;
  country?: Maybe<Country>;
  createdAt: Scalars['DateTime']['output'];
  fields: Array<DocumentField>;
  fileUrls: Array<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isTemporary: Scalars['Boolean']['output'];
  status: DocumentStatus;
  updatedAt: Scalars['DateTime']['output'];
};

export type CreatedOrUpdatedAddress = {
  __typename?: 'CreatedOrUpdatedAddress';
  buildingName?: Maybe<Scalars['String']['output']>;
  buildingNumber?: Maybe<Scalars['String']['output']>;
  city?: Maybe<City>;
  clientId: Scalars['ID']['output'];
  /** additional comment */
  comment?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Country>;
  createdAt: Scalars['DateTime']['output'];
  flatNumber?: Maybe<Scalars['String']['output']>;
  /** presentation of address as formatted string */
  formattedStringValue: Scalars['String']['output'];
  /** presentation of address as formatted string english */
  formattedStringValueEn: Scalars['String']['output'];
  geoLatitude?: Maybe<Scalars['String']['output']>;
  geoLongitude?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isActual?: Maybe<Scalars['Boolean']['output']>;
  isLegal?: Maybe<Scalars['Boolean']['output']>;
  isPrimary: Scalars['Boolean']['output'];
  postalCode?: Maybe<Scalars['String']['output']>;
  rawCityName?: Maybe<Scalars['String']['output']>;
  rawCityNameEn?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  stateEn?: Maybe<Scalars['String']['output']>;
  street?: Maybe<Scalars['String']['output']>;
  streetEn?: Maybe<Scalars['String']['output']>;
  subStreet?: Maybe<Scalars['String']['output']>;
  subStreetEn?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export enum CreditType {
  Account = 'ACCOUNT',
  Card = 'CARD',
  Iban = 'IBAN',
  Phone = 'PHONE',
  Swift = 'SWIFT'
}

export type Currency = {
  __typename?: 'Currency';
  icon?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  item: CommonDictItem;
  networkList?: Maybe<Array<CoinNetwork>>;
  precision: Scalars['Int']['output'];
  stats?: Maybe<CurrencyStats>;
  symbol?: Maybe<Scalars['String']['output']>;
  ticker: Scalars['String']['output'];
  type: CurrencyType;
};


export type CurrencyStatsArgs = {
  targetTicker: Scalars['String']['input'];
};

export type CurrencyInput = {
  name: Scalars['String']['input'];
  precision: Scalars['Int']['input'];
  symbol?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<AttachDetachTagsInput>;
  ticker: Scalars['String']['input'];
  type: CurrencyType;
};

export type CurrencyPrice = {
  __typename?: 'CurrencyPrice';
  price: Scalars['Float']['output'];
};

export type CurrencyStats = {
  __typename?: 'CurrencyStats';
  marketCap: Scalars['String']['output'];
  price: Scalars['String']['output'];
  priceChangePercent: Scalars['Float']['output'];
  volume: Scalars['String']['output'];
};

export enum CurrencyType {
  Crypto = 'CRYPTO',
  Fiat = 'FIAT'
}

export type Customer = {
  __typename?: 'Customer';
  addresses?: Maybe<CustomerAddresses>;
  id: Scalars['String']['output'];
  names?: Maybe<CustomerNames>;
  status: CustomerStatus;
  type: CustomerType;
};

export type CustomerAddress = {
  __typename?: 'CustomerAddress';
  addressLine?: Maybe<MultiLang>;
  city?: Maybe<MultiLang>;
  country?: Maybe<Scalars['String']['output']>;
  postalCode?: Maybe<Scalars['String']['output']>;
  state?: Maybe<MultiLang>;
};

export type CustomerAddresses = {
  __typename?: 'CustomerAddresses';
  correspondence?: Maybe<CustomerAddress>;
  registration?: Maybe<CustomerAddress>;
};

export type CustomerNames = {
  __typename?: 'CustomerNames';
  first?: Maybe<MultiLang>;
  full?: Maybe<MultiLang>;
  last?: Maybe<MultiLang>;
  middle?: Maybe<MultiLang>;
};

export enum CustomerStatus {
  Active = 'ACTIVE',
  Blocked = 'BLOCKED',
  Deactivated = 'DEACTIVATED',
  Inactive = 'INACTIVE'
}

export enum CustomerType {
  Beneficiary = 'BENEFICIARY',
  Corporate = 'CORPORATE',
  Correspondent = 'CORRESPONDENT',
  Native = 'NATIVE',
  Retail = 'RETAIL'
}

export type DateRangeInput = {
  from?: InputMaybe<Scalars['DateTime']['input']>;
  to?: InputMaybe<Scalars['DateTime']['input']>;
};

export type DeclineCorporateVirtualIbanAllocationInput = {
  companyId: Scalars['ID']['input'];
  moderationComment: Scalars['String']['input'];
};

export type DeleteIntermediaryInput = {
  id: Scalars['String']['input'];
};

/**
 * Description: input to delete an operation
 *
 * Example:
 *
 *
 *
 * {
 *
 *
 * "title": "BUYCRYPTO"
 *
 *
 * }
 */
export type DeleteOperationInput = {
  /**
   * Required: true
   *
   * Description: title type
   *
   * Format:
   *
   *         string parameters from custom enum
   *
   *
   * Example:
   *
   *         "BUYCRYPTO"
   */
  title: Scalars['String']['input'];
};

export type DetailSourceOfWealth = {
  __typename?: 'DetailSourceOfWealth';
  amount: Scalars['String']['output'];
  currency: Currency;
  key: Scalars['String']['output'];
  sourceOfWealth: Scalars['String']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type DetailSourceOfWealthInput = {
  amount: Scalars['String']['input'];
  currencyId: Scalars['String']['input'];
  sourceOfWealth: Scalars['String']['input'];
};

export enum Device {
  Email = 'EMAIL',
  Eos = 'EOS',
  P256 = 'P256',
  Phone = 'PHONE'
}

export type DeviceInfo = {
  __typename?: 'DeviceInfo';
  confirm: Scalars['Boolean']['output'];
  deviceId: Scalars['String']['output'];
  identity: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type DictFilterInput = {
  countryId?: InputMaybe<Scalars['ID']['input']>;
  filter?: InputMaybe<Filter>;
  itemQuery?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tickers?: InputMaybe<Array<Scalars['String']['input']>>;
  type?: InputMaybe<CurrencyType>;
};

export type DictFilterV2Input = {
  countryId?: InputMaybe<Scalars['ID']['input']>;
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  itemQuery?: InputMaybe<Scalars['String']['input']>;
  pagination?: InputMaybe<PaginationInput>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tickers?: InputMaybe<Array<Scalars['String']['input']>>;
  type?: InputMaybe<CurrencyType>;
};

export type DictionaryFilter = {
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  pagination?: InputMaybe<PaginationInput>;
};

export type Document = {
  __typename?: 'Document';
  clientId: Scalars['ID']['output'];
  clientType: IdentityTypeEnum;
  config?: Maybe<DocumentConfig>;
  country?: Maybe<Country>;
  createdAt: Scalars['DateTime']['output'];
  externalRejectReasons?: Maybe<Scalars['String']['output']>;
  fields: DocumentFields;
  fileIds?: Maybe<Array<Scalars['String']['output']>>;
  fileUrls: Array<Scalars['String']['output']>;
  files: Array<File>;
  id: Scalars['ID']['output'];
  internalRejectReasons?: Maybe<Scalars['String']['output']>;
  isActive: Scalars['Boolean']['output'];
  isTemporary: Scalars['Boolean']['output'];
  rejectTags?: Maybe<Array<Scalars['String']['output']>>;
  status: DocumentStatus;
  updatedAt: Scalars['DateTime']['output'];
};


export type DocumentFieldsArgs = {
  input: FilterInput;
};

export type DocumentConfig = {
  __typename?: 'DocumentConfig';
  availableCountries: Array<Country>;
  configVersion: Scalars['Int']['output'];
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  docType: Scalars['String']['output'];
  documents: Documents;
  fieldConfigs: DocumentFieldConfigs;
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};


export type DocumentConfigDocumentsArgs = {
  input: FilterInput;
};


export type DocumentConfigFieldConfigsArgs = {
  input: FilterInput;
};

export enum DocumentConfigSortField {
  CreatedAt = 'CREATED_AT',
  Name = 'NAME',
  UpdatedAt = 'UPDATED_AT'
}

export type DocumentConfigSortInput = {
  direction: SortOrder;
  field: DocumentConfigSortField;
};

export type DocumentConfigs = {
  __typename?: 'DocumentConfigs';
  count: Scalars['Int']['output'];
  cursor: Scalars['Int']['output'];
  nodes: Array<DocumentConfig>;
};

export type DocumentField = {
  __typename?: 'DocumentField';
  config?: Maybe<DocumentFieldConfig>;
  createdAt: Scalars['DateTime']['output'];
  document?: Maybe<Document>;
  id: Scalars['ID']['output'];
  updatedAt: Scalars['DateTime']['output'];
  value: Scalars['String']['output'];
};

export type DocumentFieldConfig = {
  __typename?: 'DocumentFieldConfig';
  createdAt: Scalars['DateTime']['output'];
  description: Scalars['String']['output'];
  displayInTable: Scalars['Boolean']['output'];
  documentConfig?: Maybe<DocumentConfig>;
  fields: DocumentFields;
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  key: Scalars['String']['output'];
  label: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  type: DocumentFieldType;
  updatedAt: Scalars['DateTime']['output'];
};


export type DocumentFieldConfigFieldsArgs = {
  input: FilterInput;
};

export enum DocumentFieldConfigSortField {
  CreatedAt = 'CREATED_AT',
  Description = 'DESCRIPTION',
  UpdatedAt = 'UPDATED_AT'
}

export type DocumentFieldConfigSortInput = {
  direction: SortOrder;
  field: DocumentFieldConfigSortField;
};

export type DocumentFieldConfigs = {
  __typename?: 'DocumentFieldConfigs';
  count: Scalars['Int']['output'];
  cursor: Scalars['Int']['output'];
  nodes: Array<DocumentFieldConfig>;
};

export enum DocumentFieldType {
  Boolean = 'BOOLEAN',
  Date = 'DATE',
  Number = 'NUMBER',
  String = 'STRING'
}

export type DocumentFields = {
  __typename?: 'DocumentFields';
  count: Scalars['Int']['output'];
  cursor: Scalars['Int']['output'];
  nodes: Array<DocumentField>;
};

export type DocumentRejectTag = {
  __typename?: 'DocumentRejectTag';
  action: DocumentRejectTagAction;
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  tags: Array<Scalars['String']['output']>;
};

export enum DocumentRejectTagAction {
  Rejected = 'REJECTED',
  RejectedRetry = 'REJECTED_RETRY'
}

export type DocumentRejectTags = {
  __typename?: 'DocumentRejectTags';
  count: Scalars['Int']['output'];
  cursor: Scalars['Int']['output'];
  nodes: Array<DocumentRejectTag>;
};

export enum DocumentSortField {
  CreatedAt = 'CREATED_AT',
  DocType = 'DOC_TYPE',
  Name = 'NAME',
  UpdatedAt = 'UPDATED_AT'
}

export type DocumentSortInput = {
  direction: SortOrder;
  field: DocumentSortField;
};

export enum DocumentStatus {
  Approved = 'APPROVED',
  NotReviewed = 'NOT_REVIEWED',
  Rejected = 'REJECTED',
  RejectedRetry = 'REJECTED_RETRY'
}

export type Documents = {
  __typename?: 'Documents';
  count: Scalars['Int']['output'];
  cursor: Scalars['Int']['output'];
  nodes: Array<Document>;
};

export type DynamicAuthData = {
  __typename?: 'DynamicAuthData';
  key: Scalars['String']['output'];
  label: Scalars['String']['output'];
};

export type DynamicAuthInstanceData = {
  __typename?: 'DynamicAuthInstanceData';
  methods: Array<DynamicAuthData>;
  name: Scalars['String']['output'];
};

export type DynamicAuthLoginResponse = {
  __typename?: 'DynamicAuthLoginResponse';
  authorizationHeaders: Scalars['JSON']['output'];
  ok: Scalars['Boolean']['output'];
  response: Scalars['JSON']['output'];
};

export type DynamicAuthLoginWithCredentialsInput = {
  credentials: Scalars['JSON']['input'];
  name: Scalars['String']['input'];
};

export type EmailDeviceInfo = {
  __typename?: 'EmailDeviceInfo';
  confirm: Scalars['Boolean']['output'];
  deviceId: Scalars['String']['output'];
  identity: Scalars['String']['output'];
  type: Device;
};

export type Exchange = {
  __typename?: 'Exchange';
  clientId: Scalars['ID']['output'];
  credit: ExchangeSide;
  debit: ExchangeSide;
  description?: Maybe<Scalars['String']['output']>;
  errorMessage?: Maybe<Scalars['String']['output']>;
  exchange: ExchangeEnum;
  exchangeId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  metadata: Scalars['JSON']['output'];
  state: ExchangeStateEnum;
};

export type ExchangeCodeInput = {
  code: Scalars['String']['input'];
  service: Scalars['String']['input'];
};

export type ExchangeConfig = {
  __typename?: 'ExchangeConfig';
  description?: Maybe<Scalars['String']['output']>;
  exchange: ExchangeEnum;
  id: Scalars['ID']['output'];
  steps?: Maybe<ExchangeStepConfigs>;
};


export type ExchangeConfigStepsArgs = {
  input?: InputMaybe<FindExchangeStepConfigsInput>;
};

export type ExchangeConfigs = {
  __typename?: 'ExchangeConfigs';
  count: Scalars['Int']['output'];
  cursor: Scalars['Int']['output'];
  nodes: Array<ExchangeConfig>;
};

export enum ExchangeEnum {
  CryptoToFiat = 'CRYPTO_TO_FIAT',
  FiatToCrypto = 'FIAT_TO_CRYPTO',
  FiatToFiat = 'FIAT_TO_FIAT',
  TopUpServiceCrypto = 'TOP_UP_SERVICE_CRYPTO',
  TopUpServiceFiat = 'TOP_UP_SERVICE_FIAT'
}

export type ExchangeInput = {
  credit?: InputMaybe<ExchangeSideInput>;
  debit?: InputMaybe<ExchangeSideInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  /** Trading direction */
  exchange: ExchangeEnum;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
};

export enum ExchangeService {
  Binance = 'BINANCE'
}

export type ExchangeSide = {
  __typename?: 'ExchangeSide';
  /** Account */
  account?: Maybe<Account>;
  /** Amount of the transaction */
  amount: Scalars['BigNumber']['output'];
  /** Ticker of the currency involved in the transaction. For example: USDT */
  currencyTicker: Scalars['String']['output'];
};

export type ExchangeSideInput = {
  /** ID of the account */
  accountId?: InputMaybe<Scalars['ID']['input']>;
  /** Amount of the transaction */
  amount: Scalars['BigNumber']['input'];
  /** Ticker of the currency involved in the transaction. For example: USDT */
  currencyTicker: Scalars['String']['input'];
};

export enum ExchangeStateEnum {
  Declined = 'DECLINED',
  Error = 'ERROR',
  Pending = 'PENDING',
  Processing = 'PROCESSING',
  Successful = 'SUCCESSFUL'
}

export type ExchangeStep = {
  __typename?: 'ExchangeStep';
  docNum?: Maybe<Scalars['String']['output']>;
  errorMessage?: Maybe<Scalars['String']['output']>;
  exchange?: Maybe<Exchange>;
  exchangeStepConfig?: Maybe<ExchangeStepConfig>;
  id: Scalars['ID']['output'];
  state: ExchangeStepStateEnum;
};

export type ExchangeStepConfig = {
  __typename?: 'ExchangeStepConfig';
  description?: Maybe<Scalars['String']['output']>;
  exchangeConfig: ExchangeConfig;
  id: Scalars['ID']['output'];
  order: Scalars['Int']['output'];
  step: ExchangeStepConfigTypeEnum;
};

export enum ExchangeStepConfigTypeEnum {
  CjTeCryptoToCjTeFiat = 'CJ_TE_CRYPTO_TO_CJ_TE_FIAT',
  CjTeFiatToCjTeCrypto = 'CJ_TE_FIAT_TO_CJ_TE_CRYPTO',
  ClientCryptoToNostroCrypto = 'CLIENT_CRYPTO_TO_NOSTRO_CRYPTO',
  ClientCryptoToTeCrypto = 'CLIENT_CRYPTO_TO_TE_CRYPTO',
  ClientFiatToNostroFiat = 'CLIENT_FIAT_TO_NOSTRO_FIAT',
  ClientFiatToTeFiat = 'CLIENT_FIAT_TO_TE_FIAT',
  NostroCryptoToClientCrypto = 'NOSTRO_CRYPTO_TO_CLIENT_CRYPTO',
  NostroCryptoToTeCrypto = 'NOSTRO_CRYPTO_TO_TE_CRYPTO',
  NostroFiatToClientFiat = 'NOSTRO_FIAT_TO_CLIENT_FIAT',
  NostroFiatToTeFiat = 'NOSTRO_FIAT_TO_TE_FIAT',
  TeCryptoToClientCrypto = 'TE_CRYPTO_TO_CLIENT_CRYPTO',
  TeCryptoToNostroCrypto = 'TE_CRYPTO_TO_NOSTRO_CRYPTO',
  TeFiatToClientFiat = 'TE_FIAT_TO_CLIENT_FIAT',
  TeFiatToNostroFiat = 'TE_FIAT_TO_NOSTRO_FIAT'
}

export type ExchangeStepConfigs = {
  __typename?: 'ExchangeStepConfigs';
  count: Scalars['Int']['output'];
  cursor: Scalars['Int']['output'];
  nodes: Array<ExchangeStepConfig>;
};

export enum ExchangeStepStateEnum {
  Error = 'ERROR',
  Pending = 'PENDING',
  Processing = 'PROCESSING',
  Successful = 'SUCCESSFUL'
}

export type Exchanges = {
  __typename?: 'Exchanges';
  count: Scalars['Int']['output'];
  cursor: Scalars['Int']['output'];
  nodes: Array<Exchange>;
};

export type ExecuteCardPaymentInput = {
  amount: PaymentsAmountInput;
  createdAt: Scalars['Timestamp']['input'];
  creditor: PaymentAccountInput;
  debitor: PaymentAccountInput;
  description?: InputMaybe<Scalars['String']['input']>;
  fee: PaymentsFeeInput;
  id?: InputMaybe<Scalars['ID']['input']>;
  isDeclined: Scalars['Boolean']['input'];
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  trackerId?: InputMaybe<Scalars['ID']['input']>;
  type: PaymentType;
};

export type ExecuteKybStepInput = {
  companyId: Scalars['String']['input'];
  documentIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  step: KybStepEnum;
};

export type ExecuteKycStepInput = {
  documentIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  step: KycStepEnum;
  userId: Scalars['String']['input'];
};

export type ExternalCompany = {
  __typename?: 'ExternalCompany';
  addresses?: Maybe<Array<Maybe<AddressData>>>;
  contacts?: Maybe<Array<Maybe<ExternalCompanyContact>>>;
  country: Country;
  id: Scalars['ID']['output'];
  item: CommonDictItem;
  kindOfActivity?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  members?: Maybe<Array<Maybe<ExternalCompanyMember>>>;
  registrationDate?: Maybe<Scalars['DateTime']['output']>;
  registrationNumber?: Maybe<Scalars['String']['output']>;
  state?: Maybe<ExternalCompanyState>;
  vat?: Maybe<Vat>;
  website?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type ExternalCompanyContact = {
  __typename?: 'ExternalCompanyContact';
  type: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type ExternalCompanyMember = {
  __typename?: 'ExternalCompanyMember';
  email?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: FullName;
  /** According to position type */
  position?: Maybe<Position>;
};

export enum ExternalCompanyState {
  Active = 'ACTIVE'
}

export type File = {
  __typename?: 'File';
  /** required if private is true. Equal to null otherwise */
  accessToken?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  mimetype: Scalars['String']['output'];
  originalName: Scalars['String']['output'];
  owner: User;
  private: Scalars['Boolean']['output'];
  /** to be implemented. Must be equal 'default' for now */
  serviceName: Scalars['String']['output'];
  size: Scalars['String']['output'];
  /** public url for file download */
  url: Scalars['String']['output'];
};

export type FileSearchFilterInput = {
  /** how many files returns in request. Default: 20 */
  limit?: InputMaybe<Scalars['Float']['input']>;
  mimetype?: InputMaybe<Scalars['String']['input']>;
  ownerId?: InputMaybe<Scalars['String']['input']>;
  /** access token for file required if private is true */
  private?: InputMaybe<Scalars['Boolean']['input']>;
  /** searching in mimetype, serviceName, originalName for full or partial match */
  query?: InputMaybe<Scalars['String']['input']>;
  serviceName?: InputMaybe<Scalars['String']['input']>;
  /** how many files skip from first one. Default: 0 */
  skip?: InputMaybe<Scalars['Float']['input']>;
  uploadedAfter?: InputMaybe<Scalars['DateTime']['input']>;
  uploadedBefore?: InputMaybe<Scalars['DateTime']['input']>;
};

export type Filter = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};

export type FilterFactorsInput = {
  conditions?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type FilterFromCore = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};

export type FilterInput = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  pagination: PaginationInput;
};

export type FinancialAmountInput = {
  amount: Scalars['BigNumber']['input'];
  currencyId: Scalars['String']['input'];
};

export type FinancialAmountType = {
  __typename?: 'FinancialAmountType';
  amount: Scalars['BigNumber']['output'];
  currency: Currency;
};

export type FindAdditionalInfosInput = {
  clientId?: InputMaybe<Scalars['ID']['input']>;
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  keys?: InputMaybe<Array<Scalars['String']['input']>>;
  pagination: PaginationInput;
  search?: InputMaybe<Scalars['String']['input']>;
};

export type FindAddressInput = {
  categoryIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  categoryName?: InputMaybe<Scalars['String']['input']>;
  cityId?: InputMaybe<Scalars['ID']['input']>;
  clientId?: InputMaybe<Scalars['ID']['input']>;
  countryId?: InputMaybe<Scalars['ID']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  isPrimary?: InputMaybe<Scalars['Boolean']['input']>;
  rawCityName?: InputMaybe<Scalars['String']['input']>;
};

export type FindAddressesInput = {
  categoryIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  categoryName?: InputMaybe<Scalars['String']['input']>;
  cityId?: InputMaybe<Scalars['ID']['input']>;
  clientId?: InputMaybe<Scalars['ID']['input']>;
  countryId?: InputMaybe<Scalars['ID']['input']>;
  countryIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  createdAt?: InputMaybe<AddressesDateRangeInput>;
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  isActual?: InputMaybe<Scalars['Boolean']['input']>;
  isPrimary?: InputMaybe<Scalars['Boolean']['input']>;
  pagination: PaginationInput;
  rawCityName?: InputMaybe<Scalars['String']['input']>;
  rawCityNameEn?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<AddressesDateRangeInput>;
};

export type FindAgeRangeStatisticSettingsInput = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  pagination: PaginationInput;
  rangeNames?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type FindCompaniesInput = {
  /** Date of creation */
  createdAt?: InputMaybe<CompaniesDateRangeInput>;
  /** Current KYB level */
  currentKybLevels?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Status of the current KYB step */
  currentKybStepStatuses?: InputMaybe<Array<KybStepStatusEnum>>;
  /** Current KYB step */
  currentKybSteps?: InputMaybe<Array<KybStepEnum>>;
  /** Created after the specified timestamp */
  from?: InputMaybe<Scalars['Long']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Is internal transfer allowed */
  isInternalTransferAllowed?: InputMaybe<Scalars['Boolean']['input']>;
  /** KYB configuration IDs */
  kybConfigIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Company name */
  name?: InputMaybe<Scalars['String']['input']>;
  pagination: PaginationInput;
  /** ID of the user who registered the company */
  registrantId?: InputMaybe<Scalars['ID']['input']>;
  /** Company scorink risk level */
  scoringRiskLevels?: InputMaybe<Array<ScoringRiskLevelEnum>>;
  /** Search by company main information */
  search?: InputMaybe<Scalars['String']['input']>;
  service?: InputMaybe<Scalars['String']['input']>;
  /** Sort companies by provided field and direction */
  sort?: InputMaybe<SortCompaniesInput>;
  /** Created before the specified timestamp */
  to?: InputMaybe<Scalars['Long']['input']>;
  /** Date of last update */
  updatedAt?: InputMaybe<CompaniesDateRangeInput>;
  /** Without parents companies. Default is true */
  withoutParents?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FindCompanyInput = {
  additionalInfos?: InputMaybe<Array<CreateMyAdditionalInfoInput>>;
  annualTurnover?: InputMaybe<FinancialAmountInput>;
  businessActivityIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  businessEmail?: InputMaybe<Scalars['String']['input']>;
  businessPhone?: InputMaybe<Scalars['String']['input']>;
  businessProfit?: InputMaybe<FinancialAmountInput>;
  companyOwnershipStructure?: InputMaybe<CompanyOwnershipStructure>;
  companyTypeId?: InputMaybe<Scalars['ID']['input']>;
  controlSchema?: InputMaybe<Scalars['String']['input']>;
  countryOfIncorporationId?: InputMaybe<Scalars['ID']['input']>;
  dateOfIncorporation?: InputMaybe<Scalars['DateTime']['input']>;
  detailsSourceOfWealth?: InputMaybe<Array<DetailSourceOfWealthInput>>;
  employmentIncome?: InputMaybe<FinancialAmountInput>;
  faxNumber?: InputMaybe<Scalars['String']['input']>;
  finalDecision?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  incomingPaymentsByCountries?: InputMaybe<Array<PaymentFlowByCountryInput>>;
  incomingPaymentsByCurrencies?: InputMaybe<Array<PaymentFlowByCurrencyInput>>;
  isInternalTransferAllowed?: InputMaybe<Scalars['Boolean']['input']>;
  loan?: InputMaybe<FinancialAmountInput>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  otherPlannedAccountUse?: InputMaybe<Scalars['String']['input']>;
  otherPurposeForAccountOpening?: InputMaybe<Scalars['String']['input']>;
  otherReasonsForAccountOpening?: InputMaybe<Scalars['String']['input']>;
  otherSourceOfFunds?: InputMaybe<Scalars['String']['input']>;
  otherSourceOfWealth?: InputMaybe<Scalars['String']['input']>;
  outgoingPaymentsByCountries?: InputMaybe<Array<PaymentFlowByCountryInput>>;
  outgoingPaymentsByCurrencies?: InputMaybe<Array<PaymentFlowByCurrencyInput>>;
  paidUpShareCapital?: InputMaybe<FinancialAmountInput>;
  plannedAccountUse?: InputMaybe<Array<Scalars['String']['input']>>;
  purposeForAccountOpening?: InputMaybe<Array<Scalars['String']['input']>>;
  reasonsForAccountOpening?: InputMaybe<Array<Scalars['String']['input']>>;
  registeredBusinessName?: InputMaybe<Scalars['String']['input']>;
  registrantId?: InputMaybe<Scalars['ID']['input']>;
  registrationLocation?: InputMaybe<Scalars['String']['input']>;
  registrationNumber?: InputMaybe<Scalars['String']['input']>;
  savingsAndDeposit?: InputMaybe<FinancialAmountInput>;
  scoringRiskLevel?: InputMaybe<ScoringRiskLevelEnum>;
  service?: InputMaybe<Scalars['String']['input']>;
  share?: InputMaybe<Scalars['Float']['input']>;
  sourceOfFunds?: InputMaybe<Array<Scalars['String']['input']>>;
  sourceOfWealth?: InputMaybe<Array<Scalars['String']['input']>>;
  taxNumber?: InputMaybe<Scalars['String']['input']>;
  totalNumberOfEmployees?: InputMaybe<Scalars['String']['input']>;
  totalScore?: InputMaybe<Scalars['String']['input']>;
  tradingName?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
};

export type FindDocumentConfigInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type FindDocumentConfigsInput = {
  availableCountryIds?: InputMaybe<Array<Scalars['String']['input']>>;
  docTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  names?: InputMaybe<Array<Scalars['String']['input']>>;
  pagination: PaginationInput;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<DocumentConfigSortInput>;
};

export type FindDocumentFieldConfigInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type FindDocumentFieldConfigsInput = {
  displayInTable?: InputMaybe<Scalars['Boolean']['input']>;
  documentConfigIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  keys?: InputMaybe<Array<Scalars['String']['input']>>;
  labels?: InputMaybe<Array<Scalars['String']['input']>>;
  pagination: PaginationInput;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<DocumentFieldConfigSortInput>;
  types?: InputMaybe<Array<DocumentFieldType>>;
};

export type FindDocumentFieldInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type FindDocumentFieldsInput = {
  displayInTable?: InputMaybe<Scalars['Boolean']['input']>;
  documentIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  fieldConfigIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  pagination: PaginationInput;
  search?: InputMaybe<Scalars['String']['input']>;
};

export type FindDocumentInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type FindDocumentRejectTagsInput = {
  documentConfigIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  pagination: PaginationInput;
};

export type FindDocumentsInput = {
  clientIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  configIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  countryIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  pagination: PaginationInput;
  sort?: InputMaybe<DocumentSortInput>;
  statuses?: InputMaybe<Array<DocumentStatus>>;
};

export type FindExchangeConfigsInput = {
  exchange?: InputMaybe<ExchangeEnum>;
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  pagination?: InputMaybe<PaginationInput>;
};

export type FindExchangeInput = {
  cryptoOrderConfigId?: InputMaybe<Scalars['ID']['input']>;
  cryptoOrderStepId?: InputMaybe<Scalars['ID']['input']>;
  exchangeId?: InputMaybe<Scalars['ID']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  innerTransferState?: InputMaybe<InnerTransferStateEnum>;
};

export type FindExchangeStepConfigsInput = {
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  order?: InputMaybe<Scalars['Int']['input']>;
  pagination?: InputMaybe<PaginationInput>;
  step?: InputMaybe<ExchangeStepConfigTypeEnum>;
};

export type FindExchangesInput = {
  cryptoOrderConfigIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  currencyId?: InputMaybe<Scalars['ID']['input']>;
  exchangeId?: InputMaybe<Scalars['ID']['input']>;
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  innerTransferState?: InputMaybe<InnerTransferStateEnum>;
  pagination?: InputMaybe<PaginationInput>;
  state?: InputMaybe<ExchangeStateEnum>;
};

export type FindKybConfigsInput = {
  configVersions?: InputMaybe<Array<Scalars['Int']['input']>>;
  createdAt?: InputMaybe<IdentityDateRangeInput>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  levels?: InputMaybe<Array<Scalars['Int']['input']>>;
  pagination: PaginationInput;
  search?: InputMaybe<Scalars['String']['input']>;
  services?: InputMaybe<Array<Scalars['String']['input']>>;
  updatedAt?: InputMaybe<IdentityDateRangeInput>;
};

export type FindKybLevelStatusesInput = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  pagination: PaginationInput;
};

export type FindKybStepStatusesInput = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  levelStatusIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  pagination: PaginationInput;
  statuses?: InputMaybe<Array<KybStepStatus>>;
  stepConfigIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type FindKycConfigsInput = {
  configVersions?: InputMaybe<Array<Scalars['Int']['input']>>;
  createdAt?: InputMaybe<IdentityDateRangeInput>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  levels?: InputMaybe<Array<Scalars['Int']['input']>>;
  pagination: PaginationInput;
  search?: InputMaybe<Scalars['String']['input']>;
  services?: InputMaybe<Array<Scalars['String']['input']>>;
  updatedAt?: InputMaybe<IdentityDateRangeInput>;
};

export type FindKycLevelStatusesInput = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  pagination: PaginationInput;
};

export type FindKycStepStatusesInput = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  levelStatusIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  pagination: PaginationInput;
  statuses?: InputMaybe<Array<KycStepStatus>>;
  stepConfigIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type FindMemberInput = {
  companyIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  type?: InputMaybe<CompanyMemberType>;
};

export type FindMembersInput = {
  companyIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  excludeMemberIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  isPep?: InputMaybe<Scalars['Boolean']['input']>;
  pagination: PaginationInput;
  type?: InputMaybe<CompanyMemberType>;
  types?: InputMaybe<Array<CompanyMemberType>>;
};

export type FindMyAddressInput = {
  categoryIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  categoryName?: InputMaybe<Scalars['String']['input']>;
  cityId?: InputMaybe<Scalars['ID']['input']>;
  countryId?: InputMaybe<Scalars['ID']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  isPrimary?: InputMaybe<Scalars['Boolean']['input']>;
  rawCityName?: InputMaybe<Scalars['String']['input']>;
};

export type FindMyAddressesInput = {
  categoryIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  categoryName?: InputMaybe<Scalars['String']['input']>;
  cityId?: InputMaybe<Scalars['ID']['input']>;
  countryId?: InputMaybe<Scalars['ID']['input']>;
  countryIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  createdAt?: InputMaybe<AddressesDateRangeInput>;
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  isActual?: InputMaybe<Scalars['Boolean']['input']>;
  isPrimary?: InputMaybe<Scalars['Boolean']['input']>;
  pagination: PaginationInput;
  rawCityName?: InputMaybe<Scalars['String']['input']>;
  rawCityNameEn?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<AddressesDateRangeInput>;
};

export type FindMyDocumentsInput = {
  configIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  countryIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  pagination: PaginationInput;
  sort?: InputMaybe<DocumentSortInput>;
  statuses?: InputMaybe<Array<DocumentStatus>>;
};

export type FindOrderFiltersForPairInput = {
  filterName?: InputMaybe<Scalars['String']['input']>;
  /** The base/quote ticker to be applied as a pair part. */
  firstAsset: Scalars['String']['input'];
  owner?: InputMaybe<ExchangeService>;
  /** The quote/base ticker to be applied as a pair part. */
  secondAsset: Scalars['String']['input'];
};

export type FindOrderFiltersInput = {
  baseAsset?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  owner?: InputMaybe<ExchangeService>;
  quoteAsset?: InputMaybe<Scalars['String']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  symbol?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<OrderFilterType>;
};

export type FindOrderPairsInput = {
  baseAsset?: InputMaybe<Scalars['String']['input']>;
  owner: ExchangeService;
  /** Tries to find the pair with specified assets. */
  pair?: InputMaybe<Array<Scalars['String']['input']>>;
  quoteAsset?: InputMaybe<Scalars['String']['input']>;
  /** Tries to find any pairs with passed assets. */
  withAssets?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type FindTariffClientInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  tariffId?: InputMaybe<Scalars['ID']['input']>;
};

export type FindTariffClientsInput = {
  billingPeriod?: InputMaybe<TariffDateRangeInput>;
  createdAt?: InputMaybe<TariffDateRangeInput>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  operationHistoryIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  pagination: PaginationInput;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<SortTariffClientsInput>;
  tariffId?: InputMaybe<Scalars['ID']['input']>;
  tariffIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  updatedAt?: InputMaybe<TariffDateRangeInput>;
};

export type FindTariffCommissionFactorInput = {
  commissionId?: InputMaybe<Scalars['ID']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type FindTariffCommissionFactorsInput = {
  commissionId?: InputMaybe<Scalars['ID']['input']>;
  createdAt?: InputMaybe<TariffDateRangeInput>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  pagination: PaginationInput;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<TariffEntitySortInput>;
  updatedAt?: InputMaybe<TariffDateRangeInput>;
};

export type FindTariffCommissionInput = {
  clientId?: InputMaybe<Scalars['ID']['input']>;
  currencyTicker?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  operationId?: InputMaybe<Scalars['ID']['input']>;
  tariffId?: InputMaybe<Scalars['ID']['input']>;
};

export type FindTariffCommissionsInput = {
  clientId?: InputMaybe<Scalars['String']['input']>;
  clientIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  commissionFactorIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  createdAt?: InputMaybe<TariffDateRangeInput>;
  currencyTickers?: InputMaybe<Array<Scalars['String']['input']>>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  isBaseCurrency?: InputMaybe<Scalars['Boolean']['input']>;
  operationId?: InputMaybe<Scalars['String']['input']>;
  operationIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  pagination: PaginationInput;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<TariffEntitySortInput>;
  tariffId?: InputMaybe<Scalars['String']['input']>;
  tariffIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  updatedAt?: InputMaybe<TariffDateRangeInput>;
  withAttachedClientsOnly?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FindTariffInput = {
  conditions?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type FindTariffLimitInput = {
  clientId?: InputMaybe<Scalars['ID']['input']>;
  currencyTicker?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  isBaseCurrency?: InputMaybe<Scalars['Boolean']['input']>;
  operationId?: InputMaybe<Scalars['ID']['input']>;
  tariffId?: InputMaybe<Scalars['ID']['input']>;
};

export type FindTariffLimitRestrictionInput = {
  currencyTicker?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type FindTariffLimitRestrictionsInput = {
  createdAt?: InputMaybe<TariffDateRangeInput>;
  currencyTickers?: InputMaybe<Array<Scalars['String']['input']>>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  limitId?: InputMaybe<Scalars['ID']['input']>;
  limitIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  pagination: PaginationInput;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<TariffEntitySortInput>;
  updatedAt?: InputMaybe<TariffDateRangeInput>;
};

export type FindTariffLimitsInput = {
  clientId?: InputMaybe<Scalars['ID']['input']>;
  clientIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  createdAt?: InputMaybe<TariffDateRangeInput>;
  currencyTickers?: InputMaybe<Array<Scalars['String']['input']>>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  isBaseCurrency?: InputMaybe<Scalars['Boolean']['input']>;
  operationId?: InputMaybe<Scalars['ID']['input']>;
  operationIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  pagination: PaginationInput;
  restrictionIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<TariffEntitySortInput>;
  tariffId?: InputMaybe<Scalars['ID']['input']>;
  tariffIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  updatedAt?: InputMaybe<TariffDateRangeInput>;
  withAttachedClientsOnly?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FindTariffOperationChainsInput = {
  clientIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  commissionId?: InputMaybe<Scalars['ID']['input']>;
  commissionIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  limitId?: InputMaybe<Scalars['ID']['input']>;
  limitIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  operationIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  pagination: PaginationInput;
  search?: InputMaybe<Scalars['String']['input']>;
  tariffIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type FindTariffOperationHistoriesInput = {
  clientId?: InputMaybe<Scalars['ID']['input']>;
  clientIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  createdAt?: InputMaybe<TariffDateRangeInput>;
  currencyTicker?: InputMaybe<Scalars['String']['input']>;
  currencyTickers?: InputMaybe<Array<Scalars['String']['input']>>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  operationId?: InputMaybe<Scalars['ID']['input']>;
  operationIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  pagination: PaginationInput;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<SortTariffOperationHistoriesInput>;
  statuses?: InputMaybe<Array<TariffOperationHistoryStatusEnum>>;
  tariffId?: InputMaybe<Scalars['ID']['input']>;
  tariffIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  updatedAt?: InputMaybe<TariffDateRangeInput>;
};

export type FindTariffOperationHistoryInput = {
  clientId?: InputMaybe<Scalars['ID']['input']>;
  currencyTicker?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  operationId?: InputMaybe<Scalars['ID']['input']>;
  tariffId?: InputMaybe<Scalars['ID']['input']>;
};

export type FindTariffOperationInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type FindTariffOperationsInput = {
  commissionIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  createdAt?: InputMaybe<TariffDateRangeInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  limitIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  name?: InputMaybe<Scalars['String']['input']>;
  operationHistoryIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  pagination: PaginationInput;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<TariffEntitySortInput>;
  tariffId?: InputMaybe<Scalars['ID']['input']>;
  tariffIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  updatedAt?: InputMaybe<TariffDateRangeInput>;
};

export type FindTariffsInput = {
  clientCategory?: InputMaybe<Scalars['String']['input']>;
  clientIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  commissionIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  createdAt?: InputMaybe<TariffDateRangeInput>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  limitIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  name?: InputMaybe<Scalars['ID']['input']>;
  operationIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  pagination: PaginationInput;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<TariffEntitySortInput>;
  updatedAt?: InputMaybe<TariffDateRangeInput>;
};

export type FindUserAddressesInput = {
  categoryIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  categoryName?: InputMaybe<Scalars['String']['input']>;
  cityId?: InputMaybe<Scalars['ID']['input']>;
  clientId?: InputMaybe<Scalars['ID']['input']>;
  countryId?: InputMaybe<Scalars['ID']['input']>;
  countryIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  createdAt?: InputMaybe<IdentityDateRangeInput>;
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  isActual?: InputMaybe<Scalars['Boolean']['input']>;
  isPrimary?: InputMaybe<Scalars['Boolean']['input']>;
  pagination: PaginationInput;
  rawCityName?: InputMaybe<Scalars['String']['input']>;
  rawCityNameEn?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<IdentityDateRangeInput>;
};

export type FindUserInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  relations?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type FindUsersInput = {
  filter?: InputMaybe<UserFilterInput>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};

export type FindUsersV2Input = {
  createdAt?: InputMaybe<IdentityDateRangeInput>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  kycConfigIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  kycStatuses?: InputMaybe<Array<KycStepStatus>>;
  kycSteps?: InputMaybe<Array<KycStepEnum>>;
  nationalityCountryIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  pagination: PaginationInput;
  placeOfBirthCountryIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  residenceCountryIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  scoringRiskLevels?: InputMaybe<Array<ScoringRiskLevelEnum>>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<UserSortInput>;
  updatedAt?: InputMaybe<IdentityDateRangeInput>;
};

export type FindWebhookInput = {
  hash?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type FullName = {
  __typename?: 'FullName';
  firstName?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  legalName?: Maybe<Scalars['String']['output']>;
  middleName?: Maybe<Scalars['String']['output']>;
};

export type FullNameInput = {
  firstName?: InputMaybe<Scalars['String']['input']>;
  firstNameEn?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  lastNameEn?: InputMaybe<Scalars['String']['input']>;
  legalName?: InputMaybe<Scalars['String']['input']>;
  legalNameEn?: InputMaybe<Scalars['String']['input']>;
  middleName?: InputMaybe<Scalars['String']['input']>;
  middleNameEn?: InputMaybe<Scalars['String']['input']>;
};

export enum Gender {
  Female = 'FEMALE',
  Male = 'MALE',
  Other = 'OTHER'
}

export enum GenderEnum {
  Female = 'FEMALE',
  Male = 'MALE',
  Other = 'OTHER'
}

/**
 * Description: input data for generating one time code
 *
 * Example:
 *
 *
 *
 * {
 *
 *
 * "service": "BANXEID",
 *
 *
 * "identity": "test-email@yourcompany. com",
 *
 *
 * "deviceId": "deviceId",
 *
 *
 * "device": "EMAIL",
 *
 *
 * "userId": "08a16b83-9094-4e89-8c05-2ccadd5c1c7e",
 *
 *
 * "type": "REGISTRATION"
 *
 *
 * }
 */
export type GenerateOneTimeCodeInput = {
  /**
   * Required: true
   *
   * Description: device type
   *
   * Format:
   *
   *         string parameter from custom enum
   *
   *
   * Example:
   *
   *         "EMAIL"
   */
  device: Device;
  /**
   * Required: true
   *
   * Description: device Id
   *
   * Additional info:
   *
   *         24 hex characters from a MongoDB ID
   *
   *
   * Format:
   *
   *         24 hexadecimal characters
   *
   *
   * Example:
   *
   *         64a5448c7e019dbee9006f62
   */
  deviceId: Scalars['String']['input'];
  /**
   * Required: true
   *
   * Description: field containing the email address or phone number to which the OneTimeCode should be sent
   *
   * Format:
   *
   *         string containing a phone number or email address
   *
   *
   * Example:
   *
   *         "test-email@yourcompany.com"
   */
  identity: Scalars['String']['input'];
  /**
   * Required: true
   *
   * Description: service type
   *
   * Format:
   *
   *         string parameter from custom enum
   *
   *
   * Example:
   *
   *         "BANXEID"
   */
  service: Scalars['String']['input'];
  /**
   * Required: true
   *
   * Description: code type
   *
   * Format:
   *
   *         string parameter from custom enum
   *
   *
   * Example:
   *
   *         "REGISTRATION"
   */
  type: SendCode;
  /**
   * Required: false
   *
   * Description: User identifier
   *
   * Format:
   *
   *         uuid v4
   */
  userId?: InputMaybe<Scalars['ID']['input']>;
};

/** Description: input for TOTP generation */
export type GenerateTotpInput = {
  /**
   * Required: false
   *
   * Description: generated code length
   *
   * Additional info:
   *
   *         default value - 6
   *
   *
   * Example:
   *
   *         6
   */
  otpLength?: InputMaybe<Scalars['Int']['input']>;
  /**
   * Required: false
   *
   * Description: user secret key
   *
   * Additional info:
   *
   *         if the secret key is not sent, it is automatically disabled for this operation
   *
   *
   * Example:
   *
   *         "banxe"
   */
  secret?: InputMaybe<Scalars['String']['input']>;
  /**
   * Required: false
   *
   * Description: number of 30 second steps to generate TOTP
   *
   * Additional info:
   *
   *         if you need to know which TOTP was generated 2 minutes ago, then you need to set window=-4
   *
   *
   * Example:
   *
   *         4
   */
  window?: InputMaybe<Scalars['Int']['input']>;
};

export type GeoByAddressInput = {
  /** [Dictionary] Represents address by which search query will be executed */
  address: Scalars['String']['input'];
};

export type GeoLocation = {
  __typename?: 'GeoLocation';
  /** [Dictionary] Valid latitudes are from -90 to 90 degrees */
  latitude: Scalars['String']['output'];
  /** [Dictionary] Valid longitudes are from -180 to 180 degrees */
  longitude: Scalars['String']['output'];
};

export type GeoLocationInput = {
  /** [Dictionary] Valid latitudes are from -90 to 90 degrees */
  latitude: Scalars['String']['input'];
  /** [Dictionary] Valid longitudes are from -180 to 180 degrees */
  longitude: Scalars['String']['input'];
};

export type GetAccountByUniversalParamInput = {
  /** Currency ticker or currencyID */
  currency: Scalars['String']['input'];
  pagination?: InputMaybe<PaginationInput>;
  /** Universal parameter, can be a phone number, email, clientID, or walletID */
  query: Scalars['String']['input'];
  tag?: InputMaybe<Scalars['String']['input']>;
};

export type GetAccountRequest = {
  absAccountId?: InputMaybe<Scalars['ID']['input']>;
  accountNumber?: InputMaybe<Scalars['String']['input']>;
  contomobileSubAccount?: InputMaybe<Scalars['String']['input']>;
  currencyId?: InputMaybe<Scalars['String']['input']>;
  currencyIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  currencyTicker?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  internalType?: InputMaybe<InternalAccountType>;
  isSystems?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  provider?: InputMaybe<AccountsProviderEnum>;
  providerTag?: InputMaybe<Scalars['String']['input']>;
  tag?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['ID']['input']>;
};

export type GetAllUsersInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterFromCore>;
  gender?: InputMaybe<GenderEnum>;
  phone?: InputMaybe<Scalars['String']['input']>;
  roles?: InputMaybe<Array<RoleEnum>>;
  service?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<StatusEnum>;
  userIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type GetApplicantInput = {
  applicantId?: InputMaybe<Scalars['ID']['input']>;
  externalUserId?: InputMaybe<Scalars['ID']['input']>;
};

export type GetAvailableCurrenciesInput = {
  accountType: InternalAccountType;
};

export type GetBankDetailsInput = {
  accountId: Scalars['ID']['input'];
  limit?: InputMaybe<Scalars['Float']['input']>;
  skip?: InputMaybe<Scalars['Float']['input']>;
};

export type GetBusinessActivitiesInput = {
  classificationSystem?: InputMaybe<Scalars['String']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
  descriptionContains?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Filter>;
  hasChildren?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isRoot?: InputMaybe<Scalars['Boolean']['input']>;
  level?: InputMaybe<Scalars['Int']['input']>;
  levelFrom?: InputMaybe<Scalars['Int']['input']>;
  levelTo?: InputMaybe<Scalars['Int']['input']>;
  nameContains?: InputMaybe<Scalars['String']['input']>;
  nameStartsWith?: InputMaybe<Scalars['String']['input']>;
  parentId?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  tagsAll?: InputMaybe<Array<Scalars['String']['input']>>;
  tagsAny?: InputMaybe<Array<Scalars['String']['input']>>;
  withoutPagination?: InputMaybe<Scalars['Boolean']['input']>;
};

export type GetBusinessActivityInput = {
  classificationSystem?: InputMaybe<Scalars['String']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  parentId?: InputMaybe<Scalars['String']['input']>;
};

export type GetCardTopUpFeeInput = {
  amount: Scalars['BigNumber']['input'];
};

export type GetChangeLimitHistoriesInput = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  limitId: Scalars['ID']['input'];
  pagination: PaginationInput;
};

export type GetCheckoutTokenInput = {
  cvv?: InputMaybe<Scalars['String']['input']>;
  expiryMonth: Scalars['Float']['input'];
  expiryYear: Scalars['Float']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  number: Scalars['String']['input'];
  type: CheckoutTokenType;
};

export type GetCityInput = {
  countryId?: InputMaybe<Scalars['ID']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type GetCityRequestPayloadInput = {
  cityId?: InputMaybe<Scalars['ID']['input']>;
  countryId?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type GetCommonDictItemRequestPayloadInput = {
  id: Scalars['ID']['input'];
};

export type GetCompanyTypeInput = {
  code?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
};

export type GetCompanyTypesInput = {
  code?: InputMaybe<Scalars['String']['input']>;
  descriptionContains?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Filter>;
  id?: InputMaybe<Scalars['String']['input']>;
  nameContains?: InputMaybe<Scalars['String']['input']>;
  nameStartsWith?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  tagsAll?: InputMaybe<Array<Scalars['String']['input']>>;
  tagsAny?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type GetCountryInput = {
  alpha3?: InputMaybe<Scalars['String']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
  iconFileId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  phoneCode?: InputMaybe<Scalars['String']['input']>;
};

export type GetCountryRequestPayloadInput = {
  countryId: Scalars['ID']['input'];
};

export type GetCurrenciesByTypeRequestPayloadInput = {
  currencyId?: InputMaybe<Scalars['ID']['input']>;
  type: CurrencyType;
};

export type GetCurrencyByTickerRequestPayloadInput = {
  currencyId?: InputMaybe<Scalars['ID']['input']>;
  ticker: Scalars['String']['input'];
};

export type GetCurrencyRequestPayloadInput = {
  currencyId: Scalars['ID']['input'];
};

export type GetCurrencyUsdtPriceByTickerInput = {
  ticker: Scalars['String']['input'];
};

export type GetFileInput = {
  fileId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};

export type GetFilesInput = {
  fileIds: Array<Scalars['ID']['input']>;
  userId: Scalars['ID']['input'];
};

export type GetIdentityDocumentsInput = {
  clientId: Scalars['ID']['input'];
  isVerified?: InputMaybe<Scalars['Boolean']['input']>;
};

export type GetIntermediariesInput = {
  /** Select intermediaries applicable for rate exchange */
  applicableForExchange?: InputMaybe<Scalars['Boolean']['input']>;
  /** Select intermediaries by bank name */
  bankNames?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Country alpha3 array. If many - OR operation is applied */
  countryAlpha3?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Currency tickers array. If many - OR operation is applied */
  currencyTickers?: InputMaybe<Array<Scalars['String']['input']>>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};

export type GetIntermediaryInput = {
  /** Search intermediary by beneficiary account number */
  beneficiaryAccountNumber?: InputMaybe<Scalars['String']['input']>;
  /** Search intermediary by beneficiary bank bic */
  beneficiaryBIC?: InputMaybe<Scalars['String']['input']>;
  /** Search intermediary by bank name */
  beneficiaryBank?: InputMaybe<Scalars['String']['input']>;
  /** Search intermediary by beneficiary IBAN */
  beneficiaryIBAN?: InputMaybe<Scalars['String']['input']>;
  /** Search intermediary by beneficiary sort code */
  beneficiarySortCode?: InputMaybe<Scalars['String']['input']>;
  /** Search intermediary by id */
  id?: InputMaybe<Scalars['String']['input']>;
};

export type GetKybCountryStatisticsInput = {
  dateRange?: InputMaybe<IdentityDateRangeInput>;
  kybConfigIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  kybStatuses?: InputMaybe<Array<KybStepStatus>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
};

export type GetKybScoringRiskLevelStatisticsInput = {
  countryIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  dateRange?: InputMaybe<IdentityDateRangeInput>;
  kybConfigIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  kybStatuses?: InputMaybe<Array<KybStepStatus>>;
};

export type GetKybStatusesStatisticsInput = {
  countryIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  dateRange?: InputMaybe<IdentityDateRangeInput>;
  kybConfigIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type GetKycAgeGenderStatisticsInput = {
  countryIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  dateRange?: InputMaybe<IdentityDateRangeInput>;
  kycConfigIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  kycStatuses?: InputMaybe<Array<KycStepStatus>>;
};

export type GetKycCountryStatisticsInput = {
  countryType: UserCountryType;
  dateRange?: InputMaybe<IdentityDateRangeInput>;
  kycConfigIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  kycStatuses?: InputMaybe<Array<KycStepStatus>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  riskLevels?: InputMaybe<Array<ScoringRiskLevelEnum>>;
};

export type GetKycScoringRiskLevelStatisticsInput = {
  countryIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  dateRange?: InputMaybe<IdentityDateRangeInput>;
  kycConfigIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  kycStatuses?: InputMaybe<Array<KycStepStatus>>;
};

export type GetKycStatusesStatisticsInput = {
  countryIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  dateRange?: InputMaybe<IdentityDateRangeInput>;
  kycConfigIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type GetLanguageByCodeRequestPayloadInput = {
  code: Scalars['String']['input'];
};

/**
 * Description: input data for the administrator to receive a one-time user code and information about it
 *
 * Example:
 *
 *
 *
 * {
 *
 *
 * "service": "BANXEID",
 *
 *
 * "identity": "test-email@yourcompany. com",
 *
 *
 * "deviceId": "deviceId",
 *
 *
 * "device": "EMAIL",
 *
 *
 * "status": "ACTIVE",
 *
 *
 * "userId": "08a16b83-9094-4e89-8c05-2ccadd5c1c7e",
 *
 *
 * "type": "REGISTRATION"
 *
 *
 * }
 */
export type GetLastSendCodeInput = {
  /**
   * Required: true
   *
   * Description: device type
   *
   * Format:
   *
   *         string parameter from custom enum
   *
   *
   * Example:
   *
   *         "EMAIL"
   */
  device?: InputMaybe<Device>;
  /**
   * Required: true
   *
   * Description: device Id
   *
   * Additional info:
   *
   *         24 hex characters from a MongoDB ID
   *
   *
   * Format:
   *
   *         24 hexadecimal characters
   *
   *
   * Example:
   *
   *         64a5448c7e019dbee9006f62
   */
  deviceId?: InputMaybe<Scalars['String']['input']>;
  /**
   * Required: true
   *
   * Description: field containing the email address or phone number to which the OneTimeCode should be sent
   *
   * Format:
   *
   *         string containing a phone number or email address
   *
   *
   * Example:
   *
   *         "test-email@yourcompany.com"
   */
  identity?: InputMaybe<Scalars['String']['input']>;
  /**
   * Required: true
   *
   * Description: service type
   *
   * Format:
   *
   *         string parameter from custom enum
   *
   *
   * Example:
   *
   *         "BANXEID"
   */
  service?: InputMaybe<Scalars['String']['input']>;
  /**
   * Required: false
   *
   * Description: status type
   *
   * Format:
   *
   *         string parameter from custom enum
   *
   *
   * Example:
   *
   *         "ACTIVE"
   */
  status?: InputMaybe<StatusEnum>;
  /**
   * Required: true
   *
   * Description: code type
   *
   * Format:
   *
   *         string parameter from custom enum
   *
   *
   * Example:
   *
   *         "REGISTRATION"
   */
  type?: InputMaybe<SendCode>;
  /**
   * Required: false
   *
   * Description: User identifier
   *
   * Format:
   *
   *         uuid v4
   */
  userId?: InputMaybe<Scalars['ID']['input']>;
};

/** returns information by one time code */
export type GetLastSendCodeResponse = {
  __typename?: 'GetLastSendCodeResponse';
  /**
   * Required: false
   *
   * Description: SMS code
   *
   * Format:
   *
   *         string containing 6 digits
   *
   *
   * Example:
   *
   *         "123456"
   */
  code?: Maybe<Scalars['String']['output']>;
  /**
   * Required: false
   *
   * Description: date and time of creation one time code
   *
   * Format:
   *
   *         Date
   *
   *
   * Example:
   *
   *         "2022-03-06T08:23:45.000Z"
   */
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  /**
   * Required: false
   *
   * Description: device type
   *
   * Format:
   *
   *         string parameter from custom enum
   *
   *
   * Example:
   *
   *         "EMAIL"
   */
  type?: Maybe<Scalars['String']['output']>;
};

export type GetMyPaymentTemplateInput = {
  id: Scalars['String']['input'];
};

export type GetNaceCodeInput = {
  code?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  parentId?: InputMaybe<Scalars['String']['input']>;
  sectionName?: InputMaybe<Scalars['String']['input']>;
};

export type GetNaceCodesInput = {
  code?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Filter>;
  id?: InputMaybe<Scalars['String']['input']>;
  parentId?: InputMaybe<Scalars['String']['input']>;
  sectionName?: InputMaybe<Scalars['String']['input']>;
  withoutPagination?: InputMaybe<Scalars['Boolean']['input']>;
};

/**
 * Description: input to search for an operation and get the operation ID
 *
 * Example:
 *
 *
 *
 * {
 *
 *
 * "operationId": "bb1bcdc6-4b3e-4e6c-bd07-9768aec5c460"
 *
 *
 * }
 */
export type GetOperationIdInput = {
  /**
   * Required: true
   *
   * Description: Operation identifier
   *
   * Format:
   *
   *         uuid v4
   */
  operationId?: InputMaybe<Scalars['ID']['input']>;
};

/**
 * Description: input to look up an operation and return the operation data
 *
 * Example:
 *
 *
 *
 * {
 *
 *
 * "title": "SELLCRYPTO"
 *
 *
 * }
 */
export type GetOperationInput = {
  /**
   * Required: true
   *
   * Description: title type
   *
   * Format:
   *
   *         string parameters from custom enum
   *
   *
   * Example:
   *
   *         "BUYCRYPTO"
   */
  title: Scalars['String']['input'];
};

export type GetPhoneNumberInfoInput = {
  /** Phone numbers according to the E.164 standard */
  phoneNumbers: Array<Scalars['String']['input']>;
};

export type GetPhoneNumberInfoType = {
  __typename?: 'GetPhoneNumberInfoType';
  error?: Maybe<TwilioLookupErrorType>;
  info?: Maybe<TwilioLookupResultType>;
  phoneNumber: Scalars['String']['output'];
};

export type GetRateCommissionInput = {
  baseAssetTicker: Scalars['String']['input'];
  quoteAssetTicker: Scalars['String']['input'];
};

export type GetScoringRiskLevelInput = {
  id: Scalars['String']['input'];
};

export type GetScoringRiskLevelsInput = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};

export type GetTariffTotalFeeInput = {
  amount: Scalars['BigNumber']['input'];
  clientId: Scalars['ID']['input'];
  currencyTicker: Scalars['String']['input'];
  factors?: InputMaybe<Array<FilterFactorsInput>>;
  inclusiveInAmount?: InputMaybe<Scalars['Boolean']['input']>;
  operationName: Scalars['String']['input'];
};

export type GetTokenInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type GetUserByPersonalDataInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
};

export type GetUserInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  /** Universal parameter, used to search by one of the values: phone, email, or wallet id. Do not use this param against the params mentioned in the list */
  query?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
  walletId?: InputMaybe<Scalars['String']['input']>;
};

export type GetVirtualAccountInput = {
  accountNumberOrIBAN?: InputMaybe<Scalars['String']['input']>;
  currency?: InputMaybe<Scalars['ID']['input']>;
  fiIntegration?: InputMaybe<AccountFiIntegration>;
  id?: InputMaybe<Scalars['ID']['input']>;
  realAccountId?: InputMaybe<Scalars['ID']['input']>;
  userId?: InputMaybe<Scalars['ID']['input']>;
};

export type GoogleSignInInput = {
  /** authorization code for auth user if no token provided */
  authorizationCode?: InputMaybe<Scalars['String']['input']>;
  /** first name */
  firstName?: InputMaybe<Scalars['String']['input']>;
  /** identity token if present */
  identityToken?: InputMaybe<Scalars['String']['input']>;
  /** last name */
  lastName?: InputMaybe<Scalars['String']['input']>;
  service: Scalars['String']['input'];
  /** token for PUSH notification */
  token?: InputMaybe<Scalars['String']['input']>;
};

export type GroupedAccountType = {
  __typename?: 'GroupedAccountType';
  accounts: Array<Account>;
  tag: Scalars['String']['output'];
};

export type GroupedAccountsType = {
  __typename?: 'GroupedAccountsType';
  count: Scalars['Int']['output'];
  cursor: Scalars['Int']['output'];
  nodes: Array<GroupedAccountType>;
};

export type IdentityCompaniesInput = {
  currentKybLevels?: InputMaybe<Array<Scalars['Int']['input']>>;
  currentKybStepStatuses?: InputMaybe<Array<KybStepStatus>>;
  currentKybSteps?: InputMaybe<Array<KybStepEnum>>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  isPassedKyb?: InputMaybe<Scalars['Boolean']['input']>;
  kybConfigIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  pagination: PaginationInput;
  service?: InputMaybe<Scalars['String']['input']>;
};

export type IdentityDateRangeInput = {
  dateFrom?: InputMaybe<Scalars['String']['input']>;
  dateTo?: InputMaybe<Scalars['String']['input']>;
};

export type IdentityDoc = {
  __typename?: 'IdentityDoc';
  common: CommonItemInfo;
  /** Country where code was created. ISO 3166-1 alpha-3 */
  country: Scalars['String']['output'];
  file: File;
  id: Scalars['ID']['output'];
  isVerified: Scalars['Boolean']['output'];
  verificationMessages: Array<VerificationMessage>;
};

export type IdentityFullName = {
  __typename?: 'IdentityFullName';
  firstName?: Maybe<Scalars['String']['output']>;
  firstNameEn?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  lastNameEn?: Maybe<Scalars['String']['output']>;
  legalName?: Maybe<Scalars['String']['output']>;
  legalNameEn?: Maybe<Scalars['String']['output']>;
  middleName?: Maybe<Scalars['String']['output']>;
  middleNameEn?: Maybe<Scalars['String']['output']>;
};

export enum IdentityType {
  Email = 'EMAIL',
  Phone = 'PHONE'
}

export enum IdentityTypeEnum {
  Corporate = 'CORPORATE',
  Individual = 'INDIVIDUAL'
}

export type IndividualBeneficiaries = {
  __typename?: 'IndividualBeneficiaries';
  count: Scalars['Int']['output'];
  cursor: Scalars['Int']['output'];
  nodes: Array<IndividualBeneficiary>;
};

export type IndividualBeneficiary = {
  __typename?: 'IndividualBeneficiary';
  addressDocument?: Maybe<IndividualBeneficiaryAddressDoc>;
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  identityDocument?: Maybe<IndividualBeneficiaryIdDoc>;
  isAdverseMedia?: Maybe<Scalars['Boolean']['output']>;
  isFamilyMemberPep?: Maybe<Scalars['Boolean']['output']>;
  isInSanctionList?: Maybe<Scalars['Boolean']['output']>;
  isPep?: Maybe<Scalars['Boolean']['output']>;
  parent?: Maybe<CompanyUnion>;
  positions?: Maybe<Array<Scalars['String']['output']>>;
  trackerId: Scalars['String']['output'];
  type?: Maybe<CompanyMemberType>;
  updatedAt: Scalars['DateTime']['output'];
};

export type IndividualBeneficiaryAddressDoc = {
  __typename?: 'IndividualBeneficiaryAddressDoc';
  address?: Maybe<Address>;
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  dob?: Maybe<Scalars['DateTime']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  gender?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  issueBy?: Maybe<Scalars['String']['output']>;
  issuedDate?: Maybe<Scalars['DateTime']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  middleName?: Maybe<Scalars['String']['output']>;
  nationality?: Maybe<Country>;
  number?: Maybe<Scalars['String']['output']>;
  placeOfBirth?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  url?: Maybe<Scalars['String']['output']>;
};

export type IndividualBeneficiaryIdDoc = {
  __typename?: 'IndividualBeneficiaryIdDoc';
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  dob?: Maybe<Scalars['DateTime']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  gender?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  issueBy?: Maybe<Scalars['String']['output']>;
  issuedDate?: Maybe<Scalars['DateTime']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  middleName?: Maybe<Scalars['String']['output']>;
  nationality?: Maybe<Country>;
  number?: Maybe<Scalars['String']['output']>;
  placeOfBirth?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  url?: Maybe<Scalars['String']['output']>;
};

export type InitiateUserRegistrationProcessInput = {
  device: Device;
  id: Scalars['ID']['input'];
  identity: Scalars['String']['input'];
  service: Scalars['String']['input'];
};

export enum InnerTransferStateEnum {
  Error = 'ERROR',
  Pending = 'PENDING',
  Processing = 'PROCESSING',
  Successful = 'SUCCESSFUL'
}

export enum InputReasonForAccountOpening {
  DailyExpenses = 'DAILY_EXPENSES',
  FamilySupport = 'FAMILY_SUPPORT',
  Investments = 'INVESTMENTS',
  InvoiceSettlements = 'INVOICE_SETTLEMENTS',
  Other = 'OTHER',
  PaymentsForServicesAndGoods = 'PAYMENTS_FOR_SERVICES_AND_GOODS',
  SalaryDeposits = 'SALARY_DEPOSITS'
}

export type Intermediaries = {
  __typename?: 'Intermediaries';
  count: Scalars['Int']['output'];
  cursor: Scalars['Int']['output'];
  nodes: Array<Intermediary>;
};

export type Intermediary = {
  __typename?: 'Intermediary';
  accountTypes: Array<InternalAccountType>;
  applicableForExchange?: Maybe<Scalars['Boolean']['output']>;
  beneficiaryAccountNumber?: Maybe<Scalars['String']['output']>;
  beneficiaryAddress?: Maybe<Scalars['String']['output']>;
  beneficiaryBIC?: Maybe<Scalars['String']['output']>;
  beneficiaryBank: Scalars['String']['output'];
  beneficiaryIBAN?: Maybe<Scalars['String']['output']>;
  beneficiaryName: Scalars['String']['output'];
  beneficiarySortCode?: Maybe<Scalars['String']['output']>;
  companyCountries: Array<Country>;
  companyCountryIds: Array<Scalars['String']['output']>;
  currencies: Array<Currency>;
  currencyIds: Array<Scalars['String']['output']>;
  forbiddenActivityIds: Array<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  userCountries: Array<Country>;
  userCountryIds: Array<Scalars['String']['output']>;
};

export enum InternalAccountType {
  MultipleCurrencyAccount = 'MULTIPLE_CURRENCY_ACCOUNT',
  Usd = 'USD'
}

export type IsPhoneNumberExistInput = {
  /** Phone number according to the E.164 standard */
  phoneNumber: Scalars['String']['input'];
};

export type IsProviderAccountsReadyInput = {
  accountNumbers?: InputMaybe<Array<Scalars['String']['input']>>;
  clientIds: Array<Scalars['ID']['input']>;
  currencyIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  internalTypes?: InputMaybe<Array<InternalAccountType>>;
  isSystemBlocks?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isSystems?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  provider?: InputMaybe<AccountsProviderEnum>;
  providerTag?: InputMaybe<Scalars['String']['input']>;
  states?: InputMaybe<Array<AccountState>>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  trackerIds?: InputMaybe<Array<Scalars['String']['input']>>;
  walletIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type IsTransferAllowedRequestPayload = {
  amount: Scalars['BigNumber']['input'];
  creditAccountId: Scalars['ID']['input'];
  debitAccountId: Scalars['ID']['input'];
  debitorUserId: Scalars['ID']['input'];
  fee: Scalars['BigNumber']['input'];
};

export type IsTransferAllowedResponseData = {
  __typename?: 'IsTransferAllowedResponseData';
  description?: Maybe<Scalars['String']['output']>;
  isAllowed: Scalars['Boolean']['output'];
};

export type IsValidCountryCodeInput = {
  alpha2?: InputMaybe<Scalars['String']['input']>;
  alpha3?: InputMaybe<Scalars['String']['input']>;
  throwError?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Item = Bank | City | Continent | Country | Currency | ExternalCompany | Language | NaceCode | NumberRange | Position | Region | Timezone | TransferMethod | Unit | Vat;

export enum ItemType {
  Bank = 'BANK',
  City = 'CITY',
  Continent = 'CONTINENT',
  Country = 'COUNTRY',
  Currency = 'CURRENCY',
  ExternalCompany = 'EXTERNAL_COMPANY',
  Language = 'LANGUAGE',
  NaceCode = 'NACE_CODE',
  NumberRange = 'NUMBER_RANGE',
  Position = 'POSITION',
  Region = 'REGION',
  Unit = 'UNIT',
  Vat = 'VAT'
}

export type KybConfig = {
  __typename?: 'KYBConfig';
  configVersion: Scalars['Int']['output'];
  countryStatistics: KybCountryStatistics;
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  /** @deprecated Outdated. Use kybLevelStatusesV2 field. */
  kybLevelStatuses: KybLevelStatuses;
  kybLevelStatusesV2: KybLevelStatusesV2;
  level: Scalars['Int']['output'];
  name?: Maybe<Scalars['String']['output']>;
  scoringRiskLevelStatistics: KybScoringRiskLevelStatistics;
  service: Scalars['String']['output'];
  statusStatistics: KybStatusStatistics;
  steps: KybStepConfigs;
  updatedAt: Scalars['DateTime']['output'];
};


export type KybConfigKybLevelStatusesArgs = {
  input: FilterInput;
};


export type KybConfigKybLevelStatusesV2Args = {
  input: FilterInput;
};


export type KybConfigStepsArgs = {
  input: FilterInput;
};

export type KybConfigFilterMetadata = {
  __typename?: 'KYBConfigFilterMetadata';
  configVersions: Array<Scalars['Int']['output']>;
  levels: Array<Scalars['Int']['output']>;
  services: Array<Scalars['String']['output']>;
};

export type KybConfigs = {
  __typename?: 'KYBConfigs';
  count: Scalars['Int']['output'];
  cursor: Scalars['Int']['output'];
  nodes: Array<KybConfig>;
};

export type KybCountryStatistic = {
  __typename?: 'KYBCountryStatistic';
  count: Scalars['Int']['output'];
  country: Country;
  percent: Scalars['Float']['output'];
};

export type KybCountryStatistics = {
  __typename?: 'KYBCountryStatistics';
  statistics: Array<KybCountryStatistic>;
  total: Scalars['Int']['output'];
};

export type KybLevelStatus = {
  __typename?: 'KYBLevelStatus';
  absCustomerStepStatus: KybStepStatus;
  accountStepStatus?: Maybe<KybStepStatus>;
  adminStepStatus: KybStepStatus;
  currentStep: KybStepEnum;
  currentStepStatus: KybStepStatus;
  id: Scalars['ID']['output'];
  kybConfig: KybConfig;
  passedKYBBy?: Maybe<Scalars['DateTime']['output']>;
  registerBeneficiariesStepStatus: KybStepStatus;
  scoringStepStatus: KybStepStatus;
  screeningStepStatus: KybStepStatus;
  sumsubStepStatus: KybStepStatus;
};

export type KybLevelStatusV2 = {
  __typename?: 'KYBLevelStatusV2';
  company: Company;
  currentStep?: Maybe<KybStep>;
  id: Scalars['ID']['output'];
  kybConfig: KybConfig;
  passedKYBBy?: Maybe<Scalars['DateTime']['output']>;
  status?: Maybe<KybStepStatus>;
  stepStatuses: KybSteps;
};


export type KybLevelStatusV2StepStatusesArgs = {
  input: FilterInput;
};

export type KybLevelStatuses = {
  __typename?: 'KYBLevelStatuses';
  count: Scalars['Int']['output'];
  cursor: Scalars['Int']['output'];
  nodes: Array<KybLevelStatus>;
};

export type KybLevelStatusesV2 = {
  __typename?: 'KYBLevelStatusesV2';
  count: Scalars['Int']['output'];
  cursor: Scalars['Int']['output'];
  nodes: Array<KybLevelStatusV2>;
};

export type KybScoringRiskLevelStatistic = {
  __typename?: 'KYBScoringRiskLevelStatistic';
  count: Scalars['Int']['output'];
  level: Scalars['String']['output'];
  percent: Scalars['Float']['output'];
};

export type KybScoringRiskLevelStatistics = {
  __typename?: 'KYBScoringRiskLevelStatistics';
  dominantRiskLevel: Scalars['String']['output'];
  statistics: Array<KybScoringRiskLevelStatistic>;
  total: Scalars['Int']['output'];
};

export type KybStatusStatistic = {
  __typename?: 'KYBStatusStatistic';
  count: Scalars['Int']['output'];
  percent: Scalars['Float']['output'];
  status: KybStepStatus;
};

export type KybStatusStatistics = {
  __typename?: 'KYBStatusStatistics';
  statistics: Array<KybStatusStatistic>;
  total: Scalars['Int']['output'];
};

export type KybStep = {
  __typename?: 'KYBStep';
  executedAt?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  kybStepConfig: KybStepConfig;
  metadata?: Maybe<Scalars['JSON']['output']>;
  processedAt?: Maybe<Scalars['String']['output']>;
  rejectionReason?: Maybe<Scalars['String']['output']>;
  status: KybStepStatus;
};

export type KybStepConfig = {
  __typename?: 'KYBStepConfig';
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  kybConfig: KybConfig;
  name?: Maybe<Scalars['String']['output']>;
  order: Scalars['Int']['output'];
  providerConfig?: Maybe<Scalars['JSON']['output']>;
  step: KybStepEnum;
  updatedAt: Scalars['DateTime']['output'];
};

export type KybStepConfigs = {
  __typename?: 'KYBStepConfigs';
  count: Scalars['Int']['output'];
  cursor: Scalars['Int']['output'];
  nodes: Array<KybStepConfig>;
};

export enum KybStepEnum {
  AbsCustomer = 'ABS_CUSTOMER',
  Admin = 'ADMIN',
  OpenAccount = 'OPEN_ACCOUNT',
  RegisterBeneficiaries = 'REGISTER_BENEFICIARIES',
  Scoring = 'SCORING',
  Screening = 'SCREENING',
  Sumsub = 'SUMSUB'
}

export enum KybStepStatus {
  NotConnected = 'NOT_CONNECTED',
  Pending = 'PENDING',
  Processing = 'PROCESSING',
  Rejected = 'REJECTED',
  RejectedRetry = 'REJECTED_RETRY',
  Successful = 'SUCCESSFUL'
}

export enum KybStepStatusEnum {
  NotConnected = 'NOT_CONNECTED',
  Pending = 'PENDING',
  Processing = 'PROCESSING',
  Rejected = 'REJECTED',
  RejectedRetry = 'REJECTED_RETRY',
  Successful = 'SUCCESSFUL'
}

export type KybSteps = {
  __typename?: 'KYBSteps';
  count: Scalars['Int']['output'];
  cursor: Scalars['Int']['output'];
  nodes: Array<KybStep>;
};

export type KybSumsubConfig = {
  __typename?: 'KYBSumsubConfig';
  id: Scalars['ID']['output'];
  levelName: Scalars['String']['output'];
  sourceKey: Scalars['String']['output'];
};

export type KycAccessTokenApplicant = {
  __typename?: 'KYCAccessTokenApplicant';
  token: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type KycAgeGenderStatistic = {
  __typename?: 'KYCAgeGenderStatistic';
  count: Scalars['Int']['output'];
  gender: KycGenderStatistic;
  percent: Scalars['Float']['output'];
  rangeName: Scalars['String']['output'];
};

export type KycAgeGenderStatistics = {
  __typename?: 'KYCAgeGenderStatistics';
  statistics: Array<KycAgeGenderStatistic>;
  total: Scalars['Int']['output'];
};

export type KycConfig = {
  __typename?: 'KYCConfig';
  ageGenderStatistics: KycAgeGenderStatistics;
  configVersion: Scalars['Int']['output'];
  countryStatistics: KycCountryStatistics;
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  /** @deprecated Outdated. Use kycLevelStatusesV2 field. */
  kycLevelStatuses: KycLevelStatuses;
  kycLevelStatusesV2: KycLevelStatusesV2;
  level: Scalars['Int']['output'];
  name?: Maybe<Scalars['String']['output']>;
  scoringRiskLevelStatistics: KycScoringRiskLevelStatistics;
  service: Scalars['String']['output'];
  statusStatistics: KycStatusStatistics;
  steps: KycStepConfigs;
  updatedAt: Scalars['DateTime']['output'];
};


export type KycConfigCountryStatisticsArgs = {
  countryType: UserCountryType;
};


export type KycConfigKycLevelStatusesArgs = {
  input: FilterInput;
};


export type KycConfigKycLevelStatusesV2Args = {
  input: FilterInput;
};


export type KycConfigStepsArgs = {
  input: FilterInput;
};

export type KycConfigFilterMetadata = {
  __typename?: 'KYCConfigFilterMetadata';
  configVersions: Array<Scalars['Int']['output']>;
  levels: Array<Scalars['Int']['output']>;
  services: Array<Scalars['String']['output']>;
};

export type KycConfigs = {
  __typename?: 'KYCConfigs';
  count: Scalars['Int']['output'];
  cursor: Scalars['Int']['output'];
  nodes: Array<KycConfig>;
};

export type KycCountryStatistic = {
  __typename?: 'KYCCountryStatistic';
  count: Scalars['Int']['output'];
  country: Country;
  percent: Scalars['Float']['output'];
};

export type KycCountryStatistics = {
  __typename?: 'KYCCountryStatistics';
  statistics: Array<KycCountryStatistic>;
  total: Scalars['Int']['output'];
};

export type KycGenderStatistic = {
  __typename?: 'KYCGenderStatistic';
  female: Scalars['Int']['output'];
  male: Scalars['Int']['output'];
  other: Scalars['Int']['output'];
};

export type KycLevelStatus = {
  __typename?: 'KYCLevelStatus';
  absCustomerStepStatus: KycStepStatus;
  adminStepStatus: KycStepStatus;
  bitrixStepStatus: KycStepStatus;
  currentStep: KycStepEnum;
  currentStepStatus: KycStepStatus;
  id: Scalars['ID']['output'];
  kycConfig: KycConfig;
  passedKYCBy?: Maybe<Scalars['DateTime']['output']>;
  rejectionReasonFromAdmin?: Maybe<Scalars['String']['output']>;
  scoringStepStatus: KycStepStatus;
  screeningStepStatus: KycStepStatus;
  sumsubStepStatus: KycStepStatus;
  user: User;
};

export type KycLevelStatusV2 = {
  __typename?: 'KYCLevelStatusV2';
  currentStep: KycStep;
  id: Scalars['ID']['output'];
  kycConfig: KycConfig;
  passedKYCBy?: Maybe<Scalars['DateTime']['output']>;
  status: KycStepStatus;
  stepStatuses: KycSteps;
  user: User;
};


export type KycLevelStatusV2StepStatusesArgs = {
  input: FilterInput;
};

export type KycLevelStatuses = {
  __typename?: 'KYCLevelStatuses';
  count: Scalars['Int']['output'];
  cursor: Scalars['Int']['output'];
  nodes: Array<KycLevelStatus>;
};

export type KycLevelStatusesV2 = {
  __typename?: 'KYCLevelStatusesV2';
  count: Scalars['Int']['output'];
  cursor: Scalars['Int']['output'];
  nodes: Array<KycLevelStatusV2>;
};

export type KycScoringRiskLevelStatistic = {
  __typename?: 'KYCScoringRiskLevelStatistic';
  count: Scalars['Int']['output'];
  level: Scalars['String']['output'];
  percent: Scalars['Float']['output'];
};

export type KycScoringRiskLevelStatistics = {
  __typename?: 'KYCScoringRiskLevelStatistics';
  dominantRiskLevel: Scalars['String']['output'];
  statistics: Array<KycScoringRiskLevelStatistic>;
  total: Scalars['Int']['output'];
};

export type KycStatusStatistic = {
  __typename?: 'KYCStatusStatistic';
  count: Scalars['Int']['output'];
  percent: Scalars['Float']['output'];
  status: KycStepStatus;
};

export type KycStatusStatistics = {
  __typename?: 'KYCStatusStatistics';
  statistics: Array<KycStatusStatistic>;
  total: Scalars['Int']['output'];
};

export type KycStep = {
  __typename?: 'KYCStep';
  executedAt?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  kycStepConfig: KycStepConfig;
  metadata?: Maybe<Scalars['JSON']['output']>;
  processedAt?: Maybe<Scalars['String']['output']>;
  rejectionReason?: Maybe<Scalars['String']['output']>;
  status: KycStepStatus;
};

export type KycStepConfig = {
  __typename?: 'KYCStepConfig';
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  kycConfig: KycConfig;
  name?: Maybe<Scalars['String']['output']>;
  order: Scalars['Int']['output'];
  providerConfig?: Maybe<Scalars['JSON']['output']>;
  step: KycStepEnum;
  updatedAt: Scalars['DateTime']['output'];
};

export type KycStepConfigs = {
  __typename?: 'KYCStepConfigs';
  count: Scalars['Int']['output'];
  cursor: Scalars['Int']['output'];
  nodes: Array<KycStepConfig>;
};

export enum KycStepEnum {
  AbsCustomer = 'ABS_CUSTOMER',
  Admin = 'ADMIN',
  Bitrix = 'BITRIX',
  Scoring = 'SCORING',
  Screening = 'SCREENING',
  Sumsub = 'SUMSUB'
}

export enum KycStepStatus {
  NotConnected = 'NOT_CONNECTED',
  Pending = 'PENDING',
  Processing = 'PROCESSING',
  Rejected = 'REJECTED',
  RejectedRetry = 'REJECTED_RETRY',
  Successful = 'SUCCESSFUL'
}

export type KycSteps = {
  __typename?: 'KYCSteps';
  count: Scalars['Int']['output'];
  cursor: Scalars['Int']['output'];
  nodes: Array<KycStep>;
};

export type KycSumsubConfig = {
  __typename?: 'KYCSumsubConfig';
  documentExpirationDays: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  levelName: Scalars['String']['output'];
  requiredDocs: Array<KycSumsubConfigRequiredDocSet>;
  sourceKey: Scalars['String']['output'];
};

export type KycSumsubConfigRequiredDoc = {
  __typename?: 'KYCSumsubConfigRequiredDoc';
  checkSubType: Scalars['Boolean']['output'];
  type: UserIdentityType;
};

export type KycSumsubConfigRequiredDocSet = {
  __typename?: 'KYCSumsubConfigRequiredDocSet';
  docSetType: UserIdentityDocSetType;
  types: Array<KycSumsubConfigRequiredDoc>;
};

export enum KeyEnum {
  Eos = 'EOS',
  P256 = 'P256'
}

export type Language = {
  __typename?: 'Language';
  id: Scalars['ID']['output'];
  item: CommonDictItem;
};

export type LanguageInput = {
  code: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type LikeConditionInput = {
  key: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export type LocalizedName = {
  __typename?: 'LocalizedName';
  id: Scalars['ID']['output'];
  lang: Language;
  name: Scalars['String']['output'];
};

export type LocalizedNameInput = {
  langId: Scalars['ID']['input'];
  name: Scalars['String']['input'];
};

export type LogoutInput = {
  fromAll?: InputMaybe<Scalars['Boolean']['input']>;
  fromOther?: InputMaybe<Scalars['Boolean']['input']>;
  refreshToken: Scalars['String']['input'];
};

export enum ManageAccountsAction {
  Activate = 'ACTIVATE',
  Deactivate = 'DEACTIVATE'
}

export type ManageMultipleCurrencyAccountsInput = {
  action: ManageAccountsAction;
  clientIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  currencyIds: Array<Scalars['ID']['input']>;
  provider: AccountsProviderEnum;
};

export type MemberKycAccessTokenApplicant = {
  __typename?: 'MemberKYCAccessTokenApplicant';
  token: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type MemberPep = {
  __typename?: 'MemberPep';
  endWorkingDate?: Maybe<Scalars['DateTime']['output']>;
  position?: Maybe<Scalars['String']['output']>;
  startWorkingDate?: Maybe<Scalars['DateTime']['output']>;
};

export type MemberPepInput = {
  endWorkingDate?: InputMaybe<Scalars['DateTime']['input']>;
  position?: InputMaybe<Scalars['String']['input']>;
  startWorkingDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export enum MessengerType {
  Whatsapp = 'WHATSAPP'
}

export type Money = {
  __typename?: 'Money';
  amount: Scalars['BigNumber']['output'];
  currency: Currency;
  formattedAmount: Scalars['String']['output'];
};

export type MoneyInput = {
  amount: Scalars['String']['input'];
  currencyId: Scalars['ID']['input'];
};

export type MultiLang = {
  __typename?: 'MultiLang';
  en?: Maybe<Scalars['String']['output']>;
  ru?: Maybe<Scalars['String']['output']>;
};

export type MultipleCurrencyAccountOrder = {
  __typename?: 'MultipleCurrencyAccountOrder';
  accounts: Array<MultipleCurrencyAccountOrderPersonalized>;
  trackerId: Scalars['ID']['output'];
};

export type MultipleCurrencyAccountOrderPersonalized = {
  __typename?: 'MultipleCurrencyAccountOrderPersonalized';
  accountId: Scalars['ID']['output'];
  currencyId: Scalars['ID']['output'];
};

export type Mutation = {
  __typename?: 'Mutation';
  /** [accounts] Create a multi-currency account */
  accountsCreateMultipleCurrencyAccount: MultipleCurrencyAccountOrder;
  /** [accounts] Route the opening of accounts to the appropriate provider */
  accountsRoute: Scalars['Boolean']['output'];
  addApplicantDocument: ApplicantDocumentType;
  addAvatar: Scalars['Boolean']['output'];
  /** [Auth] Adds FCM token to user */
  addFCMToken: Scalars['Boolean']['output'];
  /** [Dictionary] Allows tag attaching to any item by id in 'Item' union */
  addTag: Array<Maybe<Item>>;
  /** [Dictionary] Allows tag attaching to any item by code in 'Item' union */
  addTagByCode: Array<Maybe<Item>>;
  /** [Files] generates temporary url with sign for file-uploading. File must be uploaded with POST request as form-data(ROLE = USER/ADMIN/SERVICE) */
  adminInitUploadSession: UploadSesion;
  /** [Auth] Registration user without confirmation (Role = SERVICE) */
  adminSignUp: User;
  /** [Auth] Returns JWT  */
  appleSignIn: Auth;
  /** [Payments] Approve card payment */
  approveCardPayment: Payment;
  approvePayment: Payment;
  /** [Payments] Approve user's payment if it has failed. (Admin Only) */
  approveUserPayment: Payment;
  /** [sumsub] Bind individual applicant to company as beneficiary */
  bindIndividualApplicantToCompany: BoundIndividualCompanyApplicant;
  /** [Limits] Bind limit to tariff operation */
  bindLimitToTariffOperation: Scalars['Boolean']['output'];
  /** [Tariffs] Bind operation to tariff */
  bindOperationToTariff: Scalars['String']['output'];
  /** [Accounts] Block account or change block reasons */
  blockAccount: Account;
  blockCompany: Company;
  blockUser: User;
  changeApplicantLevel: ApplicantType;
  /** [Commission] Change base currency commission */
  changeBaseCurrencyCommission: TariffCommission;
  /** [Limits] Change base currency limit */
  changeBaseCurrencyLimit: TariffLimit;
  /** [Auth] Change email/phone */
  changeIdentity: ChangeIdentityResponseType;
  /**
   * [Auth] Send tokens to confirm password change
   * @deprecated Use changePasswordNew
   */
  changePassword: Send2FaTokenResponse;
  changePasswordNew: Send2FaTokenResponse;
  changePasswordV2: Send2FaTokenResponse;
  /** [Auth] Change user status (Role = SERVICE) */
  changeUserStatus: Scalars['Boolean']['output'];
  /** [Auth] Returns JWT  */
  checkVerificationPhrase: Auth;
  /**
   * [Dictionary] SuperAdmin _test mutation
   * Allows clearing all records stored in database
   */
  clearDb: Scalars['Boolean']['output'];
  /**
   * [Dictionary] SuperAdmin _test mutation
   * Allows clearing chosen entity records stored in database
   */
  clearEntityTable: Scalars['Boolean']['output'];
  /** [Auth] Confirm changed email/phone */
  confirmChangeIdentity: Scalars['Boolean']['output'];
  /** [Auth] Verify codes and change user password */
  confirmChangePassword: Scalars['Boolean']['output'];
  /** [2FA] Confirm disabling 2FA */
  confirmDisabling2FA: Scalars['Boolean']['output'];
  /** [2FA] Confirm enabling 2FA */
  confirmEnabling2FA: Scalars['Boolean']['output'];
  /** Description: [OneTimeCodes] validate and confirm code */
  confirmOneTimeCode: ConfirmOneTimeCodeResponse;
  /** [Auth] Confirm password recovery process */
  confirmPasswordRecovery: Scalars['Boolean']['output'];
  /** [Auth] Verify codes and return access tokens */
  confirmSignIn: Auth;
  /** [Referrers] Сonfirm the invitation */
  confirmationInvite: Scalars['Boolean']['output'];
  /** Description: [2FA] SUPER-ADMIN-SERVICE-ONLY Create operation. Title will be uppercased */
  create2FAOperation: Scalars['Boolean']['output'];
  /** Description: [2FA] Generates 2FA operation id */
  create2FAOperationId: Scalars['ID']['output'];
  createAccessTokenForApplicant: KycAccessTokenApplicant;
  createAccessTokenForKYBApplicant: Scalars['String']['output'];
  /** [accounts] Create accounts in the specified currencies for the existing tag */
  createAccountsForExistingTag: Scalars['Boolean']['output'];
  createAdditionalInfo: AdditionalInfo;
  createAdditionalInfos: Array<AdditionalInfo>;
  createAddress: CreatedOrUpdatedAddress;
  createAddressCategories: Array<AddressCategory>;
  createAddressCategory: AddressCategory;
  createAddresses: Array<CreatedOrUpdatedAddress>;
  /** [Identity] Create age range statistic settings */
  createAgeRangeStatisticSettings: Array<AgeRangeStatisticSetting>;
  createApplicant: ApplicantType;
  /** [dictionary] Create a new bank with the provided details. */
  createBank: Bank;
  /** [dictionary] Create a BIN (Bank Identification Number). */
  createBin?: Maybe<Bin>;
  /** [Payments] Create payment in Checkout (ROLE = [ADMIN, SUPER]) */
  createCheckoutPayment: CheckoutPayment;
  /** [Dictionary] Allows city creation (ROLE = ADMIN/SERVICE/SUPER) */
  createCity: City;
  createCompanies: Array<Company>;
  createCompany: Company;
  createCompanyApplicant: CompanyApplicant;
  /** [Companies] Create member with existing user */
  createCompanyMemberFromExistingUser: CompanyMember;
  /** [Companies] Create members with existing users */
  createCompanyMembersFromExistingUser: Array<CompanyMember>;
  /** [Dictionary] Create company type */
  createCompanyType: CompanyType;
  /** [Dictionary] Create multiple company types */
  createCompanyTypes: Array<CompanyType>;
  /** [Dictionary] Allows continent creation (ROLE = ADMIN/SERVICE/SUPER) */
  createContinent: Continent;
  /** [Dictionary] Allows country creation (ROLE = ADMIN/SERVICE/SUPER) */
  createCountry: Country;
  /** [Dictionary] (Operation for inter-service communication)  Allows currency creation */
  createCurrencies?: Maybe<Array<Currency>>;
  /** [Dictionary] Allows currency creation (ROLE = ADMIN/SERVICE/SUPER) */
  createCurrency: Currency;
  /** [Payments] Create or update current user card */
  createCurrentUserCard: UserCard;
  /** [Identity] Create document */
  createDocument: CreatedDocument;
  /** [Identity] Create document config */
  createDocumentConfig: DocumentConfig;
  /** [Identity] Create document configs */
  createDocumentConfigs: Array<DocumentConfig>;
  /** [Identity] Create document field */
  createDocumentField: DocumentField;
  /** [Identity] Create document field config */
  createDocumentFieldConfig: DocumentFieldConfig;
  /** [Identity] Create document field configs */
  createDocumentFieldConfigs: Array<DocumentFieldConfig>;
  /** [Identity] Create document fields */
  createDocumentFields: Array<DocumentField>;
  createDocumentRejectTag: DocumentRejectTag;
  createDocumentRejectTags: Array<DocumentRejectTag>;
  /** [Identity] Create documents */
  createDocuments: Array<CreatedDocument>;
  /** [Payments] Create a cryptocurrency order configuration. */
  createExchangeConfig: ExchangeConfig;
  /** [Payments] Create a cryptocurrency order configurations. */
  createExchangeConfigs: Array<ExchangeConfig>;
  /** [Payments] Create a cryptocurrency order step. */
  createExchangeStepConfig: ExchangeStepConfig;
  /** [Payments] Create a cryptocurrency order steps. */
  createExchangeStepConfigs: Array<ExchangeStepConfig>;
  /** [Payments] Create an incoming payment */
  createIncomingPayment: Payment;
  /** [Accounts] Add intermediary bank information */
  createIntermediary: Intermediary;
  createKYBConfig: KybConfig;
  createKYBStep: KybStepConfig;
  createKYBSteps: Array<KybStepConfig>;
  createKYCConfig: KycConfig;
  createKYCStep: KycStepConfig;
  /** [Dictionary] Allows language creation (ROLE = ADMIN/SERVICE/SUPER) */
  createLanguage: Language;
  /** [Identity] Create access token for KYB SumSub SDK */
  createMyAccessTokenForKYBSumSubSDK: Scalars['String']['output'];
  /** [Identity] Create access token for KYC SumSub SDK */
  createMyAccessTokenForKYCSumSubSDK: KycAccessTokenApplicant;
  createMyAddress: CreatedOrUpdatedAddress;
  /** [Companies] Create my companies */
  createMyCompanies: Array<Company>;
  /** [Companies] Create my company */
  createMyCompany: Company;
  /** [Companies] Create my company additional info */
  createMyCompanyAdditionalInfo: AdditionalInfo;
  createMyCompanyMember: CompanyMember;
  createMyCompanyMemberAddress: Address;
  createMyCompanyMemberAddresses: Array<Address>;
  createMyCompanyMemberKYCAccessToken: MemberKycAccessTokenApplicant;
  createMyCompanyMemberV2: CompanyMember;
  createMyCompanyMembers: Array<CompanyMember>;
  createMyCompanyMembersV2: Array<CompanyMember>;
  /** [Companies] Create my company */
  createMyCompanyV2: Company;
  /** [Identity] Create documents for current user */
  createMyDocuments: Array<CreatedDocument>;
  /** [Payments] Exchange fiat and cryptocurrency. */
  createMyExchange: Exchange;
  /** [Payments] Creates user's outgoing payment template (ROLE = USER). */
  createMyPaymentTemplate: PaymentTemplate;
  /** [Dictionary] Allows number range creation (ROLE = ADMIN/SERVICE/SUPER) */
  createNumberRange: NumberRange;
  /** [Dictionary] Allows position creation (ROLE = ADMIN/SERVICE/SUPER) */
  createPosition: Position;
  /** [Dictionary] Allows creation of rate commission in percent */
  createRateCommission: RateCommission;
  /** [Dictionary] Allows region creation */
  createRegion: Region;
  /** [Identity] Create scoring risk level by data (requires admin/super/service role) */
  createScoringRiskLevel: ScoringRiskLevel;
  /** [Tariffs] Create tariff */
  createTariff: Tariff;
  /** [Client] Create tariff client */
  createTariffClient: TariffClient;
  /** [Client] Create tariff clients */
  createTariffClients: Array<TariffClient>;
  /** [Commission] Create tariff commission */
  createTariffCommission: TariffCommission;
  /** [CommissionFactor] Create tariff commission factor */
  createTariffCommissionFactor: TariffCommissionFactor;
  /** [CommissionFactor] Create tariff commission factors */
  createTariffCommissionFactors: Array<TariffCommissionFactor>;
  /** [Commission] Create tariff commissions */
  createTariffCommissions: Array<TariffCommission>;
  /** [Limits] Create limit */
  createTariffLimit: TariffLimit;
  /** [Limits] Create limit restriction */
  createTariffLimitRestriction: TariffLimitRestriction;
  /** [Limits] Create limit restrictions */
  createTariffLimitRestrictions: Array<TariffLimitRestriction>;
  /** [Limits] Create limits */
  createTariffLimits: Array<TariffLimit>;
  /** [Operations] Create operation */
  createTariffOperation: TariffOperation;
  /** [OperationHistory] Create operation histories */
  createTariffOperationHistories: Array<TariffOperationHistory>;
  /** [OperationHistory] Create operation history */
  createTariffOperationHistory: TariffOperationHistory;
  /** [Operations] Create operations */
  createTariffOperations: Array<TariffOperation>;
  /** [Tariffs] Create tariffs */
  createTariffs: Array<Tariff>;
  /** [Identity] Create temporary document without client checking */
  createTemporaryDocument: CreatedDocument;
  /** [Identity] Create temporary documents without client checking */
  createTemporaryDocuments: Array<CreatedDocument>;
  /** [Dictionary] Allows measure unit creation */
  createUnit: Unit;
  /** [Payments] Create or update user card (ROLE = [ADMIN, SUPER]) */
  createUserCard: UserCard;
  /** [Dictionary] Allows VAT creation */
  createVat: Vat;
  /** [Accounts] Create virtual accounts */
  createVirtualAccounts: Array<VAccount>;
  /** [Accounts] Decline clear junction corporate virtual iban allocation for company */
  declineCJCorporateVirtualIbanAllocation: Scalars['Boolean']['output'];
  /** [Payments] Decline card payment */
  declineCardPayment: Payment;
  /** [Payments] Decline crypto order that has error status */
  declineExchange: Scalars['Boolean']['output'];
  /** Description: [2FA] SUPER-ADMIN-SERVICE-ONLY Delete operation (soft-remove) */
  delete2FAOperation: Scalars['Boolean']['output'];
  deleteAddress: Scalars['Boolean']['output'];
  deleteAddressCategories: Array<AddressCategory>;
  deleteAddressCategory: AddressCategory;
  deleteAddresses: Scalars['Boolean']['output'];
  /** [Identity] Delete age range statistic settings */
  deleteAgeRangeStatisticSettings: Array<AgeRangeStatisticSetting>;
  deleteCompanyMember: Scalars['Boolean']['output'];
  deleteCompanyMembers: Scalars['Boolean']['output'];
  /** [Payments] Delete current user card by card id */
  deleteCurrentUserCard: Scalars['String']['output'];
  /** [Identity] Delete document */
  deleteDocument: Document;
  /** [Identity] Delete document config */
  deleteDocumentConfig: DocumentConfig;
  /** [Identity] Delete document configs */
  deleteDocumentConfigs: Array<DocumentConfig>;
  /** [Identity] Delete document field */
  deleteDocumentField: DocumentField;
  /** [Identity] Delete document field config */
  deleteDocumentFieldConfig: DocumentFieldConfig;
  /** [Identity] Delete document field configs */
  deleteDocumentFieldConfigs: Array<DocumentFieldConfig>;
  /** [Identity] Delete document fields */
  deleteDocumentFields: Array<DocumentField>;
  /** [Identity] Delete documents */
  deleteDocuments: Array<Document>;
  /** [Auth] Delete user`s extra data by key (ROLE = ADMIN) */
  deleteExtra: Scalars['String']['output'];
  /** [Accounts] Delete intermediary bank information */
  deleteIntermediary: Intermediary;
  deleteMyAddress: Scalars['Boolean']['output'];
  deleteMyCompanyMember: Scalars['Boolean']['output'];
  /** [Tariffs] Delete tariff */
  deleteTariff: Tariff;
  /** [Client] Delete tariff client */
  deleteTariffClient: TariffClient;
  /** [Client] Delete tariff clients */
  deleteTariffClients: Array<TariffClient>;
  /** [Commission] Delete tariff commission */
  deleteTariffCommission: TariffCommission;
  /** [CommissionFactor] Delete tariff commission factor */
  deleteTariffCommissionFactor: TariffCommissionFactor;
  /** [CommissionFactor] Delete tariff commission factors */
  deleteTariffCommissionFactors: Array<TariffCommissionFactor>;
  /** [Commission] Delete tariff commissions */
  deleteTariffCommissions: Array<TariffCommission>;
  /** [Limits] Delete tariff limit */
  deleteTariffLimit: TariffLimit;
  /** [Limits] Delete limit restriction */
  deleteTariffLimitRestriction: TariffLimitRestriction;
  /** [Limits] Delete limit restrictions */
  deleteTariffLimitRestrictions: Array<TariffLimitRestriction>;
  /** [Limits] Delete tariff limits */
  deleteTariffLimits: Array<TariffLimit>;
  /** [Operations] Delete operation */
  deleteTariffOperation: TariffOperation;
  /** [OperationHistory] Delete operation histories */
  deleteTariffOperationHistories: Array<TariffOperationHistory>;
  /** [OperationHistory] Delete operation history */
  deleteTariffOperationHistory: TariffOperationHistory;
  /** [Operations] Delete operations */
  deleteTariffOperations: Array<TariffOperation>;
  /** [Tariffs] Delete tariffs */
  deleteTariffs: Array<Tariff>;
  /** [Payments] Delete user card by card id (ROLE = [ADMIN, SUPER]) */
  deleteUserCard: Scalars['String']['output'];
  detachMyCompany?: Maybe<Scalars['Boolean']['output']>;
  /** Description: [2FA] Send request to disable user 2FA */
  disable2FA: TfaResponse;
  /** Description: [2FA] Disable all 2FA with recovery code */
  disableAll2FA: Scalars['Boolean']['output'];
  /** Description: [2FA] Send request to enable user 2FA */
  enable2FA: TfaResponse;
  /** [Payments] Exchange fiat and cryptocurrency. */
  exchange: Exchange;
  /** [Payments] Execute card payment (prepare → approve/decline) */
  executeCardPayment: Payment;
  executeKYBStep: Scalars['Boolean']['output'];
  executeKYCStep: Scalars['Boolean']['output'];
  /** [Dictionary] Force coin networks fetching and setting up deposit and withdraw tags (ROLE = ADMIN) */
  fetchCoinNetworks: Scalars['String']['output'];
  fetchDataFromAccounts: Scalars['String']['output'];
  /** [Accounts] Start updating new column - account type holder according to user id field */
  fillAccountHolderTypeColumn: Scalars['Boolean']['output'];
  /** [Accounts] Start opening contomobile sub account column for all accounts in need */
  fillContomobileAccountSubAccountColumn: Scalars['Boolean']['output'];
  formatAddresses: Scalars['Boolean']['output'];
  /** Description: [OneTimeCodes] generate one-time code */
  generateOneTimeCode: Scalars['String']['output'];
  /** Description: [2FA] Generate TOTP */
  generateTOTP: Scalars['String']['output'];
  /** [dictionary] Fetch a bank by its BIC code or create one if not found. */
  getOrCreateBankByBicCode?: Maybe<Bank>;
  /** [dictionary] Fetch a bank by its IBAN or create one if not found. */
  getOrCreateBankByIban?: Maybe<Bank>;
  /** [dictionary] Fetch a BIN (Bank Identification Number) or create one if not found. */
  getOrCreateBin?: Maybe<Bin>;
  /** [Auth] get token for email */
  getToken: Auth;
  /** [Auth] Returns JWT  */
  googleSignIn: Auth;
  /** [Files] generates temporary url with sign for file-uploading. File must be uploaded with POST request as form-data(ROLE = USER/ADMIN/SERVICE) */
  initUploadSession: UploadSesion;
  /** @deprecated Outdated. Use initializeNextKYBLevelV2 method. */
  initializeNextKYBLevel: KybLevelStatus;
  /** [Identity] Initialize next KYB level */
  initializeNextKYBLevelV2: KybLevelStatusV2;
  /** [Auth] Initiate user registration process */
  initiateUserRegistrationProcess: Scalars['Boolean']['output'];
  /** [Dictionary] Add cities to database from city directory table (ROLE = ADMIN/SUPER) */
  loadCityDirectory: Scalars['Boolean']['output'];
  /** [Auth] Login with provided credentials */
  loginWithCredentials: DynamicAuthLoginResponse;
  /** [accounts] Activate or deactivate client accounts */
  manageMultipleCurrencyAccounts: Scalars['Boolean']['output'];
  /** [Accounts] Moves values from “contomobileSubAccount” column to separate table as virtual sub accounts */
  migrateVirtualAccountsToSeparateTable: Scalars['Boolean']['output'];
  /** [Auth] Delete current user`s extra data by key */
  myDeleteExtra: Scalars['String']['output'];
  /** [Auth] Create or update current user's extra data */
  myUpdateExtra: Scalars['String']['output'];
  /** [Auth] Get a new access token from auth code */
  oauth2Token: Auth;
  /** [Accounts] Open clear junction virtual iban for individual clients */
  openCJVirtualIban: Scalars['Boolean']['output'];
  /**
   * [Dictionary] Start parsing banks from BANKDIRECTORY tables
   * @deprecated The functionality is outdated, check is required for further use.
   */
  parseBankDirectory: Scalars['Boolean']['output'];
  /**
   * [Dictionary] SuperAdmin _test mutation
   * Allows populate database with test cities from pre-parsed data source
   */
  parseCitiesFromJson: Array<Maybe<City>>;
  /**
   * [Dictionary] SuperAdmin _test mutation
   * Allows populate database with test cities which has geo data from pre-parsed data source
   */
  parseCitiesWithGeoFromJson: Array<Maybe<AddressData>>;
  /**
   * [Dictionary] SuperAdmin _test mutation
   * Allows populate database with test countries from pre-parsed data source
   */
  parseCountriesFromJson: Array<Maybe<Country>>;
  /**
   * [Dictionary] SuperAdmin _test mutation
   * Allows populate database with test currencies from pre-parsed data source
   */
  parseCurrenciesFromJson: Array<Maybe<Currency>>;
  /**
   * [Dictionary] SuperAdmin _test mutation
   * Allows populate database with test languages from pre-parsed data source
   */
  parseLanguagesFromJson: Array<Maybe<Language>>;
  /** [IntegrationTezro] Parse stripe commissions */
  parseStripeCommissions: Scalars['Boolean']['output'];
  /**
   * [Dictionary] SuperAdmin _test mutation
   * Allows you to fill the database with timezones by pre-parsed data source.
   */
  parseTimezones: Array<Maybe<Timezone>>;
  /**
   * [Dictionary] SuperAdmin _test mutation
   * Allows you to fill the database with transfer methods by pre-parsed data source.
   */
  parseTransferMethodsFromJson: Array<Maybe<TransferMethod>>;
  /** [Payments] Create a PayPal withdrawal */
  paymentsPaypalWithdrawalCreate: PaymentsPaypalWithdrawal;
  /** [Payments] Initialize a PayPal withdrawal */
  paymentsPaypalWithdrawalInitialize: PaymentsPaypalWithdrawal;
  /** [Payments] Re-process the PayPal awaiting liquidity withdrawal */
  paymentsPaypalWithdrawalReprocessAwaitingLiquidity: Scalars['Boolean']['output'];
  /** [Payments] Re-process the status change of the PayPal withdrawal item */
  paymentsPaypalWithdrawalReprocessItemStatusChange: Scalars['Boolean']['output'];
  /** [Payments] Re-process the PayPal withdrawal update */
  paymentsPaypalWithdrawalReprocessUpdate: Scalars['Boolean']['output'];
  /** [Payments] Soft delete a PayPal withdrawal */
  paymentsPaypalWithdrawalSoftDelete: PaymentsPaypalWithdrawal;
  /** [Payments] Update a PayPal withdrawal */
  paymentsPaypalWithdrawalUpdate: PaymentsPaypalWithdrawal;
  /** [Payments] Prepare card payment */
  prepareCardPayment: Payment;
  preparePayment: Payment;
  /** [Payments] Start awaiting liquidity payments processing (ROLE = [ADMIN, SUPER]) */
  processAwaitingLiquidityPayments: Scalars['Boolean']['output'];
  processKYBStep: Scalars['Boolean']['output'];
  processKYCStep: Scalars['Boolean']['output'];
  /** [Accounts] Allows to transfer data */
  processTransfer: ProcessTransferResponseData;
  recoverAddress: Scalars['Boolean']['output'];
  recoverAddresses: Scalars['Boolean']['output'];
  refundOutgoingPayment: Scalars['Boolean']['output'];
  /** [Accounts] Register clear junction corporate virtual iban for company */
  registerAllocatedCJCorporateVirtualIban: Scalars['Boolean']['output'];
  /** [sumsub] Register existing applicant in microservice */
  registerExistingApplicant: Scalars['Boolean']['output'];
  /** [sumsub] Register existing company applicant in microservice */
  registerExistingCompanyApplicant: Scalars['Boolean']['output'];
  /** [Auth] Register identity */
  registerIdentity: CheckResendOneTimeCodeType;
  /**
   * [Auth] Register phone
   * @deprecated Please, use registerIdentity instead.
   */
  registerPhone: Scalars['Boolean']['output'];
  /** [Identity] Register new user with personal data */
  registerUser: User;
  /** [Dictionary] Removes business activities (ROLE = ADMIN/SERVICE/SUPER) */
  removeBusinessActivities: Scalars['Boolean']['output'];
  /** [Dictionary] Removes cities (ROLE = ADMIN/SERVICE/SUPER) */
  removeCities: Scalars['Boolean']['output'];
  /** [Dictionary] Remove company types */
  removeCompanyTypes: Scalars['Boolean']['output'];
  /** [Dictionary] Removes continents (ROLE = ADMIN/SERVICE/SUPER) */
  removeContinents: Scalars['Boolean']['output'];
  /** [Dictionary] Removes countries (ROLE = ADMIN/SERVICE/SUPER) */
  removeCountries: Scalars['Boolean']['output'];
  /** [Dictionary] Removes currencies (ROLE = ADMIN/SERVICE/SUPER) */
  removeCurrencies: Scalars['Boolean']['output'];
  /** [Dictionary] Removes coin networks (ROLE = ADMIN/SERVICE/SUPER) */
  removeLanguages: Scalars['Boolean']['output'];
  /** [Payments] Removes user's outgoing payment templates (ROLE = USER). */
  removeMyPaymentTemplates: Array<PaymentTemplate>;
  /** [Dictionary] Removes NACE codes (ROLE = ADMIN/SERVICE/SUPER) */
  removeNaceCodes: Scalars['Boolean']['output'];
  /** [Dictionary] Removes number ranges (ROLE = ADMIN/SERVICE/SUPER) */
  removeNumberRanges: Scalars['Boolean']['output'];
  /** [Dictionary] Removes positions (ROLE = ADMIN/SERVICE/SUPER) */
  removePositions: Scalars['Boolean']['output'];
  /** [Dictionary] Removes regions (ROLE = ADMIN/SERVICE/SUPER) */
  removeRegions: Scalars['Boolean']['output'];
  /** [Identity] Remove scoring risk level by id (requires admin/super/service role) */
  removeScoringRiskLevel: Scalars['String']['output'];
  /** [Dictionary] Removes tags (ROLE = ADMIN/SERVICE/SUPER) */
  removeTags: Scalars['Boolean']['output'];
  /** [Dictionary] Removes units (ROLE = ADMIN/SERVICE/SUPER) */
  removeUnits: Scalars['Boolean']['output'];
  /** [Dictionary] Removes vats (ROLE = ADMIN/SERVICE/SUPER) */
  removeVats: Scalars['Boolean']['output'];
  requestToReviewApplicant: Scalars['Boolean']['output'];
  rescoreUserScoring: Scalars['Boolean']['output'];
  /** [Payments] Reset users top-up limits (ROLE = [ADMIN, SUPER]) */
  resetUsersTopUpLimits: Scalars['Boolean']['output'];
  restorePassword: Scalars['Boolean']['output'];
  /** [Auth] restore phone */
  restorePhone: Scalars['Boolean']['output'];
  /** [Payments] Review the outgoing manual payment */
  reviewOutgoingManualPayment: Payment;
  /** [Payments] Route payment */
  routePayment: Scalars['Boolean']['output'];
  /** [2FA] Send 2FA token. If type is not defined prefered enabled type will be selected */
  send2FAToken: Send2FaTokenResponse;
  /** [Referrers] Send an email/sms invitation on behalf of a friend to create an account */
  sendInvitationCreateAccount: Scalars['Boolean']['output'];
  sendMyCompanyDocumentsToReview: Scalars['Boolean']['output'];
  /** [Identity] send selected documents of current user for KYC procedure */
  sendMyVerification: Array<UserIdentityDoc>;
  sendPayment: Payment;
  /** [Payments] prepare, send and approve payment. (Admin only) */
  sendSystemPayment: Payment;
  /** [Auth] Send a code to email/sms for 2FA operation */
  sendTFACode: Send2FaTokenResponse;
  /** [Identity] send selected documents of user for KYC procedure (admin method) */
  sendVerification: Array<UserIdentityDoc>;
  /** [Payments] Set card top-up config for checkout payments (ROLE = [ADMIN, SUPER]) */
  setCardTopUpConfig: CardTopUpConfig;
  /** [Auth] Set user's extra field config (ROLE = ADMIN) */
  setExtraConfig: Scalars['Boolean']['output'];
  /** [Files] changes 'isPrivate' for some file */
  setFilePrivacy: File;
  signUp: User;
  signUpV2: RegisteredUser;
  /** [Auth] Standardise auth users phone numbers */
  standardiseAuthUsersPhoneNumbers: Scalars['Boolean']['output'];
  /** @deprecated Outdated. Use startKYBProcedureV2 method. */
  startKYBProcedure: KybLevelStatus;
  /** [Identity] Start KYB procedure (V2 API) */
  startKYBProcedureV2: KybLevelStatusV2;
  /** @deprecated Outdated. Use startKYCProcedureV2 method. */
  startKYCProcedure: KycLevelStatus;
  /** [Identity] Start KYC procedure (V2 API) */
  startKYCProcedureV2: KycLevelStatusV2;
  /** [Identity] Start KYB procedure (V2 API) */
  startMyKYBProcedureV2: KybLevelStatusV2;
  /** [Identity] Start KYC procedure (V2 API) */
  startMyKYCProcedureV2: KycLevelStatusV2;
  /** [Auth] Start password recovery process */
  startPasswordRecovery: Send2FaTokenResponse;
  /** [Auth] Start password recovery process v2 */
  startPasswordRecoveryV2: Send2FaTokenResponse;
  /** [Accounts] Start reconciliation of ClearJunction balances */
  startReconciliationClearJunctionBalances: Scalars['String']['output'];
  /** [Payments] Start a checkout top up process (ROLE = [USER, ADMIN, SUPER]) */
  startTopUpBalanceByCard: CheckoutPayment;
  syncAccountBalance: Account;
  /** Synchronizes personal data of user with Sumsub */
  synchronizeDataFromSumsub: User;
  /** Synchronizes documents of user with sumsub */
  synchronizeDocumentsFromSumsub: Scalars['Boolean']['output'];
  /** [Identity] Synchronize users with expiring documents */
  synchronizeUserExpiringDocuments: Scalars['Boolean']['output'];
  /**
   * Description: [2FA] Add emails to the list allowed for authorization in Telegram bot.
   *             Owners of email addresses from the list will not receive messages in Telegram
   */
  tfaBotAddEmails: Scalars['Boolean']['output'];
  /**
   * Description: [2FA] Add phones to the list allowed for authorization in Telegram bot.
   *             Owners of phones numbers from the list will not receive messages in Telegram
   */
  tfaBotAddPhones: Scalars['Boolean']['output'];
  /**
   * Description: [2FA] Delete emails from the list allowed for authorization in Telegram bot.
   *             Owners of email addresses from the list will not receive messages in Telegram
   */
  tfaBotDeleteEmails: Scalars['Boolean']['output'];
  /**
   * Description: [2FA] Delete phones from the list allowed for authorization in Telegram bot.
   *             Owners of phones numbers from the list will not receive messages in Telegram
   */
  tfaBotDeletePhones: Scalars['Boolean']['output'];
  /** [Auth] Get a new access token based on refresh token */
  token: Auth;
  /** [sumsub] Unbind individual applicant from company */
  unbindIndividualApplicantFromCompany: Scalars['Boolean']['output'];
  /** [Limits] Unbind limit from tariff operation */
  unbindLimitFromTariffOperation: Scalars['Boolean']['output'];
  /** [Accounts] Unblock account or change block reasons */
  unblockAccount: Account;
  unblockCompany: Company;
  unblockUser: User;
  /** [Auth] Get the remaining attempts to enter the code */
  unlockUserOperation: Scalars['Boolean']['output'];
  /** Description: [2FA] SUPER-ADMIN-SERVICE-ONLY Update operation */
  update2FAOperation: Scalars['Boolean']['output'];
  /** [Accounts] Start updating status of all currency accounts */
  updateAccountsStatus: Scalars['Boolean']['output'];
  updateAdditionalInfo: AdditionalInfo;
  updateAdditionalInfos: Array<AdditionalInfo>;
  updateAddress: CreatedOrUpdatedAddress;
  updateAddressCategories: Array<AddressCategory>;
  updateAddressCategory: AddressCategory;
  updateAddresses: Array<CreatedOrUpdatedAddress>;
  /** [Identity] Update age range statistic settings */
  updateAgeRangeStatisticSettings: Array<AgeRangeStatisticSetting>;
  updateApplicantTopLevelInfo: ApplicantType;
  /** [Accounts] Update current user account's balance. (User Only) */
  updateBalance: Account;
  /** [dictionary] Update the details of an existing bank. */
  updateBank: Bank;
  /** [Dictionary] Updates business activity (ROLE = ADMIN/SERVICE/SUPER) */
  updateBusinessActivity: BusinessActivity;
  /** [Payments] Update card payment */
  updateCardPayment: Payment;
  /** [Dictionary] Allows city updation (ROLE = ADMIN/SERVICE/SUPER) */
  updateCity: City;
  updateCompanies: Array<Company>;
  updateCompany: Company;
  updateCompanyMember: CompanyMember;
  updateCompanyMembers: Array<CompanyMember>;
  /** [Dictionary] Update company type */
  updateCompanyType: CompanyType;
  /** [Dictionary] Update multiple company types */
  updateCompanyTypes: Array<CompanyType>;
  /** [Dictionary] Allows continent deletion (ROLE = ADMIN/SERVICE/SUPER) */
  updateContinent: Continent;
  /** [Dictionary] Allows country updation (ROLE = ADMIN/SERVICE/SUPER) */
  updateCountry: Country;
  /** [Dictionary] Updates crypto currencies icons from CoinMarketCap API */
  updateCryptoCurrencyIcons: Scalars['Boolean']['output'];
  /** [Dictionary] Allows currency update (ROLE = ADMIN/SERVICE/SUPER) */
  updateCurrency: Currency;
  /** [Identity] Update document */
  updateDocument: Document;
  /** [Identity] Update document config */
  updateDocumentConfig: DocumentConfig;
  /** [Identity] Update document configs */
  updateDocumentConfigs: Array<DocumentConfig>;
  /** [Identity] Update document field */
  updateDocumentField: DocumentField;
  /** [Identity] Update document field config */
  updateDocumentFieldConfig: DocumentFieldConfig;
  /** [Identity] Update document field configs */
  updateDocumentFieldConfigs: Array<DocumentFieldConfig>;
  /** [Identity] Update document fields */
  updateDocumentFields: Array<DocumentField>;
  /** [Identity] Update documents */
  updateDocuments: Array<Document>;
  /** Update exchange info (ROLE = ADMIN/SERVICE/SUPER) */
  updateExchangeInfo: Scalars['Boolean']['output'];
  /** [Auth] Create or update user's extra data (ROLE = ADMIN) */
  updateExtra: Scalars['String']['output'];
  /** [Accounts] Update intermediary bank information */
  updateIntermediary: Intermediary;
  updateKYBConfig: KybConfig;
  updateKYBStep: KybStepConfig;
  updateKYBSteps: Array<KybStepConfig>;
  updateKYCConfig: KycConfig;
  updateKYCStep: KycStepConfig;
  /** [Dictionary] Allows language updation (ROLE = ADMIN/SERVICE/SUPER) */
  updateLanguage: Language;
  updateMyAddress: CreatedOrUpdatedAddress;
  /** [Companies] Update my company */
  updateMyCompany: Company;
  /** [Companies] Update my company additional info */
  updateMyCompanyAdditionalInfo: AdditionalInfo;
  updateMyCompanyMember: CompanyMember;
  updateMyCompanyMemberAddress: Address;
  updateMyCompanyMemberAddresses: Array<Address>;
  /** [Companies] Update my company */
  updateMyCompanyV2: Company;
  /** [Identity] add new documents for current user */
  updateMyDocuments: Array<UserIdentityDoc>;
  /** [Payments] Updates user's outgoing payment template by id (ROLE = USER). */
  updateMyPaymentTemplate: PaymentTemplate;
  /** [Identity] update personal data for current user */
  updateMyPersonal: UserPersonal;
  /** [Dictionary] Updates NACE code (ROLE = ADMIN/SERVICE/SUPER) */
  updateNACECode: NaceCode;
  /** [Dictionary] Allows number range updation (ROLE = ADMIN/SERVICE/SUPER) */
  updateNumberRange: NumberRange;
  updatePayment: Payment;
  /** [Identity] update personal data for any user (admin method) */
  updatePersonal: UserPersonal;
  /** [Dictionary] Allows position updation (ROLE = ADMIN/SERVICE/SUPER) */
  updatePosition: Position;
  /** [Dictionary] Allows region updation */
  updateRegion: Region;
  /** [Identity] Update scoring risk level with new updated data (requires admin/super/service role) */
  updateScoringRiskLevel: ScoringRiskLevel;
  /** [Dictionary] Force update trading coins tags (ROLE = ADMIN/SERVICE/SUPER) */
  updateTagsOnCoins: Scalars['String']['output'];
  /** [Tariffs] Update tariff */
  updateTariff: Tariff;
  /** [Client] Update tariff client */
  updateTariffClient: TariffClient;
  /** [Client] Update tariff clients */
  updateTariffClients: Array<TariffClient>;
  /** [Commission] Update tariff commission */
  updateTariffCommission: TariffCommission;
  /** [CommissionFactor] Update tariff commission factor */
  updateTariffCommissionFactor: TariffCommissionFactor;
  /** [CommissionFactor] Update tariff commission factors */
  updateTariffCommissionFactors: Array<TariffCommissionFactor>;
  /** [Commission] Update tariff commissions */
  updateTariffCommissions: Array<TariffCommission>;
  /** [Limits] Update limit */
  updateTariffLimit: TariffLimit;
  /** [Limits] Update limit restriction */
  updateTariffLimitRestriction: TariffLimitRestriction;
  /** [Limits] Update limit restrictions */
  updateTariffLimitRestrictions: Array<TariffLimitRestriction>;
  /** [Limits] Update limits */
  updateTariffLimits: Array<TariffLimit>;
  /** [Operations] Update operation */
  updateTariffOperation: TariffOperation;
  /** [OperationHistory] Update operation histories */
  updateTariffOperationHistories: Array<TariffOperationHistory>;
  /** [OperationHistory] Update operation history */
  updateTariffOperationHistory: TariffOperationHistory;
  /** [Operations] Update operations */
  updateTariffOperations: Array<TariffOperation>;
  /** [Tariffs] Update tariffs */
  updateTariffs: Array<Tariff>;
  /** [Dictionary] Allows measure unit updation */
  updateUnit: Unit;
  /** [Accounts] Update currency accounts status for user */
  updateUserAccountsStatus: Array<Account>;
  /** [Accounts] Update a virtual order status */
  updateVOrderStatus: Scalars['Boolean']['output'];
  /** [Dictionary] Allows VAT updation */
  updateVat: Vat;
  /** [Webhook] Update webhook */
  updateWebhook: Webhook;
  /** [VABS Accounts Plugin] Create account */
  vabsAccCreateMyAccount: VabsVirtualAccount;
  /** [VABS Accounts Plugin] Create account balances */
  vabsAccCreateMyAccountBalances: Array<VabsVirtualBalance>;
  /**
   * [VABS Accounts Plugin] Validate corporate data
   * @deprecated Will be removed
   */
  vabsAccValidateCorporate?: Maybe<Scalars['Boolean']['output']>;
  /** [VABS] Add dynamic enum value */
  vabsAddDynamicEnumValue: Array<Scalars['String']['output']>;
  /** [VABS] change real balance value */
  vabsChangeRealBalance: VabsRealBalance;
  /** [VABS] Change virtual balance value */
  vabsChangeVirtualBalance: VabsVirtualBalance;
  /** [VABS] Correct broken balances */
  vabsCorrectBrokenBalances: VabsAuditBalancesReport;
  /** [VABS] Create clients */
  vabsCreateClients: Array<VabsClient>;
  /** [VABS] Create currencies */
  vabsCreateCurrencies: Array<VabsCurrency>;
  /** [VABS] Create history rate settings */
  vabsCreateHistoryRateSettings: Array<VabsHistoryRateSetting>;
  /** [VABS] Create history rates */
  vabsCreateHistoryRates: Array<VabsHistoryRate>;
  vabsCreateMyBsbPayment: VabsBsbPaymentType;
  vabsCreateMyIfscPayment: VabsIfscPaymentType;
  vabsCreateMyInnerPayment: VabsInnerPaymentType;
  vabsCreateMySwiftPayment: VabsSwiftPaymentType;
  /** [VABS] Create networks */
  vabsCreateNetworks: Array<VabsNetwork>;
  /** [VABS] Create operations */
  vabsCreateOperations: Array<VabsOperation>;
  vabsCreatePaymentMethod: VabsPaymentMethod;
  vabsCreatePaymentMethods: Array<VabsPaymentMethod>;
  /** [VABS] Create projects */
  vabsCreateProjects: Array<VabsProject>;
  /** [VABS] Create provider configs */
  vabsCreateProviderConfigs: Array<VabsProviderConfig>;
  /** [VABS] Create providers currencies mapping */
  vabsCreateProviderCurrencyMapping: Array<VabsProviderCurrencyMapping>;
  /** [VABS] Create providers */
  vabsCreateProviders: Array<VabsProvider>;
  /** [VABS] Create real accounts */
  vabsCreateRealAccounts: Array<VabsRealAccount>;
  /** [VABS] Create real balances */
  vabsCreateRealBalances: Array<VabsRealBalance>;
  /** [VABS] Create real balances histories */
  vabsCreateRealBalancesHistories: Array<VabsRealBalanceHistory>;
  /** [VABS] Create real transaction accounts */
  vabsCreateRealTransactionAccounts: Array<VabsRealTransactionAccount>;
  /** [VABS] Create real transactions */
  vabsCreateRealTransactions: Array<VabsRealTransaction>;
  /** [VABS] Create reports */
  vabsCreateReports: Array<VabsReport>;
  /** [VABS] Create virtual accounts */
  vabsCreateVirtualAccounts: Array<VabsVirtualAccount>;
  /** [VABS] Create virtual balances */
  vabsCreateVirtualBalances: Array<VabsVirtualBalance>;
  /** [VABS] Create virtual balances histories */
  vabsCreateVirtualBalancesHistories: Array<VabsVirtualBalanceHistory>;
  /** [VABS] Create virtual transactions */
  vabsCreateVirtualTransactions: Array<VabsVirtualTransaction>;
  /** [VABS H&H Provider] Create incoming payment */
  vabsHnhCreateIncomingPayment: VabsOperation;
  /**
   * [VABS H&H Provider] Set SWIFT bank details
   * @deprecated Will be removed
   */
  vabsHnhSetSwiftBankDetails: VabsRealAccount;
  /** [VABS H&H Provider] Update incoming payment */
  vabsHnhUpdateIncomingPayment: VabsOperation;
  /** [VABS] Login with provided credentials */
  vabsLoginWithCredentials: VabsLoginResponse;
  /** [VABS] Remove dynamic enum values */
  vabsRemoveDynamicEnumValues: Array<Scalars['String']['output']>;
  /** [VABS] Restart plugin hook */
  vabsRestartPluginHook: VabsPluginTracking;
  /** [VABS] Update clients */
  vabsUpdateClients: Array<VabsClient>;
  /** [VABS] Update currencies */
  vabsUpdateCurrencies: Array<VabsCurrency>;
  /** [VABS] Update history rate settings */
  vabsUpdateHistoryRateSettings: Array<VabsHistoryRateSetting>;
  /** [VABS] Update history rates */
  vabsUpdateHistoryRates: Array<VabsHistoryRate>;
  vabsUpdateMyPaymentFavorite: VabsPaymentUnion;
  /** [VABS] Update networks */
  vabsUpdateNetworks: Array<VabsNetwork>;
  /** [VABS] Update operations */
  vabsUpdateOperations: Array<VabsOperation>;
  vabsUpdatePaymentMethod: VabsPaymentMethod;
  vabsUpdatePaymentMethods: Array<VabsPaymentMethod>;
  /** [VABS] Update projects */
  vabsUpdateProjects: Array<VabsProject>;
  /** [VABS] Update provider configs */
  vabsUpdateProviderConfigs: Array<VabsProviderConfig>;
  /** [VABS] Update providers */
  vabsUpdateProviders: Array<VabsProvider>;
  /** [VABS] Update providers currencies mapping */
  vabsUpdateProvidersCurrenciesMapping: Array<VabsProviderCurrencyMapping>;
  /** [VABS] Update real accounts */
  vabsUpdateRealAccounts: Array<VabsRealAccount>;
  /** [VABS] Update real balances */
  vabsUpdateRealBalances: Array<VabsRealBalance>;
  /** [VABS] Update real balances histories */
  vabsUpdateRealBalancesHistories: Array<VabsRealBalanceHistory>;
  /** [VABS] Update realTransactionAccounts */
  vabsUpdateRealTransactionAccounts: Array<VabsRealTransactionAccount>;
  /** [VABS] Update real transactions */
  vabsUpdateRealTransactions: Array<VabsRealTransaction>;
  /** [VABS] Update reports */
  vabsUpdateReports: Array<VabsReport>;
  /** [VABS] Update virtual accounts */
  vabsUpdateVirtualAccounts: Array<VabsVirtualAccount>;
  /** [VABS] Update virtual balances */
  vabsUpdateVirtualBalances: Array<VabsVirtualBalance>;
  /** [VABS] Update virtual balances histories */
  vabsUpdateVirtualBalancesHistories: Array<VabsVirtualBalanceHistory>;
  /** [VABS] Update virtual transactions */
  vabsUpdateVirtualTransactions: Array<VabsVirtualTransaction>;
  /** [2FA] Verify OTP token */
  verify2FAToken: Scalars['Boolean']['output'];
};


export type MutationAccountsCreateMultipleCurrencyAccountArgs = {
  input: AccountsCreateMultipleCurrencyInput;
};


export type MutationAccountsRouteArgs = {
  input: AccountsRouteInput;
};


export type MutationAddApplicantDocumentArgs = {
  input: AddApplicantDocumentInput;
};


export type MutationAddAvatarArgs = {
  avatarId: Scalars['String']['input'];
};


export type MutationAddFcmTokenArgs = {
  token: Scalars['String']['input'];
};


export type MutationAddTagArgs = {
  input: AddTagInput;
};


export type MutationAddTagByCodeArgs = {
  input: AddTagByCodeInput;
};


export type MutationAdminInitUploadSessionArgs = {
  isPrivate?: InputMaybe<Scalars['Boolean']['input']>;
  userId: Scalars['String']['input'];
};


export type MutationAdminSignUpArgs = {
  input: AdminSignUpInput;
};


export type MutationAppleSignInArgs = {
  input: AppleSignInInput;
};


export type MutationApproveCardPaymentArgs = {
  paymentId: Scalars['ID']['input'];
};


export type MutationApprovePaymentArgs = {
  input: ApprovePaymentInput;
};


export type MutationApproveUserPaymentArgs = {
  input: ApproveUserPaymentInput;
};


export type MutationBindIndividualApplicantToCompanyArgs = {
  input: BindIndividualApplicantToCompanyInput;
};


export type MutationBindLimitToTariffOperationArgs = {
  input: Array<BindUnbindLimitToTariffOperationInput>;
};


export type MutationBindOperationToTariffArgs = {
  input: BindOperationToTariffInput;
};


export type MutationBlockAccountArgs = {
  input: BlockAccountInput;
};


export type MutationBlockCompanyArgs = {
  input: BlockCompanyInput;
};


export type MutationBlockUserArgs = {
  input: BlockUserInput;
};


export type MutationChangeApplicantLevelArgs = {
  input: ChangeApplicantLevelInput;
};


export type MutationChangeBaseCurrencyCommissionArgs = {
  input: TariffChangeBaseCurrencyCommissionInput;
};


export type MutationChangeBaseCurrencyLimitArgs = {
  input: ChangeBaseCurrencyLimitInput;
};


export type MutationChangeIdentityArgs = {
  input: ChangeIdentityInput;
};


export type MutationChangePasswordArgs = {
  oldPassword: Scalars['String']['input'];
};


export type MutationChangePasswordNewArgs = {
  input: ChangePasswordNew;
};


export type MutationChangePasswordV2Args = {
  input: ChangePasswordV2Input;
};


export type MutationChangeUserStatusArgs = {
  input: ChangeUserStatusInput;
};


export type MutationCheckVerificationPhraseArgs = {
  input: VerificationPhraseInput;
};


export type MutationClearEntityTableArgs = {
  entityName: Scalars['String']['input'];
};


export type MutationConfirmChangeIdentityArgs = {
  input: ConfirmChangeIdentityInput;
};


export type MutationConfirmChangePasswordArgs = {
  input: ConfirmChangePasswordInput;
};


export type MutationConfirmDisabling2FaArgs = {
  input: Confirm2FaInput;
};


export type MutationConfirmEnabling2FaArgs = {
  input: Confirm2FaInput;
};


export type MutationConfirmOneTimeCodeArgs = {
  input: ConfirmOneTimeCodeInput;
};


export type MutationConfirmPasswordRecoveryArgs = {
  input: ConfirmPasswordRecoveryInput;
};


export type MutationConfirmSignInArgs = {
  input: AuthVerify2FaInput;
};


export type MutationConfirmationInviteArgs = {
  inviteCodeOrEmail: Scalars['String']['input'];
};


export type MutationCreate2FaOperationArgs = {
  input: CreateOperationInput;
};


export type MutationCreate2FaOperationIdArgs = {
  input: CreateOperationIdInput;
};


export type MutationCreateAccessTokenForApplicantArgs = {
  userId: Scalars['String']['input'];
};


export type MutationCreateAccessTokenForKybApplicantArgs = {
  companyId: Scalars['String']['input'];
};


export type MutationCreateAccountsForExistingTagArgs = {
  input: CreateAccountsForExistingTagInput;
};


export type MutationCreateAdditionalInfoArgs = {
  input: CreateAdditionalInfoInput;
};


export type MutationCreateAdditionalInfosArgs = {
  input: Array<CreateAdditionalInfoInput>;
};


export type MutationCreateAddressArgs = {
  input: CreateAddressInput;
};


export type MutationCreateAddressCategoriesArgs = {
  inputs: Array<CreateAddressCategoryInput>;
};


export type MutationCreateAddressCategoryArgs = {
  input: CreateAddressCategoryInput;
};


export type MutationCreateAddressesArgs = {
  inputs: Array<CreateAddressInput>;
};


export type MutationCreateAgeRangeStatisticSettingsArgs = {
  input: Array<CreateAgeRangeStatisticSettingInput>;
};


export type MutationCreateApplicantArgs = {
  input: CreateApplicantInput;
};


export type MutationCreateBankArgs = {
  input: BankCreateInput;
};


export type MutationCreateBinArgs = {
  input: BinCreateInput;
};


export type MutationCreateCheckoutPaymentArgs = {
  input: CreateCheckoutPaymentInput;
};


export type MutationCreateCityArgs = {
  input: CreateCityInput;
};


export type MutationCreateCompaniesArgs = {
  input: Array<CreateCompanyInput>;
};


export type MutationCreateCompanyArgs = {
  input: CreateCompanyInput;
};


export type MutationCreateCompanyApplicantArgs = {
  input: CreateCompanyApplicantInput;
};


export type MutationCreateCompanyMemberFromExistingUserArgs = {
  input: CreateMemberFromExistingUserInput;
};


export type MutationCreateCompanyMembersFromExistingUserArgs = {
  input: Array<CreateMemberFromExistingUserInput>;
};


export type MutationCreateCompanyTypeArgs = {
  input: CreateCompanyTypeInput;
};


export type MutationCreateCompanyTypesArgs = {
  input: Array<CreateCompanyTypeInput>;
};


export type MutationCreateContinentArgs = {
  input: CreateContinentInput;
};


export type MutationCreateCountryArgs = {
  input: CreateCountryInput;
};


export type MutationCreateCurrenciesArgs = {
  input: CreateCurrenciesInput;
};


export type MutationCreateCurrencyArgs = {
  input: CreateCurrencyInput;
};


export type MutationCreateCurrentUserCardArgs = {
  token: Scalars['String']['input'];
};


export type MutationCreateDocumentArgs = {
  input: CreateDocumentInput;
};


export type MutationCreateDocumentConfigArgs = {
  input: CreateDocumentConfigInput;
};


export type MutationCreateDocumentConfigsArgs = {
  input: Array<CreateDocumentConfigInput>;
};


export type MutationCreateDocumentFieldArgs = {
  input: CreateDocumentFieldInput;
};


export type MutationCreateDocumentFieldConfigArgs = {
  input: CreateDocumentFieldConfigInput;
};


export type MutationCreateDocumentFieldConfigsArgs = {
  input: Array<CreateDocumentFieldConfigInput>;
};


export type MutationCreateDocumentFieldsArgs = {
  input: Array<CreateDocumentFieldInput>;
};


export type MutationCreateDocumentRejectTagArgs = {
  input: CreateDocumentRejectTagInput;
};


export type MutationCreateDocumentRejectTagsArgs = {
  input: Array<CreateDocumentRejectTagInput>;
};


export type MutationCreateDocumentsArgs = {
  input: Array<CreateDocumentInput>;
};


export type MutationCreateExchangeConfigArgs = {
  input: CreateExchangeConfigInput;
};


export type MutationCreateExchangeConfigsArgs = {
  input: Array<CreateExchangeConfigInput>;
};


export type MutationCreateExchangeStepConfigArgs = {
  input: CreateExchangeStepConfigInput;
};


export type MutationCreateExchangeStepConfigsArgs = {
  input: Array<CreateExchangeStepConfigInput>;
};


export type MutationCreateIncomingPaymentArgs = {
  input: CreateIncomingPaymentInput;
};


export type MutationCreateIntermediaryArgs = {
  input: CreateIntermediaryInput;
};


export type MutationCreateKybConfigArgs = {
  input: CreateKybConfigInput;
};


export type MutationCreateKybStepArgs = {
  input: CreateKybStepInput;
};


export type MutationCreateKybStepsArgs = {
  input: Array<CreateKybStepInput>;
};


export type MutationCreateKycConfigArgs = {
  input: CreateKycConfigInput;
};


export type MutationCreateKycStepArgs = {
  input: CreateKycStepInput;
};


export type MutationCreateLanguageArgs = {
  input: CreateLanguageInput;
};


export type MutationCreateMyAddressArgs = {
  input: CreateMyAddressInput;
};


export type MutationCreateMyCompaniesArgs = {
  createMyCompaniesInput: Array<CreateMyCompanyInput>;
};


export type MutationCreateMyCompanyArgs = {
  input: CreateMyCompanyInput;
};


export type MutationCreateMyCompanyAdditionalInfoArgs = {
  input: CreateMyAdditionalInfoInput;
};


export type MutationCreateMyCompanyMemberArgs = {
  input: CreateMyCompanyMemberInput;
};


export type MutationCreateMyCompanyMemberAddressArgs = {
  input: CreateAddressInput;
};


export type MutationCreateMyCompanyMemberAddressesArgs = {
  input: Array<CreateAddressInput>;
};


export type MutationCreateMyCompanyMemberKycAccessTokenArgs = {
  memberId: Scalars['String']['input'];
};


export type MutationCreateMyCompanyMemberV2Args = {
  companyId: Scalars['String']['input'];
  input: CreateMyCompanyMemberInput;
};


export type MutationCreateMyCompanyMembersArgs = {
  createMyCompanyMembersInput: Array<CreateMyCompanyMemberInput>;
};


export type MutationCreateMyCompanyMembersV2Args = {
  companyId: Scalars['String']['input'];
  createMyCompanyMembersInput: Array<CreateMyCompanyMemberInput>;
};


export type MutationCreateMyCompanyV2Args = {
  companyId: Scalars['String']['input'];
  input: CreateMyCompanyInput;
};


export type MutationCreateMyDocumentsArgs = {
  input: Array<CreateMyDocumentInput>;
};


export type MutationCreateMyExchangeArgs = {
  input: ExchangeInput;
};


export type MutationCreateMyPaymentTemplateArgs = {
  input: CreateMyPaymentTemplateInput;
};


export type MutationCreateNumberRangeArgs = {
  input: CreateNumberRangeInput;
};


export type MutationCreatePositionArgs = {
  input: CreatePositionInput;
};


export type MutationCreateRateCommissionArgs = {
  input: CreateRateCommissionInput;
};


export type MutationCreateRegionArgs = {
  input: CreateRegionInput;
};


export type MutationCreateScoringRiskLevelArgs = {
  input: CreateScoringRiskLevelInput;
};


export type MutationCreateTariffArgs = {
  input: CreateTariffInput;
};


export type MutationCreateTariffClientArgs = {
  input: CreateTariffClientInput;
};


export type MutationCreateTariffClientsArgs = {
  inputs: Array<CreateTariffClientInput>;
};


export type MutationCreateTariffCommissionArgs = {
  input: CreateTariffCommissionInput;
};


export type MutationCreateTariffCommissionFactorArgs = {
  input: CreateTariffCommissionFactorInput;
};


export type MutationCreateTariffCommissionFactorsArgs = {
  inputs: Array<CreateTariffCommissionFactorInput>;
};


export type MutationCreateTariffCommissionsArgs = {
  inputs: Array<CreateTariffCommissionInput>;
};


export type MutationCreateTariffLimitArgs = {
  input: CreateTariffLimitInput;
};


export type MutationCreateTariffLimitRestrictionArgs = {
  input: CreateTariffLimitRestrictionInput;
};


export type MutationCreateTariffLimitRestrictionsArgs = {
  inputs: Array<CreateTariffLimitRestrictionInput>;
};


export type MutationCreateTariffLimitsArgs = {
  inputs: Array<CreateTariffLimitInput>;
};


export type MutationCreateTariffOperationArgs = {
  input: CreateTariffOperationInput;
};


export type MutationCreateTariffOperationHistoriesArgs = {
  inputs: Array<CreateTariffOperationHistoryInput>;
};


export type MutationCreateTariffOperationHistoryArgs = {
  input: CreateTariffOperationHistoryInput;
};


export type MutationCreateTariffOperationsArgs = {
  inputs: Array<CreateTariffOperationInput>;
};


export type MutationCreateTariffsArgs = {
  inputs: Array<CreateTariffInput>;
};


export type MutationCreateTemporaryDocumentArgs = {
  input: CreateDocumentInput;
};


export type MutationCreateTemporaryDocumentsArgs = {
  input: Array<CreateDocumentInput>;
};


export type MutationCreateUnitArgs = {
  input: CreateUnitInput;
};


export type MutationCreateUserCardArgs = {
  input: CreateUserCardInput;
};


export type MutationCreateVatArgs = {
  input: CreateVatInput;
};


export type MutationCreateVirtualAccountsArgs = {
  input: Array<CreateVirtualAccountInput>;
};


export type MutationDeclineCjCorporateVirtualIbanAllocationArgs = {
  input: DeclineCorporateVirtualIbanAllocationInput;
};


export type MutationDeclineCardPaymentArgs = {
  paymentId: Scalars['ID']['input'];
};


export type MutationDeclineExchangeArgs = {
  exchangeId: Scalars['ID']['input'];
};


export type MutationDelete2FaOperationArgs = {
  input: DeleteOperationInput;
};


export type MutationDeleteAddressArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteAddressCategoriesArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type MutationDeleteAddressCategoryArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteAddressesArgs = {
  ids: Array<Scalars['String']['input']>;
};


export type MutationDeleteAgeRangeStatisticSettingsArgs = {
  ids: Array<Scalars['String']['input']>;
};


export type MutationDeleteCompanyMemberArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteCompanyMembersArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type MutationDeleteCurrentUserCardArgs = {
  cardId: Scalars['String']['input'];
};


export type MutationDeleteDocumentArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteDocumentConfigArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteDocumentConfigsArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type MutationDeleteDocumentFieldArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteDocumentFieldConfigArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteDocumentFieldConfigsArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type MutationDeleteDocumentFieldsArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type MutationDeleteDocumentsArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type MutationDeleteExtraArgs = {
  key: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};


export type MutationDeleteIntermediaryArgs = {
  input: DeleteIntermediaryInput;
};


export type MutationDeleteMyAddressArgs = {
  input: Scalars['String']['input'];
};


export type MutationDeleteMyCompanyMemberArgs = {
  memberId: Scalars['ID']['input'];
};


export type MutationDeleteTariffArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteTariffClientArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteTariffClientsArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type MutationDeleteTariffCommissionArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteTariffCommissionFactorArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteTariffCommissionFactorsArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type MutationDeleteTariffCommissionsArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type MutationDeleteTariffLimitArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteTariffLimitRestrictionArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteTariffLimitRestrictionsArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type MutationDeleteTariffLimitsArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type MutationDeleteTariffOperationArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteTariffOperationHistoriesArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type MutationDeleteTariffOperationHistoryArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteTariffOperationsArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type MutationDeleteTariffsArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type MutationDeleteUserCardArgs = {
  cardId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};


export type MutationDisable2FaArgs = {
  input: TfaInput;
};


export type MutationDisableAll2FaArgs = {
  input: TfaClearAll2FaInput;
};


export type MutationEnable2FaArgs = {
  input: TfaInput;
};


export type MutationExchangeArgs = {
  input: ExchangeInput;
};


export type MutationExecuteCardPaymentArgs = {
  input: ExecuteCardPaymentInput;
};


export type MutationExecuteKybStepArgs = {
  input: ExecuteKybStepInput;
};


export type MutationExecuteKycStepArgs = {
  input: ExecuteKycStepInput;
};


export type MutationGenerateOneTimeCodeArgs = {
  input: GenerateOneTimeCodeInput;
};


export type MutationGenerateTotpArgs = {
  input?: InputMaybe<GenerateTotpInput>;
};


export type MutationGetOrCreateBankByBicCodeArgs = {
  bicCode: Scalars['String']['input'];
};


export type MutationGetOrCreateBankByIbanArgs = {
  iban: Scalars['String']['input'];
};


export type MutationGetOrCreateBinArgs = {
  bin: Scalars['String']['input'];
};


export type MutationGetTokenArgs = {
  input: GetTokenInput;
};


export type MutationGoogleSignInArgs = {
  input: GoogleSignInInput;
};


export type MutationInitUploadSessionArgs = {
  isPrivate?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationInitializeNextKybLevelArgs = {
  companyId: Scalars['String']['input'];
};


export type MutationInitializeNextKybLevelV2Args = {
  companyId: Scalars['String']['input'];
};


export type MutationInitiateUserRegistrationProcessArgs = {
  input: InitiateUserRegistrationProcessInput;
};


export type MutationLoginWithCredentialsArgs = {
  input: DynamicAuthLoginWithCredentialsInput;
};


export type MutationManageMultipleCurrencyAccountsArgs = {
  input: ManageMultipleCurrencyAccountsInput;
};


export type MutationMyDeleteExtraArgs = {
  key: Scalars['String']['input'];
};


export type MutationMyUpdateExtraArgs = {
  input: UpdateExtraInput;
};


export type MutationOauth2TokenArgs = {
  input: OAuth2TokenInput;
};


export type MutationOpenCjVirtualIbanArgs = {
  input: OpenCjVirtualIbanInput;
};


export type MutationPaymentsPaypalWithdrawalCreateArgs = {
  input: PaymentsPaypalWithdrawalCreateInput;
};


export type MutationPaymentsPaypalWithdrawalInitializeArgs = {
  input: PaymentsPaypalWithdrawalInitializeInput;
};


export type MutationPaymentsPaypalWithdrawalReprocessAwaitingLiquidityArgs = {
  id: Scalars['ID']['input'];
};


export type MutationPaymentsPaypalWithdrawalReprocessItemStatusChangeArgs = {
  input: PaymentsPaypalWithdrawalReprocessItemStatusUpdateInput;
};


export type MutationPaymentsPaypalWithdrawalReprocessUpdateArgs = {
  input: PaymentsPaypalWithdrawalReprocessUpdateInput;
};


export type MutationPaymentsPaypalWithdrawalSoftDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationPaymentsPaypalWithdrawalUpdateArgs = {
  input: PaymentsPaypalWithdrawalUpdateInput;
};


export type MutationPrepareCardPaymentArgs = {
  input: ExecuteCardPaymentInput;
};


export type MutationPreparePaymentArgs = {
  input: PreparePaymentInput;
};


export type MutationProcessKybStepArgs = {
  input: ProcessKybStepInput;
};


export type MutationProcessKycStepArgs = {
  input: ProcessKycStepInput;
};


export type MutationProcessTransferArgs = {
  input: ProcessTransferRequestPayload;
};


export type MutationRecoverAddressArgs = {
  id: Scalars['String']['input'];
};


export type MutationRecoverAddressesArgs = {
  ids: Array<Scalars['String']['input']>;
};


export type MutationRefundOutgoingPaymentArgs = {
  input: RefundOutgoingPaymentInput;
};


export type MutationRegisterAllocatedCjCorporateVirtualIbanArgs = {
  input: RegisterAllocatedCorporateVirtualIbanInput;
};


export type MutationRegisterExistingApplicantArgs = {
  input: RegisterExistingApplicantInput;
};


export type MutationRegisterExistingCompanyApplicantArgs = {
  input: RegisterExistingApplicantInput;
};


export type MutationRegisterIdentityArgs = {
  input: RegisterIdentityInput;
};


export type MutationRegisterPhoneArgs = {
  input: AuthRegisterPhoneInput;
};


export type MutationRegisterUserArgs = {
  input: CreateUserInput;
};


export type MutationRemoveBusinessActivitiesArgs = {
  input: RemoveDictItemsInput;
};


export type MutationRemoveCitiesArgs = {
  input: RemoveDictItemsInput;
};


export type MutationRemoveCompanyTypesArgs = {
  input: RemoveDictItemsInput;
};


export type MutationRemoveContinentsArgs = {
  input: RemoveDictItemsInput;
};


export type MutationRemoveCountriesArgs = {
  input: RemoveDictItemsInput;
};


export type MutationRemoveCurrenciesArgs = {
  input: RemoveDictItemsInput;
};


export type MutationRemoveLanguagesArgs = {
  input: RemoveDictItemsInput;
};


export type MutationRemoveMyPaymentTemplatesArgs = {
  input: RemoveMyPaymentTemplatesInput;
};


export type MutationRemoveNaceCodesArgs = {
  input: RemoveDictItemsInput;
};


export type MutationRemoveNumberRangesArgs = {
  input: RemoveDictItemsInput;
};


export type MutationRemovePositionsArgs = {
  input: RemoveDictItemsInput;
};


export type MutationRemoveRegionsArgs = {
  input: RemoveDictItemsInput;
};


export type MutationRemoveScoringRiskLevelArgs = {
  id: Scalars['String']['input'];
};


export type MutationRemoveTagsArgs = {
  input: RemoveDictItemsInput;
};


export type MutationRemoveUnitsArgs = {
  input: RemoveDictItemsInput;
};


export type MutationRemoveVatsArgs = {
  input: RemoveDictItemsInput;
};


export type MutationRequestToReviewApplicantArgs = {
  input: RequestToReviewApplicantInput;
};


export type MutationRescoreUserScoringArgs = {
  userId: Scalars['String']['input'];
};


export type MutationRestorePasswordArgs = {
  input: RestorePasswordInput;
};


export type MutationReviewOutgoingManualPaymentArgs = {
  input: ReviewOutgoingManualPaymentInput;
};


export type MutationRoutePaymentArgs = {
  paymentId: Scalars['String']['input'];
};


export type MutationSend2FaTokenArgs = {
  input: Send2FaTokenInput;
};


export type MutationSendInvitationCreateAccountArgs = {
  input: ReferrersSendInvitationCreateAccountInput;
};


export type MutationSendMyVerificationArgs = {
  input: SendMyVerificationInput;
};


export type MutationSendPaymentArgs = {
  input: SendPaymentInput;
};


export type MutationSendSystemPaymentArgs = {
  input: SendSystemPaymentInput;
};


export type MutationSendTfaCodeArgs = {
  input: AuthTfaSend;
};


export type MutationSendVerificationArgs = {
  input: SendVerificationInput;
};


export type MutationSetCardTopUpConfigArgs = {
  input: SetCardTopUpConfigInput;
};


export type MutationSetExtraConfigArgs = {
  input: SetExtraConfigInput;
};


export type MutationSetFilePrivacyArgs = {
  input: SetFilePrivacyInput;
};


export type MutationSignUpArgs = {
  input: UserInput;
};


export type MutationSignUpV2Args = {
  input: UserInput;
};


export type MutationStartKybProcedureArgs = {
  companyId: Scalars['String']['input'];
};


export type MutationStartKybProcedureV2Args = {
  companyId: Scalars['String']['input'];
};


export type MutationStartKycProcedureArgs = {
  userId: Scalars['String']['input'];
};


export type MutationStartKycProcedureV2Args = {
  userId: Scalars['String']['input'];
};


export type MutationStartPasswordRecoveryArgs = {
  identity: Scalars['String']['input'];
};


export type MutationStartPasswordRecoveryV2Args = {
  input: StartPasswordRecoveryV2Input;
};


export type MutationStartTopUpBalanceByCardArgs = {
  input: StartTopUpBalanceByCardInput;
};


export type MutationSyncAccountBalanceArgs = {
  accountId: Scalars['String']['input'];
};


export type MutationSynchronizeDataFromSumsubArgs = {
  userId: Scalars['String']['input'];
};


export type MutationSynchronizeDocumentsFromSumsubArgs = {
  userId: Scalars['String']['input'];
};


export type MutationTfaBotAddEmailsArgs = {
  input: TfaTgEmailInput;
};


export type MutationTfaBotAddPhonesArgs = {
  input: TfaTgPhonesInput;
};


export type MutationTfaBotDeleteEmailsArgs = {
  input: TfaTgEmailInput;
};


export type MutationTfaBotDeletePhonesArgs = {
  input: TfaTgPhonesInput;
};


export type MutationTokenArgs = {
  accessToken: Scalars['String']['input'];
  refreshToken: Scalars['String']['input'];
};


export type MutationUnbindIndividualApplicantFromCompanyArgs = {
  input: UnbindIndividualApplicantFromCompanyInput;
};


export type MutationUnbindLimitFromTariffOperationArgs = {
  input: Array<BindUnbindLimitToTariffOperationInput>;
};


export type MutationUnblockAccountArgs = {
  input: UnblockAccountInput;
};


export type MutationUnblockCompanyArgs = {
  input: UnblockCompanyInput;
};


export type MutationUnblockUserArgs = {
  input: UnblockUserInput;
};


export type MutationUnlockUserOperationArgs = {
  input: UnlockUserOperationInput;
};


export type MutationUpdate2FaOperationArgs = {
  input: UpdateOperationInput;
};


export type MutationUpdateAdditionalInfoArgs = {
  input: UpdateAdditionalInfoInput;
};


export type MutationUpdateAdditionalInfosArgs = {
  input: Array<UpdateAdditionalInfoInput>;
};


export type MutationUpdateAddressArgs = {
  input: UpdateAddressInput;
};


export type MutationUpdateAddressCategoriesArgs = {
  inputs: Array<UpdateAddressCategoryInput>;
};


export type MutationUpdateAddressCategoryArgs = {
  input: UpdateAddressCategoryInput;
};


export type MutationUpdateAddressesArgs = {
  inputs: Array<UpdateAddressInput>;
};


export type MutationUpdateAgeRangeStatisticSettingsArgs = {
  input: Array<UpdateAgeRangeStatisticSettingInput>;
};


export type MutationUpdateApplicantTopLevelInfoArgs = {
  input: UpdateApplicantTopLevelInput;
};


export type MutationUpdateBalanceArgs = {
  input: UpdateBalanceInput;
};


export type MutationUpdateBankArgs = {
  input: BankUpdateInput;
};


export type MutationUpdateBusinessActivityArgs = {
  input: UpdateBusinessActivityInput;
};


export type MutationUpdateCardPaymentArgs = {
  input: UpdateCardPaymentInput;
};


export type MutationUpdateCityArgs = {
  input: UpdateCityInput;
};


export type MutationUpdateCompaniesArgs = {
  input: Array<UpdateCompanyInput>;
};


export type MutationUpdateCompanyArgs = {
  input: UpdateCompanyInput;
};


export type MutationUpdateCompanyMemberArgs = {
  input: UpdateMemberInput;
};


export type MutationUpdateCompanyMembersArgs = {
  input: Array<UpdateMemberInput>;
};


export type MutationUpdateCompanyTypeArgs = {
  input: UpdateCompanyTypeInput;
};


export type MutationUpdateCompanyTypesArgs = {
  input: Array<UpdateCompanyTypeInput>;
};


export type MutationUpdateContinentArgs = {
  input: UpdateContinentInput;
};


export type MutationUpdateCountryArgs = {
  input: UpdateCountryInput;
};


export type MutationUpdateCurrencyArgs = {
  input: UpdateCurrencyInput;
};


export type MutationUpdateDocumentArgs = {
  input: UpdateDocumentInput;
};


export type MutationUpdateDocumentConfigArgs = {
  input: UpdateDocumentConfigInput;
};


export type MutationUpdateDocumentConfigsArgs = {
  input: Array<UpdateDocumentConfigInput>;
};


export type MutationUpdateDocumentFieldArgs = {
  input: UpdateDocumentFieldInput;
};


export type MutationUpdateDocumentFieldConfigArgs = {
  input: UpdateDocumentFieldConfigInput;
};


export type MutationUpdateDocumentFieldConfigsArgs = {
  input: Array<UpdateDocumentFieldConfigInput>;
};


export type MutationUpdateDocumentFieldsArgs = {
  input: Array<UpdateDocumentFieldInput>;
};


export type MutationUpdateDocumentsArgs = {
  input: Array<UpdateDocumentInput>;
};


export type MutationUpdateExchangeInfoArgs = {
  input: UpdateExchangeInfoInput;
};


export type MutationUpdateExtraArgs = {
  input: UpdateExtraInput;
  userId: Scalars['String']['input'];
};


export type MutationUpdateIntermediaryArgs = {
  input: UpdateIntermediaryInput;
};


export type MutationUpdateKybConfigArgs = {
  input: UpdateKybConfigInput;
};


export type MutationUpdateKybStepArgs = {
  input: UpdateKybStepInput;
};


export type MutationUpdateKybStepsArgs = {
  input: Array<UpdateKybStepInput>;
};


export type MutationUpdateKycConfigArgs = {
  input: UpdateKycConfigInput;
};


export type MutationUpdateKycStepArgs = {
  input: UpdateKycStepInput;
};


export type MutationUpdateLanguageArgs = {
  input: UpdateLanguageInput;
};


export type MutationUpdateMyAddressArgs = {
  input: UpdateAddressInput;
};


export type MutationUpdateMyCompanyArgs = {
  input: UpdateMyCompanyInput;
};


export type MutationUpdateMyCompanyAdditionalInfoArgs = {
  input: UpdateMyAdditionalInfoInput;
};


export type MutationUpdateMyCompanyMemberArgs = {
  input: UpdateMyCompanyMemberInput;
};


export type MutationUpdateMyCompanyMemberAddressArgs = {
  input: UpdateAddressInput;
};


export type MutationUpdateMyCompanyMemberAddressesArgs = {
  input: Array<UpdateAddressInput>;
};


export type MutationUpdateMyCompanyV2Args = {
  companyId: Scalars['String']['input'];
  input: UpdateMyCompanyInput;
};


export type MutationUpdateMyDocumentsArgs = {
  input: UpdateMyDocumentsInput;
};


export type MutationUpdateMyPaymentTemplateArgs = {
  input: UpdateMyPaymentTemplateInput;
};


export type MutationUpdateMyPersonalArgs = {
  input: UpdateMyPersonalInput;
};


export type MutationUpdateNaceCodeArgs = {
  input: UpdateNaceCodeInput;
};


export type MutationUpdateNumberRangeArgs = {
  input: UpdateNumberRangeInput;
};


export type MutationUpdatePaymentArgs = {
  input: UpdatePaymentInput;
};


export type MutationUpdatePersonalArgs = {
  input: UpdatePersonalInput;
};


export type MutationUpdatePositionArgs = {
  input: UpdatePositionInput;
};


export type MutationUpdateRegionArgs = {
  input: UpdateRegionInput;
};


export type MutationUpdateScoringRiskLevelArgs = {
  input: UpdateScoringRiskLevelInput;
};


export type MutationUpdateTariffArgs = {
  input: UpdateTariffInput;
};


export type MutationUpdateTariffClientArgs = {
  input: UpdateTariffClientInput;
};


export type MutationUpdateTariffClientsArgs = {
  inputs: Array<UpdateTariffClientInput>;
};


export type MutationUpdateTariffCommissionArgs = {
  input: UpdateTariffCommissionInput;
};


export type MutationUpdateTariffCommissionFactorArgs = {
  input: UpdateTariffCommissionFactorInput;
};


export type MutationUpdateTariffCommissionFactorsArgs = {
  inputs: Array<UpdateTariffCommissionFactorInput>;
};


export type MutationUpdateTariffCommissionsArgs = {
  inputs: Array<UpdateTariffCommissionInput>;
};


export type MutationUpdateTariffLimitArgs = {
  input: UpdateTariffLimitInput;
};


export type MutationUpdateTariffLimitRestrictionArgs = {
  input: UpdateTariffLimitRestrictionInput;
};


export type MutationUpdateTariffLimitRestrictionsArgs = {
  inputs: Array<UpdateTariffLimitRestrictionInput>;
};


export type MutationUpdateTariffLimitsArgs = {
  inputs: Array<UpdateTariffLimitInput>;
};


export type MutationUpdateTariffOperationArgs = {
  input: UpdateTariffOperationInput;
};


export type MutationUpdateTariffOperationHistoriesArgs = {
  inputs: Array<UpdateTariffOperationHistoryInput>;
};


export type MutationUpdateTariffOperationHistoryArgs = {
  input: UpdateTariffOperationHistoryInput;
};


export type MutationUpdateTariffOperationsArgs = {
  inputs: Array<UpdateTariffOperationInput>;
};


export type MutationUpdateTariffsArgs = {
  inputs: Array<UpdateTariffInput>;
};


export type MutationUpdateUnitArgs = {
  input: UpdateUnitInput;
};


export type MutationUpdateUserAccountsStatusArgs = {
  userId: Scalars['String']['input'];
};


export type MutationUpdateVOrderStatusArgs = {
  input: UpdateVirtualOrderStatusInput;
};


export type MutationUpdateVatArgs = {
  input: UpdateVatInput;
};


export type MutationUpdateWebhookArgs = {
  input: UpdateWebhookInput;
};


export type MutationVabsAccCreateMyAccountBalancesArgs = {
  accCreateMyAccountBalancesInput: VabsAccCreateMyAccountBalancesInput;
};


export type MutationVabsAccValidateCorporateArgs = {
  companyId: Scalars['String']['input'];
};


export type MutationVabsAddDynamicEnumValueArgs = {
  enumName: VabsDynamicEnums;
  values: Array<Scalars['String']['input']>;
};


export type MutationVabsChangeRealBalanceArgs = {
  input: VabsChangeRealBalanceInput;
};


export type MutationVabsChangeVirtualBalanceArgs = {
  input: VabsChangeVirtualBalanceInput;
};


export type MutationVabsCorrectBrokenBalancesArgs = {
  correctBrokenBalancesInput?: InputMaybe<VabsAuditBalances>;
};


export type MutationVabsCreateClientsArgs = {
  input: Array<VabsCreateClientInput>;
};


export type MutationVabsCreateCurrenciesArgs = {
  input: Array<VabsCreateCurrencyInput>;
};


export type MutationVabsCreateHistoryRateSettingsArgs = {
  input: Array<VabsCreateHistoryRateSettingInput>;
};


export type MutationVabsCreateHistoryRatesArgs = {
  input: Array<VabsCreateHistoryRateCrudInput>;
};


export type MutationVabsCreateMyBsbPaymentArgs = {
  input: VabsCreateBsbPaymentInput;
};


export type MutationVabsCreateMyIfscPaymentArgs = {
  input: VabsCreateIfscPaymentInput;
};


export type MutationVabsCreateMyInnerPaymentArgs = {
  input: VabsCreateInnerPaymentInput;
};


export type MutationVabsCreateMySwiftPaymentArgs = {
  input: VabsCreateSwiftPaymentInput;
};


export type MutationVabsCreateNetworksArgs = {
  input: Array<VabsCreateNetworkInput>;
};


export type MutationVabsCreateOperationsArgs = {
  input: Array<VabsCreateOperationInput>;
};


export type MutationVabsCreatePaymentMethodArgs = {
  input: VabsCreatePaymentMethodInput;
};


export type MutationVabsCreatePaymentMethodsArgs = {
  input: Array<VabsCreatePaymentMethodInput>;
};


export type MutationVabsCreateProjectsArgs = {
  input: Array<VabsCreateProjectInput>;
};


export type MutationVabsCreateProviderConfigsArgs = {
  input: Array<VabsCreateProviderConfigInput>;
};


export type MutationVabsCreateProviderCurrencyMappingArgs = {
  input: Array<VabsCreateProviderCurrencyMappingInput>;
};


export type MutationVabsCreateProvidersArgs = {
  input: Array<VabsCreateProviderInput>;
};


export type MutationVabsCreateRealAccountsArgs = {
  input: Array<VabsCreateRealAccountInput>;
};


export type MutationVabsCreateRealBalancesArgs = {
  input: Array<VabsCreateRealBalanceInput>;
};


export type MutationVabsCreateRealBalancesHistoriesArgs = {
  input: Array<VabsCreateRealBalanceHistoryInput>;
};


export type MutationVabsCreateRealTransactionAccountsArgs = {
  input: Array<VabsCreateRealTransactionAccountInput>;
};


export type MutationVabsCreateRealTransactionsArgs = {
  input: Array<VabsCreateRealTransactionInput>;
};


export type MutationVabsCreateReportsArgs = {
  input: Array<VabsCreateReportInput>;
};


export type MutationVabsCreateVirtualAccountsArgs = {
  input: Array<VabsCreateVirtualAccountInput>;
};


export type MutationVabsCreateVirtualBalancesArgs = {
  input: Array<VabsCreateVirtualBalanceInput>;
};


export type MutationVabsCreateVirtualBalancesHistoriesArgs = {
  input: Array<VabsCreateVirtualBalanceHistoryInput>;
};


export type MutationVabsCreateVirtualTransactionsArgs = {
  input: Array<VabsCreateVirtualTransactionInput>;
};


export type MutationVabsHnhCreateIncomingPaymentArgs = {
  hnhCreateIncomingPaymentInput: VabsHnhCreateIncomingPaymentInput;
};


export type MutationVabsHnhSetSwiftBankDetailsArgs = {
  hnhSetSwiftBankDetailsInput: VabsHnhSetSwiftBankDetailsInput;
};


export type MutationVabsHnhUpdateIncomingPaymentArgs = {
  hnhUpdateIncomingPaymentInput: VabsHnhUpdateIncomingPaymentInput;
};


export type MutationVabsLoginWithCredentialsArgs = {
  input: VabsLoginWithCredentialsInput;
};


export type MutationVabsRemoveDynamicEnumValuesArgs = {
  enumName: VabsDynamicEnums;
  values: Array<Scalars['String']['input']>;
};


export type MutationVabsRestartPluginHookArgs = {
  pluginTrackingId: Scalars['String']['input'];
};


export type MutationVabsUpdateClientsArgs = {
  input: Array<VabsUpdateClientInput>;
};


export type MutationVabsUpdateCurrenciesArgs = {
  input: Array<VabsUpdateCurrencyInput>;
};


export type MutationVabsUpdateHistoryRateSettingsArgs = {
  input: Array<VabsUpdateHistoryRateSettingInput>;
};


export type MutationVabsUpdateHistoryRatesArgs = {
  input: Array<VabsUpdateHistoryRateInput>;
};


export type MutationVabsUpdateMyPaymentFavoriteArgs = {
  input: VabsUpdatePaymentFavoriteInput;
};


export type MutationVabsUpdateNetworksArgs = {
  input: Array<VabsUpdateNetworkInput>;
};


export type MutationVabsUpdateOperationsArgs = {
  input: Array<VabsUpdateOperationInput>;
};


export type MutationVabsUpdatePaymentMethodArgs = {
  input: VabsUpdatePaymentMethodInput;
};


export type MutationVabsUpdatePaymentMethodsArgs = {
  input: Array<VabsUpdatePaymentMethodInput>;
};


export type MutationVabsUpdateProjectsArgs = {
  input: Array<VabsUpdateProjectInput>;
};


export type MutationVabsUpdateProviderConfigsArgs = {
  input: Array<VabsUpdateProviderConfigInput>;
};


export type MutationVabsUpdateProvidersArgs = {
  input: Array<VabsUpdateProviderInput>;
};


export type MutationVabsUpdateProvidersCurrenciesMappingArgs = {
  input: Array<VabsUpdateProviderCurrencyMappingInput>;
};


export type MutationVabsUpdateRealAccountsArgs = {
  input: Array<VabsUpdateRealAccountInput>;
};


export type MutationVabsUpdateRealBalancesArgs = {
  input: Array<VabsUpdateRealBalanceInput>;
};


export type MutationVabsUpdateRealBalancesHistoriesArgs = {
  input: Array<VabsUpdateRealBalanceHistoryInput>;
};


export type MutationVabsUpdateRealTransactionAccountsArgs = {
  input: Array<VabsUpdateRealTransactionAccountInput>;
};


export type MutationVabsUpdateRealTransactionsArgs = {
  input: Array<VabsUpdateRealTransactionInput>;
};


export type MutationVabsUpdateReportsArgs = {
  input: Array<VabsUpdateReportInput>;
};


export type MutationVabsUpdateVirtualAccountsArgs = {
  input: Array<VabsUpdateVirtualAccountInput>;
};


export type MutationVabsUpdateVirtualBalancesArgs = {
  input: Array<VabsUpdateVirtualBalanceInput>;
};


export type MutationVabsUpdateVirtualBalancesHistoriesArgs = {
  input: Array<VabsUpdateVirtualBalanceHistoryInput>;
};


export type MutationVabsUpdateVirtualTransactionsArgs = {
  input: Array<VabsUpdateVirtualTransactionInput>;
};


export type MutationVerify2FaTokenArgs = {
  input: Verify2FaInput;
};

export type MyAccountsInput = {
  accountNumbers?: InputMaybe<Array<Scalars['String']['input']>>;
  companyId?: InputMaybe<Scalars['ID']['input']>;
  currencyIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  filter?: InputMaybe<Filter>;
  isSystems?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  provider?: InputMaybe<AccountsProviderEnum>;
  providerTag?: InputMaybe<Scalars['String']['input']>;
  requestGCP?: InputMaybe<Scalars['Boolean']['input']>;
  tag?: InputMaybe<Scalars['String']['input']>;
};

export type MyCommission = {
  __typename?: 'MyCommission';
  approximately?: Maybe<Scalars['Boolean']['output']>;
  commission: Scalars['BigNumber']['output'];
  from?: Maybe<Scalars['BigNumber']['output']>;
  max?: Maybe<Scalars['BigNumber']['output']>;
  min?: Maybe<Scalars['BigNumber']['output']>;
  to?: Maybe<Scalars['BigNumber']['output']>;
};

export type MyCommissionDirection = {
  __typename?: 'MyCommissionDirection';
  commissions: Array<MyCommission>;
  currencyTicker: Scalars['String']['output'];
};

export type MyCommissionOperation = {
  __typename?: 'MyCommissionOperation';
  incoming?: Maybe<Array<MyCommissionDirection>>;
  operation: Scalars['String']['output'];
  outgoing?: Maybe<Array<MyCommissionDirection>>;
};

export type MyCommissionOperations = {
  __typename?: 'MyCommissionOperations';
  count: Scalars['Int']['output'];
  cursor: Scalars['Int']['output'];
  nodes: Array<MyCommissionOperation>;
};

export type MyGroupedAccountsInput = {
  currencyIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  currencyTickers?: InputMaybe<Array<Scalars['String']['input']>>;
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  isSystems?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  pagination?: InputMaybe<StripePaginationInput>;
  states?: InputMaybe<Array<AccountState>>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type MyPaymentsInput = {
  accountIds?: InputMaybe<Array<Scalars['String']['input']>>;
  amount?: InputMaybe<Scalars['BigNumber']['input']>;
  amountRange?: InputMaybe<AmountRangeInput>;
  cardIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  categories?: InputMaybe<Array<PaymentCategory>>;
  creditType?: InputMaybe<Array<CreditType>>;
  currencyId?: InputMaybe<Scalars['ID']['input']>;
  dateRange?: InputMaybe<DateRangeInput>;
  direction?: InputMaybe<PaymentDirection>;
  filter?: InputMaybe<Filter>;
  isSystems?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  realAccountIds?: InputMaybe<Array<Scalars['String']['input']>>;
  schema?: InputMaybe<PaymentSchema>;
  service?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<CommonSort>;
  sortOrder?: InputMaybe<SortOrder>;
  state?: InputMaybe<PaymentState>;
  states?: InputMaybe<Array<PaymentState>>;
  trackerId?: InputMaybe<Scalars['ID']['input']>;
  types?: InputMaybe<Array<PaymentType>>;
};

export type NaceCode = {
  __typename?: 'NACECode';
  children?: Maybe<Array<NaceCode>>;
  id: Scalars['ID']['output'];
  item: CommonDictItem;
  parent?: Maybe<NaceCode>;
  section: NaceCodeSection;
};


export type NaceCodeChildrenArgs = {
  input?: InputMaybe<GetNaceCodesInput>;
};

export type NaceCodeSection = {
  __typename?: 'NACECodeSection';
  description: Scalars['String']['output'];
  item: CommonDictItem;
};

export type NaceCodes = {
  __typename?: 'NACECodes';
  count: Scalars['Int']['output'];
  cursor: Scalars['Int']['output'];
  nodes: Array<NaceCode>;
};

export type NameOrCompany = {
  __typename?: 'NameOrCompany';
  companyName?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
};

export type NameOrCompanyInput = {
  companyName?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
};

export type NameOrContactInput = {
  contactId?: InputMaybe<Scalars['String']['input']>;
  nameOrCompany?: InputMaybe<NameOrCompanyInput>;
};

export type NewBankDetail = {
  __typename?: 'NewBankDetail';
  accountHolder: NewBankDetailAccountHolder;
  address?: Maybe<Scalars['String']['output']>;
  bic?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  sortCode?: Maybe<Scalars['String']['output']>;
};

export type NewBankDetailAccountHolder = {
  __typename?: 'NewBankDetailAccountHolder';
  accountNumber: Scalars['String']['output'];
  iban?: Maybe<Scalars['String']['output']>;
  mandatoryReference: Scalars['String']['output'];
  name: Scalars['String']['output'];
  userInternalIban: Scalars['String']['output'];
  walletId: Scalars['String']['output'];
};

export type NewBankDetails = {
  __typename?: 'NewBankDetails';
  count: Scalars['Int']['output'];
  cursor: Scalars['Int']['output'];
  nodes: Array<NewBankDetail>;
};

export type NumberRange = {
  __typename?: 'NumberRange';
  item: CommonDictItem;
};

export type NumberRangeInput = {
  code: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type OAuth2Input = {
  clientId: Scalars['String']['input'];
  loginHint?: InputMaybe<Scalars['String']['input']>;
  redirectUri: Scalars['String']['input'];
  responseType: ResponseType;
  scope: Scalars['String']['input'];
  service: Scalars['String']['input'];
  state?: InputMaybe<Scalars['String']['input']>;
};

export type OAuth2TokenInput = {
  clientId: Scalars['String']['input'];
  clientSecret: Scalars['String']['input'];
  code: Scalars['String']['input'];
  redirectUri: Scalars['String']['input'];
  service: Scalars['String']['input'];
};

export type OpenCjVirtualIbanInput = {
  clientId: Scalars['String']['input'];
  providerTag: ClearJunctionWalletEnum;
};

/** enum that stores options for the status of the operation */
export enum OperationIdStatus {
  Pending = 'PENDING',
  Verified = 'VERIFIED'
}

export type Operations = {
  __typename?: 'Operations';
  count: Scalars['Int']['output'];
  cursor: Scalars['Int']['output'];
  nodes: Array<TariffOperation>;
};

export type OrderAssetInfo = {
  __typename?: 'OrderAssetInfo';
  asset: Scalars['String']['output'];
  precision: Scalars['Int']['output'];
};

export enum OrderFilterType {
  Global = 'GLOBAL',
  Pair = 'PAIR'
}

export type OrderFiltersForPair = {
  __typename?: 'OrderFiltersForPair';
  filters: Array<Maybe<BaseOrderFilter>>;
  pair?: Maybe<OrderPair>;
};

export type OrderPair = {
  __typename?: 'OrderPair';
  baseAsset: OrderAssetInfo;
  isTrading: Scalars['Boolean']['output'];
  owner: ExchangeService;
  quoteAsset: OrderAssetInfo;
  symbol: Scalars['String']['output'];
};

export type PaginationInput = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};

export type PartyAmount = {
  __typename?: 'PartyAmount';
  amount: Scalars['BigNumber']['output'];
  currency: Currency;
};

export type PartyAmountInput = {
  amount: Scalars['BigNumber']['input'];
  currencyId: Scalars['ID']['input'];
};

export type PartyFee = {
  __typename?: 'PartyFee';
  bank: Scalars['BigNumber']['output'];
  currency: Currency;
  provider: Scalars['BigNumber']['output'];
  total: Scalars['BigNumber']['output'];
};

export type PartyFeeInput = {
  bank: Scalars['BigNumber']['input'];
  currencyId: Scalars['ID']['input'];
  provider: Scalars['BigNumber']['input'];
};

/** Input data of password recovery */
export type PasswordRecoveryInput = {
  hCaptchaToken?: InputMaybe<Scalars['String']['input']>;
  /** New password */
  newPassword?: InputMaybe<Scalars['String']['input']>;
  /** SRP-6 data */
  srp?: InputMaybe<SrpInfo>;
};

export type Payment = {
  __typename?: 'Payment';
  amount: Scalars['BigNumber']['output'];
  amountV2: PaymentsAmount;
  attachment?: Maybe<File>;
  category: PaymentCategory;
  common: CommonItemInfo;
  createdAt: Scalars['DateTime']['output'];
  credit: PaymentAccount;
  creditType: CreditType;
  creditorBalance?: Maybe<Scalars['BigNumber']['output']>;
  creditorUserId?: Maybe<Scalars['ID']['output']>;
  currency?: Maybe<Currency>;
  debit: PaymentAccount;
  debitorBalance?: Maybe<Scalars['BigNumber']['output']>;
  debitorUserId?: Maybe<Scalars['ID']['output']>;
  declineReason?: Maybe<Scalars['String']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  direction?: Maybe<PaymentDirection>;
  documentNo?: Maybe<Scalars['String']['output']>;
  documentNoOrDate?: Maybe<Scalars['String']['output']>;
  fee: Scalars['BigNumber']['output'];
  feeRatio: Scalars['BigNumber']['output'];
  feeV2: PaymentsFee;
  id: Scalars['ID']['output'];
  invoicePrintedOn?: Maybe<Scalars['DateTime']['output']>;
  isRouted: Scalars['Boolean']['output'];
  isSystem?: Maybe<Scalars['Boolean']['output']>;
  metadata: Scalars['JSON']['output'];
  nostroAccount?: Maybe<Scalars['String']['output']>;
  nostroCurrency?: Maybe<Scalars['String']['output']>;
  nostroCustomerIban?: Maybe<Scalars['String']['output']>;
  nostroId?: Maybe<Scalars['String']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  operationId: Scalars['ID']['output'];
  paymentOrderNo?: Maybe<Scalars['String']['output']>;
  processedAt?: Maybe<Scalars['DateTime']['output']>;
  providerFee: Scalars['BigNumber']['output'];
  providerStatus?: Maybe<PaymentsProviderStatusEnum>;
  reason?: Maybe<PaymentReason>;
  receipt?: Maybe<File>;
  schema?: Maybe<PaymentSchema>;
  service?: Maybe<Scalars['String']['output']>;
  settled?: Maybe<Scalars['DateTime']['output']>;
  state: PaymentState;
  systemDescription?: Maybe<Scalars['String']['output']>;
  tezroFee: Scalars['BigNumber']['output'];
  totalAmount: Scalars['BigNumber']['output'];
  totalAmountV2: PaymentsTotalAmount;
  trackerId?: Maybe<Scalars['ID']['output']>;
  type: PaymentType;
  updatedAt: Scalars['DateTime']['output'];
  vat?: Maybe<Scalars['BigNumber']['output']>;
};

export type PaymentAccount = {
  __typename?: 'PaymentAccount';
  account?: Maybe<Account>;
  accountNumber?: Maybe<Scalars['String']['output']>;
  address?: Maybe<Scalars['String']['output']>;
  bank?: Maybe<Bank>;
  bankAddress?: Maybe<Scalars['String']['output']>;
  bankBic?: Maybe<Scalars['String']['output']>;
  bankCityId?: Maybe<Scalars['ID']['output']>;
  bankName?: Maybe<Scalars['String']['output']>;
  bankSortCode?: Maybe<Scalars['String']['output']>;
  cardId?: Maybe<Scalars['String']['output']>;
  cardNumber?: Maybe<Scalars['CardNumber']['output']>;
  company?: Maybe<Company>;
  /** @deprecated The property will be removed */
  contact?: Maybe<PaymentContact>;
  country?: Maybe<Country>;
  firstName?: Maybe<Scalars['String']['output']>;
  fullName?: Maybe<Scalars['String']['output']>;
  iban?: Maybe<Scalars['IBAN']['output']>;
  id: Scalars['ID']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  nameOrCompany?: Maybe<NameOrCompany>;
  phoneNumber?: Maybe<Scalars['PhoneNumber']['output']>;
  swift?: Maybe<Scalars['SWIFT']['output']>;
};

export type PaymentAccountInput = {
  accountId?: InputMaybe<Scalars['ID']['input']>;
  accountNumber?: InputMaybe<Scalars['String']['input']>;
  bankBic?: InputMaybe<Scalars['String']['input']>;
  bankId?: InputMaybe<Scalars['ID']['input']>;
  bankInfo?: InputMaybe<BankInfoInput>;
  bankSortCode?: InputMaybe<Scalars['String']['input']>;
  cardId?: InputMaybe<Scalars['ID']['input']>;
  cardNumber?: InputMaybe<Scalars['CardNumber']['input']>;
  countryId?: InputMaybe<Scalars['ID']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  iban?: InputMaybe<Scalars['IBAN']['input']>;
  nameOrContact?: InputMaybe<NameOrContactInput>;
  phoneNumber?: InputMaybe<Scalars['PhoneNumber']['input']>;
  swift?: InputMaybe<Scalars['SWIFT']['input']>;
  /** Universal parameter. Identify user by its phone, email, or wallet id */
  userIdentifier?: InputMaybe<Scalars['String']['input']>;
};

export enum PaymentCategory {
  Deposit = 'DEPOSIT',
  Exchange = 'EXCHANGE',
  FundRaising = 'FUND_RAISING',
  Reccurent = 'RECCURENT',
  Remittance = 'REMITTANCE',
  Scheduled = 'SCHEDULED',
  Transfer = 'TRANSFER'
}

export type PaymentContact = {
  __typename?: 'PaymentContact';
  id: Scalars['ID']['output'];
};

export enum PaymentDirection {
  Incoming = 'INCOMING',
  Outgoing = 'OUTGOING'
}

export type PaymentFlowByCountryInput = {
  businessActivityId?: InputMaybe<Scalars['String']['input']>;
  countryId: Scalars['String']['input'];
  percentage: Scalars['Float']['input'];
};

export type PaymentFlowByCountryType = {
  __typename?: 'PaymentFlowByCountryType';
  businessActivity?: Maybe<BusinessActivity>;
  country: Country;
  percentage: Scalars['Float']['output'];
};

export type PaymentFlowByCurrencyInput = {
  businessActivityId?: InputMaybe<Scalars['String']['input']>;
  currencyId: Scalars['String']['input'];
  percentage: Scalars['Float']['input'];
};

export type PaymentFlowByCurrencyType = {
  __typename?: 'PaymentFlowByCurrencyType';
  businessActivity?: Maybe<BusinessActivity>;
  currency: Currency;
  percentage: Scalars['Float']['output'];
};

export enum PaymentProviderType {
  BankOfChina = 'BANK_OF_CHINA',
  Cj = 'CJ',
  Satchel = 'SATCHEL'
}

export enum PaymentReason {
  FamilyTransfer = 'FAMILY_TRANSFER',
  LoanAgreement = 'LOAN_AGREEMENT',
  OtherReasons = 'OTHER_REASONS',
  OwnFundsTransfer = 'OWN_FUNDS_TRANSFER',
  PaymentForServicesUnderAgreement = 'PAYMENT_FOR_SERVICES_UNDER_AGREEMENT',
  PaymentForServicesUnderContract = 'PAYMENT_FOR_SERVICES_UNDER_CONTRACT',
  PaymentForServicesUnderInvoice = 'PAYMENT_FOR_SERVICES_UNDER_INVOICE',
  PrivateTransfer = 'PRIVATE_TRANSFER',
  PurchaseOfGoodsUnderAgreement = 'PURCHASE_OF_GOODS_UNDER_AGREEMENT',
  PurchaseOfGoodsUnderContract = 'PURCHASE_OF_GOODS_UNDER_CONTRACT',
  PurchaseOfGoodsUnderInvoice = 'PURCHASE_OF_GOODS_UNDER_INVOICE',
  ReimbursementOfExpenses = 'REIMBURSEMENT_OF_EXPENSES',
  RentalPaymentUnderAgreement = 'RENTAL_PAYMENT_UNDER_AGREEMENT',
  RentalPaymentUnderContract = 'RENTAL_PAYMENT_UNDER_CONTRACT',
  RentalPaymentUnderInvoice = 'RENTAL_PAYMENT_UNDER_INVOICE',
  ReturnFundsUnderLoanAgreement = 'RETURN_FUNDS_UNDER_LOAN_AGREEMENT',
  TaxPayment = 'TAX_PAYMENT',
  TopUpCardAccount = 'TOP_UP_CARD_ACCOUNT'
}

export enum PaymentSchema {
  AccountToCard = 'ACCOUNT_TO_CARD',
  CardDeposit = 'CARD_DEPOSIT',
  CardToAccount = 'CARD_TO_ACCOUNT',
  CardToCard = 'CARD_TO_CARD',
  CardWithdrawal = 'CARD_WITHDRAWAL',
  Chaps = 'CHAPS',
  FasterPayments = 'FASTER_PAYMENTS',
  Internal = 'INTERNAL',
  Sepa = 'SEPA',
  Swift = 'SWIFT'
}

export enum PaymentState {
  AwaitingLiquidity = 'AWAITING_LIQUIDITY',
  Declined = 'DECLINED',
  Draft = 'DRAFT',
  Initiated = 'INITIATED',
  Pending = 'PENDING',
  Settled = 'SETTLED'
}

export type PaymentTemplate = {
  __typename?: 'PaymentTemplate';
  amount: Scalars['BigNumber']['output'];
  approverId?: Maybe<Scalars['String']['output']>;
  attachmentId?: Maybe<Scalars['String']['output']>;
  category?: Maybe<PaymentCategory>;
  creatorId?: Maybe<Scalars['String']['output']>;
  creditor: PaymentTemplateParty;
  creditorUserId?: Maybe<Scalars['String']['output']>;
  currencyId: Scalars['String']['output'];
  currencyTicker: Scalars['String']['output'];
  debtor: PaymentTemplateParty;
  debtorUserId?: Maybe<Scalars['String']['output']>;
  documentNo?: Maybe<Scalars['String']['output']>;
  documentNoOrDate?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  isChosen: Scalars['Boolean']['output'];
  note?: Maybe<Scalars['String']['output']>;
  reason?: Maybe<PaymentReason>;
  receipt?: Maybe<Scalars['String']['output']>;
  schedule?: Maybe<Scalars['DateTime']['output']>;
  type?: Maybe<PaymentType>;
  vat?: Maybe<Scalars['BigNumber']['output']>;
};

export type PaymentTemplateParty = {
  __typename?: 'PaymentTemplateParty';
  absAccountId?: Maybe<Scalars['String']['output']>;
  accountId?: Maybe<Scalars['String']['output']>;
  accountNumber?: Maybe<Scalars['String']['output']>;
  address?: Maybe<Scalars['String']['output']>;
  bankAddress?: Maybe<Scalars['String']['output']>;
  bankBic?: Maybe<Scalars['String']['output']>;
  bankCityId?: Maybe<Scalars['String']['output']>;
  bankId?: Maybe<Scalars['String']['output']>;
  bankName?: Maybe<Scalars['String']['output']>;
  bankSortCode?: Maybe<Scalars['String']['output']>;
  cardId?: Maybe<Scalars['String']['output']>;
  cardNumber?: Maybe<Scalars['String']['output']>;
  contactCompanyName?: Maybe<Scalars['String']['output']>;
  contactFirstName?: Maybe<Scalars['String']['output']>;
  contactId?: Maybe<Scalars['String']['output']>;
  contactLastName?: Maybe<Scalars['String']['output']>;
  countryId?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  fullName?: Maybe<Scalars['String']['output']>;
  iban?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  swift?: Maybe<Scalars['String']['output']>;
  userIdentifier?: Maybe<Scalars['String']['output']>;
};

export type PaymentTemplatePartyInput = {
  accountId?: InputMaybe<Scalars['String']['input']>;
  accountNumber?: InputMaybe<Scalars['String']['input']>;
  address?: InputMaybe<Scalars['String']['input']>;
  bankAddress?: InputMaybe<Scalars['String']['input']>;
  bankBic?: InputMaybe<Scalars['String']['input']>;
  bankCityId?: InputMaybe<Scalars['String']['input']>;
  bankId?: InputMaybe<Scalars['String']['input']>;
  bankName?: InputMaybe<Scalars['String']['input']>;
  bankSortCode?: InputMaybe<Scalars['String']['input']>;
  cardId?: InputMaybe<Scalars['String']['input']>;
  cardNumber?: InputMaybe<Scalars['String']['input']>;
  contactCompanyName?: InputMaybe<Scalars['String']['input']>;
  contactFirstName?: InputMaybe<Scalars['String']['input']>;
  contactId?: InputMaybe<Scalars['String']['input']>;
  contactLastName?: InputMaybe<Scalars['String']['input']>;
  countryId?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  fullName?: InputMaybe<Scalars['String']['input']>;
  iban?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  swift?: InputMaybe<Scalars['String']['input']>;
  userIdentifier?: InputMaybe<Scalars['String']['input']>;
};

export type PaymentTemplates = {
  __typename?: 'PaymentTemplates';
  count: Scalars['Int']['output'];
  nodes: Array<PaymentTemplate>;
};

export enum PaymentType {
  AccountToCard = 'ACCOUNT_TO_CARD',
  CardDeposit = 'CARD_DEPOSIT',
  CardToAccount = 'CARD_TO_ACCOUNT',
  CardToCard = 'CARD_TO_CARD',
  CardWithdrawal = 'CARD_WITHDRAWAL',
  Domestic = 'DOMESTIC',
  Inner = 'INNER',
  Swift = 'SWIFT'
}

export type Payments = {
  __typename?: 'Payments';
  count: Scalars['Int']['output'];
  cursor: Scalars['Int']['output'];
  nodes: Array<Payment>;
};

export type PaymentsAmount = {
  __typename?: 'PaymentsAmount';
  exchangeRate: Scalars['BigNumber']['output'];
  source: PartyAmount;
  target: PartyAmount;
};

export type PaymentsAmountInput = {
  exchangeRate: Scalars['BigNumber']['input'];
  source: PartyAmountInput;
  target?: InputMaybe<PartyAmountInput>;
};

export type PaymentsBankAccount = {
  __typename?: 'PaymentsBankAccount';
  bank?: Maybe<PaymentsBankInfo>;
  client: PaymentsBankClient;
};

export type PaymentsBankAccountInput = {
  accountId: Scalars['ID']['input'];
};

export type PaymentsBankClient = {
  __typename?: 'PaymentsBankClient';
  iban: Scalars['String']['output'];
  vIban?: Maybe<Scalars['String']['output']>;
};

export type PaymentsBankInfo = {
  __typename?: 'PaymentsBankInfo';
  address: PaymentsBankInfoAddress;
  code?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type PaymentsBankInfoAddress = {
  __typename?: 'PaymentsBankInfoAddress';
  countryAlpha2?: Maybe<Scalars['String']['output']>;
  countryAlpha3?: Maybe<Scalars['String']['output']>;
};

export type PaymentsFee = {
  __typename?: 'PaymentsFee';
  exchangeRate: Scalars['BigNumber']['output'];
  source: PartyFee;
  target: PartyFee;
};

export type PaymentsFeeInput = {
  exchangeRate: Scalars['BigNumber']['input'];
  source: PartyFeeInput;
  target?: InputMaybe<PartyFeeInput>;
};

export type PaymentsPaypalWithdrawal = {
  __typename?: 'PaymentsPaypalWithdrawal';
  absFeeReference?: Maybe<Scalars['ID']['output']>;
  absFeeStatus?: Maybe<AbsPaymentStatus>;
  absOutgoingReference?: Maybe<Scalars['ID']['output']>;
  absOutgoingStatus?: Maybe<AbsPaymentStatus>;
  /** Transaction amount (excluding fees) */
  amount: Scalars['BigNumber']['output'];
  /** Total transaction amount (including fees) */
  amountTotal: Scalars['BigNumber']['output'];
  createdAt: Scalars['DateTime']['output'];
  /** PayPal recipient account identifier */
  creditorPaypalAccount: Scalars['String']['output'];
  /** Recipient's PayPal account identifier type */
  creditorPaypalAccountType: PaypalRecipientType;
  currencyTicker: Scalars['String']['output'];
  debitorAccountId: Scalars['ID']['output'];
  debitorClientId: Scalars['ID']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  feePaypal: Scalars['BigNumber']['output'];
  feeTezro: Scalars['BigNumber']['output'];
  feeTotal: Scalars['BigNumber']['output'];
  id: Scalars['ID']['output'];
  paypalBatchId?: Maybe<Scalars['ID']['output']>;
  paypalItemId?: Maybe<Scalars['ID']['output']>;
  paypalItemStatus?: Maybe<PaypalTransactionStatus>;
  statusCurrent: PaymentsPaypalWithdrawalStatus;
  statusPrevious?: Maybe<PaymentsPaypalWithdrawalStatus>;
  updatedAt: Scalars['DateTime']['output'];
};

export type PaymentsPaypalWithdrawalCreateInput = {
  absFeeReference?: InputMaybe<Scalars['ID']['input']>;
  absFeeStatus?: InputMaybe<AbsPaymentStatus>;
  absOutgoingReference?: InputMaybe<Scalars['ID']['input']>;
  absOutgoingStatus?: InputMaybe<AbsPaymentStatus>;
  amount: Scalars['BigNumber']['input'];
  creditorPaypalAccount: Scalars['String']['input'];
  creditorPaypalAccountType: PaypalRecipientType;
  currencyTicker: Scalars['String']['input'];
  debitorAccountId: Scalars['ID']['input'];
  debitorClientId: Scalars['ID']['input'];
  feePaypal: Scalars['BigNumber']['input'];
  feeTezro: Scalars['BigNumber']['input'];
  paypalBatchId?: InputMaybe<Scalars['ID']['input']>;
  paypalItemId?: InputMaybe<Scalars['ID']['input']>;
  paypalItemStatus?: InputMaybe<PaypalTransactionStatus>;
  status: PaymentsPaypalWithdrawalStatus;
};

export type PaymentsPaypalWithdrawalFindManyInput = {
  absFeeReference?: InputMaybe<Scalars['ID']['input']>;
  absFeeStatus?: InputMaybe<AbsPaymentStatus>;
  absOutgoingReference?: InputMaybe<Scalars['ID']['input']>;
  absOutgoingStatus?: InputMaybe<AbsPaymentStatus>;
  creditorPaypalAccount?: InputMaybe<Scalars['String']['input']>;
  creditorPaypalAccountType?: InputMaybe<PaypalRecipientType>;
  currencyTicker?: InputMaybe<Scalars['String']['input']>;
  debitorAccountId?: InputMaybe<Scalars['ID']['input']>;
  debitorClientId?: InputMaybe<Scalars['ID']['input']>;
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  pagination?: InputMaybe<PaginationInput>;
  paypalBatchId?: InputMaybe<Scalars['ID']['input']>;
  paypalItemId?: InputMaybe<Scalars['ID']['input']>;
  paypalItemStatus?: InputMaybe<PaypalTransactionStatus>;
  status?: InputMaybe<PaymentsPaypalWithdrawalStatus>;
  withDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PaymentsPaypalWithdrawalFindOneInput = {
  absFeeReference?: InputMaybe<Scalars['ID']['input']>;
  absFeeStatus?: InputMaybe<AbsPaymentStatus>;
  absOutgoingReference?: InputMaybe<Scalars['ID']['input']>;
  absOutgoingStatus?: InputMaybe<AbsPaymentStatus>;
  creditorPaypalAccount?: InputMaybe<Scalars['String']['input']>;
  creditorPaypalAccountType?: InputMaybe<PaypalRecipientType>;
  currencyTicker?: InputMaybe<Scalars['String']['input']>;
  debitorAccountId?: InputMaybe<Scalars['ID']['input']>;
  debitorClientId?: InputMaybe<Scalars['ID']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  paypalBatchId?: InputMaybe<Scalars['ID']['input']>;
  paypalItemId?: InputMaybe<Scalars['ID']['input']>;
  paypalItemStatus?: InputMaybe<PaypalTransactionStatus>;
  status?: InputMaybe<PaymentsPaypalWithdrawalStatus>;
  withDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PaymentsPaypalWithdrawalInitializeInput = {
  amount: Scalars['BigNumber']['input'];
  creditorPaypalAccount: Scalars['String']['input'];
  creditorPaypalAccountType: PaypalRecipientType;
  debitorAccountId: Scalars['ID']['input'];
};

export type PaymentsPaypalWithdrawalReprocessItemStatusUpdateInput = {
  dto: Scalars['JSON']['input'];
};

export type PaymentsPaypalWithdrawalReprocessUpdateInput = {
  dto: Scalars['JSON']['input'];
};

export enum PaymentsPaypalWithdrawalStatus {
  /** Withdrawal awaiting deposit to corporate account */
  AwaitingLiquidity = 'AWAITING_LIQUIDITY',
  /** Withdrawal completed */
  Completed = 'COMPLETED',
  /** PayPal was unable to complete the withdrawal */
  PaypalFailed = 'PAYPAL_FAILED',
  /** PayPal executes the withdrawal */
  PaypalProcessing = 'PAYPAL_PROCESSING',
  /** Withdrawal created, awaiting processing */
  Pending = 'PENDING',
  /** AML officer makes a decision */
  ReviewIn = 'REVIEW_IN',
  /** AML officer canceled the withdrawal */
  ReviewRejected = 'REVIEW_REJECTED',
  /** AML officer approved the withdrawal */
  ReviewSuccessful = 'REVIEW_SUCCESSFUL'
}

export type PaymentsPaypalWithdrawalUpdateInput = {
  absFeeReference?: InputMaybe<Scalars['ID']['input']>;
  absFeeStatus?: InputMaybe<AbsPaymentStatus>;
  absOutgoingReference?: InputMaybe<Scalars['ID']['input']>;
  absOutgoingStatus?: InputMaybe<AbsPaymentStatus>;
  amount?: InputMaybe<Scalars['BigNumber']['input']>;
  creditorPaypalAccount?: InputMaybe<Scalars['String']['input']>;
  creditorPaypalAccountType?: InputMaybe<PaypalRecipientType>;
  currencyTicker?: InputMaybe<Scalars['String']['input']>;
  debitorAccountId?: InputMaybe<Scalars['ID']['input']>;
  debitorClientId?: InputMaybe<Scalars['ID']['input']>;
  feePaypal?: InputMaybe<Scalars['BigNumber']['input']>;
  feeTezro?: InputMaybe<Scalars['BigNumber']['input']>;
  id: Scalars['ID']['input'];
  paypalBatchId?: InputMaybe<Scalars['ID']['input']>;
  paypalItemId?: InputMaybe<Scalars['ID']['input']>;
  paypalItemStatus?: InputMaybe<PaypalTransactionStatus>;
  status?: InputMaybe<PaymentsPaypalWithdrawalStatus>;
};

export type PaymentsPaypalWithdrawals = {
  __typename?: 'PaymentsPaypalWithdrawals';
  count: Scalars['Int']['output'];
  cursor: Scalars['Int']['output'];
  nodes: Array<PaymentsPaypalWithdrawal>;
};

export enum PaymentsProviderStatusEnum {
  Declined = 'DECLINED',
  InsufficientBalance = 'INSUFFICIENT_BALANCE',
  Pending = 'PENDING',
  Processing = 'PROCESSING',
  Refunded = 'REFUNDED',
  Successful = 'SUCCESSFUL'
}

export type PaymentsTotalAmount = {
  __typename?: 'PaymentsTotalAmount';
  amount: Scalars['BigNumber']['output'];
  currency: Currency;
};

export enum PaypalRecipientType {
  Email = 'EMAIL',
  PaypalId = 'PAYPAL_ID',
  Phone = 'PHONE'
}

export enum PaypalTransactionStatus {
  /** Payout request has been blocked */
  Blocked = 'BLOCKED',
  /** Payout request has failed, so funds were not deducted from the sender’s account */
  Failed = 'FAILED',
  /** Payout request is being reviewed and is on hold */
  Onhold = 'ONHOLD',
  /** Payout request has been submitted and is being processed. Recipient will get the funds once the request is processed successfully, else the funds will be returned to you */
  Pending = 'PENDING',
  /** Payout request was refunded */
  Refunded = 'REFUNDED',
  /** The recipient has not claimed this payout, so the funds have been returned to your account */
  Returned = 'RETURNED',
  /** Payout request was reversed */
  Reversed = 'REVERSED',
  /** Funds have been credited to the recipient’s account */
  Success = 'SUCCESS',
  /** The recipient for this payout does not have a PayPal account. A link to sign up for a PayPal account was sent to the recipient. However, if the recipient does not claim this payout within 30 days, the funds are returned to your account */
  Unclaimed = 'UNCLAIMED'
}

export type PersonalInput = {
  birthDate?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  expectedAnnualTurnover?: InputMaybe<MoneyInput>;
  gender?: InputMaybe<Gender>;
  name?: InputMaybe<FullNameInput>;
  nationalityCountryId?: InputMaybe<Scalars['ID']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  placeOfBirthCountryId?: InputMaybe<Scalars['ID']['input']>;
  plannedAccountUse?: InputMaybe<Array<PlannedAccountUse>>;
  plannedAccountUseOther?: InputMaybe<Scalars['String']['input']>;
  residenceCountryId?: InputMaybe<Scalars['ID']['input']>;
  scoring?: InputMaybe<Scalars['Int']['input']>;
  scoringProfile?: InputMaybe<ScoringProfileInput>;
  scoringRiskLevel?: InputMaybe<ScoringRiskLevelEnum>;
  tin?: InputMaybe<Scalars['String']['input']>;
};

export type PhoneDeviceInfo = {
  __typename?: 'PhoneDeviceInfo';
  confirm: Scalars['Boolean']['output'];
  deviceId: Scalars['String']['output'];
  identity: Scalars['String']['output'];
  type: Device;
};

export enum PlannedAccountUse {
  BankTransfers = 'BANK_TRANSFERS',
  CardPayments = 'CARD_PAYMENTS',
  CollectionOfFunds = 'COLLECTION_OF_FUNDS',
  Crypto = 'CRYPTO',
  CryptoFiatExchange = 'CRYPTO_FIAT_EXCHANGE',
  InternalPayments = 'INTERNAL_PAYMENTS',
  OnlinePurchases = 'ONLINE_PURCHASES',
  Other = 'OTHER',
  WireTransfer = 'WIRE_TRANSFER'
}

export type Position = {
  __typename?: 'Position';
  id: Scalars['ID']['output'];
  item: CommonDictItem;
};

export type PositionInput = {
  code: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type PotentialRisks = {
  __typename?: 'PotentialRisks';
  matches: Scalars['Int']['output'];
  totalRisks: Scalars['Int']['output'];
};

export type PreparePaymentInput = {
  /** Payment amount. */
  amount: Scalars['BigNumber']['input'];
  attachmentId?: InputMaybe<Scalars['ID']['input']>;
  category: PaymentCategory;
  /** Payment receiver (To). */
  credit: PaymentAccountInput;
  /** Payment currency */
  currencyId: Scalars['ID']['input'];
  /** Payment sender (From). */
  debit: PaymentAccountInput;
  documentNo?: InputMaybe<Scalars['String']['input']>;
  documentNoOrDate?: InputMaybe<Scalars['String']['input']>;
  isDeclined?: InputMaybe<Scalars['Boolean']['input']>;
  isSystem?: InputMaybe<Scalars['Boolean']['input']>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  operationId?: InputMaybe<Scalars['String']['input']>;
  reason?: InputMaybe<PaymentReason>;
  schedule?: InputMaybe<Scalars['DateTime']['input']>;
  service?: InputMaybe<Scalars['String']['input']>;
  trackerId?: InputMaybe<Scalars['ID']['input']>;
  type: PaymentType;
  vat?: InputMaybe<Scalars['BigNumber']['input']>;
};

export type ProcessCheckoutStatementInput = {
  endDate?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['String']['input']>;
};

export type ProcessKybStepInput = {
  answer?: InputMaybe<AdminResponseKybType>;
  answerFromAdmin?: InputMaybe<AdminResponseKybType>;
  companyId: Scalars['String']['input'];
  rejectReason?: InputMaybe<Scalars['String']['input']>;
  rejectionReasonsFromAdmin?: InputMaybe<Scalars['String']['input']>;
  step: KybStepEnum;
};

export type ProcessKycStepInput = {
  answer?: InputMaybe<AdminResponseKybType>;
  answerFromAdmin?: InputMaybe<AdminResponseType>;
  rejectReason?: InputMaybe<Scalars['String']['input']>;
  rejectionReasonsFromAdmin?: InputMaybe<Scalars['String']['input']>;
  step: KycStepEnum;
  userId: Scalars['String']['input'];
};

export enum ProcessStatus {
  Declined = 'DECLINED',
  Settled = 'SETTLED'
}

export type ProcessTransferRequestPayload = {
  amount: Scalars['BigNumber']['input'];
  creditAccountId: Scalars['ID']['input'];
  debitAccountId: Scalars['ID']['input'];
  debitorUserId: Scalars['ID']['input'];
  fee: Scalars['BigNumber']['input'];
};

export type ProcessTransferResponseData = {
  __typename?: 'ProcessTransferResponseData';
  description?: Maybe<Scalars['String']['output']>;
  status: ProcessStatus;
};

export type PublicKeyInfo = {
  __typename?: 'PublicKeyInfo';
  key: Scalars['String']['output'];
  type: KeyEnum;
};

export type PublicKeyInput = {
  format: KeyEnum;
  /** publicKey for auth user */
  publicKey: Scalars['String']['input'];
};

export type Query = {
  __typename?: 'Query';
  /** [Accounts] Get All Accounts, (Admin Only) */
  accounts?: Maybe<Array<Maybe<Account>>>;
  /** [accounts] Retrieve client accounts using the universal 'query' parameter. */
  accountsByUniversalParam: Accounts;
  additionalInfos: AdditionalInfos;
  address?: Maybe<Address>;
  /** [Dictionary] Get address data from given geolocation input */
  addressByGeo: Array<Maybe<AddressData>>;
  addressCategories: AddressCategories;
  addressCategory: AddressCategory;
  addresses: Addresses;
  /** [Identity] Find age range statistic settings */
  ageRangeStatisticSettings: AgeRangeStatisticSettings;
  /** [Auth] Get dynamic authorization data */
  authorizationData: Array<DynamicAuthInstanceData>;
  /** [Identity] Get available scoring risk levels */
  availableScoringRiskLevels: Array<ScoringRiskLevelEnum>;
  balanceSystemAccounts: BalanceSystemAccounts;
  /** [dictionary] Fetch a single bank based on the provided criteria. */
  bank?: Maybe<Bank>;
  /** [Accounts] Get bank details for currency in new format */
  bankDetails: NewBankDetails;
  /** [Payments] Get the fee for outgoing or inner payments */
  bankTransferFee: BankTransferFee;
  /** [dictionary] Fetch multiple banks based on the provided criteria. */
  banks: Banks;
  /** [Dictionary] Getting list of business activities */
  businessActivities?: Maybe<BusinessActivities>;
  /** [Dictionary] Get business activity */
  businessActivity?: Maybe<BusinessActivity>;
  /** [Identity] Calculate scoring risk level by scoring number (requires admin/super/service role) */
  calculateScoringRiskLevel: ScoringRiskLevelEnum;
  /** [Payments] Change amount in mock checkout statement (ROLE = [ADMIN, SUPER]) */
  changeMockCheckoutStatementAmount: Scalars['String']['output'];
  /** Description: [OneTimeCodes] check code */
  checkCode: Scalars['Boolean']['output'];
  /** [Limits] Check limit */
  checkLimit: TariffCheckLimitResult;
  /** [Payments] Check payment data without creating it */
  checkOutgoingPayment: CheckOutgoingPaymentResult;
  /** Description: [OneTimeCodes] generate one-time code */
  checkResendOneTimeCode?: Maybe<CheckResendOneTimeCodeType>;
  checkSrp: SrcCheckResult;
  /** [Referrers] Check the confirmation of the invitation */
  checkUserConfirmedInvite: Scalars['Boolean']['output'];
  /** [Dictionary] Allows getting list of cities */
  cities: Array<Maybe<City>>;
  /** [Dictionary] Allows getting list of cities */
  citiesV2: CitiesV2;
  /** [Dictionary] Get country */
  city?: Maybe<City>;
  /** [Dictionary] Get city data from given input */
  cityByName: Array<Maybe<City>>;
  /** [Companies] Retrieve companies */
  companies: Companies;
  company: Company;
  companyMember?: Maybe<CompanyMember>;
  companyMembers: CompanyMembers;
  /** Get company static data config */
  companyStaticDataConfig: CompanyStaticDataConfig;
  /** [Dictionary] Get company type */
  companyType?: Maybe<CompanyType>;
  /** [Dictionary] Getting list of company types */
  companyTypes?: Maybe<CompanyTypes>;
  /** [Auth] Confirm device */
  confirm: Scalars['Boolean']['output'];
  /** [Auth] Confirm register identity */
  confirmRegisterIdentity: Scalars['Boolean']['output'];
  /** [Dictionary] Allows getting list of */
  continents: Array<Maybe<Continent>>;
  /** [Dictionary] Allows getting list of countries */
  countries: Array<Maybe<Country>>;
  /** [Dictionary] Allows getting list of countries */
  countriesV2: CountriesV2;
  /** [Dictionary] Get country */
  country?: Maybe<Country>;
  createAccessTokenForApplicant: AccessTokenForApplicantType;
  createWebSDKLink: CreateWebSdkLinkType;
  /** [Dictionary] Allows getting list of currencies */
  currencies: Array<Maybe<Currency>>;
  /** @deprecated Do not use. This query is necessary because of the technical specifics of the resolve field implementation */
  deprecatedAccountsUser?: Maybe<User>;
  /** @deprecated Do not use. This query is necessary because of the technical specifics of the resolve field implementation */
  deprecatedTariffsUser?: Maybe<User>;
  /** [Identity] Find document */
  document: Document;
  /** [Identity] Find document config */
  documentConfig: DocumentConfig;
  /** [Identity] Find document configs */
  documentConfigs: DocumentConfigs;
  /** [Identity] Find document field */
  documentField: DocumentField;
  /** [Identity] Find document field config */
  documentFieldConfig: DocumentFieldConfig;
  /** [Identity] Find document field configs */
  documentFieldConfigs: DocumentFieldConfigs;
  /** [Identity] Find document fields */
  documentFields: DocumentFields;
  documentRejectTags: DocumentRejectTags;
  /** [Identity] Find documents */
  documents: Documents;
  /** [Auth] Get a new access token and refresh token after login */
  exchangeAuthCode: Auth;
  /** [Payments] Find cryptocurrency order configurations. */
  exchangeConfigs: ExchangeConfigs;
  /** [Files] check file by id */
  file: File;
  /** [Files] check all or filtered files */
  files: Array<File>;
  /** [Identity] Find a user. */
  findUser: User;
  findUsers: Users;
  /** [Dictionary] Get address data from given address input */
  geoByAddress: Array<Maybe<AddressData>>;
  /** Description: [2FA] SUPER-ADMIN-SERVICE-ONLY Get operation by title */
  get2FAOperation: TfaOperation;
  /** Description: [2FA] Generates 2FA operation id */
  get2FAOperationId: TfaOperationId;
  /** Query for starting user manual KYC procedure */
  getAccessTokenForLivenessLevel: Scalars['String']['output'];
  /** [Accounts] Allow getting the Account */
  getAccount?: Maybe<Account>;
  /** Description: [2FA] SUPER-ADMIN-SERVICE-ONLY Get all operations */
  getAll2FAOperations: Array<TfaOperation>;
  /** [Auth] Get users list with their full infos (Role = ADMIN, SERVICE, SUPER) */
  getAllUsers: UsersFull;
  getApplicant?: Maybe<ApplicantType>;
  getApplicantDocsStatus: Array<ApplicantDocStatusType>;
  getApplicantType: ApplicantTypeEnum;
  /** [Auth] Get the number of milliseconds until the next attempt to send a confirmation code */
  getAttemptAvailabilityTime: Scalars['Int']['output'];
  /** [Auth] Get user info (new query for getUser) only internal request (Role = SERVICE) */
  getAuthUser: AuthorizedUser;
  /** [Accounts] Get available country ids for buy */
  getAvailableCurrencies: Array<Scalars['String']['output']>;
  /**
   * [Accounts] Get bank details for currency
   * @deprecated Old format. Use bankDetails
   */
  getBankDetails: BankDetails;
  /** [Payments] Get card top-up config for checkout payments (ROLE = [ADMIN, SERVICE, SUPER]) */
  getCardTopUpConfig: CardTopUpConfig;
  /** [Payments] Get total checkout fee (ROLE= [USER, ADMIN, SUPER]) */
  getCardTopUpFee: CardTopUpFee;
  /** [Payments] Get card token from Checkout (ROLE = [ADMIN, SUPER]) */
  getCheckoutCardToken: CardData;
  /** [Dictionary] (Operation for inter-service communication) Allows getting city info */
  getCityInfo?: Maybe<City>;
  /** Description: [OneTimeCodes] Get the number of milliseconds after which the code will expire */
  getCodeExpirationTime: Scalars['Float']['output'];
  /** [2FA] Сommon types of user verification and operations */
  getCommon2FA: Array<TfaType>;
  getCompanyApplicant?: Maybe<CompanyApplicant>;
  getCompanyApplicantDocsStatus: Array<CompanyApplicantDocStatusType>;
  /** [Referrers] Get the number of users waiting for the drawing of invitation codes */
  getCountUsersWaitingDraw: Scalars['Float']['output'];
  /** [Dictionary] Get country by alpha3 ISO code */
  getCountryByAlpha3: Country;
  /** [Dictionary] Get country by alpha2 ISO code */
  getCountryByCode: Country;
  /** [Dictionary] (Operation for inter-service communication) Allows getting country info */
  getCountryInfo?: Maybe<Country>;
  /** [Dictionary] (Operation for inter-service communication) Allows getting list of currencies */
  getCurrencies: Array<Maybe<Currency>>;
  /** [Dictionary] (Operation for inter-service communication) Allows getting list of currencies by ids */
  getCurrenciesByIds: Array<Maybe<Currency>>;
  /** [Dictionary] (Operation for inter-service communication) Allows getting list of currencies by their type */
  getCurrenciesByType: Array<Maybe<Currency>>;
  /** [Dictionary] (Operation for inter-service communication) Allows getting currency by ticker */
  getCurrencyByTicker?: Maybe<Currency>;
  /** [Dictionary] (Operation for inter-service communication) Allows getting currency */
  getCurrencyInfo?: Maybe<Currency>;
  /** [Dictionary] Get currency USDT price by ticker */
  getCurrencyUSDTPriceByTicker: CurrencyPrice;
  /** [Payments] Get current user cards */
  getCurrentUserCards: Array<UserCard>;
  /** [Payments] Get current user top-up limits */
  getCurrentUserTopUpLimits: UserTopUpLimits;
  /** Description: [OneTimeCodes] Get the default number of milliseconds of the timeout */
  getDefaultTimeout: Scalars['Float']['output'];
  /** Description: [2FA] Get enabled 2FA */
  getEnabled2FA: Array<TfaType>;
  /** [Files] (Operation for inter-service communication) check file info by its id and user id */
  getFileInfo: File;
  /** [Files] (Operation for inter-service communication) check file info by its id and user id */
  getFileInfos: Array<File>;
  /** [Accounts] Get intermediaries bank details */
  getIntermediaries: Intermediaries;
  /** [Accounts] Get intermediary bank details */
  getIntermediary: Intermediary;
  /** [Referrers] Ger invite code. Used in MLM referral program */
  getInviteCode: Scalars['String']['output'];
  /** [Dictionary] (Operation for inter-service communication) Allows getting language info by code */
  getLanguageByCode?: Maybe<Language>;
  /** [Dictionary] (Operation for inter-service communication) Allows getting language info */
  getLanguageInfo?: Maybe<Language>;
  /** Description: [OneTimeCodes] SERVICE-ONLY. Get the last code sent */
  getLastSendCode: GetLastSendCodeResponse;
  /** [Auth] Returns current user's active sessions */
  getMyActiveSessions: Array<Session>;
  /** [Payments] Gets user's outgoing payment template by id (ROLE = USER). */
  getMyPaymentTemplate: PaymentTemplate;
  /**
   * [Identity] get personal data for current user
   * @deprecated Outdated. Use query myPersonalData
   */
  getMyPersonalData: User;
  /** [Dictionary] Get information about mobile numbers. Requires service/admin/super role */
  getPhoneNumbersInfo: Array<GetPhoneNumberInfoType>;
  /** [Dictionary] (Operation for inter-service communication) Allows getting position info */
  getPositionInfo?: Maybe<Position>;
  /** [Dictionary] Allows getting rate commission in percent */
  getRateCommission: RateCommission;
  /** [Dictionary] (Operation for inter-service communication) Allows getting rate commission in percent */
  getRateCommissionInfo?: Maybe<RateCommission>;
  /**
   * Description: [2FA] Creates recovery code and returns it.
   *             Once recovery code is created, no one can get it again.
   *             To delete/recreate recovery code you need to disableAll2FA
   */
  getRecoveryCode: Scalars['String']['output'];
  /** [Referrers] Get referral userID by invite code */
  getReferralUserIdByInviteCode?: Maybe<Scalars['String']['output']>;
  /** [Referrers] Find a referrer */
  getReferrer: Referrer;
  /** [Auth] Get the remaining attempts to enter the code */
  getRemainingAttemptsEnterCode: Scalars['Int']['output'];
  /** [Identity] Get residence country id for user */
  getResidenceCountryId?: Maybe<Scalars['String']['output']>;
  /** [Identity] Get scoring risk level by id (requires admin/super/service role) */
  getScoringRiskLevel?: Maybe<ScoringRiskLevel>;
  /** [Identity] Get all scorings risk level (requires admin/super/service role) */
  getScoringRiskLevels: ScoringRiskLevels;
  getTimezones: Array<Timezone>;
  /**
   * [Auth] Get user info only internal request (Role = SERVICE)
   * @deprecated Please, use getAuthUser instead.
   */
  getUser: AuthorizedUser;
  /** [Identity] Get user by personal data (requires admin/super/service role) */
  getUserByPersonalData: User;
  /** [Payments] Get user cards (ROLE = [ADMIN, SUPER]) */
  getUserCards: Array<UserCard>;
  /** [Payments] Get user top-up limits (ROLE = [ADMIN, SUPER]) */
  getUserTopUpLimits: UserTopUpLimits;
  /** [Dictionary] (Operation for inter-service communication) Allows getting VAT info */
  getVatInfo?: Maybe<Vat>;
  /** [Auth] Returns the phrase that you want to sign up for further verification */
  getVerificationPhrase: VerificationPhrase;
  /** [identity] Retrieve companies */
  identityCompanies: Companies;
  /** [Identity] Get client's identity documents */
  identityDocuments: Array<UserIdentityDoc>;
  /** Determines whether the client is company or individual */
  identityType?: Maybe<IdentityTypeEnum>;
  /**
   * [Referrers] SUPER-ADMIN-ONLY Drawing codes between users from a whitelist
   * @deprecated This query will be removed in the next version. The drawing will start automatically
   */
  invitesDrawing: Scalars['Boolean']['output'];
  /** [Dictionary] Check if the number exists in the Twilio Lookup database. Requires service/admin/super role */
  isPhoneNumberExist: Scalars['Boolean']['output'];
  /** [Accounts] Check if all accounts have an open external account with the provider. By default, tags: ["DEFAULT_FIAT"] */
  isProviderAccountsReady: Scalars['Boolean']['output'];
  /** [Accounts] Allows getting is transfer allowed */
  isTransferAllowed?: Maybe<IsTransferAllowedResponseData>;
  /** [Dictionary] Check the validity of a country code */
  isValidCountryCode: Scalars['Boolean']['output'];
  kybConfigs: KybConfigs;
  kybConfigsFilterMetadata: KybConfigFilterMetadata;
  /** [Identity] Get KYB country statistics */
  kybCountryStatistics: KybCountryStatistics;
  /** [Identity] Find KYB level statuses (V2 API) */
  kybLevelStatusV2: KybLevelStatusesV2;
  /** @deprecated Outdated. Use kybLevelStatusesV2 method. */
  kybLevelStatuses: KybLevelStatuses;
  kybNextConfigVersion: Scalars['Int']['output'];
  /** [Identity] Get KYB scoring risk level statistics */
  kybScoringRiskLevelStatistics: KybScoringRiskLevelStatistics;
  /** [Identity] Get KYB level status statistics */
  kybStatusStatistics: KybStatusStatistics;
  /** [Identity] Get KYB step status */
  kybStepStatus: KybSteps;
  /** [Identity] Get list of KYB steps */
  kybSteps: Array<KybStepEnum>;
  /** [Identity] Get KYC age and gender statistics */
  kycAgeGenderStatistics: KycAgeGenderStatistics;
  kycConfigs: KycConfigs;
  kycConfigsFilterMetadata: KycConfigFilterMetadata;
  /** [Identity] Get KYC country statistics */
  kycCountryStatistics: KycCountryStatistics;
  /** @deprecated Outdated. Use kycLevelStatusesV2 method. */
  kycLevelStatuses: KycLevelStatuses;
  /** [Identity] Find KYC level statuses (V2 API) */
  kycLevelStatusesV2: KycLevelStatusesV2;
  kycNextConfigVersion: Scalars['Int']['output'];
  /** [Identity] Get KYC scoring risk level statistics */
  kycScoringRiskLevelStatistics: KycScoringRiskLevelStatistics;
  /** [Identity] Get KYC level status statistics */
  kycStatusStatistics: KycStatusStatistics;
  /** [Identity] Get KYC step status */
  kycStepStatus: KycSteps;
  /** [Identity] Get list of KYC steps */
  kycSteps: Array<KycStepEnum>;
  /** [Dictionary] Allows getting list of languages */
  languages: Array<Maybe<Language>>;
  /**
   * [Auth] If you specify refreshToken (with no options), it will be deleted.
   * If you specify fromOther = true, all tokens (except one provided by yours) will be deleted.
   * If you specify fromAll = true, all tokens will be deleted
   */
  logout: Scalars['Boolean']['output'];
  /** [Accounts] Get current user accounts. (User Only) */
  myAccounts?: Maybe<Array<Maybe<Account>>>;
  myAddress: Address;
  myAddresses: Addresses;
  /** [Commission] Get total fee */
  myComissions: MyCommissionOperations;
  /** [Companies] Retrieve my companies */
  myCompanies: Companies;
  /** [Companies] Retrieve my company additional infos */
  myCompanyAdditionalInfos: AdditionalInfos;
  myCompanyMemberAddresses: Addresses;
  myCompanyMembers: CompanyMembers;
  /** [Accounts] Get current user accounts currencies. (User Only) */
  myCurrencies: Array<Currency>;
  /** [Identity] Find documents for current user */
  myDocuments: Documents;
  /** [Payments] Get exchange */
  myExchange: Exchange;
  /** [Payments] Get exchanges */
  myExchanges: Exchanges;
  /** [Auth] Get current user's extra by key */
  myGetExtra: Scalars['JSON']['output'];
  /** [Accounts] Get current user accounts in grouped format. (User Only) */
  myGroupedAccounts: GroupedAccountsType;
  /** [Payments] Get payment history. */
  myPayments: Payments;
  /** [Identity] Get personal data for current user */
  myPersonalData: User;
  /** [Dictionary] Get NACE code */
  naceCode?: Maybe<NaceCode>;
  /** [Dictionary] Getting list of NACE codes */
  naceCodes?: Maybe<NaceCodes>;
  /** [Dictionary] Allows getting list of number ranges */
  numberRanges: Array<Maybe<NumberRange>>;
  /** [Auth] oAuth2 grant permission on openID */
  oauth2: Redirect;
  /** @deprecated This query will be removed in the next version */
  orderFilters: Array<Maybe<CompleteOrderFilter>>;
  orderFiltersForPair: OrderFiltersForPair;
  orderPairs: Array<Maybe<OrderPair>>;
  /** [Payments] Get bank account info */
  paymentsBankAccount: PaymentsBankAccount;
  /** [Payments] Find a PayPal withdrawal */
  paymentsPaypalWithdrawal?: Maybe<PaymentsPaypalWithdrawal>;
  /** [Payments] Find PayPal withdrawals */
  paymentsPaypalWithdrawals: PaymentsPaypalWithdrawals;
  /** [Dictionary] Allows getting list of positions */
  positions: Array<Maybe<Position>>;
  /** [Payments] Start checkout statement processing (ROLE = [ADMIN, SUPER]) */
  processCheckoutStatement: Scalars['String']['output'];
  /** [Dictionary] Allows getting list of regions */
  regions: Array<Maybe<Region>>;
  resendPaymentsToTransactions: Scalars['String']['output'];
  /** [Webhook] Resend webhook to RMQ exchanger */
  resendWebhook: Scalars['Boolean']['output'];
  /** [Accounts] Search for accounts paginated, (Admin Only) */
  searchAccounts: Accounts;
  /** [Dictionary] Searches for cities (paginated version of cities query) */
  searchCities: Cities;
  /** [Dictionary] Searches for countries */
  searchCountries: Countries;
  /** [Payments] Searches user's outgoing payment templates paginated (ROLE = USER). */
  searchMyPaymentTemplates: PaymentTemplates;
  /** [Auth] Send code on device */
  sendCode: Scalars['Boolean']['output'];
  /** [Auth] Send code on device v2 version */
  sendCodeV2: CheckResendOneTimeCodeType;
  /**
   * [Referrers] SUPER-ADMIN-ONLY Send an invitation code to email
   * @deprecated This query will be removed in the next version. There are no plans to send the code to an email outside of the draw
   */
  sendInviteCode: Scalars['Boolean']['output'];
  /** [Auth] Sign in for service users only */
  serviceSignIn: Auth;
  /** [Auth] Checks creditails and enabled TFA */
  signIn: Auth;
  /** [Auth] Checks creditails and enabled TFA */
  signInV2: SignInResult;
  /** Get static data for company sources of wealth and funds */
  staticData: StaticData;
  /** [Tariffs] Get tariff */
  tariff: Tariff;
  /** [Limits] Get available limits */
  tariffAvailableLimits: Array<TariffAvailableLimit>;
  /** [Limits] Get change limit histories */
  tariffChangeLimitHistories: TariffChangeLimitHistories;
  /** [Client] Get tariff client */
  tariffClient: TariffClient;
  /** [Client] Get tariff clients */
  tariffClients: TariffClients;
  /** [Commission] Get tariff commission */
  tariffCommission: TariffCommission;
  /** [CommissionFactor] Get tariff commission factor */
  tariffCommissionFactor: TariffCommissionFactor;
  /** [CommissionFactor] Get tariff commission factors */
  tariffCommissionFactors: TariffCommissionFactors;
  /** [Commission] Get tariff commissions */
  tariffCommissions: TariffCommissions;
  /** [Limits] Get limit */
  tariffLimit: TariffLimit;
  /** [Limits] Get limit restriction */
  tariffLimitRestriction: TariffLimitRestriction;
  /** [Limits] Get limit restrictions */
  tariffLimitRestrictions: TariffLimitRestrictions;
  /** [Limits] Get limits */
  tariffLimits: TariffLimits;
  /** [Operations] Get operation */
  tariffOperation: TariffOperation;
  /** [Tariffs] Find tariff operation chains */
  tariffOperationChains: TariffOperationChains;
  /** [OperationHistory] Get operation histories */
  tariffOperationHistories: TariffOperationHistories;
  /** [OperationHistory] Get operation history */
  tariffOperationHistory: TariffOperationHistory;
  /** [Operations] Get operations */
  tariffOperations: Operations;
  /** [Commission] Get total fee */
  tariffTotalFee: TariffTotalFee;
  /** [Tariffs] Get tariffs */
  tariffs: Tariffs;
  /** [tariffs] Get Stripe factors. Factors are used to calculate commissions */
  tariffsStripeFactors: TariffsStripeFactors;
  /** [Auth] Test query */
  testAuth: Scalars['Boolean']['output'];
  /** [Dictionary] Allows getting list of transfer methods. */
  transferMethods: Array<TransferMethod>;
  /** [Dictionary] Allows getting list of measure units */
  units: Array<Maybe<Unit>>;
  /** [Payments] Get payment history. */
  userPayments: Array<Payment>;
  /** [Identity] Get the user personal data for a payment */
  userPersonalDataForPayment: UserPersonalDataForPayment;
  /** [Identity] Find users */
  users: Users;
  /** [VABS Accounts Plugin] Retrieve bank details */
  vabsAccBankDetails: VabsAccBankDetails;
  /** [VABS Accounts Plugin] Retrieve bank details */
  vabsAccMyBankDetails: VabsAccBankDetails;
  /** [VABS Accounts Plugin] Retrieve virtual accounts */
  vabsAccMyVirtualAccounts: VabsVirtualAccounts;
  /** [VABS Accounts Plugin] Retrieve virtual balances */
  vabsAccMyVirtualBalances: VabsVirtualBalances;
  /** [VABS] Audit balances */
  vabsAuditBalances: VabsAuditBalancesReport;
  /** [VABS] Get authorization data */
  vabsAuthorizationData: Array<VabsAuthorizationInstanceData>;
  /** [VABS] Balances reconciliation */
  vabsBalancesReconciliation: VabsFailedBalanceReconciliations;
  vabsCalculateMyBsbPaymentFee: VabsPaymentCalculateFeeType;
  vabsCalculateMyIfscPaymentFee: VabsPaymentCalculateFeeType;
  vabsCalculateMyInnerPaymentFee: VabsPaymentCalculateFeeType;
  vabsCalculateMySwiftPaymentFee: VabsPaymentCalculateFeeType;
  /** [VABS] Find clients */
  vabsClients: VabsClients;
  /** [VABS] Find currencies */
  vabsCurrencies: VabsCurrencies;
  /** [VABS] Get dynamic enum values */
  vabsDynamicEnumValues: Array<Scalars['String']['output']>;
  /** [VABS] Find history rate settings */
  vabsHistoryRateSettings: VabsHistoryRateSettings;
  /** [VABS] Find history rates */
  vabsHistoryRates: VabsHistoryRates;
  vabsInternalClientsForInternalPayment: Array<VabsInternalClientForPaymentType>;
  vabsMyPaymentMethods: VabsPaymentMethods;
  vabsMyPayments: VabsPayments;
  vabsMyTotalBalance: Scalars['Float']['output'];
  /** [VABS] Find networks */
  vabsNetworks: VabsNetworks;
  /** [VABS] Find operations */
  vabsOperations: VabsOperations;
  vabsPaymentMethod?: Maybe<VabsPaymentMethod>;
  vabsPaymentMethods: VabsPaymentMethods;
  /** [VABS] Get plugins */
  vabsPlugins: Array<VabsPlugin>;
  /** [VABS] Get plugins tracking */
  vabsPluginsTracking: VabsPluginsTracking;
  /** [VABS] Find projects */
  vabsProjects: VabsProjects;
  /** [VABS] Find provider configs */
  vabsProviderConfigs: VabsProviderConfigs;
  /** [VABS] Find providers */
  vabsProviders: VabsProviders;
  /** [VABS] Find providers currencies mapping */
  vabsProvidersCurrenciesMapping: VabsProvidersCurrenciesMapping;
  /** [VABS] Find real accounts */
  vabsRealAccounts: VabsRealAccounts;
  /** [VABS] Find real balances */
  vabsRealBalances: VabsRealBalances;
  /** [VABS] Find real balances histories */
  vabsRealBalancesHistories: VabsRealBalancesHistories;
  /** [VABS] Find realTransactionAccounts */
  vabsRealTransactionAccounts: VabsRealTransactionAccounts;
  /** [VABS] Real transaction balances reconciliation */
  vabsRealTransactionBalanceReconciliations: VabsFailedTransactionBalanceReconciliations;
  /** [VABS] Real transactions reconciliation */
  vabsRealTransactionReconciliations: VabsFailedTransactionReconciliations;
  /** [VABS] Find real transactions */
  vabsRealTransactions: VabsRealTransactions;
  /** [VABS] Find reports */
  vabsReports: VabsReports;
  /** [VABS] Get statistics by entities */
  vabsStatistics: VabsStatistics;
  /** [VABS] Get matching providers for transaction */
  vabsTransactionMatchingProviders: Array<VabsProvider>;
  /** [VABS] Verify real transactions */
  vabsVerifyRealTransactions: Array<VabsRealTransactionVerifyResult>;
  /** [VABS] Verify virtual transactions */
  vabsVerifyVirtualTransactions: Array<VabsVirtualTransactionVerifyResult>;
  /** [VABS] Find virtual accounts */
  vabsVirtualAccounts: VabsVirtualAccounts;
  /** [VABS] Get first and last balance history in period */
  vabsVirtualBalancePeriodHistory: VabsVirtualBalancesPeriodHistory;
  /** [VABS] Find virtual balances */
  vabsVirtualBalances: VabsVirtualBalances;
  /** [VABS] Find virtual balances histories */
  vabsVirtualBalancesHistories: VabsVirtualBalancesHistories;
  /** [VABS] Virtual transaction balances reconciliation */
  vabsVirtualTransactionBalanceReconciliations: VabsFailedTransactionBalanceReconciliations;
  /** [VABS] Virtual transactions reconciliation */
  vabsVirtualTransactionReconciliations: VabsFailedTransactionReconciliations;
  /** [VABS] Find virtual transactions */
  vabsVirtualTransactions: VabsVirtualTransactions;
  /** [Dictionary] Allows getting list of VATs */
  vats: Array<Maybe<Vat>>;
  /** Description: [2FA] Check the reCAPTCHA v3 or v2 token */
  verifyCaptchaToken: Scalars['Boolean']['output'];
  /** [Auth] Get the data of an authorized user. */
  viewer: AuthorizedUser;
  /** [Accounts] Allow getting the virtual account */
  virtualAccount: VAccount;
  webhook?: Maybe<Webhook>;
};


export type QueryAccountsArgs = {
  input: AccountsInput;
};


export type QueryAccountsByUniversalParamArgs = {
  input: GetAccountByUniversalParamInput;
};


export type QueryAdditionalInfosArgs = {
  input: FindAdditionalInfosInput;
};


export type QueryAddressArgs = {
  input: FindAddressInput;
};


export type QueryAddressByGeoArgs = {
  input: AddressByGeoInput;
};


export type QueryAddressCategoriesArgs = {
  input: AddressCategoriesInput;
};


export type QueryAddressCategoryArgs = {
  input: AddressCategoryInput;
};


export type QueryAddressesArgs = {
  input: FindAddressesInput;
};


export type QueryAgeRangeStatisticSettingsArgs = {
  input: FindAgeRangeStatisticSettingsInput;
};


export type QueryBankArgs = {
  input: BankInput;
};


export type QueryBankDetailsArgs = {
  input: GetBankDetailsInput;
};


export type QueryBankTransferFeeArgs = {
  input: PreparePaymentInput;
};


export type QueryBanksArgs = {
  input: BanksInput;
};


export type QueryBusinessActivitiesArgs = {
  input: GetBusinessActivitiesInput;
};


export type QueryBusinessActivityArgs = {
  input: GetBusinessActivityInput;
};


export type QueryCalculateScoringRiskLevelArgs = {
  scoring: Scalars['Float']['input'];
};


export type QueryChangeMockCheckoutStatementAmountArgs = {
  amount: Scalars['Float']['input'];
};


export type QueryCheckCodeArgs = {
  input: ConfirmOneTimeCodeInput;
};


export type QueryCheckLimitArgs = {
  input: TariffCheckLimitInput;
};


export type QueryCheckOutgoingPaymentArgs = {
  input: CheckOutgoingPaymentInput;
};


export type QueryCheckResendOneTimeCodeArgs = {
  input: CheckResendOneTimeCodeInput;
};


export type QueryCheckSrpArgs = {
  input: CheckSrpInput;
};


export type QueryCheckUserConfirmedInviteArgs = {
  userId: Scalars['String']['input'];
};


export type QueryCitiesArgs = {
  input: DictFilterInput;
};


export type QueryCitiesV2Args = {
  input: DictFilterV2Input;
};


export type QueryCityArgs = {
  input: GetCityInput;
};


export type QueryCityByNameArgs = {
  input: CityByNameInput;
};


export type QueryCompaniesArgs = {
  input: FindCompaniesInput;
};


export type QueryCompanyArgs = {
  input: FindCompanyInput;
};


export type QueryCompanyMemberArgs = {
  input: FindMemberInput;
};


export type QueryCompanyMembersArgs = {
  input: FindMembersInput;
};


export type QueryCompanyStaticDataConfigArgs = {
  service: Scalars['String']['input'];
};


export type QueryCompanyTypeArgs = {
  input: GetCompanyTypeInput;
};


export type QueryCompanyTypesArgs = {
  input: GetCompanyTypesInput;
};


export type QueryConfirmArgs = {
  input: ConfirmInput;
};


export type QueryConfirmRegisterIdentityArgs = {
  input: ConfirmInput;
};


export type QueryContinentsArgs = {
  input: DictFilterInput;
};


export type QueryCountriesArgs = {
  input: DictFilterInput;
};


export type QueryCountriesV2Args = {
  input: DictFilterV2Input;
};


export type QueryCountryArgs = {
  input: GetCountryInput;
};


export type QueryCreateAccessTokenForApplicantArgs = {
  input: CreateAccessTokenForApplicantInput;
};


export type QueryCreateWebSdkLinkArgs = {
  input: CreateWebSdkLinkInput;
};


export type QueryCurrenciesArgs = {
  input: DictFilterInput;
};


export type QueryDocumentArgs = {
  input: FindDocumentInput;
};


export type QueryDocumentConfigArgs = {
  input: FindDocumentConfigInput;
};


export type QueryDocumentConfigsArgs = {
  input: FindDocumentConfigsInput;
};


export type QueryDocumentFieldArgs = {
  input: FindDocumentFieldInput;
};


export type QueryDocumentFieldConfigArgs = {
  input: FindDocumentFieldConfigInput;
};


export type QueryDocumentFieldConfigsArgs = {
  input: FindDocumentFieldConfigsInput;
};


export type QueryDocumentFieldsArgs = {
  input: FindDocumentFieldsInput;
};


export type QueryDocumentRejectTagsArgs = {
  input: FindDocumentRejectTagsInput;
};


export type QueryDocumentsArgs = {
  input: FindDocumentsInput;
};


export type QueryExchangeAuthCodeArgs = {
  input: ExchangeCodeInput;
};


export type QueryExchangeConfigsArgs = {
  input?: InputMaybe<FindExchangeConfigsInput>;
};


export type QueryFileArgs = {
  id: Scalars['String']['input'];
};


export type QueryFilesArgs = {
  filter: FileSearchFilterInput;
};


export type QueryFindUserArgs = {
  input: FindUserInput;
};


export type QueryFindUsersArgs = {
  input: FindUsersInput;
};


export type QueryGeoByAddressArgs = {
  input: GeoByAddressInput;
};


export type QueryGet2FaOperationArgs = {
  input: GetOperationInput;
};


export type QueryGet2FaOperationIdArgs = {
  input: GetOperationIdInput;
};


export type QueryGetAccountArgs = {
  input: GetAccountRequest;
};


export type QueryGetAllUsersArgs = {
  input: GetAllUsersInput;
};


export type QueryGetApplicantArgs = {
  input: GetApplicantInput;
};


export type QueryGetApplicantDocsStatusArgs = {
  externalUserId: Scalars['String']['input'];
};


export type QueryGetApplicantTypeArgs = {
  externalUserId: Scalars['String']['input'];
};


export type QueryGetAttemptAvailabilityTimeArgs = {
  input: UserCodeInfoInput;
};


export type QueryGetAuthUserArgs = {
  input: GetUserInput;
};


export type QueryGetAvailableCurrenciesArgs = {
  input: GetAvailableCurrenciesInput;
};


export type QueryGetBankDetailsArgs = {
  input: GetBankDetailsInput;
};


export type QueryGetCardTopUpFeeArgs = {
  input: GetCardTopUpFeeInput;
};


export type QueryGetCheckoutCardTokenArgs = {
  input: GetCheckoutTokenInput;
};


export type QueryGetCityInfoArgs = {
  input: GetCityRequestPayloadInput;
};


export type QueryGetCodeExpirationTimeArgs = {
  input: UserCodeInfoInput;
};


export type QueryGetCommon2FaArgs = {
  input: Common2FaInput;
};


export type QueryGetCompanyApplicantArgs = {
  input: GetApplicantInput;
};


export type QueryGetCompanyApplicantDocsStatusArgs = {
  externalUserId: Scalars['String']['input'];
};


export type QueryGetCountryByAlpha3Args = {
  alpha3: Scalars['String']['input'];
};


export type QueryGetCountryByCodeArgs = {
  code: Scalars['String']['input'];
};


export type QueryGetCountryInfoArgs = {
  input: GetCountryRequestPayloadInput;
};


export type QueryGetCurrenciesArgs = {
  input: DictFilterInput;
};


export type QueryGetCurrenciesByIdsArgs = {
  ids: Array<Scalars['String']['input']>;
};


export type QueryGetCurrenciesByTypeArgs = {
  input: GetCurrenciesByTypeRequestPayloadInput;
};


export type QueryGetCurrencyByTickerArgs = {
  input: GetCurrencyByTickerRequestPayloadInput;
};


export type QueryGetCurrencyInfoArgs = {
  input: GetCurrencyRequestPayloadInput;
};


export type QueryGetCurrencyUsdtPriceByTickerArgs = {
  input: GetCurrencyUsdtPriceByTickerInput;
};


export type QueryGetFileInfoArgs = {
  input: GetFileInput;
};


export type QueryGetFileInfosArgs = {
  input: GetFilesInput;
};


export type QueryGetIntermediariesArgs = {
  input: GetIntermediariesInput;
};


export type QueryGetIntermediaryArgs = {
  input: GetIntermediaryInput;
};


export type QueryGetLanguageByCodeArgs = {
  input: GetLanguageByCodeRequestPayloadInput;
};


export type QueryGetLanguageInfoArgs = {
  input: GetCommonDictItemRequestPayloadInput;
};


export type QueryGetLastSendCodeArgs = {
  input: GetLastSendCodeInput;
};


export type QueryGetMyPaymentTemplateArgs = {
  input: GetMyPaymentTemplateInput;
};


export type QueryGetPhoneNumbersInfoArgs = {
  input: GetPhoneNumberInfoInput;
};


export type QueryGetPositionInfoArgs = {
  input: GetCommonDictItemRequestPayloadInput;
};


export type QueryGetRateCommissionArgs = {
  input: GetRateCommissionInput;
};


export type QueryGetRateCommissionInfoArgs = {
  input: GetRateCommissionInput;
};


export type QueryGetReferralUserIdByInviteCodeArgs = {
  inviteCode: Scalars['String']['input'];
};


export type QueryGetRemainingAttemptsEnterCodeArgs = {
  input: UserCodeInfoInput;
};


export type QueryGetResidenceCountryIdArgs = {
  userId: Scalars['String']['input'];
};


export type QueryGetScoringRiskLevelArgs = {
  input: GetScoringRiskLevelInput;
};


export type QueryGetScoringRiskLevelsArgs = {
  input: GetScoringRiskLevelsInput;
};


export type QueryGetUserArgs = {
  userId: Scalars['String']['input'];
};


export type QueryGetUserByPersonalDataArgs = {
  input: GetUserByPersonalDataInput;
};


export type QueryGetUserCardsArgs = {
  userId: Scalars['String']['input'];
};


export type QueryGetUserTopUpLimitsArgs = {
  userId: Scalars['String']['input'];
};


export type QueryGetVatInfoArgs = {
  input: GetCommonDictItemRequestPayloadInput;
};


export type QueryGetVerificationPhraseArgs = {
  input: PublicKeyInput;
};


export type QueryIdentityCompaniesArgs = {
  input: IdentityCompaniesInput;
};


export type QueryIdentityDocumentsArgs = {
  input: GetIdentityDocumentsInput;
};


export type QueryIdentityTypeArgs = {
  clientId: Scalars['ID']['input'];
};


export type QueryInvitesDrawingArgs = {
  countWinners: Scalars['Int']['input'];
};


export type QueryIsPhoneNumberExistArgs = {
  input: IsPhoneNumberExistInput;
};


export type QueryIsProviderAccountsReadyArgs = {
  input: IsProviderAccountsReadyInput;
};


export type QueryIsTransferAllowedArgs = {
  input: IsTransferAllowedRequestPayload;
};


export type QueryIsValidCountryCodeArgs = {
  input: IsValidCountryCodeInput;
};


export type QueryKybConfigsArgs = {
  input: FindKybConfigsInput;
};


export type QueryKybCountryStatisticsArgs = {
  input: GetKybCountryStatisticsInput;
};


export type QueryKybLevelStatusV2Args = {
  input: FindKybLevelStatusesInput;
};


export type QueryKybLevelStatusesArgs = {
  input: FindKybLevelStatusesInput;
};


export type QueryKybNextConfigVersionArgs = {
  kybConfigId: Scalars['ID']['input'];
};


export type QueryKybScoringRiskLevelStatisticsArgs = {
  input: GetKybScoringRiskLevelStatisticsInput;
};


export type QueryKybStatusStatisticsArgs = {
  input: GetKybStatusesStatisticsInput;
};


export type QueryKybStepStatusArgs = {
  input: FindKybStepStatusesInput;
};


export type QueryKycAgeGenderStatisticsArgs = {
  input: GetKycAgeGenderStatisticsInput;
};


export type QueryKycConfigsArgs = {
  input: FindKycConfigsInput;
};


export type QueryKycCountryStatisticsArgs = {
  input: GetKycCountryStatisticsInput;
};


export type QueryKycLevelStatusesArgs = {
  input: FindKycLevelStatusesInput;
};


export type QueryKycLevelStatusesV2Args = {
  input: FindKycLevelStatusesInput;
};


export type QueryKycNextConfigVersionArgs = {
  kycConfigId: Scalars['ID']['input'];
};


export type QueryKycScoringRiskLevelStatisticsArgs = {
  input: GetKycScoringRiskLevelStatisticsInput;
};


export type QueryKycStatusStatisticsArgs = {
  input: GetKycStatusesStatisticsInput;
};


export type QueryKycStepStatusArgs = {
  input: FindKycStepStatusesInput;
};


export type QueryLanguagesArgs = {
  input: DictFilterInput;
};


export type QueryLogoutArgs = {
  input: LogoutInput;
};


export type QueryMyAccountsArgs = {
  input: MyAccountsInput;
};


export type QueryMyAddressArgs = {
  input: FindMyAddressInput;
};


export type QueryMyAddressesArgs = {
  input: FindMyAddressesInput;
};


export type QueryMyCompaniesArgs = {
  input: FindCompaniesInput;
};


export type QueryMyCompanyAdditionalInfosArgs = {
  input: FindAdditionalInfosInput;
};


export type QueryMyCompanyMemberAddressesArgs = {
  input: FindMyAddressesInput;
};


export type QueryMyCompanyMembersArgs = {
  input: FindMembersInput;
};


export type QueryMyDocumentsArgs = {
  input: FindMyDocumentsInput;
};


export type QueryMyExchangeArgs = {
  input: FindExchangeInput;
};


export type QueryMyExchangesArgs = {
  input: FindExchangesInput;
};


export type QueryMyGetExtraArgs = {
  key: Scalars['String']['input'];
};


export type QueryMyGroupedAccountsArgs = {
  input: MyGroupedAccountsInput;
};


export type QueryMyPaymentsArgs = {
  input: MyPaymentsInput;
};


export type QueryNaceCodeArgs = {
  input: GetNaceCodeInput;
};


export type QueryNaceCodesArgs = {
  input: GetNaceCodesInput;
};


export type QueryNumberRangesArgs = {
  input: DictFilterInput;
};


export type QueryOauth2Args = {
  input: OAuth2Input;
};


export type QueryOrderFiltersArgs = {
  input: FindOrderFiltersInput;
};


export type QueryOrderFiltersForPairArgs = {
  input: FindOrderFiltersForPairInput;
};


export type QueryOrderPairsArgs = {
  input: FindOrderPairsInput;
};


export type QueryPaymentsBankAccountArgs = {
  input: PaymentsBankAccountInput;
};


export type QueryPaymentsPaypalWithdrawalArgs = {
  input: PaymentsPaypalWithdrawalFindOneInput;
};


export type QueryPaymentsPaypalWithdrawalsArgs = {
  input: PaymentsPaypalWithdrawalFindManyInput;
};


export type QueryPositionsArgs = {
  input: DictFilterInput;
};


export type QueryProcessCheckoutStatementArgs = {
  input: ProcessCheckoutStatementInput;
};


export type QueryRegionsArgs = {
  input: DictFilterInput;
};


export type QueryResendPaymentsToTransactionsArgs = {
  fromDaysAgo: Scalars['Float']['input'];
};


export type QueryResendWebhookArgs = {
  webhookId: Scalars['String']['input'];
};


export type QuerySearchAccountsArgs = {
  input: SearchAccountsInput;
};


export type QuerySearchCitiesArgs = {
  input: DictFilterInput;
};


export type QuerySearchCountriesArgs = {
  input: DictFilterInput;
};


export type QuerySearchMyPaymentTemplatesArgs = {
  input: SearchMyPaymentTemplatesInput;
};


export type QuerySendCodeArgs = {
  input: SendCodeInput;
};


export type QuerySendCodeV2Args = {
  input: SendCodeInput;
};


export type QuerySendInviteCodeArgs = {
  email: Scalars['String']['input'];
};


export type QueryServiceSignInArgs = {
  input: ServiceAuthInput;
};


export type QuerySignInArgs = {
  input: AuthInput;
};


export type QuerySignInV2Args = {
  input: AuthInput;
};


export type QueryTariffArgs = {
  input: FindTariffInput;
};


export type QueryTariffAvailableLimitsArgs = {
  input: TariffAvailableLimitInput;
};


export type QueryTariffChangeLimitHistoriesArgs = {
  input: GetChangeLimitHistoriesInput;
};


export type QueryTariffClientArgs = {
  input: FindTariffClientInput;
};


export type QueryTariffClientsArgs = {
  input: FindTariffClientsInput;
};


export type QueryTariffCommissionArgs = {
  input: FindTariffCommissionInput;
};


export type QueryTariffCommissionFactorArgs = {
  input: FindTariffCommissionFactorInput;
};


export type QueryTariffCommissionFactorsArgs = {
  input: FindTariffCommissionFactorsInput;
};


export type QueryTariffCommissionsArgs = {
  input: FindTariffCommissionsInput;
};


export type QueryTariffLimitArgs = {
  input: FindTariffLimitInput;
};


export type QueryTariffLimitRestrictionArgs = {
  input: FindTariffLimitRestrictionInput;
};


export type QueryTariffLimitRestrictionsArgs = {
  input: FindTariffLimitRestrictionsInput;
};


export type QueryTariffLimitsArgs = {
  input: FindTariffLimitsInput;
};


export type QueryTariffOperationArgs = {
  input: FindTariffOperationInput;
};


export type QueryTariffOperationChainsArgs = {
  input: FindTariffOperationChainsInput;
};


export type QueryTariffOperationHistoriesArgs = {
  input: FindTariffOperationHistoriesInput;
};


export type QueryTariffOperationHistoryArgs = {
  input: FindTariffOperationHistoryInput;
};


export type QueryTariffOperationsArgs = {
  input: FindTariffOperationsInput;
};


export type QueryTariffTotalFeeArgs = {
  input: GetTariffTotalFeeInput;
};


export type QueryTariffsArgs = {
  input: FindTariffsInput;
};


export type QueryTariffsStripeFactorsArgs = {
  countryAlpha2?: InputMaybe<Scalars['String']['input']>;
};


export type QueryTestAuthArgs = {
  userId: Scalars['String']['input'];
};


export type QueryTransferMethodsArgs = {
  input: TransferMethodInput;
};


export type QueryUnitsArgs = {
  input: DictFilterInput;
};


export type QueryUserPaymentsArgs = {
  input: UserPaymentsInput;
};


export type QueryUserPersonalDataForPaymentArgs = {
  userId: Scalars['ID']['input'];
};


export type QueryUsersArgs = {
  input: FindUsersV2Input;
};


export type QueryVabsAccBankDetailsArgs = {
  accBankDetailsInput: VabsAccMyBankDetailsInput;
};


export type QueryVabsAccMyBankDetailsArgs = {
  accMyBankDetailsInput: VabsAccMyBankDetailsInput;
};


export type QueryVabsAccMyVirtualAccountsArgs = {
  accMyVirtualAccountInput: VabsAccFindMyVirtualAccountsInput;
};


export type QueryVabsAccMyVirtualBalancesArgs = {
  accMyVirtualBalancesInput: VabsAccFindMyVirtualBalancesInput;
};


export type QueryVabsAuditBalancesArgs = {
  auditBalancesInput?: InputMaybe<VabsAuditBalances>;
};


export type QueryVabsCalculateMyBsbPaymentFeeArgs = {
  input: VabsCreateBsbPaymentInput;
};


export type QueryVabsCalculateMyIfscPaymentFeeArgs = {
  input: VabsCreateIfscPaymentInput;
};


export type QueryVabsCalculateMyInnerPaymentFeeArgs = {
  input: VabsCreateInnerPaymentInput;
};


export type QueryVabsCalculateMySwiftPaymentFeeArgs = {
  input: VabsCreateSwiftPaymentInput;
};


export type QueryVabsClientsArgs = {
  input: VabsFindClientsInput;
};


export type QueryVabsCurrenciesArgs = {
  input: VabsFindCurrenciesInput;
};


export type QueryVabsDynamicEnumValuesArgs = {
  enumName: VabsDynamicEnums;
};


export type QueryVabsHistoryRateSettingsArgs = {
  input: VabsFindHistoryRateSettingsInput;
};


export type QueryVabsHistoryRatesArgs = {
  input: VabsFindHistoryRatesInput;
};


export type QueryVabsInternalClientsForInternalPaymentArgs = {
  email?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
};


export type QueryVabsMyPaymentMethodsArgs = {
  input: VabsFindPaymentMethodsInput;
};


export type QueryVabsMyPaymentsArgs = {
  input: VabsFindPaymentsInput;
};


export type QueryVabsMyTotalBalanceArgs = {
  currencyId: Scalars['String']['input'];
  virtualAccountId: Scalars['String']['input'];
};


export type QueryVabsNetworksArgs = {
  input: VabsFindNetworksInput;
};


export type QueryVabsOperationsArgs = {
  input: VabsFindOperationsInput;
};


export type QueryVabsPaymentMethodArgs = {
  id: Scalars['ID']['input'];
};


export type QueryVabsPaymentMethodsArgs = {
  input: VabsFindPaymentMethodsInput;
};


export type QueryVabsPluginsArgs = {
  input: VabsFindPluginsInput;
};


export type QueryVabsPluginsTrackingArgs = {
  input: VabsFindPluginsTrackingInput;
};


export type QueryVabsProjectsArgs = {
  input: VabsFindProjectsInput;
};


export type QueryVabsProviderConfigsArgs = {
  input: VabsFindProviderConfigsInput;
};


export type QueryVabsProvidersArgs = {
  input: VabsFindProvidersInput;
};


export type QueryVabsProvidersCurrenciesMappingArgs = {
  input: VabsFindProvidersCurrenciesMappingInput;
};


export type QueryVabsRealAccountsArgs = {
  input: VabsFindRealAccountsInput;
};


export type QueryVabsRealBalancesArgs = {
  input: VabsFindRealBalancesInput;
};


export type QueryVabsRealBalancesHistoriesArgs = {
  input: VabsFindRealBalancesHistoriesInput;
};


export type QueryVabsRealTransactionAccountsArgs = {
  input: VabsFindRealTransactionAccountsInput;
};


export type QueryVabsRealTransactionReconciliationsArgs = {
  dateFrom?: InputMaybe<Scalars['VabsTimestamp']['input']>;
  dateTo?: InputMaybe<Scalars['VabsTimestamp']['input']>;
};


export type QueryVabsRealTransactionsArgs = {
  input: VabsFindRealTransactionsInput;
};


export type QueryVabsReportsArgs = {
  input: VabsFindReportsInput;
};


export type QueryVabsStatisticsArgs = {
  input: VabsGetStatisticsInput;
};


export type QueryVabsTransactionMatchingProvidersArgs = {
  input: VabsVirtualTransactionProviderConditionsInput;
};


export type QueryVabsVerifyRealTransactionsArgs = {
  input: Array<VabsCreateRealTransactionInput>;
};


export type QueryVabsVerifyVirtualTransactionsArgs = {
  input: Array<VabsCreateVirtualTransactionInput>;
};


export type QueryVabsVirtualAccountsArgs = {
  input: VabsFindVirtualAccountsInput;
};


export type QueryVabsVirtualBalancePeriodHistoryArgs = {
  input: VabsFindVirtualBalancesPeriodHistoryInput;
};


export type QueryVabsVirtualBalancesArgs = {
  input: VabsFindVirtualBalancesInput;
};


export type QueryVabsVirtualBalancesHistoriesArgs = {
  input: VabsFindVirtualBalancesHistoriesInput;
};


export type QueryVabsVirtualTransactionReconciliationsArgs = {
  dateFrom?: InputMaybe<Scalars['VabsTimestamp']['input']>;
  dateTo?: InputMaybe<Scalars['VabsTimestamp']['input']>;
};


export type QueryVabsVirtualTransactionsArgs = {
  input: VabsFindVirtualTransactionsInput;
};


export type QueryVatsArgs = {
  input: DictFilterInput;
};


export type QueryVerifyCaptchaTokenArgs = {
  input: ReCaptchaInput;
};


export type QueryVirtualAccountArgs = {
  input: GetVirtualAccountInput;
};


export type QueryWebhookArgs = {
  input: FindWebhookInput;
};

export type RateCommission = {
  __typename?: 'RateCommission';
  baseAssetTicker: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  percent: Scalars['Float']['output'];
  quoteAssetTicker: Scalars['String']['output'];
};

export type ReCaptchaInput = {
  captchaAction?: InputMaybe<Scalars['String']['input']>;
  captchaToken: Scalars['String']['input'];
};

export enum ReasonForAccountOpening {
  BusinessMaintenance = 'BUSINESS_MAINTENANCE',
  DailyExpenses = 'DAILY_EXPENSES',
  FamilySupport = 'FAMILY_SUPPORT',
  Investments = 'INVESTMENTS',
  InvoiceSettlements = 'INVOICE_SETTLEMENTS',
  Other = 'OTHER',
  PaymentsForGoods = 'PAYMENTS_FOR_GOODS',
  PaymentsForServices = 'PAYMENTS_FOR_SERVICES',
  PaymentsForServicesAndGoods = 'PAYMENTS_FOR_SERVICES_AND_GOODS',
  PaymentsToSuppliers = 'PAYMENTS_TO_SUPPLIERS',
  SalaryDeposits = 'SALARY_DEPOSITS',
  SalaryPayments = 'SALARY_PAYMENTS'
}

export type ReasonForAccountOpeningInput = {
  other?: InputMaybe<Scalars['String']['input']>;
  reasons?: InputMaybe<Array<InputReasonForAccountOpening>>;
};

export type ReasonForAccountOpeningType = {
  __typename?: 'ReasonForAccountOpeningType';
  other?: Maybe<Scalars['String']['output']>;
  reasons?: Maybe<Array<ReasonForAccountOpening>>;
};

export type Redirect = {
  __typename?: 'Redirect';
  statusCode: Scalars['Float']['output'];
  url: Scalars['String']['output'];
};

export type Referrer = {
  __typename?: 'Referrer';
  id: Scalars['ID']['output'];
  inviteCode: Scalars['String']['output'];
  referrals: Array<Maybe<Scalars['String']['output']>>;
};

export type ReferrersSendInvitationCreateAccountInput = {
  captcha: CaptchaInput;
  service: Scalars['String']['input'];
  /** Email address or mobile phone number */
  to: Scalars['String']['input'];
};

export type RefundOutgoingPaymentInput = {
  absReference?: InputMaybe<Scalars['ID']['input']>;
  paymentId?: InputMaybe<Scalars['ID']['input']>;
};

export type Region = {
  __typename?: 'Region';
  country?: Maybe<Country>;
  item: CommonDictItem;
};

export type RegionInput = {
  countryId: Scalars['ID']['input'];
  item: CommonDictItemInput;
};

export type RegisterAllocatedCorporateVirtualIbanInput = {
  companyId: Scalars['ID']['input'];
  iban: Scalars['String']['input'];
  providerTag: ClearJunctionWalletEnum;
};

export type RegisterExistingApplicantInput = {
  applicantId: Scalars['ID']['input'];
  newExternalUserId: Scalars['ID']['input'];
};

export type RegisterIdentityInput = {
  captcha: ReCaptchaInput;
  identity: Scalars['String']['input'];
  messengerType?: InputMaybe<MessengerType>;
  type: IdentityType;
};

export type RegisteredUser = {
  __typename?: 'RegisteredUser';
  auth: Auth;
  user: User;
};

export type RemoveDictItemsInput = {
  ids: Array<Scalars['String']['input']>;
};

export type RemoveMyPaymentTemplatesInput = {
  ids: Array<Scalars['String']['input']>;
};

export type RequestToReviewApplicantInput = {
  externalUserId: Scalars['String']['input'];
};

export enum ResponseType {
  Code = 'CODE'
}

export type RestorePasswordInput = {
  code: Scalars['String']['input'];
  device: Device;
  identity: Scalars['String']['input'];
  newPassword?: InputMaybe<Scalars['String']['input']>;
  service: Scalars['String']['input'];
  srp?: InputMaybe<SrpInfo>;
};

export enum ReviewManualPaymentAction {
  Approve = 'APPROVE',
  Decline = 'DECLINE'
}

export type ReviewOutgoingManualPaymentInput = {
  action: ReviewManualPaymentAction;
  paymentId: Scalars['ID']['input'];
  rejectReason?: InputMaybe<Scalars['String']['input']>;
};

export enum RoleEnum {
  Admin = 'ADMIN',
  AmlOfficer = 'AML_OFFICER',
  Moderator = 'MODERATOR',
  Service = 'SERVICE',
  Super = 'SUPER',
  User = 'USER'
}

export type ScoringProfileInput = {
  adverseMedia?: InputMaybe<Scalars['Boolean']['input']>;
  isFamilyMemberPep?: InputMaybe<Scalars['Boolean']['input']>;
  isPep?: InputMaybe<Scalars['Boolean']['input']>;
  isUsa?: InputMaybe<Scalars['Boolean']['input']>;
  sanctionList?: InputMaybe<Scalars['Boolean']['input']>;
  terroristList?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ScoringRiskLevel = {
  __typename?: 'ScoringRiskLevel';
  id: Scalars['String']['output'];
  max: Scalars['Int']['output'];
  min: Scalars['Int']['output'];
  scoringRiskLevel: ScoringRiskLevelEnum;
};

export enum ScoringRiskLevelEnum {
  HighRisk = 'HIGH_RISK',
  LowRisk = 'LOW_RISK',
  MediumRisk = 'MEDIUM_RISK',
  ProhibitedRisk = 'PROHIBITED_RISK',
  VeryHighRisk = 'VERY_HIGH_RISK'
}

export type ScoringRiskLevels = {
  __typename?: 'ScoringRiskLevels';
  count: Scalars['Int']['output'];
  cursor: Scalars['Int']['output'];
  nodes: Array<ScoringRiskLevel>;
};

export type SearchAccountsInput = {
  accountNumbers?: InputMaybe<Array<Scalars['String']['input']>>;
  companyIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  currencyIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  currencyTickers?: InputMaybe<Array<Scalars['String']['input']>>;
  filter?: InputMaybe<Filter>;
  holderType?: InputMaybe<AccountHolderType>;
  likeConditions?: InputMaybe<Array<LikeConditionInput>>;
  states?: InputMaybe<Array<AccountState>>;
  type?: InputMaybe<AccountType>;
  userIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  walletIds?: InputMaybe<Array<Scalars['String']['input']>>;
  withNonZeroBalances?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SearchMyPaymentTemplatesInput = {
  categories?: InputMaybe<Array<PaymentCategory>>;
  creditorIds?: InputMaybe<Array<Scalars['String']['input']>>;
  currencyIds?: InputMaybe<Array<Scalars['String']['input']>>;
  currencyTickers?: InputMaybe<Array<Scalars['String']['input']>>;
  filter?: InputMaybe<Filter>;
  isChosen?: InputMaybe<Scalars['Boolean']['input']>;
  types?: InputMaybe<Array<PaymentType>>;
};

/**
 * Description: input to validate the operation and create an operationId
 *
 * Additional info:
 *
 *
 * sends a verification code via SMS or email.
 *
 *
 * Example:
 *
 *
 *
 * {
 *
 *
 * "operationTitle": "BUYCRYPTO",
 *
 *
 * "operationId": "08a16b83-9094-4e89-8c05-2ccadd5c1c7e",
 *
 *
 * "type": "SMS",
 *
 *
 * "templateDataJson": "templateDataJson"
 *
 *
 * }
 */
export type Send2FaTokenInput = {
  /**
   * Required: false
   *
   * Description: baas partner name
   *
   * Example:
   *
   *         "Sharpay"
   */
  alphaName?: InputMaybe<Scalars['String']['input']>;
  /**
   * Required: true
   *
   * Description: Operation identifier
   *
   * Format:
   *
   *         uuid v4
   */
  operationId?: InputMaybe<Scalars['ID']['input']>;
  /**
   * Required: false
   *
   * Description: title type
   *
   * Format:
   *
   *         string parameters from custom enum
   *
   *
   * Example:
   *
   *         "BUYCRYPTO"
   */
  operationTitle?: InputMaybe<Scalars['String']['input']>;
  /**
   * Required: false
   *
   * Description: Serialized JSON containing variables to be inserted into an email template
   *
   * Format:
   *
   *         JSON
   */
  templateDataJson?: InputMaybe<Scalars['String']['input']>;
  /**
   * Required: true
   *
   * Description: two-factor authentication type
   *
   * Format:
   *
   *         string parameter from custom enum
   *
   *
   * Example:
   *
   *         "SMS"
   */
  type?: InputMaybe<TfaType>;
};

/** returns the selected code submission type and the operation identifier */
export type Send2FaTokenResponse = {
  __typename?: 'Send2FATokenResponse';
  /**
   * Required: false
   *
   * Description: the time when you can resend the confirmation code
   *
   * Format:
   *
   *         Date
   *
   *
   * Example:
   *
   *         "2022-03-06T08:23:45.000Z"
   */
  emailRetryAfter?: Maybe<Scalars['DateTime']['output']>;
  /**
   * Required: false
   *
   * Description: timer that shows how long it takes to resend an EMAIL
   *
   * Format:
   *
   *         milliseconds
   *
   *
   * Example:
   *
   *         45000
   */
  emailTimeout?: Maybe<Scalars['Float']['output']>;
  /**
   * Required: true
   *
   * Description: Operation identifier
   *
   * Format:
   *
   *         uuid v4
   */
  operationId: Scalars['String']['output'];
  /**
   * Required: false
   *
   * Description: phone number used to resubmit the request
   *
   * Example:
   *
   *         "+70000000000"
   */
  phoneNumber?: Maybe<Scalars['String']['output']>;
  /**
   * Required: true
   *
   * Description: types of two-factor authentication that were used when confirming the operation
   *
   * Format:
   *
   *         array of string parameters from custom enum
   *
   *
   * Example:
   *
   *         ["SMS", "EMAIL"]
   */
  response: Array<TfaType>;
  /**
   * Required: false
   *
   * Description: the time when you can resend the confirmation code
   *
   * Format:
   *
   *         Date
   *
   *
   * Example:
   *
   *         "2022-03-06T08:23:45.000Z"
   */
  smsRetryAfter?: Maybe<Scalars['DateTime']['output']>;
  /**
   * Required: false
   *
   * Description: timer that shows how long it takes to resend an SMS
   *
   * Format:
   *
   *         milliseconds
   *
   *
   * Example:
   *
   *         45000
   */
  smsTimeout?: Maybe<Scalars['Float']['output']>;
};

export enum SendCode {
  ChangeEmail = 'CHANGE_EMAIL',
  ChangePhone = 'CHANGE_PHONE',
  Forgotpassword = 'FORGOTPASSWORD',
  Registration = 'REGISTRATION',
  RegistrationEmail = 'REGISTRATION_EMAIL',
  RegistrationPhone = 'REGISTRATION_PHONE'
}

export type SendCodeInput = {
  captcha: ReCaptchaInput;
  device: Device;
  identity: Scalars['String']['input'];
  messengerType?: InputMaybe<MessengerType>;
  service: Scalars['String']['input'];
  type?: InputMaybe<SendCode>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type SendMyVerificationInput = {
  /** Ids of user identity documents that should be sent for KYC procedure */
  docIds: Array<Scalars['ID']['input']>;
};

export type SendPaymentInput = {
  paymentId: Scalars['ID']['input'];
  tfaType?: InputMaybe<TfaType>;
};

export type SendSystemPaymentInput = {
  /** Payment amount. */
  amount: Scalars['BigNumber']['input'];
  attachmentId?: InputMaybe<Scalars['ID']['input']>;
  category: PaymentCategory;
  /** Payment receiver (To). */
  credit: PaymentAccountInput;
  /** Payment currency */
  currencyId: Scalars['ID']['input'];
  /** Payment sender (From). */
  debit: PaymentAccountInput;
  documentNo?: InputMaybe<Scalars['String']['input']>;
  documentNoOrDate?: InputMaybe<Scalars['String']['input']>;
  isDeclined?: InputMaybe<Scalars['Boolean']['input']>;
  isSystem?: InputMaybe<Scalars['Boolean']['input']>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  operationId?: InputMaybe<Scalars['String']['input']>;
  providerFee?: InputMaybe<Scalars['BigNumber']['input']>;
  reason?: InputMaybe<PaymentReason>;
  schedule?: InputMaybe<Scalars['DateTime']['input']>;
  schema?: InputMaybe<PaymentSchema>;
  service?: InputMaybe<Scalars['String']['input']>;
  tezroFee?: InputMaybe<Scalars['BigNumber']['input']>;
  trackerId?: InputMaybe<Scalars['ID']['input']>;
  type: PaymentType;
  vat?: InputMaybe<Scalars['BigNumber']['input']>;
};

export type SendVerificationInput = {
  /** Ids of user identity documents that should be sent for KYC procedure */
  docIds: Array<Scalars['ID']['input']>;
  userId: Scalars['ID']['input'];
};

export type ServiceAuthInput = {
  device: Device;
  identity: Scalars['String']['input'];
  password: Scalars['String']['input'];
  service: Scalars['String']['input'];
};

export type Session = {
  __typename?: 'Session';
  createdAt: Scalars['DateTime']['output'];
  geoLocation?: Maybe<Scalars['String']['output']>;
  ipAddress?: Maybe<Scalars['String']['output']>;
  refreshToken: Scalars['String']['output'];
  userAgent: Scalars['String']['output'];
  userId: Scalars['String']['output'];
};

export type SetCardTopUpConfigInput = {
  clientEeaFinancialInstitutionsContractId?: InputMaybe<Scalars['String']['input']>;
  clientNonEeaFinancialInstitutionsContractId?: InputMaybe<Scalars['String']['input']>;
  clientUkFinancialInstitutionsContractId?: InputMaybe<Scalars['String']['input']>;
  corporateClientTransitContractId?: InputMaybe<Scalars['String']['input']>;
  corporateInwardPaymentsIncomeContractId?: InputMaybe<Scalars['String']['input']>;
  dailyLimit?: InputMaybe<Scalars['Float']['input']>;
  defaultFee?: InputMaybe<Scalars['BigNumber']['input']>;
  defaultFeeMargin?: InputMaybe<Scalars['BigNumber']['input']>;
  feePercentage?: InputMaybe<Scalars['BigNumber']['input']>;
  minimalLimit?: InputMaybe<Scalars['Float']['input']>;
  monthlyLimit?: InputMaybe<Scalars['Float']['input']>;
  otherDirectCostsContractId?: InputMaybe<Scalars['String']['input']>;
  otherReceivablesContractId?: InputMaybe<Scalars['String']['input']>;
  ownEeaFinancialInstitutionsContractId?: InputMaybe<Scalars['String']['input']>;
  ownNonEeaFinancialInstitutionsContractId?: InputMaybe<Scalars['String']['input']>;
  ownUkFinancialInstitutionsContractId?: InputMaybe<Scalars['String']['input']>;
  payablesSettlementContractId?: InputMaybe<Scalars['String']['input']>;
  physicalClientTransitContractId?: InputMaybe<Scalars['String']['input']>;
  physicalInwardPaymentsIncomeContractId?: InputMaybe<Scalars['String']['input']>;
  provisionContractId?: InputMaybe<Scalars['String']['input']>;
  receivablesFromCustomersContractId?: InputMaybe<Scalars['String']['input']>;
  transactionLimit?: InputMaybe<Scalars['Float']['input']>;
};

export type SetExtraConfigInput = {
  /** Max length of extra array */
  extraCountLimit: Scalars['Int']['input'];
  /** Max size of extra array in bytes */
  extraSizeLimit: Scalars['Int']['input'];
};

export type SetFilePrivacyInput = {
  /** file id */
  id: Scalars['String']['input'];
  /** set if file must be private or not. If value is true accessToken for file will be refreshed */
  value: Scalars['Boolean']['input'];
};

export type SignInResult = {
  __typename?: 'SignInResult';
  emailRetryAfter?: Maybe<Scalars['DateTime']['output']>;
  emailTimeout?: Maybe<Scalars['Float']['output']>;
  maskedEmail?: Maybe<Scalars['String']['output']>;
  maskedPhone?: Maybe<Scalars['String']['output']>;
  operationId: Scalars['String']['output'];
  phoneNumber?: Maybe<Scalars['String']['output']>;
  response: Array<TfaType>;
  smsRetryAfter?: Maybe<Scalars['DateTime']['output']>;
  smsTimeout?: Maybe<Scalars['Float']['output']>;
  srpServerProof?: Maybe<Scalars['String']['output']>;
};

export type SortAddressCategoriesInput = {
  direction: AddressSortOrder;
  field: SortAddressCategoryField;
};

export enum SortAddressCategoryField {
  CreatedAt = 'CREATED_AT',
  DeletedAt = 'DELETED_AT',
  UpdatedAt = 'UPDATED_AT'
}

export type SortCompaniesInput = {
  direction: CompanySortOrder;
  field: SortCompanyField;
};

export enum SortCompanyField {
  CreatedAt = 'CREATED_AT',
  Name = 'NAME',
  UpdatedAt = 'UPDATED_AT'
}

export enum SortOrder {
  Asc = 'ASC',
  Desc = 'DESC'
}

export type SortTariffClientsInput = {
  direction: TariffSortDirectionEnum;
  field: TariffClientOrderFieldsEnum;
};

export type SortTariffOperationHistoriesInput = {
  direction: TariffSortDirectionEnum;
  field: TariffOperationHistoryOrderFieldsEnum;
};

export type SourceOfFunds = {
  __typename?: 'SourceOfFunds';
  name: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type SourceOfFundsV2 = {
  __typename?: 'SourceOfFundsV2';
  key: Scalars['String']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type SourceOfWealth = {
  __typename?: 'SourceOfWealth';
  name: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type SrcCheckResult = {
  __typename?: 'SrcCheckResult';
  isEnabled: Scalars['Boolean']['output'];
  srpInfo?: Maybe<SrpClientInfo>;
};

export type SrpClientInfo = {
  __typename?: 'SrpClientInfo';
  operationId: Scalars['String']['output'];
  salt: Scalars['String']['output'];
  serverPublicEphemeral: Scalars['String']['output'];
};

export type SrpInfo = {
  salt: Scalars['String']['input'];
  verifier: Scalars['String']['input'];
};

export type SrpVerifyInput = {
  clientPublicEphemeral: Scalars['String']['input'];
  operationId: Scalars['String']['input'];
  proof: Scalars['String']['input'];
};

export type StartPasswordRecoveryV2Input = {
  device: Device;
  identity: Scalars['String']['input'];
};

export type StartTopUpBalanceByCardInput = {
  card: CardDataInput;
  checkoutId?: InputMaybe<Scalars['String']['input']>;
  checkoutPaymentType: CheckoutPaymentType;
  checkoutToken?: InputMaybe<Scalars['String']['input']>;
  creditAccountNumber: Scalars['String']['input'];
  currencyId: Scalars['String']['input'];
  failureUrl?: InputMaybe<Scalars['String']['input']>;
  fee: Scalars['BigNumber']['input'];
  operationId?: InputMaybe<Scalars['String']['input']>;
  successUrl?: InputMaybe<Scalars['String']['input']>;
  totalAmount: Scalars['BigNumber']['input'];
};

export type StaticData = {
  __typename?: 'StaticData';
  companySourcesOfFunds: Array<SourceOfFunds>;
  companySourcesOfWealth: Array<SourceOfWealth>;
};

export enum StatusEnum {
  Active = 'ACTIVE',
  Blocked = 'BLOCKED',
  Unconfirmed = 'UNCONFIRMED'
}

export type StripePaginationInput = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};

/**
 * Description: input to reset all two-factor authentication
 *
 * Example:
 *
 *
 *
 * {
 *
 *
 * "recoveryCode": "074e48c8e3c0bc19f9e2"
 *
 *
 * }
 */
export type TfaClearAll2FaInput = {
  /**
   * Required: true
   *
   * Description: Code used to disable two-factor authentication
   *
   * Additional info:
   *
   *
   * this code is generated automatically using the "getRecoveryCode" request
   *
   *
   * Format:
   *
   *         generated string value 20 characters long
   *
   *
   * Example:
   *
   *         074e48c8e3c0bc19f9e2
   */
  recoveryCode: Scalars['String']['input'];
};

/**
 * Description: input to enable or disable two-factor authentication
 *
 * Example:
 *
 *
 *
 * {
 *
 *
 * "type": "SMS"
 *
 *
 * }
 */
export type TfaInput = {
  /**
   * Required: true
   *
   * Description: two-factor authentication type
   *
   * Format:
   *
   *         string parameter from custom enum
   *
   *
   * Example:
   *
   *         "SMS"
   */
  type: TfaType;
};

/** returns type of operation and methods of its confirmation */
export type TfaOperation = {
  __typename?: 'TFAOperation';
  /**
   * Required: false
   *
   * Description: title type
   *
   * Format:
   *
   *         string parameters from custom enum
   *
   *
   * Example:
   *
   *         "BUYCRYPTO"
   */
  title: Scalars['String']['output'];
  /**
   * Required: true
   *
   * Description: two-factor authentication type
   *
   * Format:
   *
   *         array of string parameters from custom enum
   *
   *
   * Example:
   *
   *         ["SMS", "EMAIL"]
   */
  verificationTypes: Array<TfaType>;
};

/** returns the status and other details of the operation being performed */
export type TfaOperationId = {
  __typename?: 'TFAOperationId';
  /**
   * Required: false
   *
   * Description: returns the time when you can resend EMAIL with the operation confirmation code
   *
   * Format:
   *
   *         Date
   *
   *
   * Example:
   *
   *         "2022-03-06T08:23:45.000Z"
   */
  emailRetryAfter?: Maybe<Scalars['DateTime']['output']>;
  /**
   * Required: true
   *
   * Description: type of operation and methods of its confirmation
   *
   * Format:
   *
   *         2 fields containing title and array of verification types
   *
   *
   * Example:
   *
   *
   *             {
   *                 "title": "BUYCRYPTO",
   *                 "verificationTypes": ["SMS", "EMAIL"]
   *             }
   */
  operation: TfaOperation;
  /**
   * Required: false
   *
   * Description: returns the time when you can resend SMS with the operation confirmation code
   *
   * Format:
   *
   *         Date
   *
   *
   * Example:
   *
   *         "2022-03-06T08:23:45.000Z"
   */
  smsRetryAfter?: Maybe<Scalars['DateTime']['output']>;
  /**
   * Required: true
   *
   * Description: status type
   *
   * Format:
   *
   *         string parameter from custom enum
   *
   *
   * Example:
   *
   *         "VERIFIED"
   */
  status: OperationIdStatus;
};

/** the type returned when enabling or disabling two-factor authentication */
export type TfaResponse = {
  __typename?: 'TFAResponse';
  /**
   * Required: false
   *
   * Description: the time when you can resend the confirmation code
   *
   * Format:
   *
   *         Date
   *
   *
   * Example:
   *
   *         "2022-03-06T08:23:45.000Z"
   */
  emailRetryAfter?: Maybe<Scalars['DateTime']['output']>;
  /**
   * Required: false
   *
   * Description: timer that shows how long it takes to resend an EMAIL
   *
   * Format:
   *
   *         milliseconds
   *
   *
   * Example:
   *
   *         45000
   */
  emailTimeout?: Maybe<Scalars['Float']['output']>;
  /**
   * Required: true
   *
   * Description: Operation identifier
   *
   * Format:
   *
   *         uuid v4
   */
  operationId: Scalars['String']['output'];
  /**
   * Required: true
   *
   * Description: field containing the response result which can be "success" or "secret key"
   *
   * Additional info:
   *
   *         if this field is contained in the response to the "enable 2FA" request, then it can return "secret key"
   *
   *
   * Format:
   *
   *         "success" or "secret key"
   *
   *
   * Example:
   *
   *         "success"
   */
  response: Scalars['String']['output'];
  /**
   * Required: false
   *
   * Description: the time when you can resend the confirmation code
   *
   * Format:
   *
   *         Date
   *
   *
   * Example:
   *
   *         "2022-03-06T08:23:45.000Z"
   */
  smsRetryAfter?: Maybe<Scalars['DateTime']['output']>;
  /**
   * Required: false
   *
   * Description: timer that shows how long it takes to resend an SMS
   *
   * Format:
   *
   *         milliseconds
   *
   *
   * Example:
   *
   *         45000
   */
  smsTimeout?: Maybe<Scalars['Float']['output']>;
};

/** enum with a choice of two-factor authentication type */
export enum TfaType {
  Email = 'EMAIL',
  Otp = 'OTP',
  Sms = 'SMS'
}

export type Tariff = {
  __typename?: 'Tariff';
  clientCategory: Scalars['String']['output'];
  clients?: Maybe<TariffClients>;
  commissions?: Maybe<TariffCommissions>;
  conditions: Scalars['String']['output'];
  createdAt: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  limits?: Maybe<TariffLimits>;
  name: Scalars['String']['output'];
  operations?: Maybe<Operations>;
  updatedAt: Scalars['String']['output'];
};


export type TariffClientsArgs = {
  input: FilterInput;
};


export type TariffCommissionsArgs = {
  input: FilterInput;
};


export type TariffLimitsArgs = {
  input: FilterInput;
};


export type TariffOperationsArgs = {
  input: FilterInput;
};

export type TariffAvailableLimit = {
  __typename?: 'TariffAvailableLimit';
  annualAvailable: Scalars['BigNumber']['output'];
  dailyAvailable: Scalars['BigNumber']['output'];
  limit: TariffLimit;
  monthlyAvailable: Scalars['BigNumber']['output'];
  weeklyAvailable: Scalars['BigNumber']['output'];
};

export type TariffAvailableLimitInput = {
  clientId: Scalars['ID']['input'];
  limitIds: Array<Scalars['ID']['input']>;
};

export type TariffAvailableLimits = {
  __typename?: 'TariffAvailableLimits';
  count: Scalars['Int']['output'];
  cursor: Scalars['Int']['output'];
  nodes: Array<TariffAvailableLimit>;
};

export enum TariffBaseOrderFieldsEnum {
  CreatedAt = 'CREATED_AT',
  Name = 'NAME',
  UpdatedAt = 'UPDATED_AT'
}

export type TariffChangeBaseCurrencyCommissionInput = {
  attachCommissionId: Scalars['ID']['input'];
  operationId: Scalars['ID']['input'];
  tariffId: Scalars['ID']['input'];
};

export type TariffChangeClientTariffHistories = {
  __typename?: 'TariffChangeClientTariffHistories';
  count: Scalars['Int']['output'];
  cursor: Scalars['Int']['output'];
  nodes: Array<TariffChangeClientTariffHistory>;
};

export type TariffChangeClientTariffHistory = {
  __typename?: 'TariffChangeClientTariffHistory';
  billingPeriod: Scalars['String']['output'];
  client: TariffClient;
  createdAt: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  tariff: Tariff;
  updatedAt: Scalars['String']['output'];
};

export type TariffChangeLimitHistories = {
  __typename?: 'TariffChangeLimitHistories';
  count: Scalars['Int']['output'];
  cursor: Scalars['Int']['output'];
  nodes: Array<TariffChangeLimitHistory>;
};

export type TariffChangeLimitHistory = {
  __typename?: 'TariffChangeLimitHistory';
  annual: Scalars['BigNumber']['output'];
  client?: Maybe<TariffClient>;
  currencyTicker: Scalars['String']['output'];
  daily: Scalars['BigNumber']['output'];
  id: Scalars['ID']['output'];
  isBaseCurrency: Scalars['Boolean']['output'];
  limit: TariffLimit;
  max?: Maybe<Scalars['BigNumber']['output']>;
  min?: Maybe<Scalars['BigNumber']['output']>;
  monthly: Scalars['BigNumber']['output'];
  operation?: Maybe<TariffOperation>;
  restriction?: Maybe<TariffLimitRestriction>;
  tariff?: Maybe<Tariff>;
  weekly: Scalars['BigNumber']['output'];
};

export type TariffCheckLimitDeclineMetadata = {
  __typename?: 'TariffCheckLimitDeclineMetadata';
  available?: Maybe<Scalars['String']['output']>;
  max?: Maybe<Scalars['String']['output']>;
  min?: Maybe<Scalars['String']['output']>;
};

export type TariffCheckLimitInput = {
  amount: Scalars['BigNumber']['input'];
  clientId: Scalars['ID']['input'];
  currencyTicker: Scalars['String']['input'];
  operationName: Scalars['String']['input'];
};

export type TariffCheckLimitResult = {
  __typename?: 'TariffCheckLimitResult';
  amount: Scalars['BigNumber']['output'];
  annualAvailable: Scalars['BigNumber']['output'];
  currencyTicker: Scalars['String']['output'];
  dailyAvailable: Scalars['BigNumber']['output'];
  expect?: Maybe<TariffCheckLimitDeclineMetadata>;
  limit: TariffLimit;
  monthlyAvailable: Scalars['BigNumber']['output'];
  ratedAmount?: Maybe<Scalars['BigNumber']['output']>;
  reason?: Maybe<Scalars['String']['output']>;
  result: Scalars['Boolean']['output'];
  weeklyAvailable: Scalars['BigNumber']['output'];
};

export type TariffClient = {
  __typename?: 'TariffClient';
  availableLimits?: Maybe<TariffAvailableLimits>;
  billingPeriod: Scalars['String']['output'];
  changeTariffHistories?: Maybe<TariffChangeClientTariffHistories>;
  clientCategory: Scalars['String']['output'];
  commissions?: Maybe<TariffCommissions>;
  createdAt: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  limits?: Maybe<TariffLimits>;
  limitsUpdates: TariffLimitsUpdates;
  name?: Maybe<Scalars['String']['output']>;
  operationHistories?: Maybe<TariffOperationHistories>;
  tariff: Tariff;
  updatedAt: Scalars['String']['output'];
};


export type TariffClientAvailableLimitsArgs = {
  input: FilterInput;
};


export type TariffClientChangeTariffHistoriesArgs = {
  input: FilterInput;
};


export type TariffClientCommissionsArgs = {
  input: FilterInput;
};


export type TariffClientLimitsArgs = {
  input: FilterInput;
};


export type TariffClientOperationHistoriesArgs = {
  input: FilterInput;
};

export enum TariffClientOrderFieldsEnum {
  BillingPeriod = 'BILLING_PERIOD',
  CreatedAt = 'CREATED_AT',
  UpdatedAt = 'UPDATED_AT'
}

export type TariffClients = {
  __typename?: 'TariffClients';
  count: Scalars['Int']['output'];
  cursor: Scalars['Int']['output'];
  nodes: Array<TariffClient>;
};

export type TariffCommission = {
  __typename?: 'TariffCommission';
  client?: Maybe<TariffClient>;
  createdAt: Scalars['String']['output'];
  currencyTicker: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  factors?: Maybe<TariffCommissionFactors>;
  id: Scalars['ID']['output'];
  isBaseCurrency: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  operation: TariffOperation;
  statistics: TariffCommissionBindingStatistics;
  tariffOperations: TariffOperationChains;
  updatedAt: Scalars['String']['output'];
};


export type TariffCommissionFactorsArgs = {
  input: FilterInput;
};


export type TariffCommissionTariffOperationsArgs = {
  input: FilterInput;
};

export type TariffCommissionBindingStatistics = {
  __typename?: 'TariffCommissionBindingStatistics';
  operations: Scalars['Int']['output'];
  tariffs: Scalars['Int']['output'];
};

export type TariffCommissionFactor = {
  __typename?: 'TariffCommissionFactor';
  amountFrom?: Maybe<Scalars['BigNumber']['output']>;
  amountTo?: Maybe<Scalars['BigNumber']['output']>;
  commission: TariffCommission;
  conditions?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  fixed?: Maybe<Scalars['BigNumber']['output']>;
  formula?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  max?: Maybe<Scalars['BigNumber']['output']>;
  min?: Maybe<Scalars['BigNumber']['output']>;
  name: Scalars['String']['output'];
  order: Scalars['Float']['output'];
  percent?: Maybe<Scalars['BigNumber']['output']>;
  type: Scalars['String']['output'];
  updatedAt: Scalars['String']['output'];
};

export type TariffCommissionFactors = {
  __typename?: 'TariffCommissionFactors';
  count: Scalars['Int']['output'];
  cursor: Scalars['Int']['output'];
  nodes: Array<TariffCommissionFactor>;
};

export type TariffCommissions = {
  __typename?: 'TariffCommissions';
  count: Scalars['Int']['output'];
  cursor: Scalars['Int']['output'];
  nodes: Array<TariffCommission>;
};

export type TariffDateRangeInput = {
  dateFrom?: InputMaybe<Scalars['String']['input']>;
  dateTo?: InputMaybe<Scalars['String']['input']>;
};

export type TariffEntitySortInput = {
  direction: TariffSortDirectionEnum;
  field: TariffBaseOrderFieldsEnum;
};

export type TariffFee = {
  __typename?: 'TariffFee';
  commissionFactor: TariffCommissionFactor;
  fee: Scalars['BigNumber']['output'];
  originalFee: Scalars['BigNumber']['output'];
};

export type TariffLimit = {
  __typename?: 'TariffLimit';
  annual: Scalars['BigNumber']['output'];
  changeLimitHistories?: Maybe<TariffChangeLimitHistories>;
  clients?: Maybe<TariffClients>;
  createdAt: Scalars['String']['output'];
  currencyTicker: Scalars['String']['output'];
  daily: Scalars['BigNumber']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isBaseCurrency: Scalars['Boolean']['output'];
  max?: Maybe<Scalars['BigNumber']['output']>;
  min?: Maybe<Scalars['BigNumber']['output']>;
  monthly: Scalars['BigNumber']['output'];
  name?: Maybe<Scalars['String']['output']>;
  operation: TariffOperation;
  restriction?: Maybe<TariffLimitRestriction>;
  statistics: TariffLimitBindingStatistics;
  tariff?: Maybe<Tariff>;
  tariffOperations: TariffOperationChains;
  updatedAt: Scalars['String']['output'];
  weekly: Scalars['BigNumber']['output'];
};


export type TariffLimitChangeLimitHistoriesArgs = {
  input: FilterInput;
};


export type TariffLimitClientsArgs = {
  input: FilterInput;
};


export type TariffLimitTariffOperationsArgs = {
  input: FilterInput;
};

export type TariffLimitBindingStatistics = {
  __typename?: 'TariffLimitBindingStatistics';
  operations: Scalars['Int']['output'];
  tariffs: Scalars['Int']['output'];
};

export type TariffLimitRestriction = {
  __typename?: 'TariffLimitRestriction';
  createdAt: Scalars['String']['output'];
  currencyTicker: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  limits: TariffLimits;
  max?: Maybe<Scalars['BigNumber']['output']>;
  maxAnnual: Scalars['BigNumber']['output'];
  maxDaily: Scalars['BigNumber']['output'];
  maxMonthly: Scalars['BigNumber']['output'];
  maxWeekly: Scalars['BigNumber']['output'];
  min?: Maybe<Scalars['BigNumber']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  operation?: Maybe<TariffOperation>;
  tariff?: Maybe<Tariff>;
  updatedAt: Scalars['String']['output'];
};


export type TariffLimitRestrictionLimitsArgs = {
  input: FilterInput;
};

export type TariffLimitRestrictions = {
  __typename?: 'TariffLimitRestrictions';
  count: Scalars['Int']['output'];
  cursor: Scalars['Int']['output'];
  nodes: Array<TariffLimitRestriction>;
};

export type TariffLimits = {
  __typename?: 'TariffLimits';
  count: Scalars['Int']['output'];
  cursor: Scalars['Int']['output'];
  nodes: Array<TariffLimit>;
};

export type TariffLimitsUpdate = {
  __typename?: 'TariffLimitsUpdate';
  last: Scalars['Timestamp']['output'];
  next: Scalars['Timestamp']['output'];
};

export type TariffLimitsUpdates = {
  __typename?: 'TariffLimitsUpdates';
  annual: TariffLimitsUpdate;
  daily: TariffLimitsUpdate;
  monthly: TariffLimitsUpdate;
  weekly: TariffLimitsUpdate;
};

export type TariffOperation = {
  __typename?: 'TariffOperation';
  commissions?: Maybe<TariffCommissions>;
  createdAt: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  limits?: Maybe<TariffLimits>;
  name: Scalars['String']['output'];
  operationHistories?: Maybe<TariffOperationHistories>;
  tariffs?: Maybe<Tariffs>;
  updatedAt: Scalars['String']['output'];
};


export type TariffOperationCommissionsArgs = {
  input: FilterInput;
};


export type TariffOperationLimitsArgs = {
  input: FilterInput;
};


export type TariffOperationOperationHistoriesArgs = {
  input: FilterInput;
};


export type TariffOperationTariffsArgs = {
  input: FilterInput;
};

export type TariffOperationChain = {
  __typename?: 'TariffOperationChain';
  createdAt: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  operation: TariffOperation;
  tariff: Tariff;
  updatedAt: Scalars['String']['output'];
};

export type TariffOperationChains = {
  __typename?: 'TariffOperationChains';
  count: Scalars['Int']['output'];
  cursor: Scalars['Int']['output'];
  nodes: Array<TariffOperationChain>;
};

export type TariffOperationHistories = {
  __typename?: 'TariffOperationHistories';
  count: Scalars['Int']['output'];
  cursor: Scalars['Int']['output'];
  nodes: Array<TariffOperationHistory>;
};

export type TariffOperationHistory = {
  __typename?: 'TariffOperationHistory';
  amount: Scalars['BigNumber']['output'];
  client: TariffClient;
  createdAt: Scalars['String']['output'];
  currencyTicker: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  operation: TariffOperation;
  status: TariffOperationHistoryStatusEnum;
  tariff: Tariff;
  trackerId: Scalars['String']['output'];
  updatedAt: Scalars['String']['output'];
};

export enum TariffOperationHistoryOrderFieldsEnum {
  CreatedAt = 'CREATED_AT',
  UpdatedAt = 'UPDATED_AT'
}

export enum TariffOperationHistoryStatusEnum {
  Pending = 'PENDING',
  Rejected = 'REJECTED',
  Successful = 'SUCCESSFUL'
}

export enum TariffSortDirectionEnum {
  Asc = 'ASC',
  Desc = 'DESC'
}

export type TariffTotalFee = {
  __typename?: 'TariffTotalFee';
  amount: Scalars['BigNumber']['output'];
  currencyTicker: Scalars['String']['output'];
  fee: Array<TariffFee>;
  originalAmount: Scalars['BigNumber']['output'];
  originalTotalAmount: Scalars['BigNumber']['output'];
  originalTotalFee: Scalars['BigNumber']['output'];
  totalAmount: Scalars['BigNumber']['output'];
  totalFee: Scalars['BigNumber']['output'];
};

export type Tariffs = {
  __typename?: 'Tariffs';
  count: Scalars['Int']['output'];
  cursor: Scalars['Int']['output'];
  nodes: Array<Tariff>;
};

export type TariffsFilterFactor = {
  __typename?: 'TariffsFilterFactor';
  conditions: Scalars['String']['output'];
};

export type TariffsStripeFactors = {
  __typename?: 'TariffsStripeFactors';
  /** Factors are applied to the STRIPE_SHOPPING operation when conversion was conducted */
  shoppingWithConversation: Array<TariffsFilterFactor>;
  /** Factors are applied to the STRIPE_SHOPPING operation when NO conversion was conducted */
  shoppingWithoutConversation: Array<TariffsFilterFactor>;
  /** Factors are applied to the STRIPE_TOP_UP operation */
  topUp: Array<TariffsFilterFactor>;
};

/**
 * Description: input data for adding or removing emails to the list allowed for authorization in the Telegram bot
 *
 * Example:
 *
 *
 *
 * {
 *
 *
 * [ "test-email@yourcompany. com", "example@test. com" ]
 *
 *
 * }
 */
export type TfaTgEmailInput = {
  /**
   * Required: true
   *
   * Description: array of email addresses
   *
   * Example:
   *
   *         [ "test-email@yourcompany.com", "example@test.com" ]
   */
  emails: Array<Scalars['String']['input']>;
};

/**
 * Description: input data for adding or removing phones to the list allowed for authorization in the Telegram bot
 *
 * Example:
 *
 *
 *
 * {
 *
 *
 * [ "+70000000000", "+71111111111" ]
 *
 *
 * }
 */
export type TfaTgPhonesInput = {
  /**
   * Required: true
   *
   * Description: array of phone numbers
   *
   * Example:
   *
   *         [ "+70000000000", "+71111111111" ]
   */
  phones: Array<Scalars['String']['input']>;
};

export type Timestamps = {
  __typename?: 'Timestamps';
  createdAt: Scalars['DateTime']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type Timezone = {
  __typename?: 'Timezone';
  item: CommonDictItem;
  /** The time offset */
  offset: Scalars['Int']['output'];
  offsetDst: Scalars['Int']['output'];
};

export type TransferMethod = {
  __typename?: 'TransferMethod';
  country?: Maybe<Country>;
  item: CommonDictItem;
  types: Array<TransferMethodType>;
};

export type TransferMethodInput = {
  countries?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  countryId?: InputMaybe<Scalars['ID']['input']>;
  filter?: InputMaybe<Filter>;
  itemQuery?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tickers?: InputMaybe<Array<Scalars['String']['input']>>;
  type?: InputMaybe<CurrencyType>;
  types?: InputMaybe<Array<InputMaybe<TransferMethodType>>>;
};

export enum TransferMethodType {
  BankTransfer = 'BANK_TRANSFER',
  DebitCreditCard = 'DEBIT_CREDIT_CARD',
  GiftCard = 'GIFT_CARD',
  OnlineWallet = 'ONLINE_WALLET',
  OtherOptions = 'OTHER_OPTIONS'
}

export type TwilioLookupCallerNameType = {
  __typename?: 'TwilioLookupCallerNameType';
  callerName: Scalars['String']['output'];
  callerType: Scalars['String']['output'];
  errorCode?: Maybe<Scalars['Float']['output']>;
};

export type TwilioLookupCarrierType = {
  __typename?: 'TwilioLookupCarrierType';
  errorCode?: Maybe<Scalars['Float']['output']>;
  mobileCountryCode: Scalars['String']['output'];
  mobileNetworkCode: Scalars['String']['output'];
  name: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type TwilioLookupErrorType = {
  __typename?: 'TwilioLookupErrorType';
  code: Scalars['Float']['output'];
  message: Scalars['String']['output'];
  moreInfo: Scalars['String']['output'];
  phoneNumber: Scalars['String']['output'];
  status: Scalars['Float']['output'];
};

export type TwilioLookupResultType = {
  __typename?: 'TwilioLookupResultType';
  callerName?: Maybe<TwilioLookupCallerNameType>;
  carrier?: Maybe<TwilioLookupCarrierType>;
  countryCode: Scalars['String']['output'];
  nationalFormat: Scalars['String']['output'];
  phoneNumber: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type UnbindIndividualApplicantFromCompanyInput = {
  externalCompanyId: Scalars['ID']['input'];
  externalUserId: Scalars['ID']['input'];
};

export type UnblockAccountInput = {
  accountId: Scalars['ID']['input'];
  reasons: Array<Scalars['String']['input']>;
};

export type UnblockCompanyInput = {
  id: Scalars['ID']['input'];
  reasons: Array<Scalars['String']['input']>;
};

export type UnblockUserInput = {
  id: Scalars['ID']['input'];
  reasons: Array<Scalars['String']['input']>;
};

export type Unit = {
  __typename?: 'Unit';
  /** [Dictionary] e.g. name: Kilogram, code: KG */
  item: CommonDictItem;
};

export type UnitInput = {
  code: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type UnlockUserOperationInput = {
  codeType: SendCode;
  identity: Scalars['String']['input'];
  service: Scalars['String']['input'];
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateAdditionalInfoInput = {
  clientId?: InputMaybe<Scalars['ID']['input']>;
  id: Scalars['ID']['input'];
  key?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<AdditionalInfoTypeEnum>;
  value?: InputMaybe<Scalars['AdditionalInfoValue']['input']>;
};

export type UpdateAddressCategoryInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateAddressInput = {
  attachCategoryIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  buildingName?: InputMaybe<Scalars['String']['input']>;
  buildingNumber?: InputMaybe<Scalars['String']['input']>;
  /** id of city from dictionary-microservice */
  cityId?: InputMaybe<Scalars['ID']['input']>;
  clientId: Scalars['ID']['input'];
  /** additional comment */
  comment?: InputMaybe<Scalars['String']['input']>;
  /** id of country from dictionary-microservice */
  countryId?: InputMaybe<Scalars['ID']['input']>;
  detachCategoryIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  flatNumber?: InputMaybe<Scalars['String']['input']>;
  geoLatitude?: InputMaybe<Scalars['String']['input']>;
  geoLongitude?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  isActual?: InputMaybe<Scalars['Boolean']['input']>;
  isLegal?: InputMaybe<Scalars['Boolean']['input']>;
  /** should be true if current address is primary for user */
  isPrimary?: InputMaybe<Scalars['Boolean']['input']>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  rawCityName?: InputMaybe<Scalars['String']['input']>;
  rawCityNameEn?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  stateEn?: InputMaybe<Scalars['String']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
  streetEn?: InputMaybe<Scalars['String']['input']>;
  subStreet?: InputMaybe<Scalars['String']['input']>;
  subStreetEn?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateAgeRangeStatisticSettingInput = {
  ageFrom?: InputMaybe<Scalars['Int']['input']>;
  ageTo?: InputMaybe<Scalars['Int']['input']>;
  id: Scalars['ID']['input'];
  rangeName?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateApplicantTopLevelDataInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  externalUserId?: InputMaybe<Scalars['String']['input']>;
  lang?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  sourceKey?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateApplicantTopLevelInput = {
  applicantData?: InputMaybe<UpdateApplicantTopLevelDataInput>;
  externalUserId: Scalars['String']['input'];
};

export type UpdateBalanceInput = {
  accountId: Scalars['ID']['input'];
  available?: InputMaybe<Scalars['BigNumber']['input']>;
  full?: InputMaybe<Scalars['BigNumber']['input']>;
  held?: InputMaybe<Scalars['BigNumber']['input']>;
};

export type UpdateBusinessActivityDataInput = {
  classificationSystem?: InputMaybe<Scalars['String']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  level?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateBusinessActivityInput = {
  businessActivity: UpdateBusinessActivityDataInput;
  id: Scalars['String']['input'];
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateCardPaymentInput = {
  amount?: InputMaybe<PaymentsAmountInput>;
  createdAt?: InputMaybe<Scalars['Timestamp']['input']>;
  deletedAt?: InputMaybe<Scalars['Timestamp']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  fee?: InputMaybe<PaymentsFeeInput>;
  id: Scalars['ID']['input'];
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  state?: InputMaybe<PaymentState>;
  trackerId?: InputMaybe<Scalars['ID']['input']>;
};

export type UpdateCityInput = {
  city?: InputMaybe<CityInput>;
  id: Scalars['ID']['input'];
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateCompanyInput = {
  additionalInfos?: InputMaybe<Array<CreateOrUpdateMyAdditionalInfoInput>>;
  annualTurnover?: InputMaybe<FinancialAmountInput>;
  businessActivityIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  businessEmail?: InputMaybe<Scalars['String']['input']>;
  businessPhone?: InputMaybe<Scalars['String']['input']>;
  businessProfit?: InputMaybe<FinancialAmountInput>;
  companyOwnershipStructure?: InputMaybe<CompanyOwnershipStructure>;
  companyTypeId?: InputMaybe<Scalars['ID']['input']>;
  controlSchema?: InputMaybe<Scalars['String']['input']>;
  countryOfIncorporationId?: InputMaybe<Scalars['ID']['input']>;
  dateOfIncorporation?: InputMaybe<Scalars['DateTime']['input']>;
  detailsSourceOfWealth?: InputMaybe<Array<DetailSourceOfWealthInput>>;
  employmentIncome?: InputMaybe<FinancialAmountInput>;
  faxNumber?: InputMaybe<Scalars['String']['input']>;
  finalDecision?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  incomingPaymentsByCountries?: InputMaybe<Array<PaymentFlowByCountryInput>>;
  incomingPaymentsByCurrencies?: InputMaybe<Array<PaymentFlowByCurrencyInput>>;
  isInternalTransferAllowed?: InputMaybe<Scalars['Boolean']['input']>;
  loan?: InputMaybe<FinancialAmountInput>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  otherPlannedAccountUse?: InputMaybe<Scalars['String']['input']>;
  otherPurposeForAccountOpening?: InputMaybe<Scalars['String']['input']>;
  otherReasonsForAccountOpening?: InputMaybe<Scalars['String']['input']>;
  otherSourceOfFunds?: InputMaybe<Scalars['String']['input']>;
  otherSourceOfWealth?: InputMaybe<Scalars['String']['input']>;
  outgoingPaymentsByCountries?: InputMaybe<Array<PaymentFlowByCountryInput>>;
  outgoingPaymentsByCurrencies?: InputMaybe<Array<PaymentFlowByCurrencyInput>>;
  paidUpShareCapital?: InputMaybe<FinancialAmountInput>;
  plannedAccountUse?: InputMaybe<Array<Scalars['String']['input']>>;
  purposeForAccountOpening?: InputMaybe<Array<Scalars['String']['input']>>;
  reasonsForAccountOpening?: InputMaybe<Array<Scalars['String']['input']>>;
  registeredBusinessName?: InputMaybe<Scalars['String']['input']>;
  registrationLocation?: InputMaybe<Scalars['String']['input']>;
  registrationNumber?: InputMaybe<Scalars['String']['input']>;
  savingsAndDeposit?: InputMaybe<FinancialAmountInput>;
  scoringRiskLevel?: InputMaybe<ScoringRiskLevelEnum>;
  service?: InputMaybe<Scalars['String']['input']>;
  share?: InputMaybe<Scalars['Float']['input']>;
  sourceOfFunds?: InputMaybe<Array<Scalars['String']['input']>>;
  sourceOfWealth?: InputMaybe<Array<Scalars['String']['input']>>;
  taxNumber?: InputMaybe<Scalars['String']['input']>;
  totalNumberOfEmployees?: InputMaybe<Scalars['String']['input']>;
  totalScore?: InputMaybe<Scalars['String']['input']>;
  tradingName?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateCompanyTypeDataInput = {
  code?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateCompanyTypeInput = {
  companyType: UpdateCompanyTypeDataInput;
  id: Scalars['String']['input'];
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateContinentInput = {
  continent?: InputMaybe<ContinentInput>;
  id: Scalars['ID']['input'];
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateCountryInput = {
  country?: InputMaybe<CountryInput>;
  id: Scalars['ID']['input'];
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateCurrencyInput = {
  currency?: InputMaybe<CurrencyInput>;
  id: Scalars['ID']['input'];
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateDocumentConfigInput = {
  availableCountryIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateDocumentFieldConfigInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  displayInTable?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<DocumentFieldType>;
};

export type UpdateDocumentFieldInput = {
  id: Scalars['ID']['input'];
  value?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateDocumentInput = {
  externalRejectReasons?: InputMaybe<Scalars['String']['input']>;
  fileIds?: InputMaybe<Array<Scalars['String']['input']>>;
  fileUrls?: InputMaybe<Array<Scalars['String']['input']>>;
  id: Scalars['ID']['input'];
  internalRejectReasons?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  rejectTags?: InputMaybe<Array<Scalars['String']['input']>>;
  status?: InputMaybe<DocumentStatus>;
};

export type UpdateExchangeInfoInput = {
  owner: ExchangeService;
  rawData: Scalars['String']['input'];
};

export type UpdateExtraInput = {
  data: Scalars['JSON']['input'];
  key: Scalars['String']['input'];
};

export type UpdateIntermediaryInput = {
  accountTypes?: InputMaybe<Array<InternalAccountType>>;
  beneficiaryAccountNumber?: InputMaybe<Scalars['String']['input']>;
  beneficiaryAddress?: InputMaybe<Scalars['String']['input']>;
  beneficiaryBIC?: InputMaybe<Scalars['String']['input']>;
  beneficiaryBank?: InputMaybe<Scalars['String']['input']>;
  beneficiaryIBAN?: InputMaybe<Scalars['String']['input']>;
  beneficiaryName?: InputMaybe<Scalars['String']['input']>;
  beneficiarySortCode?: InputMaybe<Scalars['String']['input']>;
  companyCountriesAlpha3?: InputMaybe<Array<Scalars['String']['input']>>;
  currenciesTickers?: InputMaybe<Array<Scalars['String']['input']>>;
  forbiddenNACECodes?: InputMaybe<Array<Scalars['String']['input']>>;
  id: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  userCountriesAlpha3?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type UpdateKybConfigInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateKybStepInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  providerConfig?: InputMaybe<Scalars['JSON']['input']>;
};

export type UpdateKycConfigInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateKycStepInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  providerConfig?: InputMaybe<Scalars['JSON']['input']>;
};

export type UpdateLanguageInput = {
  id: Scalars['ID']['input'];
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  language?: InputMaybe<LanguageInput>;
};

export type UpdateMemberInput = {
  attachCompanies?: InputMaybe<Array<Scalars['ID']['input']>>;
  detachCompanies?: InputMaybe<Array<Scalars['ID']['input']>>;
  id: Scalars['ID']['input'];
  pep?: InputMaybe<MemberPepInput>;
  positions?: InputMaybe<Array<Scalars['String']['input']>>;
  share?: InputMaybe<Scalars['Float']['input']>;
  type?: InputMaybe<CompanyMemberType>;
};

export type UpdateMyAdditionalInfoInput = {
  id: Scalars['ID']['input'];
  key?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<AdditionalInfoTypeEnum>;
  value?: InputMaybe<Scalars['AdditionalInfoValue']['input']>;
};

export type UpdateMyAddressInput = {
  attachCategoryIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  buildingName?: InputMaybe<Scalars['String']['input']>;
  buildingNumber?: InputMaybe<Scalars['String']['input']>;
  /** id of city from dictionary-microservice */
  cityId?: InputMaybe<Scalars['ID']['input']>;
  /** additional comment */
  comment?: InputMaybe<Scalars['String']['input']>;
  /** id of country from dictionary-microservice */
  countryId?: InputMaybe<Scalars['ID']['input']>;
  detachCategoryIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  flatNumber?: InputMaybe<Scalars['String']['input']>;
  geoLatitude?: InputMaybe<Scalars['String']['input']>;
  geoLongitude?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  isActual?: InputMaybe<Scalars['Boolean']['input']>;
  isLegal?: InputMaybe<Scalars['Boolean']['input']>;
  /** should be true if current address is primary for user */
  isPrimary?: InputMaybe<Scalars['Boolean']['input']>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  rawCityName?: InputMaybe<Scalars['String']['input']>;
  rawCityNameEn?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  stateEn?: InputMaybe<Scalars['String']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
  streetEn?: InputMaybe<Scalars['String']['input']>;
  subStreet?: InputMaybe<Scalars['String']['input']>;
  subStreetEn?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateMyCompanyInput = {
  addresses?: InputMaybe<Array<UpdateMyAddressInput>>;
  annualTurnover?: InputMaybe<FinancialAmountInput>;
  businessActivityIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  businessEmail?: InputMaybe<Scalars['String']['input']>;
  businessPhone?: InputMaybe<Scalars['String']['input']>;
  businessProfit?: InputMaybe<FinancialAmountInput>;
  companyOwnershipStructure?: InputMaybe<CompanyOwnershipStructure>;
  companyTypeId?: InputMaybe<Scalars['ID']['input']>;
  controlSchema?: InputMaybe<Scalars['String']['input']>;
  countryOfIncorporationId?: InputMaybe<Scalars['ID']['input']>;
  dateOfIncorporation?: InputMaybe<Scalars['DateTime']['input']>;
  detailsSourceOfWealth?: InputMaybe<Array<DetailSourceOfWealthInput>>;
  employmentIncome?: InputMaybe<FinancialAmountInput>;
  faxNumber?: InputMaybe<Scalars['String']['input']>;
  finalDecision?: InputMaybe<Scalars['String']['input']>;
  incomingPaymentsByCountries?: InputMaybe<Array<PaymentFlowByCountryInput>>;
  incomingPaymentsByCurrencies?: InputMaybe<Array<PaymentFlowByCurrencyInput>>;
  isInternalTransferAllowed?: InputMaybe<Scalars['Boolean']['input']>;
  loan?: InputMaybe<FinancialAmountInput>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  otherPlannedAccountUse?: InputMaybe<Scalars['String']['input']>;
  otherPurposeForAccountOpening?: InputMaybe<Scalars['String']['input']>;
  otherReasonsForAccountOpening?: InputMaybe<Scalars['String']['input']>;
  otherSourceOfFunds?: InputMaybe<Scalars['String']['input']>;
  otherSourceOfWealth?: InputMaybe<Scalars['String']['input']>;
  outgoingPaymentsByCountries?: InputMaybe<Array<PaymentFlowByCountryInput>>;
  outgoingPaymentsByCurrencies?: InputMaybe<Array<PaymentFlowByCurrencyInput>>;
  paidUpShareCapital?: InputMaybe<FinancialAmountInput>;
  plannedAccountUse?: InputMaybe<Array<Scalars['String']['input']>>;
  purposeForAccountOpening?: InputMaybe<Array<Scalars['String']['input']>>;
  reasonsForAccountOpening?: InputMaybe<Array<Scalars['String']['input']>>;
  registeredBusinessName?: InputMaybe<Scalars['String']['input']>;
  registrationLocation?: InputMaybe<Scalars['String']['input']>;
  registrationNumber?: InputMaybe<Scalars['String']['input']>;
  savingsAndDeposit?: InputMaybe<FinancialAmountInput>;
  scoringRiskLevel?: InputMaybe<ScoringRiskLevelEnum>;
  share?: InputMaybe<Scalars['Float']['input']>;
  sourceOfFunds?: InputMaybe<Array<Scalars['String']['input']>>;
  sourceOfWealth?: InputMaybe<Array<Scalars['String']['input']>>;
  taxNumber?: InputMaybe<Scalars['String']['input']>;
  totalNumberOfEmployees?: InputMaybe<Scalars['String']['input']>;
  totalScore?: InputMaybe<Scalars['String']['input']>;
  tradingName?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateMyCompanyMemberInput = {
  attachCompanies?: InputMaybe<Array<Scalars['ID']['input']>>;
  detachCompanies?: InputMaybe<Array<Scalars['ID']['input']>>;
  id: Scalars['ID']['input'];
  pep?: InputMaybe<MemberPepInput>;
  positions?: InputMaybe<Array<Scalars['String']['input']>>;
  share?: InputMaybe<Scalars['Float']['input']>;
  type?: InputMaybe<CompanyMemberType>;
  user?: InputMaybe<UpdateMyCompanyMemberUserInput>;
};

export type UpdateMyCompanyMemberUserInput = {
  addresses?: InputMaybe<Array<UpdateMyAddressInput>>;
  adverseMedia?: InputMaybe<Scalars['Boolean']['input']>;
  birthDate?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  expectedAnnualTurnover?: InputMaybe<Scalars['BigNumber']['input']>;
  gender?: InputMaybe<Gender>;
  isFamilyMemberPep?: InputMaybe<Scalars['Boolean']['input']>;
  isPep?: InputMaybe<Scalars['Boolean']['input']>;
  isUsa?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<FullNameInput>;
  nationality?: InputMaybe<Scalars['String']['input']>;
  nationalityCountryId?: InputMaybe<Scalars['ID']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  placeOfBirthAddressId?: InputMaybe<Scalars['ID']['input']>;
  placeOfBirthCountryId?: InputMaybe<Scalars['ID']['input']>;
  plannedAccountUse?: InputMaybe<Array<PlannedAccountUse>>;
  plannedAccountUseOther?: InputMaybe<Scalars['String']['input']>;
  reasonForAccountOpening?: InputMaybe<ReasonForAccountOpeningInput>;
  residenceCountryId?: InputMaybe<Scalars['ID']['input']>;
  sanctionList?: InputMaybe<Scalars['Boolean']['input']>;
  scoring?: InputMaybe<Scalars['Float']['input']>;
  scoringRiskLevel?: InputMaybe<ScoringRiskLevelEnum>;
  screeningReasons?: InputMaybe<Scalars['String']['input']>;
  termsAndConditions?: InputMaybe<Scalars['Boolean']['input']>;
  terroristList?: InputMaybe<Scalars['Boolean']['input']>;
  tin?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateMyDocumentsInput = {
  documents: Array<UserIdentityDocInput>;
};

export type UpdateMyPaymentTemplateInput = {
  amount?: InputMaybe<Scalars['BigNumber']['input']>;
  approverId?: InputMaybe<Scalars['String']['input']>;
  attachmentId?: InputMaybe<Scalars['String']['input']>;
  category?: InputMaybe<PaymentCategory>;
  creatorId?: InputMaybe<Scalars['String']['input']>;
  creditor?: InputMaybe<PaymentTemplatePartyInput>;
  /** Creditor auth user id */
  creditorId?: InputMaybe<Scalars['String']['input']>;
  currencyTicker?: InputMaybe<Scalars['String']['input']>;
  debtor?: InputMaybe<PaymentTemplatePartyInput>;
  documentNo?: InputMaybe<Scalars['String']['input']>;
  documentNoOrDate?: InputMaybe<Scalars['String']['input']>;
  isChosen?: InputMaybe<Scalars['Boolean']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  reason?: InputMaybe<PaymentReason>;
  receipt?: InputMaybe<Scalars['String']['input']>;
  schedule?: InputMaybe<Scalars['DateTime']['input']>;
  templateId: Scalars['String']['input'];
  type?: InputMaybe<PaymentType>;
  vat?: InputMaybe<Scalars['BigNumber']['input']>;
};

export type UpdateMyPersonalInput = {
  addresses?: InputMaybe<Array<UpdateMyAddressInput>>;
  adverseMedia?: InputMaybe<Scalars['Boolean']['input']>;
  birthDate?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  expectedAnnualTurnover?: InputMaybe<Scalars['BigNumber']['input']>;
  gender?: InputMaybe<Gender>;
  isFamilyMemberPep?: InputMaybe<Scalars['Boolean']['input']>;
  isPep?: InputMaybe<Scalars['Boolean']['input']>;
  isUsa?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<FullNameInput>;
  nationality?: InputMaybe<Scalars['String']['input']>;
  nationalityCountryId?: InputMaybe<Scalars['ID']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  placeOfBirthAddressId?: InputMaybe<Scalars['ID']['input']>;
  placeOfBirthCountryId?: InputMaybe<Scalars['ID']['input']>;
  plannedAccountUse?: InputMaybe<Array<PlannedAccountUse>>;
  plannedAccountUseOther?: InputMaybe<Scalars['String']['input']>;
  reasonForAccountOpening?: InputMaybe<ReasonForAccountOpeningInput>;
  residenceCountryId?: InputMaybe<Scalars['ID']['input']>;
  sanctionList?: InputMaybe<Scalars['Boolean']['input']>;
  scoring?: InputMaybe<Scalars['Float']['input']>;
  scoringRiskLevel?: InputMaybe<ScoringRiskLevelEnum>;
  screeningReasons?: InputMaybe<Scalars['String']['input']>;
  termsAndConditions?: InputMaybe<Scalars['Boolean']['input']>;
  terroristList?: InputMaybe<Scalars['Boolean']['input']>;
  tin?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateNaceCodeDataInput = {
  code?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  section?: InputMaybe<UpdateNaceCodeSectionDataInput>;
};

export type UpdateNaceCodeInput = {
  id: Scalars['String']['input'];
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  naceCode: UpdateNaceCodeDataInput;
};

export type UpdateNaceCodeSectionDataInput = {
  code?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateNumberRangeInput = {
  id: Scalars['ID']['input'];
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  numberRange?: InputMaybe<NumberRangeInput>;
};

/**
 * Description: input to update an operation
 *
 * Example:
 *
 *
 *
 * {
 *
 *
 * "titleToFind": "BUYCRYPTO",
 *
 *
 * "title": "SELLCRYPTO",
 *
 *
 * "verificationTypes": ["SMS", "EMAIL"]
 *
 *
 * }
 */
export type UpdateOperationInput = {
  /**
   * Required: false
   *
   * Description: indicates that resending the 2fa code will increase the resend timer
   *
   * Format:
   *
   *         boolean
   *
   *
   * Example:
   *
   *         false
   */
  isTimeUp?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Required: false
   *
   * Description: title to replace
   *
   * Format:
   *
   *         string parameters from custom enum
   *
   *
   * Example:
   *
   *         "BUYCRYPTO"
   */
  title?: InputMaybe<Scalars['String']['input']>;
  /**
   * Required: true
   *
   * Description: search for title to change
   *
   * Format:
   *
   *         string parameters from custom enum
   *
   *
   * Example:
   *
   *         "BUYCRYPTO"
   */
  titleToFind: Scalars['String']['input'];
  /**
   * Required: false
   *
   * Description: two-factor authentication type
   *
   * Format:
   *
   *         array of string parameters from custom enum
   *
   *
   * Example:
   *
   *         ["SMS", "EMAIL"]
   */
  verificationTypes?: InputMaybe<Array<TfaType>>;
};

export type UpdatePaymentInput = {
  id: Scalars['ID']['input'];
  state: PaymentState;
};

export type UpdatePersonalInput = {
  addresses?: InputMaybe<Array<UpdateMyAddressInput>>;
  adverseMedia?: InputMaybe<Scalars['Boolean']['input']>;
  birthDate?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  expectedAnnualTurnover?: InputMaybe<Scalars['BigNumber']['input']>;
  gender?: InputMaybe<Gender>;
  isFamilyMemberPep?: InputMaybe<Scalars['Boolean']['input']>;
  isPep?: InputMaybe<Scalars['Boolean']['input']>;
  isUsa?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<FullNameInput>;
  nationality?: InputMaybe<Scalars['String']['input']>;
  nationalityCountryId?: InputMaybe<Scalars['ID']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  placeOfBirthAddressId?: InputMaybe<Scalars['ID']['input']>;
  placeOfBirthCountryId?: InputMaybe<Scalars['ID']['input']>;
  plannedAccountUse?: InputMaybe<Array<PlannedAccountUse>>;
  plannedAccountUseOther?: InputMaybe<Scalars['String']['input']>;
  reasonForAccountOpening?: InputMaybe<ReasonForAccountOpeningInput>;
  residenceCountryId?: InputMaybe<Scalars['ID']['input']>;
  sanctionList?: InputMaybe<Scalars['Boolean']['input']>;
  scoring?: InputMaybe<Scalars['Float']['input']>;
  scoringRiskLevel?: InputMaybe<ScoringRiskLevelEnum>;
  screeningReasons?: InputMaybe<Scalars['String']['input']>;
  termsAndConditions?: InputMaybe<Scalars['Boolean']['input']>;
  terroristList?: InputMaybe<Scalars['Boolean']['input']>;
  tin?: InputMaybe<Scalars['String']['input']>;
  userId: Scalars['ID']['input'];
};

export type UpdatePositionInput = {
  id: Scalars['ID']['input'];
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  position?: InputMaybe<PositionInput>;
};

export type UpdateRegionInput = {
  id: Scalars['ID']['input'];
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  region?: InputMaybe<RegionInput>;
};

export type UpdateScoringRiskLevelInput = {
  id: Scalars['String']['input'];
  max?: InputMaybe<Scalars['Int']['input']>;
  min?: InputMaybe<Scalars['Int']['input']>;
  /** LOW_RISK, MEDIUM_RISK, HIGH_RISK, VERY_HIGH_RISK, PROHIBITED_RISK */
  scoringRiskLevel?: InputMaybe<ScoringRiskLevelEnum>;
};

export type UpdateTariffClientInput = {
  billingPeriod?: InputMaybe<Scalars['String']['input']>;
  clientCategory?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  tariffId?: InputMaybe<Scalars['ID']['input']>;
};

export type UpdateTariffCommissionFactorInput = {
  amountFrom?: InputMaybe<Scalars['BigNumber']['input']>;
  amountTo?: InputMaybe<Scalars['BigNumber']['input']>;
  conditions?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  fixed?: InputMaybe<Scalars['BigNumber']['input']>;
  formula?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  max?: InputMaybe<Scalars['BigNumber']['input']>;
  min?: InputMaybe<Scalars['BigNumber']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Float']['input']>;
  percent?: InputMaybe<Scalars['BigNumber']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateTariffCommissionInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateTariffInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
};

export type UpdateTariffLimitInput = {
  annual: Scalars['BigNumber']['input'];
  daily: Scalars['BigNumber']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  max?: InputMaybe<Scalars['BigNumber']['input']>;
  min?: InputMaybe<Scalars['BigNumber']['input']>;
  monthly: Scalars['BigNumber']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  weekly: Scalars['BigNumber']['input'];
};

export type UpdateTariffLimitRestrictionInput = {
  currencyTicker?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  max?: InputMaybe<Scalars['BigNumber']['input']>;
  maxAnnual?: InputMaybe<Scalars['BigNumber']['input']>;
  maxDaily?: InputMaybe<Scalars['BigNumber']['input']>;
  maxMonthly?: InputMaybe<Scalars['BigNumber']['input']>;
  maxWeekly?: InputMaybe<Scalars['BigNumber']['input']>;
  min?: InputMaybe<Scalars['BigNumber']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateTariffOperationHistoryInput = {
  amount?: InputMaybe<Scalars['BigNumber']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<TariffOperationHistoryStatusEnum>;
  trackerId?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateTariffOperationInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateUnitInput = {
  id: Scalars['ID']['input'];
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  unit?: InputMaybe<UnitInput>;
};

export type UpdateVatInput = {
  id: Scalars['ID']['input'];
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  /** [Dictionary] VAT is Value Added Tax number/code of company or person */
  vat?: InputMaybe<VatInput>;
};

export type UpdateVirtualOrderStatusInput = {
  allocateIbanCalled?: InputMaybe<Scalars['Boolean']['input']>;
  allocateIbanMessageSent?: InputMaybe<Scalars['Boolean']['input']>;
  tag: ClearJunctionWalletEnum;
  userId: Scalars['ID']['input'];
};

export type UpdateWebhookInput = {
  data?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  type?: InputMaybe<Scalars['String']['input']>;
};

export type UploadSesion = {
  __typename?: 'UploadSesion';
  /** unix time */
  expiresAt: Scalars['Float']['output'];
  id: Scalars['ID']['output'];
  /** to be implemented */
  serviceName: Scalars['String']['output'];
  /** shows if uploading was successful. If session expired it is still 'created' status */
  status: UploadSessionStatus;
  /** file must be uploaded on this url by POST request via form-data */
  url: Scalars['String']['output'];
  /** session creator */
  user: User;
};

export enum UploadSessionStatus {
  Created = 'created',
  Successful = 'successful'
}

export type User = {
  __typename?: 'User';
  /** @deprecated Outdated. Will be removed in the future */
  absCustomer?: Maybe<Customer>;
  accounts?: Maybe<Array<Maybe<Account>>>;
  addresses?: Maybe<Addresses>;
  avatar: File;
  avatarId?: Maybe<Scalars['String']['output']>;
  blockReasons?: Maybe<Array<Scalars['String']['output']>>;
  createdAt: Scalars['DateTime']['output'];
  /** @deprecated Outdated. Use currentKYCLevelStatusV2 field. */
  currentKYCLevelStatus?: Maybe<KycLevelStatus>;
  currentKYCLevelStatusV2?: Maybe<KycLevelStatusV2>;
  documents?: Maybe<Array<Maybe<UserIdentityDoc>>>;
  expiringDocuments?: Maybe<Scalars['JSON']['output']>;
  id: Scalars['ID']['output'];
  /** @deprecated Outdated. Use kycLevelStatusesV2 field. */
  kycLevelStatuses: KycLevelStatuses;
  kycLevelStatusesV2: KycLevelStatusesV2;
  /** @deprecated Outdated. Will be removed in the future */
  kycStep?: Maybe<Scalars['Float']['output']>;
  personal: UserPersonal;
  role: RoleEnum;
  service: Scalars['String']['output'];
  status: StatusEnum;
  tariffClient?: Maybe<TariffClient>;
  updatedAt: Scalars['DateTime']['output'];
  userId: Scalars['String']['output'];
};


export type UserAccountsArgs = {
  input: MyAccountsInput;
};


export type UserAddressesArgs = {
  input: FindUserAddressesInput;
};


export type UserKycLevelStatusesArgs = {
  input: FilterInput;
};


export type UserKycLevelStatusesV2Args = {
  input: FilterInput;
};

export type UserAddressForPayment = {
  __typename?: 'UserAddressForPayment';
  city: Scalars['String']['output'];
  country: Scalars['String']['output'];
  countryCodeAlpha2: Scalars['String']['output'];
  countryCodeAlpha3: Scalars['String']['output'];
  state?: Maybe<Scalars['String']['output']>;
  street: Scalars['String']['output'];
  zip: Scalars['String']['output'];
};

export type UserCard = {
  __typename?: 'UserCard';
  bin: Scalars['String']['output'];
  cardCategory?: Maybe<Scalars['String']['output']>;
  cardType?: Maybe<Scalars['String']['output']>;
  checkoutId: Scalars['String']['output'];
  expiryMonth: Scalars['Float']['output'];
  expiryYear: Scalars['Float']['output'];
  fingerprint: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  issuer?: Maybe<Scalars['String']['output']>;
  issuerCountry?: Maybe<Scalars['String']['output']>;
  last4: Scalars['String']['output'];
  productId?: Maybe<Scalars['String']['output']>;
  productType?: Maybe<Scalars['String']['output']>;
  scheme?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
  userId: Scalars['String']['output'];
};

/**
 * Description: input data for getting the remaining code lifetime
 *
 * Example:
 *
 *
 *
 * {
 *
 *
 * "codeType": "REGISTRATION",
 *
 *
 * "identity": "test-email@yourcompany. com",
 *
 *
 * "service": "BANXEID"
 *
 *
 * }
 */
export type UserCodeInfoInput = {
  /**
   * Required: true
   *
   * Description: code type
   *
   * Format:
   *
   *         string parameter from custom enum
   *
   *
   * Example:
   *
   *         "REGISTRATION"
   */
  codeType: SendCode;
  /**
   * Required: true
   *
   * Description: field containing the email address or phone number to which the OneTimeCode should be sent
   *
   * Format:
   *
   *         string containing a phone number or email address
   *
   *
   * Example:
   *
   *         "test-email@yourcompany.com"
   */
  identity: Scalars['String']['input'];
  /**
   * Required: true
   *
   * Description: service type
   *
   * Format:
   *
   *         string parameter from custom enum
   *
   *
   * Example:
   *
   *         "BANXEID"
   */
  service: Scalars['String']['input'];
};

export enum UserCountryType {
  Nationality = 'NATIONALITY',
  PlaceOfBirth = 'PLACE_OF_BIRTH',
  Residence = 'RESIDENCE'
}

export type UserDocumentForPayment = {
  __typename?: 'UserDocumentForPayment';
  expirationDate: Scalars['String']['output'];
  issuedBy?: Maybe<Scalars['String']['output']>;
  issuedCountryCode: Scalars['String']['output'];
  issuedDate: Scalars['String']['output'];
  number: Scalars['String']['output'];
  type: UserIdentityType;
};

export type UserFilterInput = {
  isKycPassed?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UserFull = {
  __typename?: 'UserFull';
  EOS?: Maybe<PublicKeyInfo>;
  avatar?: Maybe<File>;
  birthDate?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  email?: Maybe<DeviceInfo>;
  firstName?: Maybe<Scalars['String']['output']>;
  gender?: Maybe<GenderEnum>;
  lastName?: Maybe<Scalars['String']['output']>;
  leadId?: Maybe<Scalars['String']['output']>;
  p256?: Maybe<PublicKeyInfo>;
  phone?: Maybe<DeviceInfo>;
  role: Scalars['String']['output'];
  service: Scalars['String']['output'];
  status: StatusEnum;
  updatedAt: Scalars['DateTime']['output'];
  userId: Scalars['String']['output'];
  username?: Maybe<Scalars['String']['output']>;
};

export type UserIdentityDoc = {
  __typename?: 'UserIdentityDoc';
  doc: IdentityDoc;
  /** Front or back side of document. Null if only one side of document is uploaded. */
  subType?: Maybe<UserIdentitySubType>;
  type: UserIdentityType;
};

export type UserIdentityDocInput = {
  /** Country where code was created. ISO 3166-1 alpha-3 */
  country: Scalars['String']['input'];
  /** Id of file from files-microservice. Make sure that it is available for current user */
  fileId: Scalars['ID']['input'];
  /** Front or back side of document. Complete this only if both sides of document are uploading, otherwise send null */
  subType?: InputMaybe<UserIdentitySubType>;
  /** Type of document */
  type: UserIdentityType;
};

export enum UserIdentitySubType {
  BackSide = 'BACK_SIDE',
  FrontSide = 'FRONT_SIDE'
}

export enum UserIdentityType {
  Agreement = 'AGREEMENT',
  BankCard = 'BANK_CARD',
  BankStatement = 'BANK_STATEMENT',
  Contract = 'CONTRACT',
  Drivers = 'DRIVERS',
  DriversTranslation = 'DRIVERS_TRANSLATION',
  EmploymentCertificate = 'EMPLOYMENT_CERTIFICATE',
  IdCard = 'ID_CARD',
  IdDocPhoto = 'ID_DOC_PHOTO',
  IncomeSource = 'INCOME_SOURCE',
  InvestorDoc = 'INVESTOR_DOC',
  Other = 'OTHER',
  Passport = 'PASSPORT',
  PaymentMethod = 'PAYMENT_METHOD',
  ProfileImage = 'PROFILE_IMAGE',
  ResidencePermit = 'RESIDENCE_PERMIT',
  Selfie = 'SELFIE',
  UtilityBill = 'UTILITY_BILL',
  VehicleRegistrationCertificate = 'VEHICLE_REGISTRATION_CERTIFICATE',
  VideoSelfie = 'VIDEO_SELFIE'
}

export type UserInput = {
  avatarId?: InputMaybe<Scalars['String']['input']>;
  birthDate?: InputMaybe<Scalars['DateTime']['input']>;
  captcha: ReCaptchaInput;
  code: Scalars['String']['input'];
  device: Device;
  firstName?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<GenderEnum>;
  identity: Scalars['String']['input'];
  lastName?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  realEmail?: InputMaybe<Scalars['String']['input']>;
  /** Referral program participant code */
  referralCode?: InputMaybe<Scalars['String']['input']>;
  /** Region client (e.g. DE, US, CH) */
  region?: InputMaybe<Scalars['String']['input']>;
  service: Scalars['String']['input'];
  srp?: InputMaybe<SrpInfo>;
  username?: InputMaybe<Scalars['String']['input']>;
};

export type UserPaymentsInput = {
  accountIds?: InputMaybe<Array<Scalars['String']['input']>>;
  cardIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  dateRange?: InputMaybe<DateRangeInput>;
  filter?: InputMaybe<Filter>;
  isSystems?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  schema?: InputMaybe<PaymentSchema>;
  service?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<CommonSort>;
  sortOrder?: InputMaybe<SortOrder>;
  trackerId?: InputMaybe<Scalars['ID']['input']>;
  userId: Scalars['String']['input'];
};

export type UserPersonal = {
  __typename?: 'UserPersonal';
  /** @deprecated Outdated. Will be removed in the future. Use scoringProfile field */
  adverseMedia?: Maybe<Scalars['Boolean']['output']>;
  birthDate?: Maybe<Scalars['DateTime']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  expectedAnnualTurnover?: Maybe<Scalars['BigNumber']['output']>;
  gender?: Maybe<Gender>;
  /** @deprecated Outdated. Will be removed in the future. Use scoringProfile field */
  isFamilyMemberPep?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Outdated. Will be removed in the future. Use scoringProfile field */
  isPep?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Outdated. Will be removed in the future. Use scoringProfile field */
  isUsa?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<IdentityFullName>;
  /** @deprecated Outdated. Will be removed in the future. Use nationalityCountry field */
  nationality?: Maybe<Scalars['String']['output']>;
  nationalityCountry?: Maybe<Country>;
  phone?: Maybe<Scalars['String']['output']>;
  placeOfBirth?: Maybe<Country>;
  plannedAccountUse?: Maybe<Array<PlannedAccountUse>>;
  plannedAccountUseOther?: Maybe<Scalars['String']['output']>;
  reasonForAccountOpening?: Maybe<ReasonForAccountOpeningType>;
  residenceCountry?: Maybe<Country>;
  /** @deprecated Outdated. Will be removed in the future. Use scoringProfile field */
  sanctionList?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Outdated. Will be removed in the future. Use scoringProfile field */
  scoring?: Maybe<Scalars['Float']['output']>;
  scoringProfile?: Maybe<UserScoringProfile>;
  /** @deprecated Outdated. Will be removed in the future. Use scoringProfile field */
  scoringRiskLevel?: Maybe<ScoringRiskLevelEnum>;
  screeningReasons?: Maybe<Scalars['String']['output']>;
  termsAndConditions?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Outdated. Will be removed in the future. Use scoringProfile field */
  terroristList?: Maybe<Scalars['Boolean']['output']>;
  tin?: Maybe<Scalars['String']['output']>;
};

export type UserPersonalDataForPayment = {
  __typename?: 'UserPersonalDataForPayment';
  address: UserAddressForPayment;
  birthDate: Scalars['String']['output'];
  birthPlace: Scalars['String']['output'];
  document: UserDocumentForPayment;
  email?: Maybe<Scalars['String']['output']>;
  firstName: Scalars['String']['output'];
  lastName: Scalars['String']['output'];
  middleName?: Maybe<Scalars['String']['output']>;
  nationalityCountryCode?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
};

export type UserScoringProfile = {
  __typename?: 'UserScoringProfile';
  adverseMedia?: Maybe<Scalars['Boolean']['output']>;
  isFamilyMemberPep?: Maybe<Scalars['Boolean']['output']>;
  isPep?: Maybe<Scalars['Boolean']['output']>;
  isUsa?: Maybe<Scalars['Boolean']['output']>;
  sanctionList?: Maybe<Scalars['Boolean']['output']>;
  scoringRiskLevel?: Maybe<ScoringRiskLevelEnum>;
  terroristList?: Maybe<Scalars['Boolean']['output']>;
  totalScore?: Maybe<Scalars['Float']['output']>;
};

export enum UserSortFieldEnum {
  CreatedAt = 'CREATED_AT',
  FullName = 'FULL_NAME',
  FullNameEn = 'FULL_NAME_EN',
  UpdatedAt = 'UPDATED_AT'
}

export type UserSortInput = {
  direction: SortOrder;
  field: UserSortFieldEnum;
};

export enum UserTariff {
  BanxePlus = 'BANXE_PLUS'
}

export type UserTopUpLimits = {
  __typename?: 'UserTopUpLimits';
  dailyAvailable: Scalars['BigNumber']['output'];
  dailyLimit: Scalars['Float']['output'];
  minimalLimit: Scalars['Float']['output'];
  monthlyAvailable: Scalars['BigNumber']['output'];
  monthlyLimit: Scalars['Float']['output'];
  monthlyLimitResetDate?: Maybe<Scalars['String']['output']>;
  transactionLimit: Scalars['Float']['output'];
  userId: Scalars['String']['output'];
};

export type Users = {
  __typename?: 'Users';
  count: Scalars['Int']['output'];
  cursor: Scalars['Int']['output'];
  nodes: Array<User>;
};

export type UsersFull = {
  __typename?: 'UsersFull';
  count: Scalars['Int']['output'];
  cursor: Scalars['Int']['output'];
  nodes: Array<UserFull>;
};

export type Vat = {
  __typename?: 'VAT';
  id: Scalars['ID']['output'];
  item: CommonDictItem;
};

export type VAccount = {
  __typename?: 'VAccount';
  /** Virtual account number of IBAN. */
  accountNumberOrIBAN: Scalars['String']['output'];
  /** Fiat currency alpha3 code. */
  currency: Scalars['String']['output'];
  /** Financial institution. */
  fiIntegration: AccountFiIntegration;
  id: Scalars['ID']['output'];
  realAccount: Account;
  userId: Scalars['ID']['output'];
};

export type VabsAccBankDetails = {
  __typename?: 'VabsAccBankDetails';
  /** Currencies with routes */
  bankDetails: Array<VabsAccBankDetailsCurrencyWithRoutes>;
  virtualAccountId: Scalars['ID']['output'];
};

export type VabsAccBankDetailsCountry = {
  __typename?: 'VabsAccBankDetailsCountry';
  alpha2: Scalars['String']['output'];
  alpha3: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type VabsAccBankDetailsCurrencyWithRoutes = {
  __typename?: 'VabsAccBankDetailsCurrencyWithRoutes';
  currency: VabsCurrency;
  currencyId: Scalars['String']['output'];
  /** Payment routes */
  routes: Array<VabsAccBankDetailsRouteUnion>;
};

export type VabsAccBankDetailsInner = {
  __typename?: 'VabsAccBankDetailsInner';
  virtualAccountId: Scalars['String']['output'];
};

export type VabsAccBankDetailsInnerRoute = {
  __typename?: 'VabsAccBankDetailsInnerRoute';
  details: VabsAccBankDetailsInner;
  schema: VabsAccBankDetailsSchemaEnum;
};

export type VabsAccBankDetailsRouteUnion = VabsAccBankDetailsInnerRoute | VabsAccBankDetailsSwiftRoute;

export enum VabsAccBankDetailsSchemaEnum {
  Inner = 'INNER',
  Swift = 'SWIFT'
}

export type VabsAccBankDetailsSwift = {
  __typename?: 'VabsAccBankDetailsSwift';
  beneficiary: VabsAccBankDetailsSwiftBeneficiary;
  beneficiaryBank: VabsAccBankDetailsSwiftBeneficiaryBank;
  correspondentBanks: Array<VabsAccBankDetailsSwiftCorrespondentBank>;
  remittanceInformation: Array<Scalars['String']['output']>;
};

export type VabsAccBankDetailsSwiftBeneficiary = {
  __typename?: 'VabsAccBankDetailsSwiftBeneficiary';
  address: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type VabsAccBankDetailsSwiftBeneficiaryBank = {
  __typename?: 'VabsAccBankDetailsSwiftBeneficiaryBank';
  account: Scalars['String']['output'];
  address?: Maybe<Scalars['String']['output']>;
  code: Scalars['String']['output'];
  country?: Maybe<VabsAccBankDetailsCountry>;
  name: Scalars['String']['output'];
};

export type VabsAccBankDetailsSwiftCorrespondentBank = {
  __typename?: 'VabsAccBankDetailsSwiftCorrespondentBank';
  account?: Maybe<Scalars['String']['output']>;
  address?: Maybe<Scalars['String']['output']>;
  code: Scalars['String']['output'];
  country?: Maybe<VabsAccBankDetailsCountry>;
  name?: Maybe<Scalars['String']['output']>;
};

export type VabsAccBankDetailsSwiftRoute = {
  __typename?: 'VabsAccBankDetailsSwiftRoute';
  details: VabsAccBankDetailsSwift;
  schema: VabsAccBankDetailsSchemaEnum;
};

export type VabsAccCreateMyAccountBalancesInput = {
  currencyIds: Array<Scalars['String']['input']>;
  virtualAccountId: Scalars['ID']['input'];
};

export type VabsAccFindMyVirtualAccountsInput = {
  categories?: InputMaybe<Array<Scalars['String']['input']>>;
  createdAt?: InputMaybe<VabsPeriodInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  ledgerTypes?: InputMaybe<Array<VabsLedgerAccountType>>;
  pagination?: InputMaybe<VabsPaginationInput>;
  parentIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  pluginsProcessIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  realAccountsIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  references?: InputMaybe<Array<VabsFindByReferenceInput>>;
  search?: InputMaybe<Scalars['String']['input']>;
  statuses?: InputMaybe<Array<VabsEntityStatus>>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  types?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type VabsAccFindMyVirtualBalancesInput = {
  createdAt?: InputMaybe<VabsPeriodInput>;
  currencyIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  currencyTickers?: InputMaybe<Array<Scalars['String']['input']>>;
  description?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  networkNames?: InputMaybe<Array<Scalars['String']['input']>>;
  pagination?: InputMaybe<VabsPaginationInput>;
  pluginsProcessId?: InputMaybe<Scalars['ID']['input']>;
  references?: InputMaybe<Array<VabsFindByReferenceInput>>;
  search?: InputMaybe<Scalars['String']['input']>;
  statuses?: InputMaybe<Array<Scalars['String']['input']>>;
  virtualAccountId: Scalars['ID']['input'];
};

export type VabsAccMyBankDetailsInput = {
  currencyIds?: InputMaybe<Array<Scalars['String']['input']>>;
  virtualAccountId: Scalars['ID']['input'];
};

export type VabsApiError = {
  __typename?: 'VabsApiError';
  code: Scalars['String']['output'];
  message?: Maybe<Scalars['String']['output']>;
  path?: Maybe<Scalars['String']['output']>;
  response?: Maybe<VabsApiErrorResponse>;
  status?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type VabsApiErrorInput = {
  code: Scalars['String']['input'];
  message?: InputMaybe<Scalars['String']['input']>;
  path?: InputMaybe<Scalars['String']['input']>;
  response?: InputMaybe<VabsApiErrorResponseInput>;
  status?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type VabsApiErrorResponse = {
  __typename?: 'VabsApiErrorResponse';
  code?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
};

export type VabsApiErrorResponseInput = {
  code?: InputMaybe<Scalars['String']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
};

export type VabsAttachDetachInput = {
  attach?: InputMaybe<Array<Scalars['ID']['input']>>;
  detach?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type VabsAttachDetachReferencesInput = {
  attach?: InputMaybe<Array<VabsCreateReferenceInput>>;
  detach?: InputMaybe<Array<VabsCreateReferenceInput>>;
};

export type VabsAuditBalances = {
  /** Filter only balances that remain negative after correction. */
  onlyNegativeAfterCorrection?: InputMaybe<Scalars['Boolean']['input']>;
  /** Real balance IDs to audit. Not provided: audit all balances. Empty array: skip real balances. Array with IDs: audit only specified balances. */
  realBalanceIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Virtual balance IDs to audit. Not provided: audit all balances. Empty array: skip virtual balances. Array with IDs: audit only specified balances. */
  virtualBalanceIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type VabsAuditBalancesReport = {
  __typename?: 'VabsAuditBalancesReport';
  realBalances: VabsAuditRealBalancesSection;
  virtualBalances: VabsAuditVirtualBalancesSection;
};

export type VabsAuditRealBalanceResult = {
  __typename?: 'VabsAuditRealBalanceResult';
  corrected: VabsRealBalance;
  current: VabsRealBalance;
  transactionHistory: Array<VabsAuditRealBalanceTransactionHistory>;
};

export type VabsAuditRealBalanceTransactionHistory = {
  __typename?: 'VabsAuditRealBalanceTransactionHistory';
  balanceSnapshot: VabsRealBalance;
  transaction: VabsRealTransaction;
};

export type VabsAuditRealBalancesSection = {
  __typename?: 'VabsAuditRealBalancesSection';
  balances: Array<VabsAuditRealBalanceResult>;
  broken: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type VabsAuditVirtualBalanceResult = {
  __typename?: 'VabsAuditVirtualBalanceResult';
  corrected: VabsVirtualBalance;
  current: VabsVirtualBalance;
  transactionHistory: Array<VabsAuditVirtualBalanceTransactionHistoryType>;
};

export type VabsAuditVirtualBalanceTransactionHistoryType = {
  __typename?: 'VabsAuditVirtualBalanceTransactionHistoryType';
  balanceSnapshot: VabsVirtualBalance;
  transaction: VabsVirtualTransaction;
};

export type VabsAuditVirtualBalancesSection = {
  __typename?: 'VabsAuditVirtualBalancesSection';
  balances: Array<VabsAuditVirtualBalanceResult>;
  broken: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type VabsAuthorizationData = {
  __typename?: 'VabsAuthorizationData';
  key: Scalars['String']['output'];
  label: Scalars['String']['output'];
};

export type VabsAuthorizationInstanceData = {
  __typename?: 'VabsAuthorizationInstanceData';
  methods: Array<VabsAuthorizationData>;
  name: Scalars['String']['output'];
};

export type VabsBasePaymentMethodExternalClientAddressInput = {
  countryId: Scalars['String']['input'];
  line1: Scalars['String']['input'];
  line2?: InputMaybe<Scalars['String']['input']>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
};

export type VabsBasePaymentMethodExternalClientAddressType = {
  __typename?: 'VabsBasePaymentMethodExternalClientAddressType';
  country: VabsDictionaryCountry;
  line1: Scalars['String']['output'];
  line2?: Maybe<Scalars['String']['output']>;
  postalCode?: Maybe<Scalars['String']['output']>;
};

export type VabsBasePaymentMethodExternalClientBankInput = {
  addressLine1?: InputMaybe<Scalars['String']['input']>;
  addressLine2?: InputMaybe<Scalars['String']['input']>;
  cityName?: InputMaybe<Scalars['String']['input']>;
  countryId: Scalars['String']['input'];
  name: Scalars['String']['input'];
  postalCode?: InputMaybe<Scalars['String']['input']>;
};

export type VabsBasePaymentMethodExternalClientBankType = {
  __typename?: 'VabsBasePaymentMethodExternalClientBankType';
  addressLine1?: Maybe<Scalars['String']['output']>;
  addressLine2?: Maybe<Scalars['String']['output']>;
  cityName?: Maybe<Scalars['String']['output']>;
  country: VabsDictionaryCountry;
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  postalCode?: Maybe<Scalars['String']['output']>;
};

export type VabsBasePaymentMethodExternalClientInput = {
  accountHolderName: Scalars['String']['input'];
  accountNumber: Scalars['String']['input'];
  address: VabsBasePaymentMethodExternalClientAddressInput;
  bank: VabsBasePaymentMethodExternalClientBankInput;
  bankCode: Scalars['String']['input'];
  branchCode?: InputMaybe<Scalars['String']['input']>;
  clientType: VabsPaymentClientTypeEnum;
  firstName?: InputMaybe<Scalars['String']['input']>;
  intermediaryBank?: InputMaybe<VabsBasePaymentMethodIntermediaryBankInput>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  middleName?: InputMaybe<Scalars['String']['input']>;
};

export type VabsBasePaymentMethodExternalClientType = {
  __typename?: 'VabsBasePaymentMethodExternalClientType';
  accountHolderName: Scalars['String']['output'];
  accountNumber: Scalars['String']['output'];
  address: VabsBasePaymentMethodExternalClientAddressType;
  bank: VabsBasePaymentMethodExternalClientBankType;
  bankCode: Scalars['String']['output'];
  branchCode: Scalars['String']['output'];
  clientType: VabsPaymentClientTypeEnum;
  firstName?: Maybe<Scalars['String']['output']>;
  intermediaryBank?: Maybe<VabsBasePaymentMethodIntermediaryBankType>;
  lastName?: Maybe<Scalars['String']['output']>;
  middleName?: Maybe<Scalars['String']['output']>;
};

export type VabsBasePaymentMethodIntermediaryBankInput = {
  accountNumber?: InputMaybe<Scalars['String']['input']>;
  addressLine1?: InputMaybe<Scalars['String']['input']>;
  addressLine2?: InputMaybe<Scalars['String']['input']>;
  bankCode: Scalars['String']['input'];
  cityName?: InputMaybe<Scalars['String']['input']>;
  countryId?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type VabsBasePaymentMethodIntermediaryBankType = {
  __typename?: 'VabsBasePaymentMethodIntermediaryBankType';
  accountNumber?: Maybe<Scalars['String']['output']>;
  addressLine1?: Maybe<Scalars['String']['output']>;
  addressLine2?: Maybe<Scalars['String']['output']>;
  bankCode?: Maybe<Scalars['String']['output']>;
  cityName?: Maybe<Scalars['String']['output']>;
  country?: Maybe<VabsDictionaryCountry>;
  name?: Maybe<Scalars['String']['output']>;
};

export type VabsBasePaymentMethodInternalClientBankType = {
  __typename?: 'VabsBasePaymentMethodInternalClientBankType';
  addressLine1?: Maybe<Scalars['String']['output']>;
  addressLine2?: Maybe<Scalars['String']['output']>;
  cityName?: Maybe<Scalars['String']['output']>;
  country?: Maybe<VabsDictionaryCountry>;
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  postalCode?: Maybe<Scalars['String']['output']>;
};

export type VabsBasePaymentMethodInternalClientInput = {
  accountId: Scalars['String']['input'];
};

export type VabsBasePaymentMethodInternalClientType = {
  __typename?: 'VabsBasePaymentMethodInternalClientType';
  accountHolderName: Scalars['String']['output'];
  accountNumber?: Maybe<Scalars['String']['output']>;
  bank?: Maybe<VabsBasePaymentMethodInternalClientBankType>;
  bankCode?: Maybe<Scalars['String']['output']>;
};

export type VabsBsbPaymentType = {
  __typename?: 'VabsBsbPaymentType';
  amount: VabsPaymentAmountType;
  createdAt: Scalars['VabsDateTime']['output'];
  direction: VabsPaymentDirection;
  external: VabsBasePaymentMethodExternalClientType;
  fee: VabsPaymentFeeType;
  id: Scalars['ID']['output'];
  internal: VabsBasePaymentMethodInternalClientType;
  note?: Maybe<Scalars['String']['output']>;
  paymentSystem: VabsPaymentSystem;
  purposeOfPayment: Scalars['String']['output'];
  recipient?: Maybe<VabsPaymentClientType>;
  sender?: Maybe<VabsPaymentClientType>;
  settled?: Maybe<Scalars['VabsDateTime']['output']>;
  sourceOfFunds?: Maybe<VabsPaymentSourceOfFunds>;
  status: VabsPaymentStatus;
  totalAmount: VabsPaymentTotalAmountType;
  updatedAt: Scalars['VabsDateTime']['output'];
};

export enum VabsChangeBalanceType {
  Freeze = 'FREEZE',
  Release = 'RELEASE',
  Unfreeze = 'UNFREEZE'
}

export type VabsChangeRealBalanceInput = {
  amount: Scalars['VabsBigNumber']['input'];
  realBalance: VabsRelatedEntityInput;
  status: VabsChangeBalanceType;
  transferType: VabsTransferType;
};

export type VabsChangeVirtualBalanceInput = {
  amount: Scalars['VabsBigNumber']['input'];
  status: VabsChangeBalanceType;
  transferType: VabsTransferType;
  virtualBalance: VabsRelatedEntityInput;
};

export type VabsClient = {
  __typename?: 'VabsClient';
  category: Scalars['String']['output'];
  createdAt: Scalars['VabsTimestamp']['output'];
  deletedAt?: Maybe<Scalars['VabsTimestamp']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  externalId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  metadata?: Maybe<Scalars['VabsJSON']['output']>;
  operations: VabsOperations;
  pluginsProcessId?: Maybe<Scalars['ID']['output']>;
  project: VabsProject;
  references: Array<VabsReference>;
  status: Scalars['String']['output'];
  type: Scalars['String']['output'];
  updatedAt: Scalars['VabsTimestamp']['output'];
  virtualAccounts: VabsVirtualAccounts;
  virtualTransactions: VabsVirtualTransactions;
};


export type VabsClientOperationsArgs = {
  input?: VabsFilterInput;
};


export type VabsClientVirtualAccountsArgs = {
  input?: VabsFilterInput;
};


export type VabsClientVirtualTransactionsArgs = {
  input?: VabsFilterInput;
};

export type VabsClientCategoryStatistic = {
  __typename?: 'VabsClientCategoryStatistic';
  corporate: Scalars['Int']['output'];
  individual: Scalars['Int']['output'];
  service: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type VabsClients = {
  __typename?: 'VabsClients';
  count: Scalars['Int']['output'];
  cursor: Scalars['Int']['output'];
  nodes: Array<VabsClient>;
};

export type VabsCoreUnion = VabsCurrency | VabsHistoryRate | VabsNetwork;

export type VabsCreateBsbPaymentInput = {
  attachmentIds: Array<Scalars['String']['input']>;
  external: VabsBasePaymentMethodExternalClientInput;
  internal: VabsBasePaymentMethodInternalClientInput;
  note?: InputMaybe<Scalars['String']['input']>;
  purposeOfPayment: Scalars['String']['input'];
  sourceCurrencyId: Scalars['String']['input'];
  sourceOfFunds: VabsPaymentSourceOfFunds;
  targetAmount: Scalars['VabsBigNumber']['input'];
  targetCurrencyId: Scalars['String']['input'];
};

export type VabsCreateClientInput = {
  category: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  externalId?: InputMaybe<Scalars['ID']['input']>;
  metadata?: InputMaybe<Scalars['VabsJSON']['input']>;
  pluginsProcessId?: InputMaybe<Scalars['ID']['input']>;
  project: VabsRelatedEntityInput;
  references?: InputMaybe<Array<VabsCreateReferenceInput>>;
  status: Scalars['String']['input'];
  type: Scalars['String']['input'];
  virtualAccounts?: InputMaybe<Array<VabsCreateVirtualAccountForClientInput>>;
};

export type VabsCreateCurrencyInput = {
  decimals: Scalars['Int']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  metadata?: InputMaybe<Scalars['VabsJSON']['input']>;
  network: VabsRelatedEntityInput;
  references?: InputMaybe<Array<VabsCreateReferenceInput>>;
  ticker: Scalars['String']['input'];
};

export type VabsCreateHistoryRateCrudInput = {
  baseCurrency: VabsRelatedEntityInput;
  createdAt: Scalars['VabsTimestamp']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  operations?: InputMaybe<Array<VabsRelatedEntityInput>>;
  pluginsProcessId?: InputMaybe<Scalars['ID']['input']>;
  priceInBase: Scalars['VabsBigNumber']['input'];
  quoteCurrency: VabsRelatedEntityInput;
  realTransactions?: InputMaybe<Array<VabsRelatedEntityInput>>;
  virtualTransactions?: InputMaybe<Array<VabsRelatedEntityInput>>;
};

export type VabsCreateHistoryRateInput = {
  baseCurrency: VabsRelatedEntityInput;
  createdAt: Scalars['VabsTimestamp']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  metadata?: InputMaybe<Scalars['VabsJSON']['input']>;
  priceInBase: Scalars['VabsBigNumber']['input'];
  quoteCurrency: VabsRelatedEntityInput;
  references?: InputMaybe<Array<VabsCreateReferenceInput>>;
};

export type VabsCreateHistoryRateSettingInput = {
  convertCurrencies: Array<VabsRelatedEntityInput>;
  filterCurrencies: Array<VabsRelatedEntityInput>;
  transactionTypes?: InputMaybe<Array<VabsTransactionType>>;
  transferTypes?: InputMaybe<Array<VabsTransferType>>;
};

export type VabsCreateIfscPaymentInput = {
  attachmentIds: Array<Scalars['String']['input']>;
  external: VabsBasePaymentMethodExternalClientInput;
  internal: VabsBasePaymentMethodInternalClientInput;
  note?: InputMaybe<Scalars['String']['input']>;
  purposeOfPayment: Scalars['String']['input'];
  sourceCurrencyId: Scalars['String']['input'];
  sourceOfFunds: VabsPaymentSourceOfFunds;
  targetAmount: Scalars['VabsBigNumber']['input'];
  targetCurrencyId: Scalars['String']['input'];
};

export type VabsCreateIndividualHistoryRateInput = {
  baseCurrency: VabsRelatedEntityInput;
  createdAt: Scalars['VabsTimestamp']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  isIndividual?: Scalars['Boolean']['input'];
  priceInBase: Scalars['VabsBigNumber']['input'];
  quoteCurrency: VabsRelatedEntityInput;
};

export type VabsCreateInnerPaymentInput = {
  attachmentIds: Array<Scalars['String']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  recipientAccountId: Scalars['String']['input'];
  recipientClientId: Scalars['ID']['input'];
  recipientEmail?: InputMaybe<Scalars['String']['input']>;
  recipientPhoneNumber?: InputMaybe<Scalars['String']['input']>;
  senderAccountId: Scalars['String']['input'];
  sourceCurrencyId: Scalars['String']['input'];
  targetAmount: Scalars['VabsBigNumber']['input'];
  targetCurrencyId: Scalars['String']['input'];
};

export type VabsCreateNetworkInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  metadata?: InputMaybe<Scalars['VabsJSON']['input']>;
  name: Scalars['String']['input'];
  references?: InputMaybe<Array<VabsCreateReferenceInput>>;
};

export type VabsCreateOperationInput = {
  client: VabsRelatedEntityInput;
  description?: InputMaybe<Scalars['String']['input']>;
  externalOperationId?: InputMaybe<Scalars['ID']['input']>;
  historyRates?: InputMaybe<Array<VabsCreateIndividualHistoryRateInput>>;
  metadata?: InputMaybe<Scalars['VabsJSON']['input']>;
  name: Scalars['String']['input'];
  realTransactions?: InputMaybe<Array<VabsCreateRealTransactionForOperationInput>>;
  references?: InputMaybe<Array<VabsCreateReferenceInput>>;
  virtualTransactions: Array<VabsCreateVirtualTransactionForOperationInput>;
};

export type VabsCreatePaymentMethodInput = {
  availableCountryIds: Array<Scalars['String']['input']>;
  availableCurrencyIds: Array<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  participantTypes: Array<VabsParticipantType>;
  type: VabsPaymentSystem;
};

export type VabsCreateProjectInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  metadata?: InputMaybe<Scalars['VabsJSON']['input']>;
  name: Scalars['String']['input'];
  references?: InputMaybe<Array<VabsCreateReferenceInput>>;
};

export type VabsCreateProviderConfigInput = {
  config: Scalars['VabsJSON']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  provider: VabsRelatedEntityInput;
};

export type VabsCreateProviderCurrencyMappingInput = {
  currency: VabsRelatedEntityInput;
  decimals: Scalars['Int']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  provider: VabsRelatedEntityInput;
  providerCurrency: VabsRelatedEntityInput;
};

export type VabsCreateProviderInput = {
  category?: InputMaybe<Scalars['String']['input']>;
  conditions?: InputMaybe<Scalars['VabsJSON']['input']>;
  config?: InputMaybe<VabsProviderConfigInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  metadata?: InputMaybe<Scalars['VabsJSON']['input']>;
  name: Scalars['String']['input'];
  project: VabsRelatedEntityInput;
  realAccounts?: InputMaybe<Array<VabsCreateRealAccountForProviderInput>>;
  references?: InputMaybe<Array<VabsCreateReferenceInput>>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type VabsCreateRealAccountForProviderInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  ledgerType: VabsLedgerAccountType;
  metadata?: InputMaybe<Scalars['VabsJSON']['input']>;
  operations?: InputMaybe<Array<VabsRelatedEntityInput>>;
  pluginsProcessId?: InputMaybe<Scalars['ID']['input']>;
  providerExternalId?: InputMaybe<Scalars['ID']['input']>;
  realBalances?: InputMaybe<Array<VabsRealBalanceInput>>;
  references?: InputMaybe<Array<VabsCreateReferenceInput>>;
  requisites: Scalars['VabsJSON']['input'];
  tag?: InputMaybe<Scalars['String']['input']>;
  type: Scalars['String']['input'];
  virtualAccounts?: InputMaybe<Array<VabsRelatedEntityInput>>;
};

export type VabsCreateRealAccountInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  ledgerType: VabsLedgerAccountType;
  metadata?: InputMaybe<Scalars['VabsJSON']['input']>;
  operations?: InputMaybe<Array<VabsRelatedEntityInput>>;
  pluginsProcessId?: InputMaybe<Scalars['ID']['input']>;
  provider: VabsRelatedEntityInput;
  providerExternalId?: InputMaybe<Scalars['ID']['input']>;
  realBalances?: InputMaybe<Array<VabsRealBalanceInput>>;
  references?: InputMaybe<Array<VabsCreateReferenceInput>>;
  requisites: Scalars['VabsJSON']['input'];
  tag?: InputMaybe<Scalars['String']['input']>;
  type: Scalars['String']['input'];
  virtualAccounts?: InputMaybe<Array<VabsRelatedEntityInput>>;
};

export type VabsCreateRealBalanceHistoryInput = {
  availableAmount: Scalars['VabsBigNumber']['input'];
  availableAmountDelta: Scalars['VabsBigNumber']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  endDate: Scalars['Int']['input'];
  firstTransaction?: InputMaybe<VabsRelatedEntityInput>;
  holdAmount: Scalars['VabsBigNumber']['input'];
  holdAmountDelta: Scalars['VabsBigNumber']['input'];
  lastTransaction?: InputMaybe<VabsRelatedEntityInput>;
  realBalance?: InputMaybe<VabsRelatedEntityInput>;
  startDate: Scalars['Int']['input'];
  totalAmount: Scalars['VabsBigNumber']['input'];
  totalAmountDelta: Scalars['VabsBigNumber']['input'];
};

export type VabsCreateRealBalanceInput = {
  currency: VabsRelatedEntityInput;
  description?: InputMaybe<Scalars['String']['input']>;
  metadata?: InputMaybe<Scalars['VabsJSON']['input']>;
  realAccount: VabsRelatedEntityInput;
  references?: InputMaybe<Array<VabsCreateReferenceInput>>;
  status: Scalars['String']['input'];
  type: Scalars['String']['input'];
};

export type VabsCreateRealTransactionAccountInput = {
  amount: Scalars['VabsBigNumber']['input'];
  currency: VabsRelatedEntityInput;
  description?: InputMaybe<Scalars['String']['input']>;
  metadata?: InputMaybe<Scalars['VabsJSON']['input']>;
  realAccount: VabsRelatedEntityInput;
  realTransaction: VabsRelatedEntityInput;
  references?: InputMaybe<Array<VabsCreateReferenceInput>>;
  type: VabsRealTransactionAddressType;
};

export type VabsCreateRealTransactionForOperationInput = {
  amount: Scalars['VabsBigNumber']['input'];
  currency: VabsRelatedEntityInput;
  description?: InputMaybe<Scalars['String']['input']>;
  historyRates?: InputMaybe<Array<VabsCreateIndividualHistoryRateInput>>;
  metadata?: InputMaybe<Scalars['VabsJSON']['input']>;
  order: Scalars['Int']['input'];
  providerTxId?: InputMaybe<Scalars['ID']['input']>;
  rawTxData?: InputMaybe<Scalars['String']['input']>;
  realAccount: VabsRelatedEntityInput;
  references?: InputMaybe<Array<VabsCreateReferenceInput>>;
  transferType: VabsTransferType;
};

export type VabsCreateRealTransactionInput = {
  amount: Scalars['VabsBigNumber']['input'];
  currency: VabsRelatedEntityInput;
  description?: InputMaybe<Scalars['String']['input']>;
  historyRates?: InputMaybe<Array<VabsCreateHistoryRateInput>>;
  metadata?: InputMaybe<Scalars['VabsJSON']['input']>;
  operation: VabsRelatedEntityInput;
  order: Scalars['Int']['input'];
  providerTxId?: InputMaybe<Scalars['ID']['input']>;
  rawTxData?: InputMaybe<Scalars['String']['input']>;
  realAccount: VabsRelatedEntityInput;
  references?: InputMaybe<Array<VabsCreateReferenceInput>>;
  transferType: VabsTransferType;
};

export type VabsCreateReferenceInput = {
  name: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export type VabsCreateReportInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  metadata?: InputMaybe<Scalars['VabsJSON']['input']>;
  operation: VabsRelatedEntityInput;
  references?: InputMaybe<Array<VabsCreateReferenceInput>>;
  virtualBalanceAfter?: InputMaybe<Scalars['VabsBigNumber']['input']>;
  virtualBalanceBefore?: InputMaybe<Scalars['VabsBigNumber']['input']>;
};

export type VabsCreateSwiftPaymentInput = {
  attachmentIds: Array<Scalars['String']['input']>;
  external: VabsBasePaymentMethodExternalClientInput;
  internal: VabsBasePaymentMethodInternalClientInput;
  note?: InputMaybe<Scalars['String']['input']>;
  purposeOfPayment: Scalars['String']['input'];
  sourceCurrencyId: Scalars['String']['input'];
  sourceOfFunds: VabsPaymentSourceOfFunds;
  targetAmount: Scalars['VabsBigNumber']['input'];
  targetCurrencyId: Scalars['String']['input'];
};

export type VabsCreateVirtualAccountForClientInput = {
  category: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  ledgerType: VabsLedgerAccountType;
  metadata?: InputMaybe<Scalars['VabsJSON']['input']>;
  operations?: InputMaybe<Array<VabsRelatedEntityInput>>;
  parent?: InputMaybe<VabsRelatedEntityInput>;
  pluginsProcessId?: InputMaybe<Scalars['ID']['input']>;
  realAccounts?: InputMaybe<Array<VabsRelatedEntityInput>>;
  references?: InputMaybe<Array<VabsCreateReferenceInput>>;
  tag?: InputMaybe<Scalars['String']['input']>;
  type: Scalars['String']['input'];
  virtualBalances?: InputMaybe<Array<VabsVirtualBalanceInput>>;
};

export type VabsCreateVirtualAccountInput = {
  category: Scalars['String']['input'];
  client: VabsRelatedEntityInput;
  description?: InputMaybe<Scalars['String']['input']>;
  ledgerType: VabsLedgerAccountType;
  metadata?: InputMaybe<Scalars['VabsJSON']['input']>;
  operations?: InputMaybe<Array<VabsRelatedEntityInput>>;
  parent?: InputMaybe<VabsRelatedEntityInput>;
  pluginsProcessId?: InputMaybe<Scalars['ID']['input']>;
  realAccounts?: InputMaybe<Array<VabsRelatedEntityInput>>;
  references?: InputMaybe<Array<VabsCreateReferenceInput>>;
  tag?: InputMaybe<Scalars['String']['input']>;
  type: Scalars['String']['input'];
  virtualBalances?: InputMaybe<Array<VabsVirtualBalanceInput>>;
};

export type VabsCreateVirtualBalanceHistoryInput = {
  availableAmount: Scalars['VabsBigNumber']['input'];
  availableAmountDelta: Scalars['VabsBigNumber']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  endDate: Scalars['Int']['input'];
  firstTransaction?: InputMaybe<VabsRelatedEntityInput>;
  holdAmount: Scalars['VabsBigNumber']['input'];
  holdAmountDelta: Scalars['VabsBigNumber']['input'];
  lastTransaction?: InputMaybe<VabsRelatedEntityInput>;
  startDate: Scalars['Int']['input'];
  totalAmount: Scalars['VabsBigNumber']['input'];
  totalAmountDelta: Scalars['VabsBigNumber']['input'];
  virtualBalance?: InputMaybe<VabsRelatedEntityInput>;
};

export type VabsCreateVirtualBalanceInput = {
  currency: VabsRelatedEntityInput;
  description?: InputMaybe<Scalars['String']['input']>;
  metadata?: InputMaybe<Scalars['VabsJSON']['input']>;
  pluginsProcessId?: InputMaybe<Scalars['ID']['input']>;
  references?: InputMaybe<Array<VabsCreateReferenceInput>>;
  status: Scalars['String']['input'];
  virtualAccount: VabsRelatedEntityInput;
};

export type VabsCreateVirtualTransactionForOperationInput = {
  amount: Scalars['VabsBigNumber']['input'];
  currency: VabsRelatedEntityInput;
  description?: InputMaybe<Scalars['String']['input']>;
  historyRates?: InputMaybe<Array<VabsCreateIndividualHistoryRateInput>>;
  metadata?: InputMaybe<Scalars['VabsJSON']['input']>;
  order: Scalars['Int']['input'];
  provider?: InputMaybe<VabsVirtualTransactionProviderInput>;
  providerTxId?: InputMaybe<Scalars['ID']['input']>;
  rawTxData?: InputMaybe<Scalars['String']['input']>;
  references?: InputMaybe<Array<VabsCreateReferenceInput>>;
  transferType: VabsTransferType;
  virtualAccount: VabsRelatedEntityInput;
};

export type VabsCreateVirtualTransactionInput = {
  amount: Scalars['VabsBigNumber']['input'];
  currency: VabsRelatedEntityInput;
  description?: InputMaybe<Scalars['String']['input']>;
  historyRates?: InputMaybe<Array<VabsCreateHistoryRateInput>>;
  metadata?: InputMaybe<Scalars['VabsJSON']['input']>;
  operation: VabsRelatedEntityInput;
  order: Scalars['Int']['input'];
  providerTxId?: InputMaybe<Scalars['ID']['input']>;
  rawTxData?: InputMaybe<Scalars['String']['input']>;
  references?: InputMaybe<Array<VabsCreateReferenceInput>>;
  transferType: VabsTransferType;
  virtualAccount: VabsRelatedEntityInput;
};

export type VabsCurrencies = {
  __typename?: 'VabsCurrencies';
  count: Scalars['Int']['output'];
  cursor: Scalars['Int']['output'];
  nodes: Array<VabsCurrency>;
};

export type VabsCurrency = {
  __typename?: 'VabsCurrency';
  createdAt: Scalars['VabsTimestamp']['output'];
  decimals: Scalars['Int']['output'];
  deletedAt?: Maybe<Scalars['VabsTimestamp']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  metadata?: Maybe<Scalars['VabsJSON']['output']>;
  network: VabsNetwork;
  pluginsProcessId?: Maybe<Scalars['ID']['output']>;
  references: Array<VabsReference>;
  status: VabsEntityStatus;
  ticker: Scalars['String']['output'];
  updatedAt: Scalars['VabsTimestamp']['output'];
};

export type VabsDateRangeInput = {
  from?: InputMaybe<Scalars['VabsDateTime']['input']>;
  to?: InputMaybe<Scalars['VabsDateTime']['input']>;
};

export type VabsDictionaryCountry = {
  __typename?: 'VabsDictionaryCountry';
  id: Scalars['ID']['output'];
};

export type VabsDictionaryCurrency = {
  __typename?: 'VabsDictionaryCurrency';
  id: Scalars['ID']['output'];
};

export enum VabsDynamicEnums {
  AccountTypeEnum = 'AccountTypeEnum',
  BalanceStatusEnum = 'BalanceStatusEnum',
  ClientCategoryEnum = 'ClientCategoryEnum',
  ClientStatusEnum = 'ClientStatusEnum',
  ClientTypeEnum = 'ClientTypeEnum',
  EntityCategoryEnum = 'EntityCategoryEnum',
  ProviderTypeEnum = 'ProviderTypeEnum',
  RealBalanceTypeEnum = 'RealBalanceTypeEnum'
}

export enum VabsEntityName {
  Client = 'Client',
  Currency = 'Currency',
  HistoryRate = 'HistoryRate',
  HistoryRateSetting = 'HistoryRateSetting',
  Network = 'Network',
  Operation = 'Operation',
  Project = 'Project',
  Provider = 'Provider',
  ProviderConfig = 'ProviderConfig',
  ProviderCurrencyMapping = 'ProviderCurrencyMapping',
  RealAccount = 'RealAccount',
  RealBalance = 'RealBalance',
  RealBalanceHistory = 'RealBalanceHistory',
  RealTransaction = 'RealTransaction',
  RealTransactionAccount = 'RealTransactionAccount',
  Report = 'Report',
  VirtualAccount = 'VirtualAccount',
  VirtualBalance = 'VirtualBalance',
  VirtualBalanceHistory = 'VirtualBalanceHistory',
  VirtualTransaction = 'VirtualTransaction'
}

export enum VabsEntityStatus {
  Active = 'ACTIVE',
  Disabled = 'DISABLED'
}

export type VabsEntityStatusStatistic = {
  __typename?: 'VabsEntityStatusStatistic';
  active: Scalars['Int']['output'];
  disabled: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type VabsFailedBalanceReconciliation = {
  __typename?: 'VabsFailedBalanceReconciliation';
  currency: VabsCurrency;
  currencyId: Scalars['ID']['output'];
  difference: Scalars['String']['output'];
  totalRealBalance: Scalars['String']['output'];
  totalVirtualBalance: Scalars['String']['output'];
};

export type VabsFailedBalanceReconciliations = {
  __typename?: 'VabsFailedBalanceReconciliations';
  count: Scalars['Int']['output'];
  nodes: Array<VabsFailedBalanceReconciliation>;
};

export type VabsFailedTransactionBalanceReconciliation = {
  __typename?: 'VabsFailedTransactionBalanceReconciliation';
  currency: VabsCurrency;
  currencyId: Scalars['ID']['output'];
  difference: Scalars['String']['output'];
  totalBalance: Scalars['String']['output'];
  totalCredit: Scalars['String']['output'];
  totalDebit: Scalars['String']['output'];
};

export type VabsFailedTransactionBalanceReconciliations = {
  __typename?: 'VabsFailedTransactionBalanceReconciliations';
  count: Scalars['Int']['output'];
  nodes: Array<VabsFailedTransactionBalanceReconciliation>;
};

export type VabsFailedTransactionReconciliation = {
  __typename?: 'VabsFailedTransactionReconciliation';
  currency: VabsCurrency;
  currencyId: Scalars['ID']['output'];
  difference: Scalars['String']['output'];
  invalidOperations: Array<VabsOperation>;
  totalCredit: Scalars['String']['output'];
  totalDebit: Scalars['String']['output'];
};

export type VabsFailedTransactionReconciliations = {
  __typename?: 'VabsFailedTransactionReconciliations';
  count: Scalars['Int']['output'];
  nodes: Array<VabsFailedTransactionReconciliation>;
};

export type VabsFilterInput = {
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  pagination?: InputMaybe<VabsPaginationInput>;
};

export type VabsFindByReferenceInput = {
  name: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export type VabsFindClientsInput = {
  accountIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  categories?: InputMaybe<Array<Scalars['String']['input']>>;
  createdAt?: InputMaybe<VabsPeriodInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  externalIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  operationIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  pagination?: InputMaybe<VabsPaginationInput>;
  pluginsProcessIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  projects?: InputMaybe<Array<Scalars['String']['input']>>;
  references?: InputMaybe<Array<VabsFindByReferenceInput>>;
  search?: InputMaybe<Scalars['String']['input']>;
  statuses?: InputMaybe<Array<Scalars['String']['input']>>;
  transactionIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  types?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type VabsFindCurrenciesInput = {
  createdAt?: InputMaybe<VabsPeriodInput>;
  decimals?: InputMaybe<Array<Scalars['Int']['input']>>;
  description?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  networkIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  networkNames?: InputMaybe<Array<Scalars['String']['input']>>;
  pagination?: InputMaybe<VabsPaginationInput>;
  references?: InputMaybe<Array<VabsFindByReferenceInput>>;
  search?: InputMaybe<Scalars['String']['input']>;
  statuses?: InputMaybe<Array<VabsEntityStatus>>;
  tickers?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type VabsFindHistoryRateSettingsInput = {
  baseCurrencyIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  pagination?: InputMaybe<VabsPaginationInput>;
  quoteCurrencyIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  transactionTypes?: InputMaybe<Array<VabsTransactionType>>;
  transferTypes?: InputMaybe<Array<VabsTransferType>>;
};

export type VabsFindHistoryRatesInput = {
  baseCurrenciesIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  description?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  pagination?: InputMaybe<VabsPaginationInput>;
  quoteCurrenciesIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  references?: InputMaybe<Array<VabsFindByReferenceInput>>;
  search?: InputMaybe<Scalars['String']['input']>;
};

export type VabsFindNetworksInput = {
  createdAt?: InputMaybe<VabsPeriodInput>;
  currencyIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  description?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  name?: InputMaybe<Scalars['String']['input']>;
  pagination?: InputMaybe<VabsPaginationInput>;
  references?: InputMaybe<Array<VabsFindByReferenceInput>>;
  search?: InputMaybe<Scalars['String']['input']>;
  statuses?: InputMaybe<Array<VabsEntityStatus>>;
};

export type VabsFindOperationsInput = {
  accountIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  clientIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  createdAt?: InputMaybe<VabsPeriodInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  externalOperationIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  name?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Array<VabsOrderByInput>>;
  pagination?: InputMaybe<VabsPaginationInput>;
  providerIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  rateIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  references?: InputMaybe<Array<VabsFindByReferenceInput>>;
  search?: InputMaybe<Scalars['String']['input']>;
  statuses?: InputMaybe<Array<VabsOperationStatus>>;
  transactionIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type VabsFindPaymentMethodsInput = {
  countryIds?: InputMaybe<Array<Scalars['String']['input']>>;
  currencyIds?: InputMaybe<Array<Scalars['String']['input']>>;
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<VabsPaginationInput>;
  participantTypes?: InputMaybe<Array<VabsParticipantType>>;
  paymentSystems?: InputMaybe<Array<VabsPaymentSystem>>;
};

export type VabsFindPaymentsInput = {
  clientIds?: InputMaybe<Array<Scalars['String']['input']>>;
  currencyIds?: InputMaybe<Array<Scalars['String']['input']>>;
  dateRange?: InputMaybe<VabsDateRangeInput>;
  directions?: InputMaybe<Array<VabsPaymentDirection>>;
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  isFavorite?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<VabsPaginationInput>;
  paymentSystems?: InputMaybe<Array<VabsPaymentSystem>>;
  search?: InputMaybe<Scalars['String']['input']>;
  sourceCurrencyIds?: InputMaybe<Array<Scalars['String']['input']>>;
  statuses?: InputMaybe<Array<VabsPaymentStatus>>;
  targetCurrencyIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type VabsFindPluginsInput = {
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  statuses?: InputMaybe<Array<VabsPluginStatus>>;
};

export type VabsFindPluginsTrackingInput = {
  entityNames?: InputMaybe<Array<VabsEntityName>>;
  hooks?: InputMaybe<Array<VabsHooks>>;
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  pagination?: InputMaybe<VabsPaginationInput>;
  pluginIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  processIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  statuses?: InputMaybe<Array<VabsPluginTrackingStatus>>;
};

export type VabsFindProjectsInput = {
  clientIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  createdAt?: InputMaybe<VabsPeriodInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  name?: InputMaybe<Scalars['String']['input']>;
  pagination?: InputMaybe<VabsPaginationInput>;
  providers?: InputMaybe<Array<Scalars['String']['input']>>;
  references?: InputMaybe<Array<VabsFindByReferenceInput>>;
  search?: InputMaybe<Scalars['String']['input']>;
  statuses?: InputMaybe<Array<VabsEntityStatus>>;
};

export type VabsFindProviderConfigsInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  pagination?: InputMaybe<VabsPaginationInput>;
  providerIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  search?: InputMaybe<Scalars['String']['input']>;
  statuses?: InputMaybe<Array<VabsEntityStatus>>;
};

export type VabsFindProvidersCurrenciesMappingInput = {
  currenciesIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  description?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  pagination?: InputMaybe<VabsPaginationInput>;
  providerCurrenciesIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  providersIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type VabsFindProvidersInput = {
  accountIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  categories?: InputMaybe<Array<Scalars['String']['input']>>;
  createdAt?: InputMaybe<VabsPeriodInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  name?: InputMaybe<Scalars['String']['input']>;
  operationIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  pagination?: InputMaybe<VabsPaginationInput>;
  projects?: InputMaybe<Array<Scalars['String']['input']>>;
  providerConfigIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  references?: InputMaybe<Array<VabsFindByReferenceInput>>;
  search?: InputMaybe<Scalars['String']['input']>;
  statuses?: InputMaybe<Array<VabsEntityStatus>>;
  transactionIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  types?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type VabsFindRealAccountsInput = {
  createdAt?: InputMaybe<VabsPeriodInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  pagination?: InputMaybe<VabsPaginationInput>;
  providerExternalIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  providerIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  references?: InputMaybe<Array<VabsFindByReferenceInput>>;
  requisites?: InputMaybe<Array<Scalars['String']['input']>>;
  search?: InputMaybe<Scalars['String']['input']>;
  statuses?: InputMaybe<Array<VabsEntityStatus>>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  types?: InputMaybe<Array<Scalars['String']['input']>>;
  virtualAccountsIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type VabsFindRealBalancesHistoriesInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  endDates?: InputMaybe<Array<Scalars['Int']['input']>>;
  firstTransactionIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  lastTransactionId?: InputMaybe<Array<Scalars['ID']['input']>>;
  pagination?: InputMaybe<VabsPaginationInput>;
  realBalancesIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  search?: InputMaybe<Scalars['String']['input']>;
  startDates?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type VabsFindRealBalancesInput = {
  createdAt?: InputMaybe<VabsPeriodInput>;
  currencyIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  description?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  pagination?: InputMaybe<VabsPaginationInput>;
  realAccountIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  references?: InputMaybe<Array<VabsFindByReferenceInput>>;
  search?: InputMaybe<Scalars['String']['input']>;
  statuses?: InputMaybe<Array<Scalars['String']['input']>>;
  types?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type VabsFindRealTransactionAccountsInput = {
  currencyIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  description?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  pagination?: InputMaybe<VabsPaginationInput>;
  realAccountIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  realTransactionIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  references?: InputMaybe<Array<VabsFindByReferenceInput>>;
  search?: InputMaybe<Scalars['String']['input']>;
  types?: InputMaybe<Array<VabsRealTransactionAddressType>>;
};

export type VabsFindRealTransactionsInput = {
  createdAt?: InputMaybe<VabsPeriodInput>;
  currencyIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  description?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  operationIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  orders?: InputMaybe<Array<Scalars['Int']['input']>>;
  pagination?: InputMaybe<VabsPaginationInput>;
  previousStatuses?: InputMaybe<Array<VabsTransactionStatus>>;
  providerIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  providerTxIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  realAccountIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  references?: InputMaybe<Array<VabsFindByReferenceInput>>;
  search?: InputMaybe<Scalars['String']['input']>;
  statuses?: InputMaybe<Array<VabsTransactionStatus>>;
};

export type VabsFindReportsInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  operationsIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  pagination?: InputMaybe<VabsPaginationInput>;
  references?: InputMaybe<Array<VabsFindByReferenceInput>>;
  search?: InputMaybe<Scalars['String']['input']>;
};

export type VabsFindVirtualAccountsInput = {
  categories?: InputMaybe<Array<Scalars['String']['input']>>;
  clientIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  createdAt?: InputMaybe<VabsPeriodInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  ledgerTypes?: InputMaybe<Array<VabsLedgerAccountType>>;
  pagination?: InputMaybe<VabsPaginationInput>;
  parentIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  pluginsProcessIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  realAccountsIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  references?: InputMaybe<Array<VabsFindByReferenceInput>>;
  search?: InputMaybe<Scalars['String']['input']>;
  statuses?: InputMaybe<Array<VabsEntityStatus>>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  types?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type VabsFindVirtualBalancesHistoriesInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  endDates?: InputMaybe<Array<Scalars['Int']['input']>>;
  firstTransactionIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  lastTransactionId?: InputMaybe<Array<Scalars['ID']['input']>>;
  pagination?: InputMaybe<VabsPaginationInput>;
  search?: InputMaybe<Scalars['String']['input']>;
  startDates?: InputMaybe<Array<Scalars['Int']['input']>>;
  virtualBalancesIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type VabsFindVirtualBalancesInput = {
  createdAt?: InputMaybe<VabsPeriodInput>;
  currencyIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  currencyTickers?: InputMaybe<Array<Scalars['String']['input']>>;
  description?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  networkNames?: InputMaybe<Array<Scalars['String']['input']>>;
  pagination?: InputMaybe<VabsPaginationInput>;
  pluginsProcessId?: InputMaybe<Scalars['ID']['input']>;
  references?: InputMaybe<Array<VabsFindByReferenceInput>>;
  search?: InputMaybe<Scalars['String']['input']>;
  statuses?: InputMaybe<Array<Scalars['String']['input']>>;
  virtualAccountId?: InputMaybe<Scalars['ID']['input']>;
};

export type VabsFindVirtualBalancesPeriodHistoryInput = {
  endDate: Scalars['Float']['input'];
  startDate: Scalars['Float']['input'];
  virtualBalanceId: Scalars['String']['input'];
};

export type VabsFindVirtualTransactionsInput = {
  clientIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  createdAt?: InputMaybe<VabsPeriodInput>;
  currenciesIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  description?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  operationIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  orders?: InputMaybe<Array<Scalars['Int']['input']>>;
  pagination?: InputMaybe<VabsPaginationInput>;
  pluginsProcessIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  previousStatuses?: InputMaybe<Array<VabsTransactionStatus>>;
  references?: InputMaybe<Array<VabsFindByReferenceInput>>;
  search?: InputMaybe<Scalars['String']['input']>;
  statuses?: InputMaybe<Array<VabsTransactionStatus>>;
  transferTypes?: InputMaybe<Array<VabsTransferType>>;
  virtualAccountIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type VabsGetStatisticsInput = {
  period?: InputMaybe<VabsPeriodInput>;
};

export type VabsHistoryRate = {
  __typename?: 'VabsHistoryRate';
  baseCurrency: VabsCurrency;
  createdAt: Scalars['VabsTimestamp']['output'];
  deletedAt?: Maybe<Scalars['VabsTimestamp']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  metadata?: Maybe<Scalars['VabsJSON']['output']>;
  pluginsProcessId?: Maybe<Scalars['ID']['output']>;
  priceInBase: Scalars['VabsBigNumber']['output'];
  quoteCurrency: VabsCurrency;
  references: Array<VabsReference>;
  updatedAt: Scalars['VabsTimestamp']['output'];
};

export type VabsHistoryRateData = {
  __typename?: 'VabsHistoryRateData';
  baseCurrency: VabsRelatedEntity;
  createdAt: Scalars['VabsTimestamp']['output'];
  description?: Maybe<Scalars['String']['output']>;
  priceInBase: Scalars['VabsBigNumber']['output'];
  quoteCurrency: VabsRelatedEntity;
};

export type VabsHistoryRateSetting = {
  __typename?: 'VabsHistoryRateSetting';
  convertCurrencies: VabsCurrencies;
  createdAt: Scalars['VabsTimestamp']['output'];
  deletedAt?: Maybe<Scalars['VabsTimestamp']['output']>;
  filterCurrencies: VabsCurrencies;
  id: Scalars['ID']['output'];
  pluginsProcessId?: Maybe<Scalars['ID']['output']>;
  transactionTypes: Array<VabsTransactionType>;
  transferTypes: Array<VabsTransferType>;
  updatedAt: Scalars['VabsTimestamp']['output'];
};


export type VabsHistoryRateSettingConvertCurrenciesArgs = {
  input: VabsFilterInput;
};


export type VabsHistoryRateSettingFilterCurrenciesArgs = {
  input: VabsFilterInput;
};

export type VabsHistoryRateSettings = {
  __typename?: 'VabsHistoryRateSettings';
  count: Scalars['Int']['output'];
  cursor: Scalars['Int']['output'];
  nodes: Array<VabsHistoryRateSetting>;
};

export type VabsHistoryRates = {
  __typename?: 'VabsHistoryRates';
  count: Scalars['Int']['output'];
  cursor: Scalars['Int']['output'];
  nodes: Array<VabsHistoryRate>;
};

export type VabsHnhCreateIncomingPaymentBankAddressInput = {
  city?: InputMaybe<Scalars['String']['input']>;
  countryAlpha3: Scalars['String']['input'];
  fullAddress?: InputMaybe<Scalars['String']['input']>;
  line1?: InputMaybe<Scalars['String']['input']>;
  line2?: InputMaybe<Scalars['String']['input']>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  region?: InputMaybe<Scalars['String']['input']>;
};

export type VabsHnhCreateIncomingPaymentBankInput = {
  account: Scalars['String']['input'];
  address: VabsHnhCreateIncomingPaymentBankAddressInput;
  branchCode: Scalars['String']['input'];
  code: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type VabsHnhCreateIncomingPaymentBeneficiaryDetailsInput = {
  account: Scalars['String']['input'];
};

export type VabsHnhCreateIncomingPaymentCorrespondentBankInput = {
  account?: InputMaybe<Scalars['String']['input']>;
  address?: InputMaybe<VabsHnhCreateIncomingPaymentBankAddressInput>;
  branchCode?: InputMaybe<Scalars['String']['input']>;
  code: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
};

export type VabsHnhCreateIncomingPaymentDetailsAmountInput = {
  source: VabsHnhCreateIncomingPaymentDetailsAmountPartyInput;
  target: VabsHnhCreateIncomingPaymentDetailsAmountPartyInput;
};

export type VabsHnhCreateIncomingPaymentDetailsAmountPartyInput = {
  amount: Scalars['VabsBigNumber']['input'];
  currencyTicker: Scalars['String']['input'];
};

export type VabsHnhCreateIncomingPaymentInput = {
  amount: VabsHnhCreateIncomingPaymentDetailsAmountInput;
  beneficiaryDetails: VabsHnhCreateIncomingPaymentBeneficiaryDetailsInput;
  paymentSchema: VabsHnhSupportedPaymentSchemaEnum;
  providerTxId: Scalars['ID']['input'];
  remittanceInformation: Scalars['String']['input'];
  senderDetails: VabsHnhCreateIncomingPaymentSenderDetailsInput;
};

export type VabsHnhCreateIncomingPaymentSenderAddressInput = {
  city?: InputMaybe<Scalars['String']['input']>;
  countryAlpha3: Scalars['String']['input'];
  fullAddress: Scalars['String']['input'];
  line1: Scalars['String']['input'];
  line2?: InputMaybe<Scalars['String']['input']>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  region?: InputMaybe<Scalars['String']['input']>;
};

export type VabsHnhCreateIncomingPaymentSenderDetailsInput = {
  bank: VabsHnhCreateIncomingPaymentBankInput;
  correspondentBank?: InputMaybe<VabsHnhCreateIncomingPaymentCorrespondentBankInput>;
  sender: VabsHnhCreateIncomingPaymentSenderInput;
};

export type VabsHnhCreateIncomingPaymentSenderInput = {
  address: VabsHnhCreateIncomingPaymentSenderAddressInput;
  firstName?: InputMaybe<Scalars['String']['input']>;
  fullName: Scalars['String']['input'];
  lastName?: InputMaybe<Scalars['String']['input']>;
  middleName?: InputMaybe<Scalars['String']['input']>;
  type: VabsHnhParticipantTypeEnum;
};

export enum VabsHnhParticipantTypeEnum {
  Corporate = 'CORPORATE',
  Individual = 'INDIVIDUAL'
}

export type VabsHnhSetSwiftBankDetailsBeneficiaryInput = {
  beneficiaryAddress?: InputMaybe<Scalars['String']['input']>;
  beneficiaryBankAccount?: InputMaybe<Scalars['String']['input']>;
  beneficiaryName?: InputMaybe<Scalars['String']['input']>;
};

export type VabsHnhSetSwiftBankDetailsInput = {
  currencyId: Scalars['ID']['input'];
  details: VabsHnhSetSwiftBankDetailsBeneficiaryInput;
  realAccountId: Scalars['ID']['input'];
};

export enum VabsHnhSupportedPaymentSchemaEnum {
  Bsb = 'BSB',
  Ifsc = 'IFSC',
  Swift = 'SWIFT'
}

export type VabsHnhUpdateIncomingPaymentInput = {
  paymentSchema: VabsHnhSupportedPaymentSchemaEnum;
  providerTxId: Scalars['ID']['input'];
  remittanceInformation: Scalars['String']['input'];
  senderDetails: VabsHnhCreateIncomingPaymentSenderDetailsInput;
};

export enum VabsHooks {
  PostClientCreate = 'PostClientCreate',
  PostClientUpdate = 'PostClientUpdate',
  PostCurrencyCreate = 'PostCurrencyCreate',
  PostCurrencyUpdate = 'PostCurrencyUpdate',
  PostHistoryRateCreate = 'PostHistoryRateCreate',
  PostHistoryRateSettingCreate = 'PostHistoryRateSettingCreate',
  PostHistoryRateSettingUpdate = 'PostHistoryRateSettingUpdate',
  PostHistoryRateUpdate = 'PostHistoryRateUpdate',
  PostNetworkCreate = 'PostNetworkCreate',
  PostNetworkUpdate = 'PostNetworkUpdate',
  PostOperationCreate = 'PostOperationCreate',
  PostOperationUpdate = 'PostOperationUpdate',
  PostProjectCreate = 'PostProjectCreate',
  PostProjectUpdate = 'PostProjectUpdate',
  PostProviderConfigCreate = 'PostProviderConfigCreate',
  PostProviderConfigUpdate = 'PostProviderConfigUpdate',
  PostProviderCreate = 'PostProviderCreate',
  PostProviderCurrencyMappingCreate = 'PostProviderCurrencyMappingCreate',
  PostProviderCurrencyMappingUpdate = 'PostProviderCurrencyMappingUpdate',
  PostProviderUpdate = 'PostProviderUpdate',
  PostRealAccountCreate = 'PostRealAccountCreate',
  PostRealAccountUpdate = 'PostRealAccountUpdate',
  PostRealBalanceCreate = 'PostRealBalanceCreate',
  PostRealBalanceHistoryCreate = 'PostRealBalanceHistoryCreate',
  PostRealBalanceHistoryUpdate = 'PostRealBalanceHistoryUpdate',
  PostRealBalanceUpdate = 'PostRealBalanceUpdate',
  PostRealTransactionAccountCreate = 'PostRealTransactionAccountCreate',
  PostRealTransactionAccountUpdate = 'PostRealTransactionAccountUpdate',
  PostRealTransactionCreate = 'PostRealTransactionCreate',
  PostRealTransactionExecute = 'PostRealTransactionExecute',
  PostRealTransactionUpdate = 'PostRealTransactionUpdate',
  PostReportCreate = 'PostReportCreate',
  PostReportUpdate = 'PostReportUpdate',
  PostVirtualAccountCreate = 'PostVirtualAccountCreate',
  PostVirtualAccountExecute = 'PostVirtualAccountExecute',
  PostVirtualAccountRouted = 'PostVirtualAccountRouted',
  PostVirtualAccountUpdate = 'PostVirtualAccountUpdate',
  PostVirtualBalanceCreate = 'PostVirtualBalanceCreate',
  PostVirtualBalanceExecute = 'PostVirtualBalanceExecute',
  PostVirtualBalanceHistoryCreate = 'PostVirtualBalanceHistoryCreate',
  PostVirtualBalanceHistoryUpdate = 'PostVirtualBalanceHistoryUpdate',
  PostVirtualBalanceRouted = 'PostVirtualBalanceRouted',
  PostVirtualBalanceUpdate = 'PostVirtualBalanceUpdate',
  PostVirtualTransactionCreate = 'PostVirtualTransactionCreate',
  PostVirtualTransactionExecute = 'PostVirtualTransactionExecute',
  PostVirtualTransactionRouted = 'PostVirtualTransactionRouted',
  PostVirtualTransactionUpdate = 'PostVirtualTransactionUpdate'
}

export type VabsIfscPaymentType = {
  __typename?: 'VabsIfscPaymentType';
  amount: VabsPaymentAmountType;
  createdAt: Scalars['VabsDateTime']['output'];
  direction: VabsPaymentDirection;
  external: VabsBasePaymentMethodExternalClientType;
  fee: VabsPaymentFeeType;
  id: Scalars['ID']['output'];
  internal: VabsBasePaymentMethodInternalClientType;
  note?: Maybe<Scalars['String']['output']>;
  paymentSystem: VabsPaymentSystem;
  purposeOfPayment: Scalars['String']['output'];
  recipient?: Maybe<VabsPaymentClientType>;
  sender?: Maybe<VabsPaymentClientType>;
  settled?: Maybe<Scalars['VabsDateTime']['output']>;
  sourceOfFunds?: Maybe<VabsPaymentSourceOfFunds>;
  status: VabsPaymentStatus;
  totalAmount: VabsPaymentTotalAmountType;
  updatedAt: Scalars['VabsDateTime']['output'];
};

export type VabsInnerClientPaymentType = {
  __typename?: 'VabsInnerClientPaymentType';
  accountHolderName: Scalars['String']['output'];
  accountId: Scalars['String']['output'];
  clientId: Scalars['String']['output'];
  clientType: Scalars['String']['output'];
  email?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
};

export type VabsInnerPaymentType = {
  __typename?: 'VabsInnerPaymentType';
  amount: VabsPaymentAmountType;
  createdAt: Scalars['VabsDateTime']['output'];
  direction: VabsPaymentDirection;
  fee: VabsPaymentFeeType;
  id: Scalars['ID']['output'];
  note?: Maybe<Scalars['String']['output']>;
  paymentSystem: VabsPaymentSystem;
  purposeOfPayment: Scalars['String']['output'];
  recipient?: Maybe<VabsPaymentClientType>;
  recipientClient: VabsInnerClientPaymentType;
  sender?: Maybe<VabsPaymentClientType>;
  senderClient: VabsInnerClientPaymentType;
  settled?: Maybe<Scalars['VabsDateTime']['output']>;
  status: VabsPaymentStatus;
  totalAmount: VabsPaymentTotalAmountType;
  updatedAt: Scalars['VabsDateTime']['output'];
};

export type VabsInternalClientForPaymentType = {
  __typename?: 'VabsInternalClientForPaymentType';
  accountId: Scalars['String']['output'];
  availableCurrencies: Array<VabsDictionaryCurrency>;
  clientId: Scalars['String']['output'];
  companyName: Scalars['String']['output'];
};

export enum VabsLedgerAccountType {
  Active = 'ACTIVE',
  Passive = 'PASSIVE'
}

export type VabsLoginResponse = {
  __typename?: 'VabsLoginResponse';
  authorizationHeaders: Scalars['VabsJSON']['output'];
  ok: Scalars['Boolean']['output'];
  response: Scalars['VabsJSON']['output'];
};

export type VabsLoginWithCredentialsInput = {
  credentials: Scalars['VabsJSON']['input'];
  name: Scalars['String']['input'];
};

export type VabsNetwork = {
  __typename?: 'VabsNetwork';
  createdAt: Scalars['VabsTimestamp']['output'];
  currencies: VabsCurrencies;
  deletedAt?: Maybe<Scalars['VabsTimestamp']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  metadata?: Maybe<Scalars['VabsJSON']['output']>;
  name: Scalars['String']['output'];
  pluginsProcessId?: Maybe<Scalars['ID']['output']>;
  references: Array<VabsReference>;
  status: VabsEntityStatus;
  updatedAt: Scalars['VabsTimestamp']['output'];
};


export type VabsNetworkCurrenciesArgs = {
  input: VabsFilterInput;
};

export type VabsNetworks = {
  __typename?: 'VabsNetworks';
  count: Scalars['Int']['output'];
  cursor: Scalars['Int']['output'];
  nodes: Array<VabsNetwork>;
};

export type VabsOperation = {
  __typename?: 'VabsOperation';
  client: VabsClient;
  clients: VabsClients;
  createdAt: Scalars['VabsTimestamp']['output'];
  deletedAt?: Maybe<Scalars['VabsTimestamp']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  errorMessages?: Maybe<Array<VabsApiError>>;
  externalOperationId?: Maybe<Scalars['ID']['output']>;
  historyRates: VabsHistoryRates;
  id: Scalars['ID']['output'];
  metadata?: Maybe<Scalars['VabsJSON']['output']>;
  name: Scalars['String']['output'];
  pluginsProcessId?: Maybe<Scalars['ID']['output']>;
  providers: VabsProviders;
  realTransactions: VabsRealTransactions;
  references: Array<VabsReference>;
  status: VabsOperationStatus;
  updatedAt: Scalars['VabsTimestamp']['output'];
  virtualTransactions: VabsVirtualTransactions;
};


export type VabsOperationClientsArgs = {
  input?: VabsFilterInput;
};


export type VabsOperationHistoryRatesArgs = {
  input?: VabsFilterInput;
};


export type VabsOperationProvidersArgs = {
  input?: VabsFilterInput;
};


export type VabsOperationRealTransactionsArgs = {
  input?: VabsFilterInput;
};


export type VabsOperationVirtualTransactionsArgs = {
  input?: VabsFilterInput;
};

export enum VabsOperationStatus {
  Completed = 'COMPLETED',
  Declined = 'DECLINED',
  Error = 'ERROR',
  New = 'NEW',
  PartialDeclined = 'PARTIAL_DECLINED',
  Processing = 'PROCESSING'
}

export type VabsOperationStatusStatistic = {
  __typename?: 'VabsOperationStatusStatistic';
  completed: Scalars['Int']['output'];
  declined: Scalars['Int']['output'];
  error: Scalars['Int']['output'];
  new: Scalars['Int']['output'];
  partialDeclined: Scalars['Int']['output'];
  processing: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type VabsOperations = {
  __typename?: 'VabsOperations';
  count: Scalars['Int']['output'];
  cursor: Scalars['Int']['output'];
  nodes: Array<VabsOperation>;
};

export enum VabsOrderByDirection {
  Asc = 'ASC',
  Desc = 'DESC'
}

export type VabsOrderByInput = {
  column: Scalars['String']['input'];
  direction: VabsOrderByDirection;
};

export type VabsPaginationInput = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};

/** Transaction participant types */
export enum VabsParticipantType {
  B2B = 'B2B',
  B2C = 'B2C',
  C2B = 'C2B',
  C2C = 'C2C',
  Self = 'SELF'
}

export type VabsPaymentAmountType = {
  __typename?: 'VabsPaymentAmountType';
  exchangeRate: Scalars['VabsBigNumber']['output'];
  source: VabsPaymentPartyAmountType;
  target: VabsPaymentPartyAmountType;
};

export type VabsPaymentCalculateFeeType = {
  __typename?: 'VabsPaymentCalculateFeeType';
  currencyTicker: Scalars['String']['output'];
  originalAmount: Scalars['VabsBigNumber']['output'];
  originalTotalAmount: Scalars['VabsBigNumber']['output'];
  originalTotalFee: Scalars['VabsBigNumber']['output'];
  totalAmount: Scalars['VabsBigNumber']['output'];
  totalFee: Scalars['VabsBigNumber']['output'];
};

export type VabsPaymentClientType = {
  __typename?: 'VabsPaymentClientType';
  clientId: Scalars['ID']['output'];
  clientType: VabsPaymentClientTypeEnum;
};

/** Payment client type */
export enum VabsPaymentClientTypeEnum {
  Corporate = 'CORPORATE',
  Individual = 'INDIVIDUAL'
}

/** Payment direction */
export enum VabsPaymentDirection {
  Incoming = 'INCOMING',
  Outgoing = 'OUTGOING'
}

export type VabsPaymentFeeType = {
  __typename?: 'VabsPaymentFeeType';
  exchangeRate: Scalars['VabsBigNumber']['output'];
  source: VabsPaymentPartyFeeType;
  target: VabsPaymentPartyFeeType;
};

export type VabsPaymentMethod = {
  __typename?: 'VabsPaymentMethod';
  availableCountries: Array<VabsDictionaryCountry>;
  availableCurrencies: Array<VabsDictionaryCurrency>;
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  participantTypes: Array<VabsParticipantType>;
  type: VabsPaymentSystem;
};

export type VabsPaymentMethods = {
  __typename?: 'VabsPaymentMethods';
  count: Scalars['Int']['output'];
  cursor: Scalars['Int']['output'];
  nodes: Array<VabsPaymentMethod>;
};

export type VabsPaymentPartyAmountType = {
  __typename?: 'VabsPaymentPartyAmountType';
  amount: Scalars['VabsBigNumber']['output'];
  currency: VabsDictionaryCurrency;
};

export type VabsPaymentPartyFeeType = {
  __typename?: 'VabsPaymentPartyFeeType';
  bank: Scalars['VabsBigNumber']['output'];
  currency: VabsDictionaryCurrency;
  provider: Scalars['VabsBigNumber']['output'];
  total: Scalars['VabsBigNumber']['output'];
};

/** Payment source of funds */
export enum VabsPaymentSourceOfFunds {
  CommissionOfSales = 'COMMISSION_OF_SALES',
  DividendIncomeFromShare = 'DIVIDEND_INCOME_FROM_SHARE',
  InvestmentCapital = 'INVESTMENT_CAPITAL',
  RevenueGeneratedFromBusinessActivities = 'REVENUE_GENERATED_FROM_BUSINESS_ACTIVITIES',
  Salary = 'SALARY',
  Saving = 'SAVING'
}

/** Payment status */
export enum VabsPaymentStatus {
  Declined = 'DECLINED',
  Draft = 'DRAFT',
  Processing = 'PROCESSING',
  Refunded = 'REFUNDED',
  Successful = 'SUCCESSFUL'
}

/** Payment type in system */
export enum VabsPaymentSystem {
  Bsb = 'BSB',
  Ifsc = 'IFSC',
  Inner = 'INNER',
  Swift = 'SWIFT'
}

export type VabsPaymentTotalAmountType = {
  __typename?: 'VabsPaymentTotalAmountType';
  exchangeRate: Scalars['VabsBigNumber']['output'];
  source: VabsPaymentPartyAmountType;
  target: VabsPaymentPartyAmountType;
};

export type VabsPaymentUnion = VabsBsbPaymentType | VabsIfscPaymentType | VabsInnerPaymentType | VabsSwiftPaymentType;

export type VabsPayments = {
  __typename?: 'VabsPayments';
  count: Scalars['Int']['output'];
  cursor: Scalars['Int']['output'];
  nodes: Array<VabsPaymentUnion>;
};

export type VabsPeriodInput = {
  dateFrom?: InputMaybe<Scalars['VabsTimestamp']['input']>;
  dateTo?: InputMaybe<Scalars['VabsTimestamp']['input']>;
};

export type VabsPlugin = {
  __typename?: 'VabsPlugin';
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  status: VabsPluginStatus;
};

export enum VabsPluginStatus {
  Disabled = 'DISABLED',
  Enabled = 'ENABLED'
}

export type VabsPluginTracking = {
  __typename?: 'VabsPluginTracking';
  createdAt: Scalars['VabsTimestamp']['output'];
  entity?: Maybe<VabsCoreUnion>;
  entityName?: Maybe<Scalars['String']['output']>;
  errorMessage?: Maybe<Scalars['String']['output']>;
  hook: VabsHooks;
  hookData: Scalars['VabsJSON']['output'];
  id: Scalars['ID']['output'];
  order: Scalars['Int']['output'];
  processId: Scalars['ID']['output'];
  status: VabsPluginTrackingStatus;
  updatedAt: Scalars['VabsTimestamp']['output'];
};

export enum VabsPluginTrackingStatus {
  Error = 'ERROR',
  Paused = 'PAUSED',
  Pending = 'PENDING',
  Processing = 'PROCESSING',
  Rejected = 'REJECTED',
  Successful = 'SUCCESSFUL'
}

export type VabsPluginsTracking = {
  __typename?: 'VabsPluginsTracking';
  count: Scalars['Int']['output'];
  cursor: Scalars['Int']['output'];
  nodes: Array<VabsPluginTracking>;
};

export type VabsProject = {
  __typename?: 'VabsProject';
  clients: VabsClients;
  createdAt: Scalars['VabsTimestamp']['output'];
  deletedAt?: Maybe<Scalars['VabsTimestamp']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  metadata?: Maybe<Scalars['VabsJSON']['output']>;
  name: Scalars['String']['output'];
  pluginsProcessId?: Maybe<Scalars['ID']['output']>;
  providers: VabsProviders;
  references: Array<VabsReference>;
  status: VabsEntityStatus;
  updatedAt: Scalars['VabsTimestamp']['output'];
};


export type VabsProjectClientsArgs = {
  input: VabsFilterInput;
};


export type VabsProjectProvidersArgs = {
  input: VabsFilterInput;
};

export type VabsProjects = {
  __typename?: 'VabsProjects';
  count: Scalars['Int']['output'];
  cursor: Scalars['Int']['output'];
  nodes: Array<VabsProject>;
};

export type VabsProvider = {
  __typename?: 'VabsProvider';
  category: Scalars['String']['output'];
  conditions?: Maybe<Scalars['VabsJSON']['output']>;
  createdAt: Scalars['VabsTimestamp']['output'];
  deletedAt?: Maybe<Scalars['VabsTimestamp']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  metadata?: Maybe<Scalars['VabsJSON']['output']>;
  name: Scalars['String']['output'];
  operations: VabsOperations;
  pluginsProcessId?: Maybe<Scalars['ID']['output']>;
  project?: Maybe<VabsProject>;
  providerConfig?: Maybe<VabsProviderConfig>;
  realAccounts: VabsRealAccounts;
  realTransactions: VabsRealTransactions;
  references: Array<VabsReference>;
  status: VabsEntityStatus;
  type: Scalars['String']['output'];
  updatedAt: Scalars['VabsTimestamp']['output'];
};


export type VabsProviderOperationsArgs = {
  input?: VabsFilterInput;
};


export type VabsProviderRealAccountsArgs = {
  input?: VabsFilterInput;
};


export type VabsProviderRealTransactionsArgs = {
  input?: VabsFilterInput;
};

export type VabsProviderConfig = {
  __typename?: 'VabsProviderConfig';
  config: Scalars['VabsJSON']['output'];
  createdAt: Scalars['VabsTimestamp']['output'];
  deletedAt?: Maybe<Scalars['VabsTimestamp']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  pluginsProcessId?: Maybe<Scalars['ID']['output']>;
  provider: VabsProvider;
  status: VabsEntityStatus;
  updatedAt: Scalars['VabsTimestamp']['output'];
};

export type VabsProviderConfigInput = {
  config: Scalars['VabsJSON']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
};

export type VabsProviderConfigs = {
  __typename?: 'VabsProviderConfigs';
  count: Scalars['Int']['output'];
  cursor: Scalars['Int']['output'];
  nodes: Array<VabsProviderConfig>;
};

export type VabsProviderCurrencyMapping = {
  __typename?: 'VabsProviderCurrencyMapping';
  createdAt: Scalars['VabsTimestamp']['output'];
  currency: VabsCurrency;
  decimals: Scalars['Int']['output'];
  deletedAt?: Maybe<Scalars['VabsTimestamp']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  pluginsProcessId?: Maybe<Scalars['ID']['output']>;
  provider: VabsProvider;
  providerCurrency: VabsCurrency;
  updatedAt: Scalars['VabsTimestamp']['output'];
};

export enum VabsProviderSearchingType {
  Equals = 'EQUALS',
  GreaterThan = 'GREATER_THAN',
  GreaterThanOrEquals = 'GREATER_THAN_OR_EQUALS',
  Includes = 'INCLUDES',
  LowerThan = 'LOWER_THAN',
  LowerThanOrEquals = 'LOWER_THAN_OR_EQUALS'
}

export type VabsProviderTypeStatistic = {
  __typename?: 'VabsProviderTypeStatistic';
  account: Scalars['Int']['output'];
  exchange: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type VabsProviders = {
  __typename?: 'VabsProviders';
  count: Scalars['Int']['output'];
  cursor: Scalars['Int']['output'];
  nodes: Array<VabsProvider>;
};

export type VabsProvidersCurrenciesMapping = {
  __typename?: 'VabsProvidersCurrenciesMapping';
  count: Scalars['Int']['output'];
  cursor: Scalars['Int']['output'];
  nodes: Array<VabsProviderCurrencyMapping>;
};

export type VabsRealAccount = {
  __typename?: 'VabsRealAccount';
  createdAt: Scalars['VabsTimestamp']['output'];
  deletedAt?: Maybe<Scalars['VabsTimestamp']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  ledgerType: VabsLedgerAccountType;
  metadata?: Maybe<Scalars['VabsJSON']['output']>;
  pluginsProcessId?: Maybe<Scalars['ID']['output']>;
  provider: VabsProvider;
  providerExternalId?: Maybe<Scalars['ID']['output']>;
  realBalances: VabsRealBalances;
  realOperations: VabsOperations;
  references: Array<VabsReference>;
  requisites: Scalars['VabsJSON']['output'];
  status: VabsEntityStatus;
  tag?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
  updatedAt: Scalars['VabsTimestamp']['output'];
  virtualAccounts: VabsVirtualAccounts;
};


export type VabsRealAccountRealBalancesArgs = {
  input?: VabsFilterInput;
};


export type VabsRealAccountRealOperationsArgs = {
  input?: VabsFilterInput;
};


export type VabsRealAccountVirtualAccountsArgs = {
  input?: VabsFilterInput;
};

export type VabsRealAccounts = {
  __typename?: 'VabsRealAccounts';
  count: Scalars['Int']['output'];
  cursor: Scalars['Int']['output'];
  nodes: Array<VabsRealAccount>;
};

export type VabsRealBalance = {
  __typename?: 'VabsRealBalance';
  availableAmount: Scalars['VabsBigNumber']['output'];
  createdAt: Scalars['VabsTimestamp']['output'];
  currency?: Maybe<VabsCurrency>;
  deletedAt?: Maybe<Scalars['VabsTimestamp']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  holdAmount: Scalars['VabsBigNumber']['output'];
  id: Scalars['ID']['output'];
  metadata?: Maybe<Scalars['VabsJSON']['output']>;
  pluginsProcessId?: Maybe<Scalars['ID']['output']>;
  realAccount?: Maybe<VabsRealAccount>;
  references: Array<VabsReference>;
  status: Scalars['String']['output'];
  totalAmount: Scalars['VabsBigNumber']['output'];
  type: Scalars['String']['output'];
  updatedAt: Scalars['VabsTimestamp']['output'];
};

export type VabsRealBalanceHistory = {
  __typename?: 'VabsRealBalanceHistory';
  availableAmount: Scalars['VabsBigNumber']['output'];
  availableAmountDelta: Scalars['VabsBigNumber']['output'];
  createdAt: Scalars['VabsTimestamp']['output'];
  deletedAt?: Maybe<Scalars['VabsTimestamp']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  endDate: Scalars['Int']['output'];
  firstTransaction?: Maybe<VabsRealTransaction>;
  holdAmount: Scalars['VabsBigNumber']['output'];
  holdAmountDelta: Scalars['VabsBigNumber']['output'];
  id: Scalars['ID']['output'];
  lastTransaction?: Maybe<VabsRealTransaction>;
  pluginsProcessId?: Maybe<Scalars['ID']['output']>;
  realBalance?: Maybe<VabsRealBalance>;
  startDate: Scalars['Int']['output'];
  totalAmount: Scalars['VabsBigNumber']['output'];
  totalAmountDelta: Scalars['VabsBigNumber']['output'];
  updatedAt: Scalars['VabsTimestamp']['output'];
};

export type VabsRealBalanceInput = {
  currency: VabsRelatedEntityInput;
  description?: InputMaybe<Scalars['String']['input']>;
  metadata?: InputMaybe<Scalars['VabsJSON']['input']>;
  references?: InputMaybe<Array<VabsCreateReferenceInput>>;
  status: Scalars['String']['input'];
  type: Scalars['String']['input'];
};

export type VabsRealBalances = {
  __typename?: 'VabsRealBalances';
  count: Scalars['Int']['output'];
  cursor: Scalars['Int']['output'];
  nodes: Array<VabsRealBalance>;
};

export type VabsRealBalancesHistories = {
  __typename?: 'VabsRealBalancesHistories';
  count: Scalars['Int']['output'];
  cursor: Scalars['Int']['output'];
  nodes: Array<VabsRealBalanceHistory>;
};

export type VabsRealTransaction = {
  __typename?: 'VabsRealTransaction';
  amount: Scalars['VabsBigNumber']['output'];
  createdAt: Scalars['VabsTimestamp']['output'];
  currency?: Maybe<VabsCurrency>;
  deletedAt?: Maybe<Scalars['VabsTimestamp']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  errorMessages?: Maybe<Array<VabsApiError>>;
  historyRates: VabsHistoryRates;
  id: Scalars['ID']['output'];
  metadata?: Maybe<Scalars['VabsJSON']['output']>;
  operation: VabsOperation;
  order: Scalars['Int']['output'];
  pluginsProcessId?: Maybe<Scalars['ID']['output']>;
  previousStatus?: Maybe<VabsTransactionStatus>;
  providerTxId?: Maybe<Scalars['ID']['output']>;
  rawTxData?: Maybe<Scalars['String']['output']>;
  realAccount: VabsRealAccount;
  references: Array<VabsReference>;
  status: VabsTransactionStatus;
  transferType: VabsTransferType;
  updatedAt: Scalars['VabsTimestamp']['output'];
};


export type VabsRealTransactionHistoryRatesArgs = {
  input?: VabsFilterInput;
};

export type VabsRealTransactionAccount = {
  __typename?: 'VabsRealTransactionAccount';
  amount: Scalars['VabsBigNumber']['output'];
  createdAt: Scalars['VabsTimestamp']['output'];
  currency?: Maybe<VabsCurrency>;
  deletedAt?: Maybe<Scalars['VabsTimestamp']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  metadata?: Maybe<Scalars['VabsJSON']['output']>;
  pluginsProcessId?: Maybe<Scalars['ID']['output']>;
  realAccount?: Maybe<VabsRealAccount>;
  realTransaction?: Maybe<VabsRealTransaction>;
  references: Array<VabsReference>;
  type: VabsRealTransactionAddressType;
  updatedAt: Scalars['VabsTimestamp']['output'];
};

export type VabsRealTransactionAccounts = {
  __typename?: 'VabsRealTransactionAccounts';
  count: Scalars['Int']['output'];
  cursor: Scalars['Int']['output'];
  nodes: Array<VabsRealTransactionAccount>;
};

export enum VabsRealTransactionAddressType {
  Input = 'INPUT',
  Output = 'OUTPUT'
}

export type VabsRealTransactionVerifyResult = {
  __typename?: 'VabsRealTransactionVerifyResult';
  amount: Scalars['VabsBigNumber']['output'];
  currency: VabsRelatedEntity;
  declineReason: VabsApiError;
  description?: Maybe<Scalars['String']['output']>;
  historyRates?: Maybe<Array<VabsHistoryRateData>>;
  operation: VabsRelatedEntity;
  order: Scalars['Int']['output'];
  providerTxId?: Maybe<Scalars['ID']['output']>;
  rawTxData?: Maybe<Scalars['String']['output']>;
  realAccount: VabsRelatedEntity;
  transferType: VabsTransferType;
};

export type VabsRealTransactions = {
  __typename?: 'VabsRealTransactions';
  count: Scalars['Int']['output'];
  cursor: Scalars['Int']['output'];
  nodes: Array<VabsRealTransaction>;
};

export type VabsReference = {
  __typename?: 'VabsReference';
  createdAt: Scalars['VabsTimestamp']['output'];
  deletedAt?: Maybe<Scalars['VabsTimestamp']['output']>;
  name: Scalars['String']['output'];
  pluginsProcessId?: Maybe<Scalars['ID']['output']>;
  updatedAt: Scalars['VabsTimestamp']['output'];
  value: Scalars['String']['output'];
};

export type VabsRelatedEntity = {
  __typename?: 'VabsRelatedEntity';
  id: Scalars['ID']['output'];
};

export type VabsRelatedEntityInput = {
  id: Scalars['ID']['input'];
};

export type VabsReport = {
  __typename?: 'VabsReport';
  createdAt: Scalars['VabsTimestamp']['output'];
  deletedAt?: Maybe<Scalars['VabsTimestamp']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  metadata?: Maybe<Scalars['VabsJSON']['output']>;
  operation: VabsOperation;
  pluginsProcessId?: Maybe<Scalars['ID']['output']>;
  references: Array<VabsReference>;
  updatedAt: Scalars['VabsTimestamp']['output'];
  virtualBalanceAfter?: Maybe<Scalars['VabsBigNumber']['output']>;
  virtualBalanceBefore?: Maybe<Scalars['VabsBigNumber']['output']>;
};

export type VabsReports = {
  __typename?: 'VabsReports';
  count: Scalars['Int']['output'];
  cursor: Scalars['Int']['output'];
  nodes: Array<VabsReport>;
};

export type VabsStatistics = {
  __typename?: 'VabsStatistics';
  clients: VabsClientCategoryStatistic;
  currencies: VabsEntityStatusStatistic;
  networks: VabsEntityStatusStatistic;
  operations: VabsOperationStatusStatistic;
  projects: VabsEntityStatusStatistic;
  providers: VabsProviderTypeStatistic;
  realAccounts: VabsEntityStatusStatistic;
  virtualAccounts: VabsEntityStatusStatistic;
};

export type VabsSwiftPaymentType = {
  __typename?: 'VabsSwiftPaymentType';
  amount: VabsPaymentAmountType;
  createdAt: Scalars['VabsDateTime']['output'];
  direction: VabsPaymentDirection;
  external: VabsBasePaymentMethodExternalClientType;
  fee: VabsPaymentFeeType;
  id: Scalars['ID']['output'];
  internal: VabsBasePaymentMethodInternalClientType;
  note?: Maybe<Scalars['String']['output']>;
  paymentSystem: VabsPaymentSystem;
  purposeOfPayment: Scalars['String']['output'];
  recipient?: Maybe<VabsPaymentClientType>;
  sender?: Maybe<VabsPaymentClientType>;
  settled?: Maybe<Scalars['VabsDateTime']['output']>;
  sourceOfFunds?: Maybe<VabsPaymentSourceOfFunds>;
  status: VabsPaymentStatus;
  totalAmount: VabsPaymentTotalAmountType;
  updatedAt: Scalars['VabsDateTime']['output'];
};

export enum VabsTransactionStatus {
  Confirmed = 'CONFIRMED',
  Declined = 'DECLINED',
  Error = 'ERROR',
  Pending = 'PENDING',
  Processing = 'PROCESSING',
  Replaced = 'REPLACED'
}

export enum VabsTransactionType {
  Real = 'REAL',
  Virtual = 'VIRTUAL'
}

export enum VabsTransferType {
  Credit = 'CREDIT',
  Debit = 'DEBIT'
}

export type VabsUpdateClientInput = {
  category?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  externalId?: InputMaybe<Scalars['ID']['input']>;
  id: Scalars['ID']['input'];
  metadata?: InputMaybe<Scalars['VabsJSON']['input']>;
  pluginsProcessId?: InputMaybe<Scalars['ID']['input']>;
  project?: InputMaybe<VabsRelatedEntityInput>;
  references?: InputMaybe<VabsAttachDetachReferencesInput>;
  status?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type VabsUpdateCurrencyInput = {
  decimals?: InputMaybe<Scalars['Int']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  metadata?: InputMaybe<Scalars['VabsJSON']['input']>;
  network?: InputMaybe<VabsRelatedEntityInput>;
  references?: InputMaybe<VabsAttachDetachReferencesInput>;
  status?: InputMaybe<VabsEntityStatus>;
  ticker?: InputMaybe<Scalars['String']['input']>;
};

export type VabsUpdateHistoryRateInput = {
  baseCurrency?: InputMaybe<VabsRelatedEntityInput>;
  createdAt?: InputMaybe<Scalars['VabsTimestamp']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  metadata?: InputMaybe<Scalars['VabsJSON']['input']>;
  operations?: InputMaybe<Array<VabsRelatedEntityInput>>;
  pluginsProcessId?: InputMaybe<Scalars['ID']['input']>;
  priceInBase?: InputMaybe<Scalars['VabsBigNumber']['input']>;
  quoteCurrency?: InputMaybe<VabsRelatedEntityInput>;
  realTransactions?: InputMaybe<Array<VabsRelatedEntityInput>>;
  references?: InputMaybe<VabsAttachDetachReferencesInput>;
  virtualTransactions?: InputMaybe<Array<VabsRelatedEntityInput>>;
};

export type VabsUpdateHistoryRateSettingInput = {
  baseCurrencies?: InputMaybe<Array<VabsRelatedEntityInput>>;
  id: Scalars['ID']['input'];
  quoteCurrencies?: InputMaybe<Array<VabsRelatedEntityInput>>;
  transactionTypes?: InputMaybe<Array<VabsTransactionType>>;
  transferTypes?: InputMaybe<Array<VabsTransferType>>;
};

export type VabsUpdateNetworkInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  metadata?: InputMaybe<Scalars['VabsJSON']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  references?: InputMaybe<VabsAttachDetachReferencesInput>;
  status?: InputMaybe<VabsEntityStatus>;
};

export type VabsUpdateOperationInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  errorMessages?: InputMaybe<Array<VabsApiErrorInput>>;
  externalOperationId?: InputMaybe<Scalars['ID']['input']>;
  id: Scalars['ID']['input'];
  metadata?: InputMaybe<Scalars['VabsJSON']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  pluginsProcessId?: InputMaybe<Scalars['ID']['input']>;
  references?: InputMaybe<VabsAttachDetachReferencesInput>;
  status?: InputMaybe<VabsOperationStatus>;
};

export type VabsUpdatePaymentFavoriteInput = {
  isFavorite: Scalars['Boolean']['input'];
  paymentId: Scalars['ID']['input'];
};

export type VabsUpdatePaymentMethodInput = {
  availableCountryIds?: InputMaybe<Array<Scalars['String']['input']>>;
  availableCurrencies?: InputMaybe<Array<Scalars['String']['input']>>;
  id: Scalars['ID']['input'];
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  participantTypes?: InputMaybe<Array<VabsParticipantType>>;
  type?: InputMaybe<VabsPaymentSystem>;
};

export type VabsUpdateProjectInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  metadata?: InputMaybe<Scalars['VabsJSON']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  references?: InputMaybe<VabsAttachDetachReferencesInput>;
  status?: InputMaybe<VabsEntityStatus>;
};

export type VabsUpdateProviderConfigInput = {
  config?: InputMaybe<Scalars['VabsJSON']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  provider?: InputMaybe<VabsRelatedEntityInput>;
  status?: InputMaybe<VabsEntityStatus>;
};

export type VabsUpdateProviderCurrencyMappingInput = {
  decimals?: InputMaybe<Scalars['Int']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

export type VabsUpdateProviderInput = {
  category?: InputMaybe<Scalars['String']['input']>;
  conditions?: InputMaybe<Scalars['VabsJSON']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  metadata?: InputMaybe<Scalars['VabsJSON']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  references?: InputMaybe<VabsAttachDetachReferencesInput>;
  status?: InputMaybe<VabsEntityStatus>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type VabsUpdateRealAccountInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  ledgerType?: InputMaybe<VabsLedgerAccountType>;
  metadata?: InputMaybe<Scalars['VabsJSON']['input']>;
  pluginsProcessId?: InputMaybe<Scalars['ID']['input']>;
  references?: InputMaybe<VabsAttachDetachReferencesInput>;
  requisites?: InputMaybe<Scalars['VabsJSON']['input']>;
  status?: InputMaybe<VabsEntityStatus>;
  tag?: InputMaybe<Scalars['String']['input']>;
  virtualAccountIds?: InputMaybe<VabsAttachDetachInput>;
};

export type VabsUpdateRealBalanceHistoryInput = {
  availableAmount?: InputMaybe<Scalars['VabsBigNumber']['input']>;
  availableAmountDelta?: InputMaybe<Scalars['VabsBigNumber']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['Int']['input']>;
  firstTransaction?: InputMaybe<VabsRelatedEntityInput>;
  holdAmount?: InputMaybe<Scalars['VabsBigNumber']['input']>;
  holdAmountDelta?: InputMaybe<Scalars['VabsBigNumber']['input']>;
  id: Scalars['ID']['input'];
  lastTransaction?: InputMaybe<VabsRelatedEntityInput>;
  realBalance?: InputMaybe<VabsRelatedEntityInput>;
  startDate?: InputMaybe<Scalars['Int']['input']>;
  totalAmount?: InputMaybe<Scalars['VabsBigNumber']['input']>;
  totalAmountDelta?: InputMaybe<Scalars['VabsBigNumber']['input']>;
};

export type VabsUpdateRealBalanceInput = {
  availableAmount?: InputMaybe<Scalars['VabsBigNumber']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  holdAmount?: InputMaybe<Scalars['VabsBigNumber']['input']>;
  id: Scalars['ID']['input'];
  metadata?: InputMaybe<Scalars['VabsJSON']['input']>;
  references?: InputMaybe<VabsAttachDetachReferencesInput>;
  status?: InputMaybe<Scalars['String']['input']>;
  totalAmount?: InputMaybe<Scalars['VabsBigNumber']['input']>;
};

export type VabsUpdateRealTransactionAccountInput = {
  amount?: InputMaybe<Scalars['VabsBigNumber']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  metadata?: InputMaybe<Scalars['VabsJSON']['input']>;
  references?: InputMaybe<VabsAttachDetachReferencesInput>;
};

export type VabsUpdateRealTransactionInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  errorMessages?: InputMaybe<Array<VabsApiErrorInput>>;
  id: Scalars['ID']['input'];
  metadata?: InputMaybe<Scalars['VabsJSON']['input']>;
  previousStatus?: InputMaybe<VabsTransactionStatus>;
  providerTxId?: InputMaybe<Scalars['ID']['input']>;
  rawTxData?: InputMaybe<Scalars['String']['input']>;
  references?: InputMaybe<VabsAttachDetachReferencesInput>;
  status?: InputMaybe<VabsTransactionStatus>;
};

export type VabsUpdateReportInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  metadata?: InputMaybe<Scalars['VabsJSON']['input']>;
  references?: InputMaybe<VabsAttachDetachReferencesInput>;
  virtualBalanceAfter?: InputMaybe<Scalars['VabsBigNumber']['input']>;
  virtualBalanceBefore?: InputMaybe<Scalars['VabsBigNumber']['input']>;
};

export type VabsUpdateVirtualAccountInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  ledgerType?: InputMaybe<VabsLedgerAccountType>;
  metadata?: InputMaybe<Scalars['VabsJSON']['input']>;
  pluginsProcessId?: InputMaybe<Scalars['ID']['input']>;
  realAccountIds?: InputMaybe<VabsAttachDetachInput>;
  references?: InputMaybe<VabsAttachDetachReferencesInput>;
  status?: InputMaybe<VabsEntityStatus>;
  tag?: InputMaybe<Scalars['String']['input']>;
};

export type VabsUpdateVirtualBalanceHistoryInput = {
  availableAmount?: InputMaybe<Scalars['VabsBigNumber']['input']>;
  availableAmountDelta?: InputMaybe<Scalars['VabsBigNumber']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['Int']['input']>;
  firstTransaction?: InputMaybe<VabsRelatedEntityInput>;
  holdAmount?: InputMaybe<Scalars['VabsBigNumber']['input']>;
  holdAmountDelta?: InputMaybe<Scalars['VabsBigNumber']['input']>;
  id: Scalars['ID']['input'];
  lastTransaction?: InputMaybe<VabsRelatedEntityInput>;
  startDate?: InputMaybe<Scalars['Int']['input']>;
  totalAmount?: InputMaybe<Scalars['VabsBigNumber']['input']>;
  totalAmountDelta?: InputMaybe<Scalars['VabsBigNumber']['input']>;
  virtualBalance?: InputMaybe<VabsRelatedEntityInput>;
};

export type VabsUpdateVirtualBalanceInput = {
  availableAmount?: InputMaybe<Scalars['VabsBigNumber']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  holdAmount?: InputMaybe<Scalars['VabsBigNumber']['input']>;
  id: Scalars['ID']['input'];
  metadata?: InputMaybe<Scalars['VabsJSON']['input']>;
  references?: InputMaybe<VabsAttachDetachReferencesInput>;
  status?: InputMaybe<Scalars['String']['input']>;
  totalAmount?: InputMaybe<Scalars['VabsBigNumber']['input']>;
};

export type VabsUpdateVirtualTransactionInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  errorMessages?: InputMaybe<Array<VabsApiErrorInput>>;
  id: Scalars['ID']['input'];
  metadata?: InputMaybe<Scalars['VabsJSON']['input']>;
  previousStatus?: InputMaybe<VabsTransactionStatus>;
  providerTxId?: InputMaybe<Scalars['ID']['input']>;
  rawTxData?: InputMaybe<Scalars['String']['input']>;
  references?: InputMaybe<VabsAttachDetachReferencesInput>;
  status?: InputMaybe<VabsTransactionStatus>;
};

export type VabsVirtualAccount = {
  __typename?: 'VabsVirtualAccount';
  category: Scalars['String']['output'];
  children: VabsVirtualAccounts;
  client: VabsClient;
  createdAt: Scalars['VabsTimestamp']['output'];
  deletedAt?: Maybe<Scalars['VabsTimestamp']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  errorMessages?: Maybe<Array<VabsApiError>>;
  id: Scalars['ID']['output'];
  ledgerType: VabsLedgerAccountType;
  metadata?: Maybe<Scalars['VabsJSON']['output']>;
  parent?: Maybe<VabsVirtualAccount>;
  pluginsProcessId?: Maybe<Scalars['ID']['output']>;
  realAccounts: VabsRealAccounts;
  references: Array<VabsReference>;
  status: VabsEntityStatus;
  tag?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
  updatedAt: Scalars['VabsTimestamp']['output'];
  virtualBalances: VabsVirtualBalances;
  virtualTransactions: VabsVirtualTransactions;
};


export type VabsVirtualAccountChildrenArgs = {
  input?: VabsFilterInput;
};


export type VabsVirtualAccountRealAccountsArgs = {
  input?: VabsFilterInput;
};


export type VabsVirtualAccountVirtualBalancesArgs = {
  input?: VabsFilterInput;
};


export type VabsVirtualAccountVirtualTransactionsArgs = {
  input?: VabsFilterInput;
};

export type VabsVirtualAccounts = {
  __typename?: 'VabsVirtualAccounts';
  count: Scalars['Int']['output'];
  cursor: Scalars['Int']['output'];
  nodes: Array<VabsVirtualAccount>;
};

export type VabsVirtualBalance = {
  __typename?: 'VabsVirtualBalance';
  availableAmount: Scalars['VabsBigNumber']['output'];
  createdAt: Scalars['VabsTimestamp']['output'];
  currency?: Maybe<VabsCurrency>;
  deletedAt?: Maybe<Scalars['VabsTimestamp']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  holdAmount: Scalars['VabsBigNumber']['output'];
  id: Scalars['ID']['output'];
  metadata?: Maybe<Scalars['VabsJSON']['output']>;
  pluginsProcessId?: Maybe<Scalars['ID']['output']>;
  references: Array<VabsReference>;
  status: Scalars['String']['output'];
  totalAmount: Scalars['VabsBigNumber']['output'];
  updatedAt: Scalars['VabsTimestamp']['output'];
  virtualAccount?: Maybe<VabsVirtualAccount>;
};

export type VabsVirtualBalanceHistory = {
  __typename?: 'VabsVirtualBalanceHistory';
  availableAmount: Scalars['VabsBigNumber']['output'];
  availableAmountDelta: Scalars['VabsBigNumber']['output'];
  createdAt: Scalars['VabsTimestamp']['output'];
  deletedAt?: Maybe<Scalars['VabsTimestamp']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  endDate: Scalars['Int']['output'];
  firstTransaction?: Maybe<VabsVirtualTransaction>;
  holdAmount: Scalars['VabsBigNumber']['output'];
  holdAmountDelta: Scalars['VabsBigNumber']['output'];
  id: Scalars['ID']['output'];
  lastTransaction?: Maybe<VabsVirtualTransaction>;
  pluginsProcessId?: Maybe<Scalars['ID']['output']>;
  startDate: Scalars['Int']['output'];
  totalAmount: Scalars['VabsBigNumber']['output'];
  totalAmountDelta: Scalars['VabsBigNumber']['output'];
  updatedAt: Scalars['VabsTimestamp']['output'];
  virtualBalance?: Maybe<VabsVirtualBalance>;
};

export type VabsVirtualBalanceInput = {
  currency: VabsRelatedEntityInput;
  description?: InputMaybe<Scalars['String']['input']>;
  metadata?: InputMaybe<Scalars['VabsJSON']['input']>;
  pluginsProcessId?: InputMaybe<Scalars['ID']['input']>;
  references?: InputMaybe<Array<VabsCreateReferenceInput>>;
  status: Scalars['String']['input'];
};

export type VabsVirtualBalances = {
  __typename?: 'VabsVirtualBalances';
  count: Scalars['Int']['output'];
  cursor: Scalars['Int']['output'];
  nodes: Array<VabsVirtualBalance>;
};

export type VabsVirtualBalancesHistories = {
  __typename?: 'VabsVirtualBalancesHistories';
  count: Scalars['Int']['output'];
  cursor: Scalars['Int']['output'];
  nodes: Array<VabsVirtualBalanceHistory>;
};

export type VabsVirtualBalancesPeriodHistory = {
  __typename?: 'VabsVirtualBalancesPeriodHistory';
  endDateBalance?: Maybe<VabsVirtualBalanceHistory>;
  startDateBalance?: Maybe<VabsVirtualBalanceHistory>;
};

export type VabsVirtualTransaction = {
  __typename?: 'VabsVirtualTransaction';
  amount: Scalars['VabsBigNumber']['output'];
  balanceFirstInHistory?: Maybe<VabsVirtualBalanceHistory>;
  balanceLastInHistory?: Maybe<VabsVirtualBalanceHistory>;
  createdAt: Scalars['VabsTimestamp']['output'];
  currency?: Maybe<VabsCurrency>;
  deletedAt?: Maybe<Scalars['VabsTimestamp']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  errorMessages?: Maybe<Array<VabsApiError>>;
  hasRequisites: Scalars['Boolean']['output'];
  historyRates: VabsHistoryRates;
  id: Scalars['ID']['output'];
  metadata?: Maybe<Scalars['VabsJSON']['output']>;
  operation: VabsOperation;
  order: Scalars['Int']['output'];
  pluginsProcessId?: Maybe<Scalars['ID']['output']>;
  previousStatus?: Maybe<VabsTransactionStatus>;
  provider?: Maybe<VabsVirtualTransactionProviderInfo>;
  providerTxId?: Maybe<Scalars['ID']['output']>;
  rawTxData?: Maybe<Scalars['String']['output']>;
  references: Array<VabsReference>;
  status: VabsTransactionStatus;
  transferType: VabsTransferType;
  updatedAt: Scalars['VabsTimestamp']['output'];
  virtualAccount?: Maybe<VabsVirtualAccount>;
};


export type VabsVirtualTransactionHistoryRatesArgs = {
  input?: VabsFilterInput;
};

export type VabsVirtualTransactionProviderConditionsFieldInput = {
  searchingField: Scalars['String']['input'];
  searchingType: VabsProviderSearchingType;
  value: Scalars['String']['input'];
};

export type VabsVirtualTransactionProviderConditionsInput = {
  fields: Array<VabsVirtualTransactionProviderConditionsFieldInput>;
  matchCount: Scalars['Int']['input'];
};

export type VabsVirtualTransactionProviderInfo = {
  __typename?: 'VabsVirtualTransactionProviderInfo';
  requisites?: Maybe<Scalars['VabsJSON']['output']>;
};

export type VabsVirtualTransactionProviderInput = {
  conditions: VabsVirtualTransactionProviderConditionsInput;
  requisites: Scalars['VabsJSON']['input'];
};

export type VabsVirtualTransactionVerifyResult = {
  __typename?: 'VabsVirtualTransactionVerifyResult';
  amount: Scalars['VabsBigNumber']['output'];
  currency: VabsRelatedEntity;
  declineReason: VabsApiError;
  description?: Maybe<Scalars['String']['output']>;
  historyRates?: Maybe<Array<VabsHistoryRateData>>;
  operation: VabsRelatedEntity;
  order: Scalars['Int']['output'];
  providerTxId?: Maybe<Scalars['ID']['output']>;
  rawTxData?: Maybe<Scalars['String']['output']>;
  transferType: VabsTransferType;
  virtualAccount: VabsRelatedEntity;
};

export type VabsVirtualTransactions = {
  __typename?: 'VabsVirtualTransactions';
  count: Scalars['Int']['output'];
  cursor: Scalars['Int']['output'];
  nodes: Array<VabsVirtualTransaction>;
};

export type VatInput = {
  code: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type VerificationMessage = {
  __typename?: 'VerificationMessage';
  messages: Array<Scalars['String']['output']>;
  type: VerificationMessageType;
};

export enum VerificationMessageType {
  Green = 'GREEN',
  Red = 'RED',
  RedFinal = 'RED_FINAL',
  Sent = 'SENT'
}

export type VerificationPhrase = {
  __typename?: 'VerificationPhrase';
  /** phrase expiration time */
  expire: Scalars['DateTime']['output'];
  /** stringify phrase value */
  phrase: Scalars['String']['output'];
  /** phrase that signed by server */
  serverSign: Scalars['String']['output'];
};

export type VerificationPhraseInput = {
  format: KeyEnum;
  /** stringify phrase value */
  phrase: Scalars['String']['input'];
  /** publicKey for auth user */
  publicKey: Scalars['String']['input'];
  /** phrase that signed by server */
  serverSign: Scalars['String']['input'];
  service: Scalars['String']['input'];
  /** phrase that signed by client */
  sign: Scalars['String']['input'];
  /** token for PUSH notification */
  token?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Description: input data for OTP tokens validation
 *
 * Example:
 *
 *
 *
 * {
 *
 *
 * "operationId": "operationId",
 *
 *
 * "tokens": [
 *
 *
 * {
 *
 *
 * "type": "SMS",
 *
 *
 * "token": "token"
 *
 *
 * }
 *
 *
 * ]
 *
 *
 * }
 */
export type Verify2FaInput = {
  /**
   * Required: true
   *
   * Description: Operation identifier
   *
   * Format:
   *
   *         uuid v4
   */
  operationId: Scalars['String']['input'];
  /**
   * Required: true
   *
   * Description: a field that contains an array of SMS codes and two-factor authentication types
   *
   * Format:
   *
   *         2 fields containing two-factor authentication typ and SMS code
   *
   *
   * Example:
   *
   *
   *             {
   *                 "type": "SMS",
   *                 "token": "123456"
   *             }
   */
  tokens: Array<VerifyTokenInput>;
};

/** Description: input for token validation */
export type VerifyTokenInput = {
  /**
   * Required: true
   *
   * Description: SMS code
   *
   * Format:
   *
   *         string containing 6 digits
   *
   *
   * Example:
   *
   *         "123456"
   */
  token: Scalars['String']['input'];
  /**
   * Required: true
   *
   * Description: two-factor authentication type
   *
   * Format:
   *
   *         string parameter from custom enum
   *
   *
   * Example:
   *
   *         "SMS"
   */
  type: TfaType;
};

export type Webhook = {
  __typename?: 'Webhook';
  data: Scalars['String']['output'];
  hash: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  type: Scalars['String']['output'];
};

export enum UserIdentityDocSetType {
  ApplicantData = 'APPLICANT_DATA',
  Company = 'COMPANY',
  Identity = 'IDENTITY',
  Identity2 = 'IDENTITY2',
  Investability = 'INVESTABILITY',
  PaymentMethods = 'PAYMENT_METHODS',
  ProofOfResidence = 'PROOF_OF_RESIDENCE',
  Questionnaire = 'QUESTIONNAIRE',
  Selfie = 'SELFIE',
  Selfie2 = 'SELFIE2'
}

export type AddressCategoriesQueryVariables = Exact<{
  input: AddressCategoriesInput;
}>;


export type AddressCategoriesQuery = { __typename?: 'Query', addressCategories: { __typename?: 'AddressCategories', count: number, nodes: Array<{ __typename?: 'AddressCategory', id: string, name: string }> } };

export type BusinessActivitiesQueryVariables = Exact<{
  input: GetBusinessActivitiesInput;
}>;


export type BusinessActivitiesQuery = { __typename?: 'Query', businessActivities?: { __typename?: 'BusinessActivities', count: number, cursor: number, nodes: Array<{ __typename?: 'BusinessActivity', id: string, description?: string | null, item: { __typename?: 'CommonDictItem', name: string } }> } | null };

export type CountriesV2QueryVariables = Exact<{
  input: DictFilterV2Input;
}>;


export type CountriesV2Query = { __typename?: 'Query', countriesV2: { __typename?: 'CountriesV2', count: number, cursor: number, nodes: Array<{ __typename?: 'Country', id: string, alpha3: string, phoneCode: string, phoneTemplate: string, item?: { __typename?: 'CommonDictItem', code: string, name: string } | null }> } };

export type DefaultCountryQueryVariables = Exact<{
  input: GetCountryInput;
}>;


export type DefaultCountryQuery = { __typename?: 'Query', country?: { __typename?: 'Country', id: string, alpha3: string, phoneCode: string, phoneTemplate: string, item?: { __typename?: 'CommonDictItem', code: string, name: string } | null } | null };

export type VabsAccCreateMyAccountBalancesMutationVariables = Exact<{
  input: VabsAccCreateMyAccountBalancesInput;
}>;


export type VabsAccCreateMyAccountBalancesMutation = { __typename?: 'Mutation', vabsAccCreateMyAccountBalances: Array<{ __typename?: 'VabsVirtualBalance', id: string, status: string, currency?: { __typename?: 'VabsCurrency', ticker: string } | null, virtualAccount?: { __typename?: 'VabsVirtualAccount', id: string } | null }> };

export type VabsAccMyBankDetailsQueryVariables = Exact<{
  input: VabsAccMyBankDetailsInput;
}>;


export type VabsAccMyBankDetailsQuery = { __typename?: 'Query', vabsAccMyBankDetails: { __typename?: 'VabsAccBankDetails', virtualAccountId: string, bankDetails: Array<{ __typename?: 'VabsAccBankDetailsCurrencyWithRoutes', currency: { __typename?: 'VabsCurrency', id: string, ticker: string, network: { __typename?: 'VabsNetwork', name: string } }, routes: Array<{ __typename?: 'VabsAccBankDetailsInnerRoute', schema: VabsAccBankDetailsSchemaEnum, details: { __typename?: 'VabsAccBankDetailsInner', virtualAccountId: string } } | { __typename?: 'VabsAccBankDetailsSwiftRoute', schema: VabsAccBankDetailsSchemaEnum, details: { __typename?: 'VabsAccBankDetailsSwift', remittanceInformation: Array<string>, beneficiary: { __typename?: 'VabsAccBankDetailsSwiftBeneficiary', address: string, name: string }, beneficiaryBank: { __typename?: 'VabsAccBankDetailsSwiftBeneficiaryBank', account: string, address?: string | null, code: string, name: string, country?: { __typename?: 'VabsAccBankDetailsCountry', alpha2: string, alpha3: string, name: string } | null }, correspondentBanks: Array<{ __typename?: 'VabsAccBankDetailsSwiftCorrespondentBank', account?: string | null, address?: string | null, code: string, name?: string | null, country?: { __typename?: 'VabsAccBankDetailsCountry', alpha2: string, alpha3: string, name: string } | null }> } }> }> } };

export type VirtualBalanceFragment = { __typename?: 'VabsVirtualBalance', id: string, status: string, availableAmount: any, currency?: { __typename?: 'VabsCurrency', ticker: string, id: string } | null };

export type VabsAccMyVirtualAccountsQueryVariables = Exact<{
  input: VabsAccFindMyVirtualAccountsInput;
  balancesInput: VabsFilterInput;
}>;


export type VabsAccMyVirtualAccountsQuery = { __typename?: 'Query', vabsAccMyVirtualAccounts: { __typename?: 'VabsVirtualAccounts', count: number, nodes: Array<{ __typename?: 'VabsVirtualAccount', id: string, virtualBalances: { __typename?: 'VabsVirtualBalances', count: number, cursor: number, nodes: Array<{ __typename?: 'VabsVirtualBalance', id: string, status: string, availableAmount: any, currency?: { __typename?: 'VabsCurrency', ticker: string, id: string } | null }> } }> } };

export type VabsAccMyVirtualBalancesQueryVariables = Exact<{
  accMyVirtualBalancesInput: VabsAccFindMyVirtualBalancesInput;
}>;


export type VabsAccMyVirtualBalancesQuery = { __typename?: 'Query', vabsAccMyVirtualBalances: { __typename?: 'VabsVirtualBalances', count: number, cursor: number, nodes: Array<{ __typename?: 'VabsVirtualBalance', id: string, status: string, availableAmount: any, currency?: { __typename?: 'VabsCurrency', ticker: string, id: string } | null }> } };

export type VabsCurrenciesQueryVariables = Exact<{ [key: string]: never; }>;


export type VabsCurrenciesQuery = { __typename?: 'Query', currencies: Array<{ __typename?: 'Currency', id: string, ticker: string, symbol?: string | null, item: { __typename?: 'CommonDictItem', name: string } } | null> };

export type VabsMyTotalBalanceQueryVariables = Exact<{
  currencyId: Scalars['String']['input'];
  virtualAccountId: Scalars['String']['input'];
}>;


export type VabsMyTotalBalanceQuery = { __typename?: 'Query', vabsMyTotalBalance: number };

export type CurrenciesQueryVariables = Exact<{
  input: DictFilterInput;
}>;


export type CurrenciesQuery = { __typename?: 'Query', currencies: Array<{ __typename?: 'Currency', id: string, ticker: string, symbol?: string | null, precision: number, item: { __typename?: 'CommonDictItem', code: string, name: string } } | null> };

export type VabsPaymentCalculatedFeeFragment = { __typename?: 'VabsPaymentCalculateFeeType', currencyTicker: string, originalAmount: any, originalTotalAmount: any, originalTotalFee: any };

export type VabsCalculateMyBsbPaymentFeeQueryVariables = Exact<{
  input: VabsCreateBsbPaymentInput;
}>;


export type VabsCalculateMyBsbPaymentFeeQuery = { __typename?: 'Query', vabsCalculateMyBsbPaymentFee: { __typename?: 'VabsPaymentCalculateFeeType', currencyTicker: string, originalAmount: any, originalTotalAmount: any, originalTotalFee: any } };

export type VabsCalculateMySwiftPaymentFeeQueryVariables = Exact<{
  input: VabsCreateSwiftPaymentInput;
}>;


export type VabsCalculateMySwiftPaymentFeeQuery = { __typename?: 'Query', vabsCalculateMySwiftPaymentFee: { __typename?: 'VabsPaymentCalculateFeeType', currencyTicker: string, originalAmount: any, originalTotalAmount: any, originalTotalFee: any } };

export type VabsCalculateMyInnerPaymentFeeQueryVariables = Exact<{
  input: VabsCreateInnerPaymentInput;
}>;


export type VabsCalculateMyInnerPaymentFeeQuery = { __typename?: 'Query', vabsCalculateMyInnerPaymentFee: { __typename?: 'VabsPaymentCalculateFeeType', currencyTicker: string, originalAmount: any, originalTotalAmount: any, originalTotalFee: any } };

export type VabsCalculateMyIfscPaymentFeeQueryVariables = Exact<{
  input: VabsCreateIfscPaymentInput;
}>;


export type VabsCalculateMyIfscPaymentFeeQuery = { __typename?: 'Query', vabsCalculateMyIfscPaymentFee: { __typename?: 'VabsPaymentCalculateFeeType', currencyTicker: string, originalAmount: any, originalTotalAmount: any, originalTotalFee: any } };

export type VabsCreateMyBsbPaymentMutationVariables = Exact<{
  input: VabsCreateBsbPaymentInput;
}>;


export type VabsCreateMyBsbPaymentMutation = { __typename?: 'Mutation', vabsCreateMyBsbPayment: { __typename?: 'VabsBsbPaymentType', id: string } };

export type VabsCreateMyIfscPaymentMutationVariables = Exact<{
  input: VabsCreateIfscPaymentInput;
}>;


export type VabsCreateMyIfscPaymentMutation = { __typename?: 'Mutation', vabsCreateMyIfscPayment: { __typename?: 'VabsIfscPaymentType', id: string } };

export type VabsCreateMyInnerPaymentMutationVariables = Exact<{
  input: VabsCreateInnerPaymentInput;
}>;


export type VabsCreateMyInnerPaymentMutation = { __typename?: 'Mutation', vabsCreateMyInnerPayment: { __typename?: 'VabsInnerPaymentType', id: string } };

export type VabsCreateMySwiftPaymentMutationVariables = Exact<{
  input: VabsCreateSwiftPaymentInput;
}>;


export type VabsCreateMySwiftPaymentMutation = { __typename?: 'Mutation', vabsCreateMySwiftPayment: { __typename?: 'VabsSwiftPaymentType', id: string } };

export type VabsInternalClientsForInternalPaymentQueryVariables = Exact<{
  email?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
}>;


export type VabsInternalClientsForInternalPaymentQuery = { __typename?: 'Query', vabsInternalClientsForInternalPayment: Array<{ __typename?: 'VabsInternalClientForPaymentType', accountId: string, clientId: string, companyName: string, availableCurrencies: Array<{ __typename?: 'VabsDictionaryCurrency', id: string }> }> };

export type VabsMyPaymentMethodsQueryVariables = Exact<{
  input: VabsFindPaymentMethodsInput;
}>;


export type VabsMyPaymentMethodsQuery = { __typename?: 'Query', vabsMyPaymentMethods: { __typename?: 'VabsPaymentMethods', cursor: number, count: number, nodes: Array<{ __typename?: 'VabsPaymentMethod', id: string, isActive: boolean, type: VabsPaymentSystem }> } };

export type VabsMyPaymentsQueryVariables = Exact<{
  input: VabsFindPaymentsInput;
}>;


export type VabsMyPaymentsQuery = { __typename?: 'Query', vabsMyPayments: { __typename?: 'VabsPayments', cursor: number, count: number, nodes: Array<{ __typename?: 'VabsBsbPaymentType', id: string, createdAt: any, status: VabsPaymentStatus, direction: VabsPaymentDirection, paymentSystem: VabsPaymentSystem, purposeOfPayment: string, sourceOfFunds?: VabsPaymentSourceOfFunds | null, totalAmount: { __typename?: 'VabsPaymentTotalAmountType', source: { __typename?: 'VabsPaymentPartyAmountType', amount: any }, target: { __typename?: 'VabsPaymentPartyAmountType', amount: any } }, fee: { __typename?: 'VabsPaymentFeeType', target: { __typename?: 'VabsPaymentPartyFeeType', provider: any, total: any } }, amount: { __typename?: 'VabsPaymentAmountType', source: { __typename?: 'VabsPaymentPartyAmountType', amount: any, currency: { __typename?: 'VabsDictionaryCurrency', id: string } }, target: { __typename?: 'VabsPaymentPartyAmountType', amount: any, currency: { __typename?: 'VabsDictionaryCurrency', id: string } } }, external: { __typename?: 'VabsBasePaymentMethodExternalClientType', accountNumber: string, bankCode: string, clientType: VabsPaymentClientTypeEnum, firstName?: string | null, lastName?: string | null, accountHolderName: string, address: { __typename?: 'VabsBasePaymentMethodExternalClientAddressType', line1: string, line2?: string | null, postalCode?: string | null, country: { __typename?: 'VabsDictionaryCountry', id: string } }, bank: { __typename?: 'VabsBasePaymentMethodExternalClientBankType', cityName?: string | null, name?: string | null, addressLine1?: string | null, postalCode?: string | null, country: { __typename?: 'VabsDictionaryCountry', id: string } } } } | { __typename?: 'VabsIfscPaymentType', id: string, createdAt: any, direction: VabsPaymentDirection, status: VabsPaymentStatus, paymentSystem: VabsPaymentSystem, purposeOfPayment: string, sourceOfFunds?: VabsPaymentSourceOfFunds | null, totalAmount: { __typename?: 'VabsPaymentTotalAmountType', source: { __typename?: 'VabsPaymentPartyAmountType', amount: any }, target: { __typename?: 'VabsPaymentPartyAmountType', amount: any } }, fee: { __typename?: 'VabsPaymentFeeType', target: { __typename?: 'VabsPaymentPartyFeeType', provider: any, total: any } }, amount: { __typename?: 'VabsPaymentAmountType', source: { __typename?: 'VabsPaymentPartyAmountType', amount: any, currency: { __typename?: 'VabsDictionaryCurrency', id: string } }, target: { __typename?: 'VabsPaymentPartyAmountType', amount: any, currency: { __typename?: 'VabsDictionaryCurrency', id: string } } }, external: { __typename?: 'VabsBasePaymentMethodExternalClientType', accountNumber: string, bankCode: string, clientType: VabsPaymentClientTypeEnum, firstName?: string | null, lastName?: string | null, accountHolderName: string, address: { __typename?: 'VabsBasePaymentMethodExternalClientAddressType', line1: string, line2?: string | null, postalCode?: string | null, country: { __typename?: 'VabsDictionaryCountry', id: string } }, bank: { __typename?: 'VabsBasePaymentMethodExternalClientBankType', cityName?: string | null, name?: string | null, addressLine1?: string | null, postalCode?: string | null, country: { __typename?: 'VabsDictionaryCountry', id: string } } } } | { __typename?: 'VabsInnerPaymentType', createdAt: any, direction: VabsPaymentDirection, id: string, note?: string | null, paymentSystem: VabsPaymentSystem, purposeOfPayment: string, settled?: any | null, status: VabsPaymentStatus, updatedAt: any, amount: { __typename?: 'VabsPaymentAmountType', source: { __typename?: 'VabsPaymentPartyAmountType', amount: any, currency: { __typename?: 'VabsDictionaryCurrency', id: string } }, target: { __typename?: 'VabsPaymentPartyAmountType', amount: any, currency: { __typename?: 'VabsDictionaryCurrency', id: string } } }, fee: { __typename?: 'VabsPaymentFeeType', source: { __typename?: 'VabsPaymentPartyFeeType', total: any, currency: { __typename?: 'VabsDictionaryCurrency', id: string } }, target: { __typename?: 'VabsPaymentPartyFeeType', provider: any, total: any, currency: { __typename?: 'VabsDictionaryCurrency', id: string } } }, recipientClient: { __typename?: 'VabsInnerClientPaymentType', phoneNumber?: string | null, email?: string | null, clientId: string, accountId: string, accountHolderName: string }, senderClient: { __typename?: 'VabsInnerClientPaymentType', accountId: string, accountHolderName: string }, totalAmount: { __typename?: 'VabsPaymentTotalAmountType', source: { __typename?: 'VabsPaymentPartyAmountType', amount: any, currency: { __typename?: 'VabsDictionaryCurrency', id: string } }, target: { __typename?: 'VabsPaymentPartyAmountType', amount: any, currency: { __typename?: 'VabsDictionaryCurrency', id: string } } } } | { __typename?: 'VabsSwiftPaymentType', id: string, createdAt: any, status: VabsPaymentStatus, direction: VabsPaymentDirection, paymentSystem: VabsPaymentSystem, purposeOfPayment: string, sourceOfFunds?: VabsPaymentSourceOfFunds | null, fee: { __typename?: 'VabsPaymentFeeType', target: { __typename?: 'VabsPaymentPartyFeeType', provider: any, total: any } }, totalAmount: { __typename?: 'VabsPaymentTotalAmountType', source: { __typename?: 'VabsPaymentPartyAmountType', amount: any }, target: { __typename?: 'VabsPaymentPartyAmountType', amount: any } }, amount: { __typename?: 'VabsPaymentAmountType', source: { __typename?: 'VabsPaymentPartyAmountType', amount: any, currency: { __typename?: 'VabsDictionaryCurrency', id: string } }, target: { __typename?: 'VabsPaymentPartyAmountType', amount: any, currency: { __typename?: 'VabsDictionaryCurrency', id: string } } }, external: { __typename?: 'VabsBasePaymentMethodExternalClientType', accountNumber: string, bankCode: string, clientType: VabsPaymentClientTypeEnum, accountHolderName: string, firstName?: string | null, lastName?: string | null, address: { __typename?: 'VabsBasePaymentMethodExternalClientAddressType', line1: string, line2?: string | null, postalCode?: string | null, country: { __typename?: 'VabsDictionaryCountry', id: string } }, bank: { __typename?: 'VabsBasePaymentMethodExternalClientBankType', cityName?: string | null, name?: string | null, addressLine1?: string | null, postalCode?: string | null, country: { __typename?: 'VabsDictionaryCountry', id: string } }, intermediaryBank?: { __typename?: 'VabsBasePaymentMethodIntermediaryBankType', accountNumber?: string | null, addressLine1?: string | null, addressLine2?: string | null, bankCode?: string | null, cityName?: string | null, name?: string | null, country?: { __typename?: 'VabsDictionaryCountry', id: string } | null } | null } }> } };

export type VabsUpdateMyPaymentFavoriteMutationVariables = Exact<{
  input: VabsUpdatePaymentFavoriteInput;
}>;


export type VabsUpdateMyPaymentFavoriteMutation = { __typename?: 'Mutation', vabsUpdateMyPaymentFavorite: { __typename?: 'VabsBsbPaymentType', id: string } | { __typename?: 'VabsIfscPaymentType', id: string } | { __typename?: 'VabsInnerPaymentType' } | { __typename?: 'VabsSwiftPaymentType', id: string } };

export type CompanyTypesQueryVariables = Exact<{ [key: string]: never; }>;


export type CompanyTypesQuery = { __typename?: 'Query', companyTypes?: { __typename?: 'CompanyTypes', nodes: Array<{ __typename?: 'CompanyType', id: string, item: { __typename?: 'CommonDictItem', name: string } }> } | null };

export type CountriesQueryVariables = Exact<{ [key: string]: never; }>;


export type CountriesQuery = { __typename?: 'Query', countries: Array<{ __typename?: 'Country', alpha3: string, id: string, item?: { __typename?: 'CommonDictItem', name: string } | null } | null> };

export type StaticDataQueryVariables = Exact<{ [key: string]: never; }>;


export type StaticDataQuery = { __typename?: 'Query', staticData: { __typename?: 'StaticData', companySourcesOfFunds: Array<{ __typename?: 'SourceOfFunds', name: string, value: string }>, companySourcesOfWealth: Array<{ __typename?: 'SourceOfWealth', name: string, value: string }> } };

export type CountryFragment = { __typename?: 'Country', id: string, alpha3: string, item?: { __typename?: 'CommonDictItem', code: string, name: string } | null };

export type MyCompaniesQueryVariables = Exact<{
  input: FindCompaniesInput;
  additionalInfosInput: FindAdditionalInfosInput;
}>;


export type MyCompaniesQuery = { __typename?: 'Query', myCompanies: { __typename?: 'Companies', count: number, nodes: Array<{ __typename?: 'Company', id: string, isInternalTransferAllowed: boolean, registeredBusinessName?: string | null, companyOwnershipStructure?: CompanyOwnershipStructure | null, type?: string | null, currentKYBLevelStatusV2?: { __typename?: 'KYBLevelStatusV2', status?: KybStepStatus | null } | null, countryOfIncorporation?: { __typename?: 'Country', id: string, alpha3: string, item?: { __typename?: 'CommonDictItem', code: string, name: string } | null } | null, registrant: { __typename?: 'CompanyMember', id: string }, companyType?: { __typename?: 'CompanyType', id: string, item: { __typename?: 'CommonDictItem', name: string } } | null, additionalInfos: { __typename?: 'AdditionalInfos', count: number, nodes: Array<{ __typename?: 'AdditionalInfo', id: string, clientId: string, key: string, name: string, value: any }> } }> } };

export type MyPersonalDataQueryVariables = Exact<{
  addressesInput: FindUserAddressesInput;
}>;


export type MyPersonalDataQuery = { __typename?: 'Query', myPersonalData: { __typename?: 'User', userId: string, addresses?: { __typename?: 'Addresses', count: number, nodes: Array<{ __typename?: 'Address', postalCode?: string | null, rawCityName?: string | null, formattedStringValue: string }> } | null, personal: { __typename?: 'UserPersonal', email?: string | null, phone?: string | null, birthDate?: any | null, name?: { __typename?: 'IdentityFullName', firstName?: string | null, lastName?: string | null, middleName?: string | null } | null, residenceCountry?: { __typename?: 'Country', id: string, alpha3: string, item?: { __typename?: 'CommonDictItem', name: string } | null } | null } } };

export type SignInV2QueryVariables = Exact<{
  input: AuthInput;
}>;


export type SignInV2Query = { __typename?: 'Query', signInV2: { __typename?: 'SignInResult', emailRetryAfter?: any | null, emailTimeout?: number | null, smsRetryAfter?: any | null, smsTimeout?: number | null, phoneNumber?: string | null, response: Array<TfaType>, operationId: string } };

export type CompanyFragmentFragment = { __typename?: 'Company', id: string, registrationNumber?: string | null, registeredBusinessName?: string | null, countryOfIncorporation?: { __typename?: 'Country', id: string, alpha3: string, item?: { __typename?: 'CommonDictItem', code: string, name: string } | null } | null };

export type UserFragmentFragment = { __typename?: 'User', currentKYCLevelStatusV2?: { __typename?: 'KYCLevelStatusV2', status: KycStepStatus } | null, personal: { __typename?: 'UserPersonal', birthDate?: any | null, gender?: Gender | null, name?: { __typename?: 'IdentityFullName', firstName?: string | null, middleName?: string | null, lastName?: string | null } | null, nationalityCountry?: { __typename?: 'Country', id: string, alpha3: string, item?: { __typename?: 'CommonDictItem', code: string, name: string } | null } | null, residenceCountry?: { __typename?: 'Country', id: string, alpha3: string, item?: { __typename?: 'CommonDictItem', code: string, name: string } | null } | null } };

export type ChildMembersQueryVariables = Exact<{
  input: FindCompaniesInput;
  childCompaniesInput: FilterInput;
  companiesAddressesInput: FilterInput;
  childMembersInput: FindMembersInput;
  membersAddressesInput: FindUserAddressesInput;
  childCompaniesSubmembersInput: FilterInput;
  childSubmembersInput: FindMembersInput;
}>;


export type ChildMembersQuery = { __typename?: 'Query', myCompanies: { __typename?: 'Companies', nodes: Array<{ __typename?: 'Company', childCompanies?: { __typename?: 'Companies', count: number, nodes: Array<{ __typename?: 'Company', share?: number | null, id: string, registrationNumber?: string | null, registeredBusinessName?: string | null, addresses: { __typename?: 'Addresses', nodes: Array<{ __typename?: 'Address', id: string, street?: string | null, postalCode?: string | null, rawCityName?: string | null, country?: { __typename?: 'Country', id: string, alpha3: string, item?: { __typename?: 'CommonDictItem', code: string, name: string } | null } | null }> }, childCompanies?: { __typename?: 'Companies', nodes: Array<{ __typename?: 'Company', id: string, registrationNumber?: string | null, registeredBusinessName?: string | null, addresses: { __typename?: 'Addresses', nodes: Array<{ __typename?: 'Address', id: string, street?: string | null, postalCode?: string | null, rawCityName?: string | null, country?: { __typename?: 'Country', id: string, alpha3: string, item?: { __typename?: 'CommonDictItem', code: string, name: string } | null } | null }> }, countryOfIncorporation?: { __typename?: 'Country', id: string, alpha3: string, item?: { __typename?: 'CommonDictItem', code: string, name: string } | null } | null }> } | null, members: { __typename?: 'CompanyMembers', nodes: Array<{ __typename?: 'CompanyMember', id: string, positions?: Array<string> | null, pep?: { __typename?: 'MemberPep', position?: string | null, startWorkingDate?: any | null, endWorkingDate?: any | null } | null, user: { __typename?: 'User', currentKYCLevelStatusV2?: { __typename?: 'KYCLevelStatusV2', status: KycStepStatus } | null, personal: { __typename?: 'UserPersonal', birthDate?: any | null, gender?: Gender | null, name?: { __typename?: 'IdentityFullName', firstName?: string | null, middleName?: string | null, lastName?: string | null } | null, nationalityCountry?: { __typename?: 'Country', id: string, alpha3: string, item?: { __typename?: 'CommonDictItem', code: string, name: string } | null } | null, residenceCountry?: { __typename?: 'Country', id: string, alpha3: string, item?: { __typename?: 'CommonDictItem', code: string, name: string } | null } | null } } }> }, countryOfIncorporation?: { __typename?: 'Country', id: string, alpha3: string, item?: { __typename?: 'CommonDictItem', code: string, name: string } | null } | null }> } | null, members: { __typename?: 'CompanyMembers', count: number, nodes: Array<{ __typename?: 'CompanyMember', id: string, share?: number | null, type: CompanyMemberType, positions?: Array<string> | null, pep?: { __typename?: 'MemberPep', position?: string | null, startWorkingDate?: any | null, endWorkingDate?: any | null } | null, user: { __typename?: 'User', addresses?: { __typename?: 'Addresses', nodes: Array<{ __typename?: 'Address', id: string, street?: string | null, postalCode?: string | null, rawCityName?: string | null, country?: { __typename?: 'Country', id: string, alpha3: string, item?: { __typename?: 'CommonDictItem', code: string, name: string } | null } | null }> } | null, currentKYCLevelStatusV2?: { __typename?: 'KYCLevelStatusV2', status: KycStepStatus } | null, personal: { __typename?: 'UserPersonal', birthDate?: any | null, gender?: Gender | null, name?: { __typename?: 'IdentityFullName', firstName?: string | null, middleName?: string | null, lastName?: string | null } | null, nationalityCountry?: { __typename?: 'Country', id: string, alpha3: string, item?: { __typename?: 'CommonDictItem', code: string, name: string } | null } | null, residenceCountry?: { __typename?: 'Country', id: string, alpha3: string, item?: { __typename?: 'CommonDictItem', code: string, name: string } | null } | null } } }> } }> } };

export type CreateCorporateMemberMutationVariables = Exact<{
  companyId: Scalars['String']['input'];
  input: CreateMyCompanyInput;
}>;


export type CreateCorporateMemberMutation = { __typename?: 'Mutation', createMyCompanyV2: { __typename?: 'Company', id: string } };

export type CreateCorporateMemberAddressMutationVariables = Exact<{
  input: CreateMyAddressInput;
}>;


export type CreateCorporateMemberAddressMutation = { __typename?: 'Mutation', createMyAddress: { __typename?: 'CreatedOrUpdatedAddress', id: string } };

export type CreateCorporateMembersMutationVariables = Exact<{
  createMyCompaniesInput: Array<CreateMyCompanyInput> | CreateMyCompanyInput;
}>;


export type CreateCorporateMembersMutation = { __typename?: 'Mutation', createMyCompanies: Array<{ __typename?: 'Company', id: string }> };

export type CreateIndividualMemberMutationVariables = Exact<{
  companyId: Scalars['String']['input'];
  input: CreateMyCompanyMemberInput;
}>;


export type CreateIndividualMemberMutation = { __typename?: 'Mutation', createMyCompanyMemberV2: { __typename?: 'CompanyMember', id: string } };

export type CreateIndividualMemberAddressMutationVariables = Exact<{
  input: CreateAddressInput;
}>;


export type CreateIndividualMemberAddressMutation = { __typename?: 'Mutation', createMyCompanyMemberAddress: { __typename?: 'Address', id: string, street?: string | null, subStreet?: string | null, rawCityName?: string | null, postalCode?: string | null, country?: { __typename?: 'Country', id: string, alpha3: string, item?: { __typename?: 'CommonDictItem', code: string, name: string } | null } | null } };

export type CreateIndividualMembersMutationVariables = Exact<{
  companyId: Scalars['String']['input'];
  createMyCompanyMembersInput: Array<CreateMyCompanyMemberInput> | CreateMyCompanyMemberInput;
}>;


export type CreateIndividualMembersMutation = { __typename?: 'Mutation', createMyCompanyMembersV2: Array<{ __typename?: 'CompanyMember', id: string }> };

export type DeleteCorporateMemberMutationVariables = Exact<{ [key: string]: never; }>;


export type DeleteCorporateMemberMutation = { __typename?: 'Mutation', detachMyCompany?: boolean | null };

export type DeleteIndividualMemberMutationVariables = Exact<{
  memberId: Scalars['ID']['input'];
}>;


export type DeleteIndividualMemberMutation = { __typename?: 'Mutation', deleteMyCompanyMember: boolean };

export type UpdateCorporateMemberMutationVariables = Exact<{
  companyId: Scalars['String']['input'];
  input: UpdateMyCompanyInput;
}>;


export type UpdateCorporateMemberMutation = { __typename?: 'Mutation', updateMyCompanyV2: { __typename?: 'Company', id: string } };

export type UpdateIndividualMemberMutationVariables = Exact<{
  input: UpdateMyCompanyMemberInput;
}>;


export type UpdateIndividualMemberMutation = { __typename?: 'Mutation', updateMyCompanyMember: { __typename?: 'CompanyMember', id: string } };

export type CreateMyAddressMutationVariables = Exact<{
  input: CreateMyAddressInput;
}>;


export type CreateMyAddressMutation = { __typename?: 'Mutation', createMyAddress: { __typename?: 'CreatedOrUpdatedAddress', id: string } };

export type CreateMyCompanyAdditionalInfoMutationVariables = Exact<{
  input: CreateMyAdditionalInfoInput;
}>;


export type CreateMyCompanyAdditionalInfoMutation = { __typename?: 'Mutation', createMyCompanyAdditionalInfo: { __typename?: 'AdditionalInfo', id: string } };

export type DeleteMyAddressMutationVariables = Exact<{
  input: Scalars['String']['input'];
}>;


export type DeleteMyAddressMutation = { __typename?: 'Mutation', deleteMyAddress: boolean };

export type MyCompanyMemberRegistrantFragment = { __typename?: 'CompanyMember', id: string, share?: number | null, type: CompanyMemberType, positions?: Array<string> | null, pep?: { __typename?: 'MemberPep', position?: string | null, startWorkingDate?: any | null, endWorkingDate?: any | null } | null, user: { __typename?: 'User', id: string, currentKYCLevelStatusV2?: { __typename?: 'KYCLevelStatusV2', status: KycStepStatus, passedKYCBy?: any | null, currentStep: { __typename?: 'KYCStep', rejectionReason?: string | null } } | null, personal: { __typename?: 'UserPersonal', gender?: Gender | null, birthDate?: any | null, name?: { __typename?: 'IdentityFullName', firstName?: string | null, middleName?: string | null, lastName?: string | null } | null, nationalityCountry?: { __typename?: 'Country', id: string, alpha3: string, item?: { __typename?: 'CommonDictItem', code: string, name: string } | null } | null, residenceCountry?: { __typename?: 'Country', id: string, alpha3: string, item?: { __typename?: 'CommonDictItem', code: string, name: string } | null } | null }, addresses?: { __typename?: 'Addresses', count: number, nodes: Array<{ __typename?: 'Address', id: string, street?: string | null, subStreet?: string | null, rawCityName?: string | null, postalCode?: string | null, country?: { __typename?: 'Country', id: string, alpha3: string, item?: { __typename?: 'CommonDictItem', code: string, name: string } | null } | null }> } | null } };

export type CreateMyCompanyMutationVariables = Exact<{
  input: CreateMyCompanyInput;
}>;


export type CreateMyCompanyMutation = { __typename?: 'Mutation', createMyCompany: { __typename?: 'Company', id: string, registrant: { __typename?: 'CompanyMember', id: string, share?: number | null, type: CompanyMemberType, positions?: Array<string> | null, pep?: { __typename?: 'MemberPep', position?: string | null, startWorkingDate?: any | null, endWorkingDate?: any | null } | null, user: { __typename?: 'User', id: string, currentKYCLevelStatusV2?: { __typename?: 'KYCLevelStatusV2', status: KycStepStatus, passedKYCBy?: any | null, currentStep: { __typename?: 'KYCStep', rejectionReason?: string | null } } | null, personal: { __typename?: 'UserPersonal', gender?: Gender | null, birthDate?: any | null, name?: { __typename?: 'IdentityFullName', firstName?: string | null, middleName?: string | null, lastName?: string | null } | null, nationalityCountry?: { __typename?: 'Country', id: string, alpha3: string, item?: { __typename?: 'CommonDictItem', code: string, name: string } | null } | null, residenceCountry?: { __typename?: 'Country', id: string, alpha3: string, item?: { __typename?: 'CommonDictItem', code: string, name: string } | null } | null }, addresses?: { __typename?: 'Addresses', count: number, nodes: Array<{ __typename?: 'Address', id: string, street?: string | null, subStreet?: string | null, rawCityName?: string | null, postalCode?: string | null, country?: { __typename?: 'Country', id: string, alpha3: string, item?: { __typename?: 'CommonDictItem', code: string, name: string } | null } | null }> } | null } } } };

export type DraftCompanyQueryVariables = Exact<{
  input: FindCompaniesInput;
  additionalInfosInput: FindAdditionalInfosInput;
  addressesInput: FilterInput;
  membersInput: FindMembersInput;
  categoriesInput: FilterInput;
  childCompaniesInput: FilterInput;
}>;


export type DraftCompanyQuery = { __typename?: 'Query', myCompanies: { __typename?: 'Companies', count: number, nodes: Array<{ __typename?: 'Company', id: string, registrationNumber?: string | null, sourceOfFunds?: Array<string> | null, otherSourceOfFunds?: string | null, otherSourceOfWealth?: string | null, sourceOfWealth?: Array<string> | null, controlSchema?: string | null, registeredBusinessName?: string | null, companyOwnershipStructure?: CompanyOwnershipStructure | null, website?: string | null, faxNumber?: string | null, totalNumberOfEmployees?: string | null, type?: string | null, registrant: { __typename?: 'CompanyMember', id: string, share?: number | null, type: CompanyMemberType, positions?: Array<string> | null, pep?: { __typename?: 'MemberPep', position?: string | null, startWorkingDate?: any | null, endWorkingDate?: any | null } | null, user: { __typename?: 'User', id: string, currentKYCLevelStatusV2?: { __typename?: 'KYCLevelStatusV2', status: KycStepStatus, passedKYCBy?: any | null, currentStep: { __typename?: 'KYCStep', rejectionReason?: string | null } } | null, personal: { __typename?: 'UserPersonal', gender?: Gender | null, birthDate?: any | null, name?: { __typename?: 'IdentityFullName', firstName?: string | null, middleName?: string | null, lastName?: string | null } | null, nationalityCountry?: { __typename?: 'Country', id: string, alpha3: string, item?: { __typename?: 'CommonDictItem', code: string, name: string } | null } | null, residenceCountry?: { __typename?: 'Country', id: string, alpha3: string, item?: { __typename?: 'CommonDictItem', code: string, name: string } | null } | null }, addresses?: { __typename?: 'Addresses', count: number, nodes: Array<{ __typename?: 'Address', id: string, street?: string | null, subStreet?: string | null, rawCityName?: string | null, postalCode?: string | null, country?: { __typename?: 'Country', id: string, alpha3: string, item?: { __typename?: 'CommonDictItem', code: string, name: string } | null } | null }> } | null } }, members: { __typename?: 'CompanyMembers', count: number }, businessProfit?: { __typename?: 'FinancialAmountType', amount: any, currency: { __typename?: 'Currency', id: string, ticker: string, item: { __typename?: 'CommonDictItem', name: string } } } | null, employmentIncome?: { __typename?: 'FinancialAmountType', amount: any, currency: { __typename?: 'Currency', id: string, ticker: string } } | null, savingsAndDeposit?: { __typename?: 'FinancialAmountType', amount: any, currency: { __typename?: 'Currency', id: string, ticker: string } } | null, childCompanies?: { __typename?: 'Companies', count: number } | null, loan?: { __typename?: 'FinancialAmountType', amount: any, currency: { __typename?: 'Currency', id: string, ticker: string } } | null, annualTurnover?: { __typename?: 'FinancialAmountType', amount: any, currency: { __typename?: 'Currency', id: string, ticker: string, item: { __typename?: 'CommonDictItem', name: string } } } | null, detailsSourceOfWealth?: Array<{ __typename?: 'DetailSourceOfWealth', amount: string, sourceOfWealth: string, currency: { __typename?: 'Currency', id: string, symbol?: string | null, ticker: string } }> | null, outgoingPaymentsByCountries?: Array<{ __typename?: 'PaymentFlowByCountryType', percentage: number, country: { __typename?: 'Country', id: string, alpha3: string, item?: { __typename?: 'CommonDictItem', code: string, name: string } | null }, businessActivity?: { __typename?: 'BusinessActivity', id: string, item: { __typename?: 'CommonDictItem', name: string } } | null }> | null, incomingPaymentsByCountries?: Array<{ __typename?: 'PaymentFlowByCountryType', percentage: number, country: { __typename?: 'Country', id: string, alpha3: string, item?: { __typename?: 'CommonDictItem', code: string, name: string } | null }, businessActivity?: { __typename?: 'BusinessActivity', id: string, item: { __typename?: 'CommonDictItem', name: string } } | null }> | null, countryOfIncorporation?: { __typename?: 'Country', id: string, alpha3: string, item?: { __typename?: 'CommonDictItem', code: string, name: string } | null } | null, paidUpShareCapital?: { __typename?: 'FinancialAmountType', amount: any, currency: { __typename?: 'Currency', id: string, ticker: string } } | null, businessActivities?: Array<{ __typename?: 'BusinessActivity', id: string, item: { __typename?: 'CommonDictItem', name: string }, parent?: { __typename?: 'BusinessActivity', id: string, item: { __typename?: 'CommonDictItem', name: string } } | null }> | null, addresses: { __typename?: 'Addresses', nodes: Array<{ __typename?: 'Address', id: string, street?: string | null, subStreet?: string | null, postalCode?: string | null, rawCityName?: string | null, categories?: { __typename?: 'AddressCategories', nodes: Array<{ __typename?: 'AddressCategory', id: string, name: string }> } | null, country?: { __typename?: 'Country', id: string, alpha3: string, item?: { __typename?: 'CommonDictItem', code: string, name: string } | null } | null }> }, companyType?: { __typename?: 'CompanyType', id: string, item: { __typename?: 'CommonDictItem', name: string } } | null, additionalInfos: { __typename?: 'AdditionalInfos', nodes: Array<{ __typename?: 'AdditionalInfo', id: string, clientId: string, key: string, name: string, value: any }> } }> } };

export type MyCompanyAdditionalInfosQueryVariables = Exact<{
  input: FindAdditionalInfosInput;
}>;


export type MyCompanyAdditionalInfosQuery = { __typename?: 'Query', myCompanyAdditionalInfos: { __typename?: 'AdditionalInfos', nodes: Array<{ __typename?: 'AdditionalInfo', id: string, key: string, name: string, value: any }> } };

export type MyCompanyMemberUserFragment = { __typename?: 'User', id: string, currentKYCLevelStatusV2?: { __typename?: 'KYCLevelStatusV2', status: KycStepStatus, passedKYCBy?: any | null, currentStep: { __typename?: 'KYCStep', rejectionReason?: string | null } } | null, personal: { __typename?: 'UserPersonal', gender?: Gender | null, name?: { __typename?: 'IdentityFullName', firstName?: string | null, middleName?: string | null, lastName?: string | null } | null, nationalityCountry?: { __typename?: 'Country', id: string, alpha3: string, item?: { __typename?: 'CommonDictItem', code: string, name: string } | null } | null, residenceCountry?: { __typename?: 'Country', id: string, alpha3: string, item?: { __typename?: 'CommonDictItem', code: string, name: string } | null } | null } };

export type MyCompanyMemberFragment = { __typename?: 'CompanyMember', id: string, share?: number | null, type: CompanyMemberType, positions?: Array<string> | null, pep?: { __typename?: 'MemberPep', position?: string | null, startWorkingDate?: any | null, endWorkingDate?: any | null } | null };

export type MyCompanyMembersQueryVariables = Exact<{
  input: FindMembersInput;
  addressesInput: FindUserAddressesInput;
}>;


export type MyCompanyMembersQuery = { __typename?: 'Query', myCompanyMembers: { __typename?: 'CompanyMembers', count: number, cursor: number, nodes: Array<{ __typename?: 'CompanyMember', id: string, share?: number | null, type: CompanyMemberType, positions?: Array<string> | null, user: { __typename?: 'User', id: string, addresses?: { __typename?: 'Addresses', nodes: Array<{ __typename?: 'Address', id: string, street?: string | null, subStreet?: string | null, rawCityName?: string | null, postalCode?: string | null, country?: { __typename?: 'Country', id: string, alpha3: string, item?: { __typename?: 'CommonDictItem', code: string, name: string } | null } | null }> } | null, currentKYCLevelStatusV2?: { __typename?: 'KYCLevelStatusV2', status: KycStepStatus, passedKYCBy?: any | null, currentStep: { __typename?: 'KYCStep', rejectionReason?: string | null } } | null, personal: { __typename?: 'UserPersonal', gender?: Gender | null, name?: { __typename?: 'IdentityFullName', firstName?: string | null, middleName?: string | null, lastName?: string | null } | null, nationalityCountry?: { __typename?: 'Country', id: string, alpha3: string, item?: { __typename?: 'CommonDictItem', code: string, name: string } | null } | null, residenceCountry?: { __typename?: 'Country', id: string, alpha3: string, item?: { __typename?: 'CommonDictItem', code: string, name: string } | null } | null } }, pep?: { __typename?: 'MemberPep', position?: string | null, startWorkingDate?: any | null, endWorkingDate?: any | null } | null }> } };

export type StartMyKybProcedureV2MutationVariables = Exact<{ [key: string]: never; }>;


export type StartMyKybProcedureV2Mutation = { __typename?: 'Mutation', startMyKYBProcedureV2: { __typename?: 'KYBLevelStatusV2', id: string, status?: KybStepStatus | null } };

export type UpdateMyAddressMutationVariables = Exact<{
  input: UpdateAddressInput;
}>;


export type UpdateMyAddressMutation = { __typename?: 'Mutation', updateMyAddress: { __typename?: 'CreatedOrUpdatedAddress', id: string } };

export type UpdateMyCompanyMutationVariables = Exact<{
  input: UpdateMyCompanyInput;
}>;


export type UpdateMyCompanyMutation = { __typename?: 'Mutation', updateMyCompany: { __typename?: 'Company', id: string } };

export type UpdateMyCompanyAdditionalInfoMutationVariables = Exact<{
  input: UpdateMyAdditionalInfoInput;
}>;


export type UpdateMyCompanyAdditionalInfoMutation = { __typename?: 'Mutation', updateMyCompanyAdditionalInfo: { __typename?: 'AdditionalInfo', id: string } };

export type UpdateMyCompanyMemberMutationVariables = Exact<{
  input: UpdateMyCompanyMemberInput;
  addressesInput: FindUserAddressesInput;
}>;


export type UpdateMyCompanyMemberMutation = { __typename?: 'Mutation', updateMyCompanyMember: { __typename?: 'CompanyMember', id: string, share?: number | null, type: CompanyMemberType, positions?: Array<string> | null, user: { __typename?: 'User', personal: { __typename?: 'UserPersonal', birthDate?: any | null, gender?: Gender | null, name?: { __typename?: 'IdentityFullName', firstName?: string | null, middleName?: string | null, lastName?: string | null } | null, nationalityCountry?: { __typename?: 'Country', id: string, alpha3: string, item?: { __typename?: 'CommonDictItem', code: string, name: string } | null } | null, residenceCountry?: { __typename?: 'Country', id: string, alpha3: string, item?: { __typename?: 'CommonDictItem', code: string, name: string } | null } | null }, addresses?: { __typename?: 'Addresses', nodes: Array<{ __typename?: 'Address', id: string, street?: string | null, postalCode?: string | null, rawCityName?: string | null, country?: { __typename?: 'Country', id: string, alpha3: string, item?: { __typename?: 'CommonDictItem', code: string, name: string } | null } | null }> } | null } } };

export type UpdatePersonalMutationVariables = Exact<{
  input: UpdatePersonalInput;
}>;


export type UpdatePersonalMutation = { __typename?: 'Mutation', updatePersonal: { __typename?: 'UserPersonal', birthDate?: any | null } };

export type LogoutQueryVariables = Exact<{
  input: LogoutInput;
}>;


export type LogoutQuery = { __typename?: 'Query', logout: boolean };

export type InitUploadSessionMutationVariables = Exact<{ [key: string]: never; }>;


export type InitUploadSessionMutation = { __typename?: 'Mutation', initUploadSession: { __typename?: 'UploadSesion', id: string, expiresAt: number, url: string } };

export type ConfirmPasswordRecoveryMutationVariables = Exact<{
  input: ConfirmPasswordRecoveryInput;
}>;


export type ConfirmPasswordRecoveryMutation = { __typename?: 'Mutation', confirmPasswordRecovery: boolean };

export type StartPasswordRecoveryV2MutationVariables = Exact<{
  input: StartPasswordRecoveryV2Input;
}>;


export type StartPasswordRecoveryV2Mutation = { __typename?: 'Mutation', startPasswordRecoveryV2: { __typename?: 'Send2FATokenResponse', operationId: string, response: Array<TfaType> } };

export type CompanyTotalShareQueryVariables = Exact<{
  input: FindCompaniesInput;
}>;


export type CompanyTotalShareQuery = { __typename?: 'Query', myCompanies: { __typename?: 'Companies', nodes: Array<{ __typename?: 'Company', id: string, totalShare: number }> } };

export type CreateMyCompanyMemberKycAccessTokenMutationVariables = Exact<{
  memberId: Scalars['String']['input'];
}>;


export type CreateMyCompanyMemberKycAccessTokenMutation = { __typename?: 'Mutation', createMyCompanyMemberKYCAccessToken: { __typename?: 'MemberKYCAccessTokenApplicant', url: string } };

export type CreateMyDocumentsMutationVariables = Exact<{
  input: Array<CreateMyDocumentInput> | CreateMyDocumentInput;
}>;


export type CreateMyDocumentsMutation = { __typename?: 'Mutation', createMyDocuments: Array<{ __typename?: 'CreatedDocument', fileUrls: Array<string>, config?: { __typename?: 'DocumentConfig', id: string } | null }> };

export type DocumentConfigsQueryVariables = Exact<{
  input: FindDocumentConfigsInput;
}>;


export type DocumentConfigsQuery = { __typename?: 'Query', documentConfigs: { __typename?: 'DocumentConfigs', nodes: Array<{ __typename?: 'DocumentConfig', docType: string, id: string, isActive: boolean, name: string }> } };

export type ExecuteKybStepMutationVariables = Exact<{
  input: ExecuteKybStepInput;
}>;


export type ExecuteKybStepMutation = { __typename?: 'Mutation', executeKYBStep: boolean };

export type GetFileInfoQueryVariables = Exact<{
  input: GetFileInput;
}>;


export type GetFileInfoQuery = { __typename?: 'Query', getFileInfo: { __typename?: 'File', originalName: string, size: string } };

export type IncomingPaymentsQueryVariables = Exact<{
  input: FindCompaniesInput;
}>;


export type IncomingPaymentsQuery = { __typename?: 'Query', myCompanies: { __typename?: 'Companies', nodes: Array<{ __typename?: 'Company', id: string, incomingPaymentsByCountries?: Array<{ __typename?: 'PaymentFlowByCountryType', percentage: number, country: { __typename?: 'Country', id: string, alpha3: string, item?: { __typename?: 'CommonDictItem', code: string, name: string } | null }, businessActivity?: { __typename?: 'BusinessActivity', id: string, item: { __typename?: 'CommonDictItem', name: string } } | null }> | null }> } };

export type MyDocumentsQueryVariables = Exact<{
  input: FindMyDocumentsInput;
}>;


export type MyDocumentsQuery = { __typename?: 'Query', myDocuments: { __typename?: 'Documents', nodes: Array<{ __typename?: 'Document', fileUrls: Array<string>, fileIds?: Array<string> | null, isActive: boolean, status: DocumentStatus, id: string, config?: { __typename?: 'DocumentConfig', id: string } | null }> } };

export type OutgoingPaymentsQueryVariables = Exact<{
  input: FindCompaniesInput;
}>;


export type OutgoingPaymentsQuery = { __typename?: 'Query', myCompanies: { __typename?: 'Companies', nodes: Array<{ __typename?: 'Company', id: string, outgoingPaymentsByCountries?: Array<{ __typename?: 'PaymentFlowByCountryType', percentage: number, country: { __typename?: 'Country', id: string, alpha3: string, item?: { __typename?: 'CommonDictItem', code: string, name: string } | null }, businessActivity?: { __typename?: 'BusinessActivity', id: string, item: { __typename?: 'CommonDictItem', name: string } } | null }> | null }> } };

export type SendMyCompanyDocumentsToReviewMutationVariables = Exact<{ [key: string]: never; }>;


export type SendMyCompanyDocumentsToReviewMutation = { __typename?: 'Mutation', sendMyCompanyDocumentsToReview: boolean };

export type UpdateDocumentMutationVariables = Exact<{
  input: UpdateDocumentInput;
}>;


export type UpdateDocumentMutation = { __typename?: 'Mutation', updateDocument: { __typename?: 'Document', id: string, isActive: boolean, fileUrls: Array<string>, config?: { __typename?: 'DocumentConfig', id: string } | null } };

export type ConfirmRegisterIdentityQueryVariables = Exact<{
  input: ConfirmInput;
}>;


export type ConfirmRegisterIdentityQuery = { __typename?: 'Query', confirmRegisterIdentity: boolean };

export type RegisterIdentityMutationVariables = Exact<{
  input: RegisterIdentityInput;
}>;


export type RegisterIdentityMutation = { __typename?: 'Mutation', registerIdentity: { __typename?: 'CheckResendOneTimeCodeType', device: Device, deviceId: string, smsRetryAfter?: any | null, smsTimeout?: number | null } };

export type ConfirmSignInMutationVariables = Exact<{
  input: AuthVerify2FaInput;
}>;


export type ConfirmSignInMutation = { __typename?: 'Mutation', confirmSignIn: { __typename?: 'Auth', accessToken: string, refreshToken: string } };

export type SendTfaCodeMutationVariables = Exact<{
  input: AuthTfaSend;
}>;


export type SendTfaCodeMutation = { __typename?: 'Mutation', sendTFACode: { __typename?: 'Send2FATokenResponse', emailRetryAfter?: any | null, emailTimeout?: number | null, operationId: string, phoneNumber?: string | null, response: Array<TfaType>, smsRetryAfter?: any | null, smsTimeout?: number | null } };

export type CheckCodeQueryVariables = Exact<{
  input: ConfirmOneTimeCodeInput;
}>;


export type CheckCodeQuery = { __typename?: 'Query', checkCode: boolean };

export type SendCodeV2QueryVariables = Exact<{
  input: SendCodeInput;
}>;


export type SendCodeV2Query = { __typename?: 'Query', sendCodeV2: { __typename?: 'CheckResendOneTimeCodeType', device: Device, deviceId: string, emailRetryAfter?: any | null, emailTimeout?: number | null } };

export type SignUpV2MutationVariables = Exact<{
  input: UserInput;
}>;


export type SignUpV2Mutation = { __typename?: 'Mutation', signUpV2: { __typename?: 'RegisteredUser', auth: { __typename?: 'Auth', accessToken: string, expiresIn: number, idToken?: string | null, refreshToken: string, tokenType: string }, user: { __typename?: 'User', userId: string } } };

export type TokenMutationVariables = Exact<{
  accessToken: Scalars['String']['input'];
  refreshToken: Scalars['String']['input'];
}>;


export type TokenMutation = { __typename?: 'Mutation', token: { __typename?: 'Auth', accessToken: string, expiresIn: number, refreshToken: string } };

export type ChangeIdentityMutationVariables = Exact<{
  input: ChangeIdentityInput;
}>;


export type ChangeIdentityMutation = { __typename?: 'Mutation', changeIdentity: { __typename?: 'ChangeIdentityResponseType', newIdentity2fa: { __typename?: 'CheckResendOneTimeCodeType', emailRetryAfter?: any | null, emailTimeout?: number | null, smsRetryAfter?: any | null, smsTimeout?: number | null, deviceId: string, device: Device } } };

export type ConfirmChangeIdentityMutationVariables = Exact<{
  input: ConfirmChangeIdentityInput;
}>;


export type ConfirmChangeIdentityMutation = { __typename?: 'Mutation', confirmChangeIdentity: boolean };

export type ChangePasswordV2MutationVariables = Exact<{
  input: ChangePasswordV2Input;
}>;


export type ChangePasswordV2Mutation = { __typename?: 'Mutation', changePasswordV2: { __typename?: 'Send2FATokenResponse', emailRetryAfter?: any | null, emailTimeout?: number | null, operationId: string, phoneNumber?: string | null, response: Array<TfaType>, smsRetryAfter?: any | null, smsTimeout?: number | null } };

export type ConfirmChangePasswordMutationVariables = Exact<{
  input: ConfirmChangePasswordInput;
}>;


export type ConfirmChangePasswordMutation = { __typename?: 'Mutation', confirmChangePassword: boolean };

export const VirtualBalanceFragmentDoc = gql`
    fragment VirtualBalance on VabsVirtualBalance {
  id
  status
  availableAmount
  currency {
    ticker
    id
  }
}
    `;
export const VabsPaymentCalculatedFeeFragmentDoc = gql`
    fragment VabsPaymentCalculatedFee on VabsPaymentCalculateFeeType {
  currencyTicker
  originalAmount
  originalTotalAmount
  originalTotalFee
}
    `;
export const CountryFragmentDoc = gql`
    fragment country on Country {
  id
  alpha3
  item {
    code
    name
  }
}
    `;
export const CompanyFragmentFragmentDoc = gql`
    fragment CompanyFragment on Company {
  id
  registrationNumber
  registeredBusinessName
  countryOfIncorporation {
    id
    alpha3
    item {
      code
      name
    }
  }
}
    `;
export const UserFragmentFragmentDoc = gql`
    fragment UserFragment on User {
  currentKYCLevelStatusV2 {
    status
  }
  personal {
    birthDate
    gender
    name {
      firstName
      middleName
      lastName
    }
    nationalityCountry {
      id
      alpha3
      item {
        code
        name
      }
    }
    residenceCountry {
      id
      alpha3
      item {
        code
        name
      }
    }
  }
}
    `;
export const MyCompanyMemberRegistrantFragmentDoc = gql`
    fragment MyCompanyMemberRegistrant on CompanyMember {
  id
  share
  type
  positions
  pep {
    position
    startWorkingDate
    endWorkingDate
  }
  user {
    id
    currentKYCLevelStatusV2 {
      status
      passedKYCBy
      currentStep {
        rejectionReason
      }
    }
    personal {
      gender
      birthDate
      name {
        firstName
        middleName
        lastName
      }
      nationalityCountry {
        id
        alpha3
        item {
          code
          name
        }
      }
      residenceCountry {
        id
        alpha3
        item {
          code
          name
        }
      }
    }
    addresses(input: {pagination: {}}) {
      count
      nodes {
        id
        street
        subStreet
        rawCityName
        postalCode
        country {
          id
          alpha3
          item {
            code
            name
          }
        }
      }
    }
  }
}
    `;
export const MyCompanyMemberUserFragmentDoc = gql`
    fragment MyCompanyMemberUser on User {
  id
  currentKYCLevelStatusV2 {
    status
    passedKYCBy
    currentStep {
      rejectionReason
    }
  }
  personal {
    gender
    name {
      firstName
      middleName
      lastName
    }
    nationalityCountry {
      id
      alpha3
      item {
        code
        name
      }
    }
    residenceCountry {
      id
      alpha3
      item {
        code
        name
      }
    }
  }
}
    `;
export const MyCompanyMemberFragmentDoc = gql`
    fragment MyCompanyMember on CompanyMember {
  id
  share
  type
  positions
  pep {
    position
    startWorkingDate
    endWorkingDate
  }
}
    `;
export const AddressCategoriesDocument = gql`
    query addressCategories($input: AddressCategoriesInput!) {
  addressCategories(input: $input) {
    count
    nodes {
      id
      name
    }
  }
}
    `;
export const BusinessActivitiesDocument = gql`
    query businessActivities($input: GetBusinessActivitiesInput!) {
  businessActivities(input: $input) {
    count
    cursor
    nodes {
      id
      description
      item {
        name
      }
    }
  }
}
    `;
export const CountriesV2Document = gql`
    query countriesV2($input: DictFilterV2Input!) {
  countriesV2(input: $input) {
    count
    cursor
    nodes {
      id
      alpha3
      item {
        code
        name
      }
      phoneCode
      phoneTemplate
    }
  }
}
    `;
export const DefaultCountryDocument = gql`
    query defaultCountry($input: GetCountryInput!) {
  country(input: $input) {
    id
    alpha3
    item {
      code
      name
    }
    phoneCode
    phoneTemplate
  }
}
    `;
export const VabsAccCreateMyAccountBalancesDocument = gql`
    mutation vabsAccCreateMyAccountBalances($input: VabsAccCreateMyAccountBalancesInput!) {
  vabsAccCreateMyAccountBalances(accCreateMyAccountBalancesInput: $input) {
    id
    status
    currency {
      ticker
    }
    virtualAccount {
      id
    }
  }
}
    `;
export const VabsAccMyBankDetailsDocument = gql`
    query vabsAccMyBankDetails($input: VabsAccMyBankDetailsInput!) {
  vabsAccMyBankDetails(accMyBankDetailsInput: $input) {
    virtualAccountId
    bankDetails {
      currency {
        id
        ticker
        network {
          name
        }
      }
      routes {
        ... on VabsAccBankDetailsInnerRoute {
          schema
          details {
            virtualAccountId
          }
        }
        ... on VabsAccBankDetailsSwiftRoute {
          schema
          details {
            beneficiary {
              address
              name
            }
            beneficiaryBank {
              account
              address
              code
              country {
                alpha2
                alpha3
                name
              }
              name
            }
            correspondentBanks {
              account
              address
              code
              country {
                alpha2
                alpha3
                name
              }
              name
            }
            remittanceInformation
          }
        }
      }
    }
  }
}
    `;
export const VabsAccMyVirtualAccountsDocument = gql`
    query vabsAccMyVirtualAccounts($input: VabsAccFindMyVirtualAccountsInput!, $balancesInput: VabsFilterInput!) {
  vabsAccMyVirtualAccounts(accMyVirtualAccountInput: $input) {
    count
    nodes {
      id
      virtualBalances(input: $balancesInput) {
        count
        cursor
        nodes {
          ...VirtualBalance
        }
      }
    }
  }
}
    ${VirtualBalanceFragmentDoc}`;
export const VabsAccMyVirtualBalancesDocument = gql`
    query vabsAccMyVirtualBalances($accMyVirtualBalancesInput: VabsAccFindMyVirtualBalancesInput!) {
  vabsAccMyVirtualBalances(accMyVirtualBalancesInput: $accMyVirtualBalancesInput) {
    count
    cursor
    nodes {
      id
      status
      availableAmount
      currency {
        ticker
        id
      }
    }
  }
}
    `;
export const VabsCurrenciesDocument = gql`
    query vabsCurrencies {
  currencies(input: {type: FIAT, tags: ["for_fiat_account"]}) {
    id
    ticker
    symbol
    item {
      name
    }
  }
}
    `;
export const VabsMyTotalBalanceDocument = gql`
    query vabsMyTotalBalance($currencyId: String!, $virtualAccountId: String!) {
  vabsMyTotalBalance(currencyId: $currencyId, virtualAccountId: $virtualAccountId)
}
    `;
export const CurrenciesDocument = gql`
    query currencies($input: DictFilterInput!) {
  currencies(input: $input) {
    id
    ticker
    symbol
    precision
    item {
      code
      name
    }
  }
}
    `;
export const VabsCalculateMyBsbPaymentFeeDocument = gql`
    query vabsCalculateMyBsbPaymentFee($input: VabsCreateBsbPaymentInput!) {
  vabsCalculateMyBsbPaymentFee(input: $input) {
    ...VabsPaymentCalculatedFee
  }
}
    ${VabsPaymentCalculatedFeeFragmentDoc}`;
export const VabsCalculateMySwiftPaymentFeeDocument = gql`
    query vabsCalculateMySwiftPaymentFee($input: VabsCreateSwiftPaymentInput!) {
  vabsCalculateMySwiftPaymentFee(input: $input) {
    ...VabsPaymentCalculatedFee
  }
}
    ${VabsPaymentCalculatedFeeFragmentDoc}`;
export const VabsCalculateMyInnerPaymentFeeDocument = gql`
    query vabsCalculateMyInnerPaymentFee($input: VabsCreateInnerPaymentInput!) {
  vabsCalculateMyInnerPaymentFee(input: $input) {
    ...VabsPaymentCalculatedFee
  }
}
    ${VabsPaymentCalculatedFeeFragmentDoc}`;
export const VabsCalculateMyIfscPaymentFeeDocument = gql`
    query vabsCalculateMyIfscPaymentFee($input: VabsCreateIfscPaymentInput!) {
  vabsCalculateMyIfscPaymentFee(input: $input) {
    ...VabsPaymentCalculatedFee
  }
}
    ${VabsPaymentCalculatedFeeFragmentDoc}`;
export const VabsCreateMyBsbPaymentDocument = gql`
    mutation vabsCreateMyBsbPayment($input: VabsCreateBsbPaymentInput!) {
  vabsCreateMyBsbPayment(input: $input) {
    id
  }
}
    `;
export const VabsCreateMyIfscPaymentDocument = gql`
    mutation vabsCreateMyIfscPayment($input: VabsCreateIfscPaymentInput!) {
  vabsCreateMyIfscPayment(input: $input) {
    id
  }
}
    `;
export const VabsCreateMyInnerPaymentDocument = gql`
    mutation vabsCreateMyInnerPayment($input: VabsCreateInnerPaymentInput!) {
  vabsCreateMyInnerPayment(input: $input) {
    id
  }
}
    `;
export const VabsCreateMySwiftPaymentDocument = gql`
    mutation vabsCreateMySwiftPayment($input: VabsCreateSwiftPaymentInput!) {
  vabsCreateMySwiftPayment(input: $input) {
    id
  }
}
    `;
export const VabsInternalClientsForInternalPaymentDocument = gql`
    query vabsInternalClientsForInternalPayment($email: String, $phoneNumber: String) {
  vabsInternalClientsForInternalPayment(email: $email, phoneNumber: $phoneNumber) {
    accountId
    availableCurrencies {
      id
    }
    clientId
    companyName
  }
}
    `;
export const VabsMyPaymentMethodsDocument = gql`
    query vabsMyPaymentMethods($input: VabsFindPaymentMethodsInput!) {
  vabsMyPaymentMethods(input: $input) {
    cursor
    count
    nodes {
      id
      isActive
      type
    }
  }
}
    `;
export const VabsMyPaymentsDocument = gql`
    query vabsMyPayments($input: VabsFindPaymentsInput!) {
  vabsMyPayments(input: $input) {
    cursor
    count
    nodes {
      ... on VabsSwiftPaymentType {
        id
        createdAt
        status
        direction
        paymentSystem
        purposeOfPayment
        sourceOfFunds
        fee {
          target {
            provider
            total
          }
        }
        totalAmount {
          source {
            amount
          }
          target {
            amount
          }
        }
        amount {
          source {
            amount
            currency {
              id
            }
          }
          target {
            amount
            currency {
              id
            }
          }
        }
        external {
          accountNumber
          bankCode
          clientType
          accountHolderName
          firstName
          lastName
          address {
            country {
              id
            }
            line1
            line2
            postalCode
          }
          bank {
            country {
              id
            }
            cityName
            name
            addressLine1
            postalCode
          }
          intermediaryBank {
            accountNumber
            addressLine1
            addressLine2
            bankCode
            cityName
            country {
              id
            }
            name
          }
        }
      }
      ... on VabsBsbPaymentType {
        id
        createdAt
        status
        direction
        paymentSystem
        purposeOfPayment
        totalAmount {
          source {
            amount
          }
          target {
            amount
          }
        }
        sourceOfFunds
        fee {
          target {
            provider
            total
          }
        }
        amount {
          source {
            amount
            currency {
              id
            }
          }
          target {
            amount
            currency {
              id
            }
          }
        }
        external {
          accountNumber
          bankCode
          clientType
          firstName
          lastName
          accountHolderName
          address {
            country {
              id
            }
            line1
            line2
            postalCode
          }
          bank {
            country {
              id
            }
            cityName
            name
            addressLine1
            postalCode
          }
        }
      }
      ... on VabsInnerPaymentType {
        amount {
          source {
            amount
            currency {
              id
            }
          }
          target {
            amount
            currency {
              id
            }
          }
        }
        createdAt
        direction
        fee {
          source {
            currency {
              id
            }
            total
          }
          target {
            currency {
              id
            }
            provider
            total
          }
        }
        id
        note
        paymentSystem
        purposeOfPayment
        recipientClient {
          phoneNumber
          email
          clientId
          accountId
          accountHolderName
        }
        senderClient {
          accountId
          accountHolderName
        }
        settled
        status
        totalAmount {
          source {
            amount
            currency {
              id
            }
          }
          target {
            amount
            currency {
              id
            }
          }
        }
        updatedAt
      }
      ... on VabsIfscPaymentType {
        id
        createdAt
        direction
        status
        paymentSystem
        purposeOfPayment
        totalAmount {
          source {
            amount
          }
          target {
            amount
          }
        }
        sourceOfFunds
        fee {
          target {
            provider
            total
          }
        }
        amount {
          source {
            amount
            currency {
              id
            }
          }
          target {
            amount
            currency {
              id
            }
          }
        }
        external {
          accountNumber
          bankCode
          clientType
          firstName
          lastName
          accountHolderName
          address {
            country {
              id
            }
            line1
            line2
            postalCode
          }
          bank {
            country {
              id
            }
            cityName
            name
            addressLine1
            postalCode
          }
        }
      }
    }
  }
}
    `;
export const VabsUpdateMyPaymentFavoriteDocument = gql`
    mutation vabsUpdateMyPaymentFavorite($input: VabsUpdatePaymentFavoriteInput!) {
  vabsUpdateMyPaymentFavorite(input: $input) {
    ... on VabsBsbPaymentType {
      id
    }
    ... on VabsIfscPaymentType {
      id
    }
    ... on VabsSwiftPaymentType {
      id
    }
  }
}
    `;
export const CompanyTypesDocument = gql`
    query companyTypes {
  companyTypes(input: {}) {
    nodes {
      id
      item {
        name
      }
    }
  }
}
    `;
export const CountriesDocument = gql`
    query countries {
  countries(input: {}) {
    alpha3
    id
    item {
      name
    }
  }
}
    `;
export const StaticDataDocument = gql`
    query staticData {
  staticData {
    companySourcesOfFunds {
      name
      value
    }
    companySourcesOfWealth {
      name
      value
    }
  }
}
    `;
export const MyCompaniesDocument = gql`
    query myCompanies($input: FindCompaniesInput!, $additionalInfosInput: FindAdditionalInfosInput!) {
  myCompanies(input: $input) {
    count
    nodes {
      id
      isInternalTransferAllowed
      currentKYBLevelStatusV2 {
        status
      }
      registeredBusinessName
      companyOwnershipStructure
      countryOfIncorporation {
        ...country
      }
      registrant {
        id
      }
      companyType {
        id
        item {
          name
        }
      }
      type
      additionalInfos(input: $additionalInfosInput) {
        count
        nodes {
          id
          clientId
          key
          name
          value
        }
      }
    }
  }
}
    ${CountryFragmentDoc}`;
export const MyPersonalDataDocument = gql`
    query myPersonalData($addressesInput: FindUserAddressesInput!) {
  myPersonalData {
    userId
    addresses(input: $addressesInput) {
      count
      nodes {
        postalCode
        rawCityName
        formattedStringValue
      }
    }
    personal {
      email
      phone
      name {
        firstName
        lastName
        middleName
      }
      residenceCountry {
        id
        alpha3
        item {
          name
        }
      }
      birthDate
    }
  }
}
    `;
export const SignInV2Document = gql`
    query signInV2($input: AuthInput!) {
  signInV2(input: $input) {
    emailRetryAfter
    emailTimeout
    smsRetryAfter
    smsTimeout
    phoneNumber
    response
    operationId
  }
}
    `;
export const ChildMembersDocument = gql`
    query childMembers($input: FindCompaniesInput!, $childCompaniesInput: FilterInput!, $companiesAddressesInput: FilterInput!, $childMembersInput: FindMembersInput!, $membersAddressesInput: FindUserAddressesInput!, $childCompaniesSubmembersInput: FilterInput!, $childSubmembersInput: FindMembersInput!) {
  myCompanies(input: $input) {
    nodes {
      childCompanies(input: $childCompaniesInput) {
        count
        nodes {
          ...CompanyFragment
          addresses(input: $companiesAddressesInput) {
            nodes {
              id
              street
              postalCode
              rawCityName
              country {
                id
                alpha3
                item {
                  code
                  name
                }
              }
            }
          }
          share
          childCompanies(input: $childCompaniesSubmembersInput) {
            nodes {
              ...CompanyFragment
              addresses(input: $companiesAddressesInput) {
                nodes {
                  id
                  street
                  postalCode
                  rawCityName
                  country {
                    id
                    alpha3
                    item {
                      code
                      name
                    }
                  }
                }
              }
            }
          }
          members(input: $childSubmembersInput) {
            nodes {
              id
              positions
              pep {
                position
                startWorkingDate
                endWorkingDate
              }
              user {
                ...UserFragment
              }
            }
          }
        }
      }
      members(input: $childMembersInput) {
        count
        nodes {
          id
          share
          type
          positions
          pep {
            position
            startWorkingDate
            endWorkingDate
          }
          user {
            ...UserFragment
            addresses(input: $membersAddressesInput) {
              nodes {
                id
                street
                postalCode
                rawCityName
                country {
                  id
                  alpha3
                  item {
                    code
                    name
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
    ${CompanyFragmentFragmentDoc}
${UserFragmentFragmentDoc}`;
export const CreateCorporateMemberDocument = gql`
    mutation createCorporateMember($companyId: String!, $input: CreateMyCompanyInput!) {
  createMyCompanyV2(companyId: $companyId, input: $input) {
    id
  }
}
    `;
export const CreateCorporateMemberAddressDocument = gql`
    mutation createCorporateMemberAddress($input: CreateMyAddressInput!) {
  createMyAddress(input: $input) {
    id
  }
}
    `;
export const CreateCorporateMembersDocument = gql`
    mutation createCorporateMembers($createMyCompaniesInput: [CreateMyCompanyInput!]!) {
  createMyCompanies(createMyCompaniesInput: $createMyCompaniesInput) {
    id
  }
}
    `;
export const CreateIndividualMemberDocument = gql`
    mutation createIndividualMember($companyId: String!, $input: CreateMyCompanyMemberInput!) {
  createMyCompanyMemberV2(companyId: $companyId, input: $input) {
    id
  }
}
    `;
export const CreateIndividualMemberAddressDocument = gql`
    mutation createIndividualMemberAddress($input: CreateAddressInput!) {
  createMyCompanyMemberAddress(input: $input) {
    id
    street
    subStreet
    rawCityName
    postalCode
    country {
      id
      alpha3
      item {
        code
        name
      }
    }
  }
}
    `;
export const CreateIndividualMembersDocument = gql`
    mutation createIndividualMembers($companyId: String!, $createMyCompanyMembersInput: [CreateMyCompanyMemberInput!]!) {
  createMyCompanyMembersV2(
    companyId: $companyId
    createMyCompanyMembersInput: $createMyCompanyMembersInput
  ) {
    id
  }
}
    `;
export const DeleteCorporateMemberDocument = gql`
    mutation deleteCorporateMember {
  detachMyCompany
}
    `;
export const DeleteIndividualMemberDocument = gql`
    mutation deleteIndividualMember($memberId: ID!) {
  deleteMyCompanyMember(memberId: $memberId)
}
    `;
export const UpdateCorporateMemberDocument = gql`
    mutation updateCorporateMember($companyId: String!, $input: UpdateMyCompanyInput!) {
  updateMyCompanyV2(companyId: $companyId, input: $input) {
    id
  }
}
    `;
export const UpdateIndividualMemberDocument = gql`
    mutation updateIndividualMember($input: UpdateMyCompanyMemberInput!) {
  updateMyCompanyMember(input: $input) {
    id
  }
}
    `;
export const CreateMyAddressDocument = gql`
    mutation createMyAddress($input: CreateMyAddressInput!) {
  createMyAddress(input: $input) {
    id
  }
}
    `;
export const CreateMyCompanyAdditionalInfoDocument = gql`
    mutation createMyCompanyAdditionalInfo($input: CreateMyAdditionalInfoInput!) {
  createMyCompanyAdditionalInfo(input: $input) {
    id
  }
}
    `;
export const DeleteMyAddressDocument = gql`
    mutation deleteMyAddress($input: String!) {
  deleteMyAddress(input: $input)
}
    `;
export const CreateMyCompanyDocument = gql`
    mutation createMyCompany($input: CreateMyCompanyInput!) {
  createMyCompany(input: $input) {
    id
    registrant {
      ...MyCompanyMemberRegistrant
    }
  }
}
    ${MyCompanyMemberRegistrantFragmentDoc}`;
export const DraftCompanyDocument = gql`
    query draftCompany($input: FindCompaniesInput!, $additionalInfosInput: FindAdditionalInfosInput!, $addressesInput: FilterInput!, $membersInput: FindMembersInput!, $categoriesInput: FilterInput!, $childCompaniesInput: FilterInput!) {
  myCompanies(input: $input) {
    count
    nodes {
      id
      registrant {
        ...MyCompanyMemberRegistrant
      }
      registrationNumber
      members(input: $membersInput) {
        count
      }
      businessProfit {
        amount
        currency {
          id
          ticker
          item {
            name
          }
        }
      }
      employmentIncome {
        amount
        currency {
          id
          ticker
        }
      }
      savingsAndDeposit {
        amount
        currency {
          id
          ticker
        }
      }
      childCompanies(input: $childCompaniesInput) {
        count
      }
      loan {
        amount
        currency {
          id
          ticker
        }
      }
      annualTurnover {
        amount
        currency {
          id
          ticker
          item {
            name
          }
        }
      }
      sourceOfFunds
      otherSourceOfFunds
      otherSourceOfWealth
      sourceOfWealth
      controlSchema
      detailsSourceOfWealth {
        currency {
          id
          symbol
          ticker
        }
        amount
        sourceOfWealth
      }
      registeredBusinessName
      outgoingPaymentsByCountries {
        country {
          ...country
        }
        businessActivity {
          id
          item {
            name
          }
        }
        percentage
      }
      incomingPaymentsByCountries {
        country {
          ...country
        }
        businessActivity {
          id
          item {
            name
          }
        }
        percentage
      }
      companyOwnershipStructure
      countryOfIncorporation {
        ...country
      }
      paidUpShareCapital {
        amount
        currency {
          id
          ticker
        }
      }
      annualTurnover {
        amount
        currency {
          id
          ticker
        }
      }
      website
      faxNumber
      totalNumberOfEmployees
      businessActivities {
        id
        item {
          name
        }
        parent {
          id
          item {
            name
          }
        }
      }
      addresses(input: $addressesInput) {
        nodes {
          id
          street
          subStreet
          postalCode
          rawCityName
          categories(input: $categoriesInput) {
            nodes {
              id
              name
            }
          }
          country {
            ...country
          }
        }
      }
      companyType {
        id
        item {
          name
        }
      }
      type
      additionalInfos(input: $additionalInfosInput) {
        nodes {
          id
          clientId
          key
          name
          value
        }
      }
    }
  }
}
    ${MyCompanyMemberRegistrantFragmentDoc}
${CountryFragmentDoc}`;
export const MyCompanyAdditionalInfosDocument = gql`
    query myCompanyAdditionalInfos($input: FindAdditionalInfosInput!) {
  myCompanyAdditionalInfos(input: $input) {
    nodes {
      id
      key
      name
      value
    }
  }
}
    `;
export const MyCompanyMembersDocument = gql`
    query myCompanyMembers($input: FindMembersInput!, $addressesInput: FindUserAddressesInput!) {
  myCompanyMembers(input: $input) {
    count
    cursor
    nodes {
      ...MyCompanyMember
      user {
        ...MyCompanyMemberUser
        addresses(input: $addressesInput) {
          nodes {
            id
            street
            subStreet
            rawCityName
            postalCode
            country {
              id
              alpha3
              item {
                code
                name
              }
            }
          }
        }
      }
    }
  }
}
    ${MyCompanyMemberFragmentDoc}
${MyCompanyMemberUserFragmentDoc}`;
export const StartMyKybProcedureV2Document = gql`
    mutation startMyKYBProcedureV2 {
  startMyKYBProcedureV2 {
    id
    status
  }
}
    `;
export const UpdateMyAddressDocument = gql`
    mutation updateMyAddress($input: UpdateAddressInput!) {
  updateMyAddress(input: $input) {
    id
  }
}
    `;
export const UpdateMyCompanyDocument = gql`
    mutation updateMyCompany($input: UpdateMyCompanyInput!) {
  updateMyCompany(input: $input) {
    id
  }
}
    `;
export const UpdateMyCompanyAdditionalInfoDocument = gql`
    mutation updateMyCompanyAdditionalInfo($input: UpdateMyAdditionalInfoInput!) {
  updateMyCompanyAdditionalInfo(input: $input) {
    id
  }
}
    `;
export const UpdateMyCompanyMemberDocument = gql`
    mutation updateMyCompanyMember($input: UpdateMyCompanyMemberInput!, $addressesInput: FindUserAddressesInput!) {
  updateMyCompanyMember(input: $input) {
    id
    share
    type
    positions
    user {
      personal {
        birthDate
        gender
        name {
          firstName
          middleName
          lastName
        }
        nationalityCountry {
          id
          alpha3
          item {
            code
            name
          }
        }
        residenceCountry {
          id
          alpha3
          item {
            code
            name
          }
        }
      }
      addresses(input: $addressesInput) {
        nodes {
          id
          street
          postalCode
          rawCityName
          country {
            id
            alpha3
            item {
              code
              name
            }
          }
        }
      }
    }
  }
}
    `;
export const UpdatePersonalDocument = gql`
    mutation updatePersonal($input: UpdatePersonalInput!) {
  updatePersonal(input: $input) {
    birthDate
  }
}
    `;
export const LogoutDocument = gql`
    query logout($input: LogoutInput!) {
  logout(input: $input)
}
    `;
export const InitUploadSessionDocument = gql`
    mutation initUploadSession {
  initUploadSession {
    id
    expiresAt
    url
  }
}
    `;
export const ConfirmPasswordRecoveryDocument = gql`
    mutation confirmPasswordRecovery($input: ConfirmPasswordRecoveryInput!) {
  confirmPasswordRecovery(input: $input)
}
    `;
export const StartPasswordRecoveryV2Document = gql`
    mutation startPasswordRecoveryV2($input: StartPasswordRecoveryV2Input!) {
  startPasswordRecoveryV2(input: $input) {
    operationId
    response
  }
}
    `;
export const CompanyTotalShareDocument = gql`
    query companyTotalShare($input: FindCompaniesInput!) {
  myCompanies(input: $input) {
    nodes {
      id
      totalShare
    }
  }
}
    `;
export const CreateMyCompanyMemberKycAccessTokenDocument = gql`
    mutation createMyCompanyMemberKYCAccessToken($memberId: String!) {
  createMyCompanyMemberKYCAccessToken(memberId: $memberId) {
    url
  }
}
    `;
export const CreateMyDocumentsDocument = gql`
    mutation createMyDocuments($input: [CreateMyDocumentInput!]!) {
  createMyDocuments(input: $input) {
    config {
      id
    }
    fileUrls
  }
}
    `;
export const DocumentConfigsDocument = gql`
    query documentConfigs($input: FindDocumentConfigsInput!) {
  documentConfigs(input: $input) {
    nodes {
      docType
      id
      isActive
      name
    }
  }
}
    `;
export const ExecuteKybStepDocument = gql`
    mutation executeKYBStep($input: ExecuteKYBStepInput!) {
  executeKYBStep(input: $input)
}
    `;
export const GetFileInfoDocument = gql`
    query getFileInfo($input: GetFileInput!) {
  getFileInfo(input: $input) {
    originalName
    size
  }
}
    `;
export const IncomingPaymentsDocument = gql`
    query incomingPayments($input: FindCompaniesInput!) {
  myCompanies(input: $input) {
    nodes {
      id
      incomingPaymentsByCountries {
        country {
          ...country
        }
        businessActivity {
          id
          item {
            name
          }
        }
        percentage
      }
    }
  }
}
    ${CountryFragmentDoc}`;
export const MyDocumentsDocument = gql`
    query myDocuments($input: FindMyDocumentsInput!) {
  myDocuments(input: $input) {
    nodes {
      fileUrls
      fileIds
      isActive
      status
      id
      config {
        id
      }
    }
  }
}
    `;
export const OutgoingPaymentsDocument = gql`
    query outgoingPayments($input: FindCompaniesInput!) {
  myCompanies(input: $input) {
    nodes {
      id
      outgoingPaymentsByCountries {
        country {
          ...country
        }
        businessActivity {
          id
          item {
            name
          }
        }
        percentage
      }
    }
  }
}
    ${CountryFragmentDoc}`;
export const SendMyCompanyDocumentsToReviewDocument = gql`
    mutation sendMyCompanyDocumentsToReview {
  sendMyCompanyDocumentsToReview
}
    `;
export const UpdateDocumentDocument = gql`
    mutation updateDocument($input: UpdateDocumentInput!) {
  updateDocument(input: $input) {
    config {
      id
    }
    id
    isActive
    fileUrls
  }
}
    `;
export const ConfirmRegisterIdentityDocument = gql`
    query confirmRegisterIdentity($input: ConfirmInput!) {
  confirmRegisterIdentity(input: $input)
}
    `;
export const RegisterIdentityDocument = gql`
    mutation registerIdentity($input: RegisterIdentityInput!) {
  registerIdentity(input: $input) {
    device
    deviceId
    smsRetryAfter
    smsTimeout
  }
}
    `;
export const ConfirmSignInDocument = gql`
    mutation confirmSignIn($input: AuthVerify2FAInput!) {
  confirmSignIn(input: $input) {
    accessToken
    refreshToken
  }
}
    `;
export const SendTfaCodeDocument = gql`
    mutation sendTFACode($input: AuthTFASend!) {
  sendTFACode(input: $input) {
    emailRetryAfter
    emailTimeout
    operationId
    phoneNumber
    response
    smsRetryAfter
    smsTimeout
  }
}
    `;
export const CheckCodeDocument = gql`
    query checkCode($input: ConfirmOneTimeCodeInput!) {
  checkCode(input: $input)
}
    `;
export const SendCodeV2Document = gql`
    query sendCodeV2($input: SendCodeInput!) {
  sendCodeV2(input: $input) {
    device
    deviceId
    emailRetryAfter
    emailTimeout
  }
}
    `;
export const SignUpV2Document = gql`
    mutation signUpV2($input: UserInput!) {
  signUpV2(input: $input) {
    auth {
      accessToken
      expiresIn
      idToken
      refreshToken
      tokenType
    }
    user {
      userId
    }
  }
}
    `;
export const TokenDocument = gql`
    mutation token($accessToken: String!, $refreshToken: String!) {
  token(accessToken: $accessToken, refreshToken: $refreshToken) {
    accessToken
    expiresIn
    refreshToken
  }
}
    `;
export const ChangeIdentityDocument = gql`
    mutation changeIdentity($input: ChangeIdentityInput!) {
  changeIdentity(input: $input) {
    newIdentity2fa {
      emailRetryAfter
      emailTimeout
      smsRetryAfter
      smsTimeout
      deviceId
      device
    }
  }
}
    `;
export const ConfirmChangeIdentityDocument = gql`
    mutation confirmChangeIdentity($input: ConfirmChangeIdentityInput!) {
  confirmChangeIdentity(input: $input)
}
    `;
export const ChangePasswordV2Document = gql`
    mutation changePasswordV2($input: ChangePasswordV2Input!) {
  changePasswordV2(input: $input) {
    emailRetryAfter
    emailTimeout
    operationId
    phoneNumber
    response
    smsRetryAfter
    smsTimeout
  }
}
    `;
export const ConfirmChangePasswordDocument = gql`
    mutation confirmChangePassword($input: ConfirmChangePasswordInput!) {
  confirmChangePassword(input: $input)
}
    `;
export type Requester<C = {}> = <R, V>(doc: DocumentNode, vars?: V, options?: C) => Promise<R> | AsyncIterable<R>
export function getSdk<C>(requester: Requester<C>) {
  return {
    addressCategories(variables: AddressCategoriesQueryVariables, options?: C): Promise<AddressCategoriesQuery> {
      return requester<AddressCategoriesQuery, AddressCategoriesQueryVariables>(AddressCategoriesDocument, variables, options) as Promise<AddressCategoriesQuery>;
    },
    businessActivities(variables: BusinessActivitiesQueryVariables, options?: C): Promise<BusinessActivitiesQuery> {
      return requester<BusinessActivitiesQuery, BusinessActivitiesQueryVariables>(BusinessActivitiesDocument, variables, options) as Promise<BusinessActivitiesQuery>;
    },
    countriesV2(variables: CountriesV2QueryVariables, options?: C): Promise<CountriesV2Query> {
      return requester<CountriesV2Query, CountriesV2QueryVariables>(CountriesV2Document, variables, options) as Promise<CountriesV2Query>;
    },
    defaultCountry(variables: DefaultCountryQueryVariables, options?: C): Promise<DefaultCountryQuery> {
      return requester<DefaultCountryQuery, DefaultCountryQueryVariables>(DefaultCountryDocument, variables, options) as Promise<DefaultCountryQuery>;
    },
    vabsAccCreateMyAccountBalances(variables: VabsAccCreateMyAccountBalancesMutationVariables, options?: C): Promise<VabsAccCreateMyAccountBalancesMutation> {
      return requester<VabsAccCreateMyAccountBalancesMutation, VabsAccCreateMyAccountBalancesMutationVariables>(VabsAccCreateMyAccountBalancesDocument, variables, options) as Promise<VabsAccCreateMyAccountBalancesMutation>;
    },
    vabsAccMyBankDetails(variables: VabsAccMyBankDetailsQueryVariables, options?: C): Promise<VabsAccMyBankDetailsQuery> {
      return requester<VabsAccMyBankDetailsQuery, VabsAccMyBankDetailsQueryVariables>(VabsAccMyBankDetailsDocument, variables, options) as Promise<VabsAccMyBankDetailsQuery>;
    },
    vabsAccMyVirtualAccounts(variables: VabsAccMyVirtualAccountsQueryVariables, options?: C): Promise<VabsAccMyVirtualAccountsQuery> {
      return requester<VabsAccMyVirtualAccountsQuery, VabsAccMyVirtualAccountsQueryVariables>(VabsAccMyVirtualAccountsDocument, variables, options) as Promise<VabsAccMyVirtualAccountsQuery>;
    },
    vabsAccMyVirtualBalances(variables: VabsAccMyVirtualBalancesQueryVariables, options?: C): Promise<VabsAccMyVirtualBalancesQuery> {
      return requester<VabsAccMyVirtualBalancesQuery, VabsAccMyVirtualBalancesQueryVariables>(VabsAccMyVirtualBalancesDocument, variables, options) as Promise<VabsAccMyVirtualBalancesQuery>;
    },
    vabsCurrencies(variables?: VabsCurrenciesQueryVariables, options?: C): Promise<VabsCurrenciesQuery> {
      return requester<VabsCurrenciesQuery, VabsCurrenciesQueryVariables>(VabsCurrenciesDocument, variables, options) as Promise<VabsCurrenciesQuery>;
    },
    vabsMyTotalBalance(variables: VabsMyTotalBalanceQueryVariables, options?: C): Promise<VabsMyTotalBalanceQuery> {
      return requester<VabsMyTotalBalanceQuery, VabsMyTotalBalanceQueryVariables>(VabsMyTotalBalanceDocument, variables, options) as Promise<VabsMyTotalBalanceQuery>;
    },
    currencies(variables: CurrenciesQueryVariables, options?: C): Promise<CurrenciesQuery> {
      return requester<CurrenciesQuery, CurrenciesQueryVariables>(CurrenciesDocument, variables, options) as Promise<CurrenciesQuery>;
    },
    vabsCalculateMyBsbPaymentFee(variables: VabsCalculateMyBsbPaymentFeeQueryVariables, options?: C): Promise<VabsCalculateMyBsbPaymentFeeQuery> {
      return requester<VabsCalculateMyBsbPaymentFeeQuery, VabsCalculateMyBsbPaymentFeeQueryVariables>(VabsCalculateMyBsbPaymentFeeDocument, variables, options) as Promise<VabsCalculateMyBsbPaymentFeeQuery>;
    },
    vabsCalculateMySwiftPaymentFee(variables: VabsCalculateMySwiftPaymentFeeQueryVariables, options?: C): Promise<VabsCalculateMySwiftPaymentFeeQuery> {
      return requester<VabsCalculateMySwiftPaymentFeeQuery, VabsCalculateMySwiftPaymentFeeQueryVariables>(VabsCalculateMySwiftPaymentFeeDocument, variables, options) as Promise<VabsCalculateMySwiftPaymentFeeQuery>;
    },
    vabsCalculateMyInnerPaymentFee(variables: VabsCalculateMyInnerPaymentFeeQueryVariables, options?: C): Promise<VabsCalculateMyInnerPaymentFeeQuery> {
      return requester<VabsCalculateMyInnerPaymentFeeQuery, VabsCalculateMyInnerPaymentFeeQueryVariables>(VabsCalculateMyInnerPaymentFeeDocument, variables, options) as Promise<VabsCalculateMyInnerPaymentFeeQuery>;
    },
    vabsCalculateMyIfscPaymentFee(variables: VabsCalculateMyIfscPaymentFeeQueryVariables, options?: C): Promise<VabsCalculateMyIfscPaymentFeeQuery> {
      return requester<VabsCalculateMyIfscPaymentFeeQuery, VabsCalculateMyIfscPaymentFeeQueryVariables>(VabsCalculateMyIfscPaymentFeeDocument, variables, options) as Promise<VabsCalculateMyIfscPaymentFeeQuery>;
    },
    vabsCreateMyBsbPayment(variables: VabsCreateMyBsbPaymentMutationVariables, options?: C): Promise<VabsCreateMyBsbPaymentMutation> {
      return requester<VabsCreateMyBsbPaymentMutation, VabsCreateMyBsbPaymentMutationVariables>(VabsCreateMyBsbPaymentDocument, variables, options) as Promise<VabsCreateMyBsbPaymentMutation>;
    },
    vabsCreateMyIfscPayment(variables: VabsCreateMyIfscPaymentMutationVariables, options?: C): Promise<VabsCreateMyIfscPaymentMutation> {
      return requester<VabsCreateMyIfscPaymentMutation, VabsCreateMyIfscPaymentMutationVariables>(VabsCreateMyIfscPaymentDocument, variables, options) as Promise<VabsCreateMyIfscPaymentMutation>;
    },
    vabsCreateMyInnerPayment(variables: VabsCreateMyInnerPaymentMutationVariables, options?: C): Promise<VabsCreateMyInnerPaymentMutation> {
      return requester<VabsCreateMyInnerPaymentMutation, VabsCreateMyInnerPaymentMutationVariables>(VabsCreateMyInnerPaymentDocument, variables, options) as Promise<VabsCreateMyInnerPaymentMutation>;
    },
    vabsCreateMySwiftPayment(variables: VabsCreateMySwiftPaymentMutationVariables, options?: C): Promise<VabsCreateMySwiftPaymentMutation> {
      return requester<VabsCreateMySwiftPaymentMutation, VabsCreateMySwiftPaymentMutationVariables>(VabsCreateMySwiftPaymentDocument, variables, options) as Promise<VabsCreateMySwiftPaymentMutation>;
    },
    vabsInternalClientsForInternalPayment(variables?: VabsInternalClientsForInternalPaymentQueryVariables, options?: C): Promise<VabsInternalClientsForInternalPaymentQuery> {
      return requester<VabsInternalClientsForInternalPaymentQuery, VabsInternalClientsForInternalPaymentQueryVariables>(VabsInternalClientsForInternalPaymentDocument, variables, options) as Promise<VabsInternalClientsForInternalPaymentQuery>;
    },
    vabsMyPaymentMethods(variables: VabsMyPaymentMethodsQueryVariables, options?: C): Promise<VabsMyPaymentMethodsQuery> {
      return requester<VabsMyPaymentMethodsQuery, VabsMyPaymentMethodsQueryVariables>(VabsMyPaymentMethodsDocument, variables, options) as Promise<VabsMyPaymentMethodsQuery>;
    },
    vabsMyPayments(variables: VabsMyPaymentsQueryVariables, options?: C): Promise<VabsMyPaymentsQuery> {
      return requester<VabsMyPaymentsQuery, VabsMyPaymentsQueryVariables>(VabsMyPaymentsDocument, variables, options) as Promise<VabsMyPaymentsQuery>;
    },
    vabsUpdateMyPaymentFavorite(variables: VabsUpdateMyPaymentFavoriteMutationVariables, options?: C): Promise<VabsUpdateMyPaymentFavoriteMutation> {
      return requester<VabsUpdateMyPaymentFavoriteMutation, VabsUpdateMyPaymentFavoriteMutationVariables>(VabsUpdateMyPaymentFavoriteDocument, variables, options) as Promise<VabsUpdateMyPaymentFavoriteMutation>;
    },
    companyTypes(variables?: CompanyTypesQueryVariables, options?: C): Promise<CompanyTypesQuery> {
      return requester<CompanyTypesQuery, CompanyTypesQueryVariables>(CompanyTypesDocument, variables, options) as Promise<CompanyTypesQuery>;
    },
    countries(variables?: CountriesQueryVariables, options?: C): Promise<CountriesQuery> {
      return requester<CountriesQuery, CountriesQueryVariables>(CountriesDocument, variables, options) as Promise<CountriesQuery>;
    },
    staticData(variables?: StaticDataQueryVariables, options?: C): Promise<StaticDataQuery> {
      return requester<StaticDataQuery, StaticDataQueryVariables>(StaticDataDocument, variables, options) as Promise<StaticDataQuery>;
    },
    myCompanies(variables: MyCompaniesQueryVariables, options?: C): Promise<MyCompaniesQuery> {
      return requester<MyCompaniesQuery, MyCompaniesQueryVariables>(MyCompaniesDocument, variables, options) as Promise<MyCompaniesQuery>;
    },
    myPersonalData(variables: MyPersonalDataQueryVariables, options?: C): Promise<MyPersonalDataQuery> {
      return requester<MyPersonalDataQuery, MyPersonalDataQueryVariables>(MyPersonalDataDocument, variables, options) as Promise<MyPersonalDataQuery>;
    },
    signInV2(variables: SignInV2QueryVariables, options?: C): Promise<SignInV2Query> {
      return requester<SignInV2Query, SignInV2QueryVariables>(SignInV2Document, variables, options) as Promise<SignInV2Query>;
    },
    childMembers(variables: ChildMembersQueryVariables, options?: C): Promise<ChildMembersQuery> {
      return requester<ChildMembersQuery, ChildMembersQueryVariables>(ChildMembersDocument, variables, options) as Promise<ChildMembersQuery>;
    },
    createCorporateMember(variables: CreateCorporateMemberMutationVariables, options?: C): Promise<CreateCorporateMemberMutation> {
      return requester<CreateCorporateMemberMutation, CreateCorporateMemberMutationVariables>(CreateCorporateMemberDocument, variables, options) as Promise<CreateCorporateMemberMutation>;
    },
    createCorporateMemberAddress(variables: CreateCorporateMemberAddressMutationVariables, options?: C): Promise<CreateCorporateMemberAddressMutation> {
      return requester<CreateCorporateMemberAddressMutation, CreateCorporateMemberAddressMutationVariables>(CreateCorporateMemberAddressDocument, variables, options) as Promise<CreateCorporateMemberAddressMutation>;
    },
    createCorporateMembers(variables: CreateCorporateMembersMutationVariables, options?: C): Promise<CreateCorporateMembersMutation> {
      return requester<CreateCorporateMembersMutation, CreateCorporateMembersMutationVariables>(CreateCorporateMembersDocument, variables, options) as Promise<CreateCorporateMembersMutation>;
    },
    createIndividualMember(variables: CreateIndividualMemberMutationVariables, options?: C): Promise<CreateIndividualMemberMutation> {
      return requester<CreateIndividualMemberMutation, CreateIndividualMemberMutationVariables>(CreateIndividualMemberDocument, variables, options) as Promise<CreateIndividualMemberMutation>;
    },
    createIndividualMemberAddress(variables: CreateIndividualMemberAddressMutationVariables, options?: C): Promise<CreateIndividualMemberAddressMutation> {
      return requester<CreateIndividualMemberAddressMutation, CreateIndividualMemberAddressMutationVariables>(CreateIndividualMemberAddressDocument, variables, options) as Promise<CreateIndividualMemberAddressMutation>;
    },
    createIndividualMembers(variables: CreateIndividualMembersMutationVariables, options?: C): Promise<CreateIndividualMembersMutation> {
      return requester<CreateIndividualMembersMutation, CreateIndividualMembersMutationVariables>(CreateIndividualMembersDocument, variables, options) as Promise<CreateIndividualMembersMutation>;
    },
    deleteCorporateMember(variables?: DeleteCorporateMemberMutationVariables, options?: C): Promise<DeleteCorporateMemberMutation> {
      return requester<DeleteCorporateMemberMutation, DeleteCorporateMemberMutationVariables>(DeleteCorporateMemberDocument, variables, options) as Promise<DeleteCorporateMemberMutation>;
    },
    deleteIndividualMember(variables: DeleteIndividualMemberMutationVariables, options?: C): Promise<DeleteIndividualMemberMutation> {
      return requester<DeleteIndividualMemberMutation, DeleteIndividualMemberMutationVariables>(DeleteIndividualMemberDocument, variables, options) as Promise<DeleteIndividualMemberMutation>;
    },
    updateCorporateMember(variables: UpdateCorporateMemberMutationVariables, options?: C): Promise<UpdateCorporateMemberMutation> {
      return requester<UpdateCorporateMemberMutation, UpdateCorporateMemberMutationVariables>(UpdateCorporateMemberDocument, variables, options) as Promise<UpdateCorporateMemberMutation>;
    },
    updateIndividualMember(variables: UpdateIndividualMemberMutationVariables, options?: C): Promise<UpdateIndividualMemberMutation> {
      return requester<UpdateIndividualMemberMutation, UpdateIndividualMemberMutationVariables>(UpdateIndividualMemberDocument, variables, options) as Promise<UpdateIndividualMemberMutation>;
    },
    createMyAddress(variables: CreateMyAddressMutationVariables, options?: C): Promise<CreateMyAddressMutation> {
      return requester<CreateMyAddressMutation, CreateMyAddressMutationVariables>(CreateMyAddressDocument, variables, options) as Promise<CreateMyAddressMutation>;
    },
    createMyCompanyAdditionalInfo(variables: CreateMyCompanyAdditionalInfoMutationVariables, options?: C): Promise<CreateMyCompanyAdditionalInfoMutation> {
      return requester<CreateMyCompanyAdditionalInfoMutation, CreateMyCompanyAdditionalInfoMutationVariables>(CreateMyCompanyAdditionalInfoDocument, variables, options) as Promise<CreateMyCompanyAdditionalInfoMutation>;
    },
    deleteMyAddress(variables: DeleteMyAddressMutationVariables, options?: C): Promise<DeleteMyAddressMutation> {
      return requester<DeleteMyAddressMutation, DeleteMyAddressMutationVariables>(DeleteMyAddressDocument, variables, options) as Promise<DeleteMyAddressMutation>;
    },
    createMyCompany(variables: CreateMyCompanyMutationVariables, options?: C): Promise<CreateMyCompanyMutation> {
      return requester<CreateMyCompanyMutation, CreateMyCompanyMutationVariables>(CreateMyCompanyDocument, variables, options) as Promise<CreateMyCompanyMutation>;
    },
    draftCompany(variables: DraftCompanyQueryVariables, options?: C): Promise<DraftCompanyQuery> {
      return requester<DraftCompanyQuery, DraftCompanyQueryVariables>(DraftCompanyDocument, variables, options) as Promise<DraftCompanyQuery>;
    },
    myCompanyAdditionalInfos(variables: MyCompanyAdditionalInfosQueryVariables, options?: C): Promise<MyCompanyAdditionalInfosQuery> {
      return requester<MyCompanyAdditionalInfosQuery, MyCompanyAdditionalInfosQueryVariables>(MyCompanyAdditionalInfosDocument, variables, options) as Promise<MyCompanyAdditionalInfosQuery>;
    },
    myCompanyMembers(variables: MyCompanyMembersQueryVariables, options?: C): Promise<MyCompanyMembersQuery> {
      return requester<MyCompanyMembersQuery, MyCompanyMembersQueryVariables>(MyCompanyMembersDocument, variables, options) as Promise<MyCompanyMembersQuery>;
    },
    startMyKYBProcedureV2(variables?: StartMyKybProcedureV2MutationVariables, options?: C): Promise<StartMyKybProcedureV2Mutation> {
      return requester<StartMyKybProcedureV2Mutation, StartMyKybProcedureV2MutationVariables>(StartMyKybProcedureV2Document, variables, options) as Promise<StartMyKybProcedureV2Mutation>;
    },
    updateMyAddress(variables: UpdateMyAddressMutationVariables, options?: C): Promise<UpdateMyAddressMutation> {
      return requester<UpdateMyAddressMutation, UpdateMyAddressMutationVariables>(UpdateMyAddressDocument, variables, options) as Promise<UpdateMyAddressMutation>;
    },
    updateMyCompany(variables: UpdateMyCompanyMutationVariables, options?: C): Promise<UpdateMyCompanyMutation> {
      return requester<UpdateMyCompanyMutation, UpdateMyCompanyMutationVariables>(UpdateMyCompanyDocument, variables, options) as Promise<UpdateMyCompanyMutation>;
    },
    updateMyCompanyAdditionalInfo(variables: UpdateMyCompanyAdditionalInfoMutationVariables, options?: C): Promise<UpdateMyCompanyAdditionalInfoMutation> {
      return requester<UpdateMyCompanyAdditionalInfoMutation, UpdateMyCompanyAdditionalInfoMutationVariables>(UpdateMyCompanyAdditionalInfoDocument, variables, options) as Promise<UpdateMyCompanyAdditionalInfoMutation>;
    },
    updateMyCompanyMember(variables: UpdateMyCompanyMemberMutationVariables, options?: C): Promise<UpdateMyCompanyMemberMutation> {
      return requester<UpdateMyCompanyMemberMutation, UpdateMyCompanyMemberMutationVariables>(UpdateMyCompanyMemberDocument, variables, options) as Promise<UpdateMyCompanyMemberMutation>;
    },
    updatePersonal(variables: UpdatePersonalMutationVariables, options?: C): Promise<UpdatePersonalMutation> {
      return requester<UpdatePersonalMutation, UpdatePersonalMutationVariables>(UpdatePersonalDocument, variables, options) as Promise<UpdatePersonalMutation>;
    },
    logout(variables: LogoutQueryVariables, options?: C): Promise<LogoutQuery> {
      return requester<LogoutQuery, LogoutQueryVariables>(LogoutDocument, variables, options) as Promise<LogoutQuery>;
    },
    initUploadSession(variables?: InitUploadSessionMutationVariables, options?: C): Promise<InitUploadSessionMutation> {
      return requester<InitUploadSessionMutation, InitUploadSessionMutationVariables>(InitUploadSessionDocument, variables, options) as Promise<InitUploadSessionMutation>;
    },
    confirmPasswordRecovery(variables: ConfirmPasswordRecoveryMutationVariables, options?: C): Promise<ConfirmPasswordRecoveryMutation> {
      return requester<ConfirmPasswordRecoveryMutation, ConfirmPasswordRecoveryMutationVariables>(ConfirmPasswordRecoveryDocument, variables, options) as Promise<ConfirmPasswordRecoveryMutation>;
    },
    startPasswordRecoveryV2(variables: StartPasswordRecoveryV2MutationVariables, options?: C): Promise<StartPasswordRecoveryV2Mutation> {
      return requester<StartPasswordRecoveryV2Mutation, StartPasswordRecoveryV2MutationVariables>(StartPasswordRecoveryV2Document, variables, options) as Promise<StartPasswordRecoveryV2Mutation>;
    },
    companyTotalShare(variables: CompanyTotalShareQueryVariables, options?: C): Promise<CompanyTotalShareQuery> {
      return requester<CompanyTotalShareQuery, CompanyTotalShareQueryVariables>(CompanyTotalShareDocument, variables, options) as Promise<CompanyTotalShareQuery>;
    },
    createMyCompanyMemberKYCAccessToken(variables: CreateMyCompanyMemberKycAccessTokenMutationVariables, options?: C): Promise<CreateMyCompanyMemberKycAccessTokenMutation> {
      return requester<CreateMyCompanyMemberKycAccessTokenMutation, CreateMyCompanyMemberKycAccessTokenMutationVariables>(CreateMyCompanyMemberKycAccessTokenDocument, variables, options) as Promise<CreateMyCompanyMemberKycAccessTokenMutation>;
    },
    createMyDocuments(variables: CreateMyDocumentsMutationVariables, options?: C): Promise<CreateMyDocumentsMutation> {
      return requester<CreateMyDocumentsMutation, CreateMyDocumentsMutationVariables>(CreateMyDocumentsDocument, variables, options) as Promise<CreateMyDocumentsMutation>;
    },
    documentConfigs(variables: DocumentConfigsQueryVariables, options?: C): Promise<DocumentConfigsQuery> {
      return requester<DocumentConfigsQuery, DocumentConfigsQueryVariables>(DocumentConfigsDocument, variables, options) as Promise<DocumentConfigsQuery>;
    },
    executeKYBStep(variables: ExecuteKybStepMutationVariables, options?: C): Promise<ExecuteKybStepMutation> {
      return requester<ExecuteKybStepMutation, ExecuteKybStepMutationVariables>(ExecuteKybStepDocument, variables, options) as Promise<ExecuteKybStepMutation>;
    },
    getFileInfo(variables: GetFileInfoQueryVariables, options?: C): Promise<GetFileInfoQuery> {
      return requester<GetFileInfoQuery, GetFileInfoQueryVariables>(GetFileInfoDocument, variables, options) as Promise<GetFileInfoQuery>;
    },
    incomingPayments(variables: IncomingPaymentsQueryVariables, options?: C): Promise<IncomingPaymentsQuery> {
      return requester<IncomingPaymentsQuery, IncomingPaymentsQueryVariables>(IncomingPaymentsDocument, variables, options) as Promise<IncomingPaymentsQuery>;
    },
    myDocuments(variables: MyDocumentsQueryVariables, options?: C): Promise<MyDocumentsQuery> {
      return requester<MyDocumentsQuery, MyDocumentsQueryVariables>(MyDocumentsDocument, variables, options) as Promise<MyDocumentsQuery>;
    },
    outgoingPayments(variables: OutgoingPaymentsQueryVariables, options?: C): Promise<OutgoingPaymentsQuery> {
      return requester<OutgoingPaymentsQuery, OutgoingPaymentsQueryVariables>(OutgoingPaymentsDocument, variables, options) as Promise<OutgoingPaymentsQuery>;
    },
    sendMyCompanyDocumentsToReview(variables?: SendMyCompanyDocumentsToReviewMutationVariables, options?: C): Promise<SendMyCompanyDocumentsToReviewMutation> {
      return requester<SendMyCompanyDocumentsToReviewMutation, SendMyCompanyDocumentsToReviewMutationVariables>(SendMyCompanyDocumentsToReviewDocument, variables, options) as Promise<SendMyCompanyDocumentsToReviewMutation>;
    },
    updateDocument(variables: UpdateDocumentMutationVariables, options?: C): Promise<UpdateDocumentMutation> {
      return requester<UpdateDocumentMutation, UpdateDocumentMutationVariables>(UpdateDocumentDocument, variables, options) as Promise<UpdateDocumentMutation>;
    },
    confirmRegisterIdentity(variables: ConfirmRegisterIdentityQueryVariables, options?: C): Promise<ConfirmRegisterIdentityQuery> {
      return requester<ConfirmRegisterIdentityQuery, ConfirmRegisterIdentityQueryVariables>(ConfirmRegisterIdentityDocument, variables, options) as Promise<ConfirmRegisterIdentityQuery>;
    },
    registerIdentity(variables: RegisterIdentityMutationVariables, options?: C): Promise<RegisterIdentityMutation> {
      return requester<RegisterIdentityMutation, RegisterIdentityMutationVariables>(RegisterIdentityDocument, variables, options) as Promise<RegisterIdentityMutation>;
    },
    confirmSignIn(variables: ConfirmSignInMutationVariables, options?: C): Promise<ConfirmSignInMutation> {
      return requester<ConfirmSignInMutation, ConfirmSignInMutationVariables>(ConfirmSignInDocument, variables, options) as Promise<ConfirmSignInMutation>;
    },
    sendTFACode(variables: SendTfaCodeMutationVariables, options?: C): Promise<SendTfaCodeMutation> {
      return requester<SendTfaCodeMutation, SendTfaCodeMutationVariables>(SendTfaCodeDocument, variables, options) as Promise<SendTfaCodeMutation>;
    },
    checkCode(variables: CheckCodeQueryVariables, options?: C): Promise<CheckCodeQuery> {
      return requester<CheckCodeQuery, CheckCodeQueryVariables>(CheckCodeDocument, variables, options) as Promise<CheckCodeQuery>;
    },
    sendCodeV2(variables: SendCodeV2QueryVariables, options?: C): Promise<SendCodeV2Query> {
      return requester<SendCodeV2Query, SendCodeV2QueryVariables>(SendCodeV2Document, variables, options) as Promise<SendCodeV2Query>;
    },
    signUpV2(variables: SignUpV2MutationVariables, options?: C): Promise<SignUpV2Mutation> {
      return requester<SignUpV2Mutation, SignUpV2MutationVariables>(SignUpV2Document, variables, options) as Promise<SignUpV2Mutation>;
    },
    token(variables: TokenMutationVariables, options?: C): Promise<TokenMutation> {
      return requester<TokenMutation, TokenMutationVariables>(TokenDocument, variables, options) as Promise<TokenMutation>;
    },
    changeIdentity(variables: ChangeIdentityMutationVariables, options?: C): Promise<ChangeIdentityMutation> {
      return requester<ChangeIdentityMutation, ChangeIdentityMutationVariables>(ChangeIdentityDocument, variables, options) as Promise<ChangeIdentityMutation>;
    },
    confirmChangeIdentity(variables: ConfirmChangeIdentityMutationVariables, options?: C): Promise<ConfirmChangeIdentityMutation> {
      return requester<ConfirmChangeIdentityMutation, ConfirmChangeIdentityMutationVariables>(ConfirmChangeIdentityDocument, variables, options) as Promise<ConfirmChangeIdentityMutation>;
    },
    changePasswordV2(variables: ChangePasswordV2MutationVariables, options?: C): Promise<ChangePasswordV2Mutation> {
      return requester<ChangePasswordV2Mutation, ChangePasswordV2MutationVariables>(ChangePasswordV2Document, variables, options) as Promise<ChangePasswordV2Mutation>;
    },
    confirmChangePassword(variables: ConfirmChangePasswordMutationVariables, options?: C): Promise<ConfirmChangePasswordMutation> {
      return requester<ConfirmChangePasswordMutation, ConfirmChangePasswordMutationVariables>(ConfirmChangePasswordDocument, variables, options) as Promise<ConfirmChangePasswordMutation>;
    }
  };
}
export type Sdk = ReturnType<typeof getSdk>;